var map = {
	".": [
		31,
		9
	],
	"./": [
		31,
		9
	],
	"./App": [
		42,
		9
	],
	"./App.js": [
		42,
		9
	],
	"./App.test": [
		660,
		9,
		788
	],
	"./App.test.js": [
		660,
		9,
		788
	],
	"./Context": [
		6,
		9
	],
	"./Context.js": [
		6,
		9
	],
	"./assets/fonts/ostrich-sans-black/ostrichsans-black-webfont.woff": [
		2140,
		9,
		1487
	],
	"./assets/fonts/ostrich-sans-black/ostrichsans-black-webfont.woff2": [
		2141,
		9,
		1488
	],
	"./assets/fonts/ostrich-sans-black/stylesheet.css": [
		2142,
		7,
		833
	],
	"./assets/fonts/poppins-bold/poppins-bold-webfont.woff": [
		2143,
		9,
		1489
	],
	"./assets/fonts/poppins-bold/poppins-bold-webfont.woff2": [
		2144,
		9,
		1490
	],
	"./assets/fonts/poppins-bold/stylesheet.css": [
		2145,
		7,
		834
	],
	"./assets/fonts/poppins-light/Poppins-Light.woff": [
		2146,
		9,
		1491
	],
	"./assets/fonts/poppins-light/Poppins-Light.woff2": [
		2147,
		9,
		1492
	],
	"./assets/fonts/poppins-light/stylesheet.css": [
		2148,
		7,
		835
	],
	"./assets/fonts/poppins-normal/Poppins-Medium.woff": [
		2149,
		9,
		1493
	],
	"./assets/fonts/poppins-normal/Poppins-Medium.woff2": [
		2150,
		9,
		1494
	],
	"./assets/fonts/poppins-normal/Poppins-Regular.woff": [
		2151,
		9,
		1495
	],
	"./assets/fonts/poppins-normal/Poppins-Regular.woff2": [
		2152,
		9,
		1496
	],
	"./assets/fonts/poppins-normal/stylesheet.css": [
		2153,
		7,
		836
	],
	"./assets/fonts/poppins-semibold/Poppins-SemiBold.woff": [
		2154,
		9,
		1497
	],
	"./assets/fonts/poppins-semibold/Poppins-SemiBold.woff2": [
		2155,
		9,
		1498
	],
	"./assets/fonts/poppins-semibold/stylesheet.css": [
		2156,
		7,
		837
	],
	"./assets/fonts/roboto-bold/roboto-bold-webfont.woff": [
		2157,
		9,
		1499
	],
	"./assets/fonts/roboto-bold/roboto-bold-webfont.woff2": [
		2158,
		9,
		1500
	],
	"./assets/fonts/roboto-bold/stylesheet.css": [
		2159,
		7,
		838
	],
	"./assets/fonts/roboto-light/Roboto-Light.woff": [
		2160,
		9,
		1501
	],
	"./assets/fonts/roboto-light/Roboto-Light.woff2": [
		2161,
		9,
		1502
	],
	"./assets/fonts/roboto-light/stylesheet.css": [
		2162,
		7,
		839
	],
	"./assets/fonts/roboto-regular/Roboto-Italic.woff": [
		2163,
		9,
		1503
	],
	"./assets/fonts/roboto-regular/Roboto-Italic.woff2": [
		2164,
		9,
		1504
	],
	"./assets/fonts/roboto-regular/roboto-regular-webfont.woff": [
		2165,
		9,
		1505
	],
	"./assets/fonts/roboto-regular/roboto-regular-webfont.woff2": [
		2166,
		9,
		1506
	],
	"./assets/fonts/roboto-regular/stylesheet.css": [
		2167,
		7,
		840
	],
	"./assets/icomoon.zip": [
		2175,
		9,
		1507
	],
	"./assets/icomoon/Read Me.txt": [
		2168,
		9,
		1508
	],
	"./assets/icomoon/demo-files/demo": [
		661,
		7,
		789
	],
	"./assets/icomoon/demo-files/demo.css": [
		2169,
		7,
		841
	],
	"./assets/icomoon/demo-files/demo.js": [
		661,
		7,
		789
	],
	"./assets/icomoon/fonts/icomoon.eot": [
		2170,
		9,
		1509
	],
	"./assets/icomoon/fonts/icomoon.svg": [
		2171,
		9,
		1510
	],
	"./assets/icomoon/fonts/icomoon.ttf": [
		2172,
		9,
		1511
	],
	"./assets/icomoon/fonts/icomoon.woff": [
		2173,
		9,
		1512
	],
	"./assets/icomoon/selection": [
		662,
		3,
		812
	],
	"./assets/icomoon/selection.json": [
		662,
		3,
		812
	],
	"./assets/icomoon/style.css": [
		2174,
		7,
		842
	],
	"./assets/icons/cloud-services.svg": [
		1502,
		9,
		1513
	],
	"./assets/icons/cross.svg": [
		2176,
		9,
		1514
	],
	"./assets/icons/down-chevron.svg": [
		2177,
		9,
		1515
	],
	"./assets/icons/game.svg": [
		70,
		9
	],
	"./assets/icons/icon_QA.svg": [
		2178,
		9,
		1516
	],
	"./assets/icons/icon_backend.svg": [
		1646,
		9,
		1517
	],
	"./assets/icons/icon_blockchain.svg": [
		1647,
		9,
		1518
	],
	"./assets/icons/icon_emerging.svg": [
		1648,
		9,
		1519
	],
	"./assets/icons/icon_front_end.svg": [
		2179,
		9,
		1520
	],
	"./assets/icons/icon_graphic.svg": [
		1503,
		9,
		1521
	],
	"./assets/icons/icon_uiux.svg": [
		1649,
		9,
		1522
	],
	"./assets/icons/menu-career-icon.svg": [
		1650,
		9,
		1523
	],
	"./assets/icons/menu-cloud-icon.svg": [
		65,
		9
	],
	"./assets/icons/menu-graphic-icon.svg": [
		63,
		9
	],
	"./assets/icons/menu-ibeacon-icon.svg": [
		68,
		9
	],
	"./assets/icons/menu-icon.svg": [
		2180,
		9,
		1524
	],
	"./assets/icons/menu-iot-icon.svg": [
		66,
		9
	],
	"./assets/icons/menu-mobile-icon.svg": [
		61,
		9
	],
	"./assets/icons/menu-new-icon.svg": [
		71,
		9
	],
	"./assets/icons/menu-qa-icon.svg": [
		64,
		9
	],
	"./assets/icons/menu-quote.svg": [
		69,
		9
	],
	"./assets/icons/menu-watch-icon.svg": [
		67,
		9
	],
	"./assets/icons/menu-web-icon.svg": [
		62,
		9
	],
	"./assets/icons/mobile-icon.svg": [
		1504,
		9,
		1525
	],
	"./assets/icons/right-arrow.svg": [
		22,
		9
	],
	"./assets/icons/web-front-end-icon.svg": [
		1505,
		9,
		1526
	],
	"./assets/imgs/a-watch-black.svg": [
		929,
		9,
		1527
	],
	"./assets/imgs/a-watch.svg": [
		2181,
		9,
		1528
	],
	"./assets/imgs/adaptive-uis.svg": [
		1651,
		9,
		1529
	],
	"./assets/imgs/admin.svg": [
		1652,
		9,
		1530
	],
	"./assets/imgs/android-black.svg": [
		932,
		9,
		1531
	],
	"./assets/imgs/android.svg": [
		1023,
		9,
		1532
	],
	"./assets/imgs/beacon-black.svg": [
		930,
		9,
		1533
	],
	"./assets/imgs/beacon.svg": [
		1144,
		9,
		1534
	],
	"./assets/imgs/blog.jpg": [
		2182,
		9,
		2905
	],
	"./assets/imgs/check.svg": [
		2183,
		9,
		1535
	],
	"./assets/imgs/discovery-pg-imgs/A.png": [
		2184,
		9,
		2906
	],
	"./assets/imgs/discovery-pg-imgs/B.png": [
		2185,
		9,
		2907
	],
	"./assets/imgs/discovery-pg-imgs/C.png": [
		2186,
		9,
		2908
	],
	"./assets/imgs/discovery-pg-imgs/D.png": [
		2187,
		9,
		2909
	],
	"./assets/imgs/discovery-pg-imgs/E.png": [
		2188,
		9,
		2910
	],
	"./assets/imgs/discovery-pg-imgs/F.png": [
		2189,
		9,
		2911
	],
	"./assets/imgs/discovery-pg-imgs/ba.png": [
		2190,
		9,
		2912
	],
	"./assets/imgs/discovery-pg-imgs/banner-bg.png": [
		2191,
		9,
		2913
	],
	"./assets/imgs/discovery-pg-imgs/behance.png": [
		2192,
		9,
		2914
	],
	"./assets/imgs/discovery-pg-imgs/close-icon.svg": [
		2193,
		9,
		1536
	],
	"./assets/imgs/discovery-pg-imgs/contact-bg.png": [
		2194,
		9,
		2915
	],
	"./assets/imgs/discovery-pg-imgs/desinger.png": [
		2195,
		9,
		2916
	],
	"./assets/imgs/discovery-pg-imgs/dots.png": [
		2196,
		9,
		2917
	],
	"./assets/imgs/discovery-pg-imgs/dribble.png": [
		2197,
		9,
		2918
	],
	"./assets/imgs/discovery-pg-imgs/ellipse.png": [
		2198,
		9,
		2919
	],
	"./assets/imgs/discovery-pg-imgs/fb.png": [
		2199,
		9,
		2920
	],
	"./assets/imgs/discovery-pg-imgs/feasibilty.png": [
		2200,
		9,
		2921
	],
	"./assets/imgs/discovery-pg-imgs/footer-shape.png": [
		2201,
		9,
		2922
	],
	"./assets/imgs/discovery-pg-imgs/google.png": [
		2202,
		9,
		2923
	],
	"./assets/imgs/discovery-pg-imgs/ideation.png": [
		2203,
		9,
		2924
	],
	"./assets/imgs/discovery-pg-imgs/logo-mind-inventory.svg": [
		2204,
		9,
		1537
	],
	"./assets/imgs/discovery-pg-imgs/logo-whitetext.svg": [
		2205,
		9,
		1538
	],
	"./assets/imgs/discovery-pg-imgs/multi-ellipse.png": [
		2206,
		9,
		2925
	],
	"./assets/imgs/discovery-pg-imgs/phase.png": [
		2207,
		9,
		2926
	],
	"./assets/imgs/discovery-pg-imgs/pink-dots.png": [
		2208,
		9,
		2927
	],
	"./assets/imgs/discovery-pg-imgs/play.png": [
		2209,
		9,
		2928
	],
	"./assets/imgs/discovery-pg-imgs/pm.png": [
		2210,
		9,
		2929
	],
	"./assets/imgs/discovery-pg-imgs/project-plan.png": [
		2211,
		9,
		2930
	],
	"./assets/imgs/discovery-pg-imgs/slack.png": [
		2212,
		9,
		2931
	],
	"./assets/imgs/discovery-pg-imgs/ui-ux.png": [
		2213,
		9,
		2932
	],
	"./assets/imgs/discovery-pg-imgs/user-journey.png": [
		2214,
		9,
		2933
	],
	"./assets/imgs/discovery-pg-imgs/viber.png": [
		2215,
		9,
		2934
	],
	"./assets/imgs/discovery-pg-imgs/white-dots.png": [
		2216,
		9,
		2935
	],
	"./assets/imgs/discovery-pg-imgs/wireframing.png": [
		2217,
		9,
		2936
	],
	"./assets/imgs/favicon/apple-icon-114x114.png": [
		996,
		9,
		2937
	],
	"./assets/imgs/favicon/apple-icon-120x120.png": [
		997,
		9,
		2938
	],
	"./assets/imgs/favicon/apple-icon-144x144.png": [
		998,
		9,
		2939
	],
	"./assets/imgs/favicon/apple-icon-152x152.png": [
		999,
		9,
		2940
	],
	"./assets/imgs/favicon/apple-icon-180x180.png": [
		1000,
		9,
		2941
	],
	"./assets/imgs/favicon/apple-icon-57x57.png": [
		992,
		9,
		2942
	],
	"./assets/imgs/favicon/apple-icon-60x60.png": [
		993,
		9,
		2943
	],
	"./assets/imgs/favicon/apple-icon-72x72.png": [
		994,
		9,
		2944
	],
	"./assets/imgs/favicon/apple-icon-76x76.png": [
		995,
		9,
		2945
	],
	"./assets/imgs/favicon/favicon.png": [
		991,
		9,
		2946
	],
	"./assets/imgs/ios.svg": [
		1142,
		9,
		1539
	],
	"./assets/imgs/iot-black.svg": [
		931,
		9,
		1540
	],
	"./assets/imgs/iot.svg": [
		1145,
		9,
		1541
	],
	"./assets/imgs/ipad.svg": [
		2218,
		9,
		1542
	],
	"./assets/imgs/looking-developers/grediant-bg.svg": [
		2219,
		9,
		1543
	],
	"./assets/imgs/other-services/android.svg": [
		1018,
		9,
		1544
	],
	"./assets/imgs/other-services/angular.svg": [
		979,
		9,
		1545
	],
	"./assets/imgs/other-services/arrow-white.svg": [
		917,
		9,
		1546
	],
	"./assets/imgs/other-services/backbonejs.svg": [
		2220,
		9,
		1547
	],
	"./assets/imgs/other-services/cloud-computing.svg": [
		2221,
		9,
		1548
	],
	"./assets/imgs/other-services/devops.svg": [
		1653,
		9,
		1549
	],
	"./assets/imgs/other-services/digital-transformation.svg": [
		2222,
		9,
		1550
	],
	"./assets/imgs/other-services/docker.svg": [
		2223,
		9,
		1551
	],
	"./assets/imgs/other-services/enterprise-app.svg": [
		2224,
		9,
		1552
	],
	"./assets/imgs/other-services/expressjs.svg": [
		1192,
		9,
		1553
	],
	"./assets/imgs/other-services/figma.svg": [
		2225,
		9,
		1554
	],
	"./assets/imgs/other-services/flutter.svg": [
		1019,
		9,
		1555
	],
	"./assets/imgs/other-services/fullstack.svg": [
		2226,
		9,
		1556
	],
	"./assets/imgs/other-services/git.svg": [
		1069,
		9,
		1557
	],
	"./assets/imgs/other-services/golang.svg": [
		1001,
		9,
		1558
	],
	"./assets/imgs/other-services/hire-dedicated.svg": [
		1506,
		9,
		1559
	],
	"./assets/imgs/other-services/ibeacon.svg": [
		2227,
		9,
		1560
	],
	"./assets/imgs/other-services/invinsion-1.svg": [
		2228,
		9,
		1561
	],
	"./assets/imgs/other-services/invinsion.svg": [
		2229,
		9,
		1562
	],
	"./assets/imgs/other-services/ionic.svg": [
		2230,
		9,
		1563
	],
	"./assets/imgs/other-services/ios.svg": [
		975,
		9,
		1564
	],
	"./assets/imgs/other-services/iot.svg": [
		1654,
		9,
		1565
	],
	"./assets/imgs/other-services/javascript.svg": [
		1507,
		9,
		1566
	],
	"./assets/imgs/other-services/jenkins.svg": [
		1070,
		9,
		1567
	],
	"./assets/imgs/other-services/kubernets.svg": [
		2231,
		9,
		1568
	],
	"./assets/imgs/other-services/laravel.svg": [
		1002,
		9,
		1569
	],
	"./assets/imgs/other-services/meteoter.svg": [
		1025,
		9,
		1570
	],
	"./assets/imgs/other-services/mobile-app-development.svg": [
		1508,
		9,
		1571
	],
	"./assets/imgs/other-services/nodejs-horizontal.svg": [
		2232,
		9,
		1572
	],
	"./assets/imgs/other-services/nodejs.svg": [
		976,
		9,
		1573
	],
	"./assets/imgs/other-services/php.svg": [
		2233,
		9,
		1574
	],
	"./assets/imgs/other-services/product-eng.svg": [
		2234,
		9,
		1575
	],
	"./assets/imgs/other-services/python.svg": [
		1067,
		9,
		1576
	],
	"./assets/imgs/other-services/qa-eng.svg": [
		2235,
		9,
		1577
	],
	"./assets/imgs/other-services/react.svg": [
		968,
		9,
		1578
	],
	"./assets/imgs/other-services/selenium.svg": [
		1072,
		9,
		1579
	],
	"./assets/imgs/other-services/startup-services.svg": [
		1655,
		9,
		1580
	],
	"./assets/imgs/other-services/swift.svg": [
		2236,
		9,
		1581
	],
	"./assets/imgs/other-services/uiux.svg": [
		1656,
		9,
		1582
	],
	"./assets/imgs/other-services/vuejs.svg": [
		980,
		9,
		1583
	],
	"./assets/imgs/other-services/wearable.svg": [
		1657,
		9,
		1584
	],
	"./assets/imgs/other-services/web-development.svg": [
		1658,
		9,
		1585
	],
	"./assets/imgs/other-services/wordpress.svg": [
		1066,
		9,
		1586
	],
	"./assets/imgs/other-services/xd.svg": [
		2237,
		9,
		1587
	],
	"./assets/imgs/other-services/zeplin.svg": [
		2238,
		9,
		1588
	],
	"./assets/imgs/tablet-black.svg": [
		928,
		9,
		1589
	],
	"./assets/imgs/tablet.svg": [
		2239,
		9,
		1590
	],
	"./assets/imgs/trendingtech/a-watch-black.svg": [
		2240,
		9,
		1591
	],
	"./assets/imgs/trendingtech/docker.svg": [
		2241,
		9,
		1592
	],
	"./assets/imgs/trendingtech/firebase.svg": [
		2242,
		9,
		1593
	],
	"./assets/imgs/trendingtech/flutter.svg": [
		2243,
		9,
		1594
	],
	"./assets/imgs/trendingtech/golang.svg": [
		2244,
		9,
		1595
	],
	"./assets/imgs/trendingtech/kubernetes.svg": [
		2245,
		9,
		1596
	],
	"./assets/imgs/trendingtech/react.svg": [
		2246,
		9,
		1597
	],
	"./assets/imgs/trendingtech/tablet-black.svg": [
		2247,
		9,
		1598
	],
	"./assets/imgs/video-testimonial.png": [
		2248,
		9,
		2947
	],
	"./assets/imgs/wearable.svg": [
		1143,
		9,
		1599
	],
	"./assets/imgs/web.svg": [
		1022,
		9,
		1600
	],
	"./assets/moonicons/Read Me.txt": [
		2249,
		9,
		1601
	],
	"./assets/moonicons/demo-files/demo": [
		663,
		7,
		790
	],
	"./assets/moonicons/demo-files/demo.css": [
		2250,
		7,
		843
	],
	"./assets/moonicons/demo-files/demo.js": [
		663,
		7,
		790
	],
	"./assets/moonicons/fonts/icomoon.eot": [
		2251,
		9,
		1602
	],
	"./assets/moonicons/fonts/icomoon.svg": [
		2252,
		9,
		1603
	],
	"./assets/moonicons/fonts/icomoon.ttf": [
		2253,
		9,
		1604
	],
	"./assets/moonicons/fonts/icomoon.woff": [
		2254,
		9,
		1605
	],
	"./assets/moonicons/selection": [
		664,
		3,
		813
	],
	"./assets/moonicons/selection.json": [
		664,
		3,
		813
	],
	"./assets/moonicons/style.css": [
		2255,
		7,
		844
	],
	"./assets/og-images/jiyosoft.jpg": [
		880,
		9,
		2948
	],
	"./components/10thAnniversaryBanner/Confetti/Confetti": [
		665,
		9,
		670
	],
	"./components/10thAnniversaryBanner/Confetti/Confetti.js": [
		665,
		9,
		670
	],
	"./components/10thAnniversaryBanner/Confetti/Confetti.scss": [
		1659,
		7,
		864
	],
	"./components/AboutText/AboutText": [
		211,
		9,
		791
	],
	"./components/AboutText/AboutText.js": [
		211,
		9,
		791
	],
	"./components/AboutTitle/AboutTitle": [
		212,
		9,
		792
	],
	"./components/AboutTitle/AboutTitle.js": [
		212,
		9,
		792
	],
	"./components/AvailableDevelopers/AvailableDevelopers": [
		666,
		9,
		300
	],
	"./components/AvailableDevelopers/AvailableDevelopers.js": [
		666,
		9,
		300
	],
	"./components/AvailableDevelopers/AvailableDevelopers.scss": [
		1660,
		7,
		865
	],
	"./components/BlogSection/BlogItem": [
		667,
		9,
		793
	],
	"./components/BlogSection/BlogItem.js": [
		667,
		9,
		793
	],
	"./components/BlogSection/BlogSection": [
		668,
		9,
		5,
		446
	],
	"./components/BlogSection/BlogSection.js": [
		668,
		9,
		5,
		446
	],
	"./components/BlogSection/BlogSection.scss": [
		1661,
		7,
		866
	],
	"./components/BlogSection/img/left-quote.svg": [
		2256,
		9,
		1606
	],
	"./components/BlogSection/img/next-arrow.svg": [
		2257,
		9,
		1607
	],
	"./components/BlogSection/img/prev-arrow.svg": [
		2258,
		9,
		1608
	],
	"./components/BlogSection/img/right-quote.svg": [
		2259,
		9,
		1609
	],
	"./components/BlogSection/img/user.png": [
		2260,
		9,
		2949
	],
	"./components/BusinessModels/BusinessModels": [
		236,
		9,
		9,
		174
	],
	"./components/BusinessModels/BusinessModels.js": [
		236,
		9,
		9,
		174
	],
	"./components/BusinessModels/BusinessModels.scss": [
		1007,
		7,
		867
	],
	"./components/BusinessModels/imgs/arrows2.svg": [
		1010,
		9,
		1610
	],
	"./components/BusinessModels/imgs/arrows3.svg": [
		1011,
		9,
		1611
	],
	"./components/BusinessModels/imgs/client.svg": [
		1014,
		9,
		1612
	],
	"./components/BusinessModels/imgs/clock.svg": [
		1013,
		9,
		1613
	],
	"./components/BusinessModels/imgs/code-arrow.svg": [
		1009,
		9,
		1614
	],
	"./components/BusinessModels/imgs/d1.svg": [
		1015,
		9,
		1615
	],
	"./components/BusinessModels/imgs/d2.svg": [
		1016,
		9,
		1616
	],
	"./components/BusinessModels/imgs/d3.svg": [
		1017,
		9,
		1617
	],
	"./components/BusinessModels/imgs/money-arrow.svg": [
		1008,
		9,
		1618
	],
	"./components/BusinessModels/imgs/pm.svg": [
		1012,
		9,
		1619
	],
	"./components/CallToAction/CallToAction": [
		201,
		9,
		301
	],
	"./components/CallToAction/CallToAction.js": [
		201,
		9,
		301
	],
	"./components/CallToAction/CallToAction.scss": [
		881,
		7,
		868
	],
	"./components/CallToAction/img/arrow-white.svg": [
		2261,
		9,
		1620
	],
	"./components/CallToAction/img/grediant-bg.svg": [
		2262,
		9,
		1621
	],
	"./components/CantFindTechnology/CantFindTechnology": [
		205,
		9,
		671
	],
	"./components/CantFindTechnology/CantFindTechnology.js": [
		205,
		9,
		671
	],
	"./components/CantFindTechnology/CantFindTechnology.scss": [
		914,
		7,
		869
	],
	"./components/CantFindTechnologyBlack/CantFindTechnologyBlack": [
		227,
		9,
		510
	],
	"./components/CantFindTechnologyBlack/CantFindTechnologyBlack.js": [
		227,
		9,
		510
	],
	"./components/CantFindTechnologyBlack/CantFindTechnologyBlack.scss": [
		973,
		7,
		870
	],
	"./components/CaseStudy/CaseStudy": [
		669,
		9,
		0,
		3,
		11,
		1,
		172
	],
	"./components/CaseStudy/CaseStudy.js": [
		669,
		9,
		0,
		3,
		11,
		1,
		172
	],
	"./components/CaseStudy/CaseStudy.scss": [
		1662,
		7,
		871
	],
	"./components/CaseStudy/CaseStudyList": [
		226,
		9,
		672
	],
	"./components/CaseStudy/CaseStudyList.js": [
		226,
		9,
		672
	],
	"./components/CaseStudy/img/CS CArt.svg": [
		2263,
		9,
		1622
	],
	"./components/CaseStudy/img/Engintron.svg": [
		2264,
		9,
		1623
	],
	"./components/CaseStudy/img/Flutter.svg": [
		2265,
		9,
		1624
	],
	"./components/CaseStudy/img/Golang.svg": [
		2266,
		9,
		1625
	],
	"./components/CaseStudy/img/Ionic.svg": [
		2267,
		9,
		1626
	],
	"./components/CaseStudy/img/Java.svg": [
		2268,
		9,
		1627
	],
	"./components/CaseStudy/img/Laravel.svg": [
		2269,
		9,
		1628
	],
	"./components/CaseStudy/img/Objective-C.svg": [
		2270,
		9,
		1629
	],
	"./components/CaseStudy/img/React.svg": [
		2271,
		9,
		1630
	],
	"./components/CaseStudy/img/Vue.svg": [
		2272,
		9,
		1631
	],
	"./components/CaseStudy/img/angular.svg": [
		2273,
		9,
		1632
	],
	"./components/CaseStudy/img/client.png": [
		2274,
		9,
		2950
	],
	"./components/CaseStudy/img/download.svg": [
		1005,
		9,
		1633
	],
	"./components/CaseStudy/img/feature1.png": [
		2275,
		9,
		2951
	],
	"./components/CaseStudy/img/feature2.png": [
		2276,
		9,
		2952
	],
	"./components/CaseStudy/img/hero-bg.jpg": [
		2277,
		9,
		2953
	],
	"./components/CaseStudy/img/html.svg": [
		2278,
		9,
		1634
	],
	"./components/CaseStudy/img/kotlin.svg": [
		2279,
		9,
		1635
	],
	"./components/CaseStudy/img/mongoDB.svg": [
		2280,
		9,
		1636
	],
	"./components/CaseStudy/img/mySQL.svg": [
		2281,
		9,
		1637
	],
	"./components/CaseStudy/img/node.svg": [
		2282,
		9,
		1638
	],
	"./components/CaseStudy/img/orange-quote.svg": [
		2283,
		9,
		1639
	],
	"./components/CaseStudy/img/qaar-appicon.png": [
		1004,
		9,
		2954
	],
	"./components/CaseStudy/img/swift.svg": [
		2284,
		9,
		1640
	],
	"./components/CaseStudy/img/tick.svg": [
		2285,
		9,
		1641
	],
	"./components/CaseStudy/img/video.png": [
		2286,
		9,
		2955
	],
	"./components/CaseStudy/img/view.svg": [
		2287,
		9,
		1642
	],
	"./components/CaseStudy/new-imgs/app-store.svg": [
		1666,
		9,
		1643
	],
	"./components/CaseStudy/new-imgs/close.svg": [
		1665,
		9,
		1644
	],
	"./components/CaseStudy/new-imgs/next.svg": [
		1664,
		9,
		1645
	],
	"./components/CaseStudy/new-imgs/play-store.svg": [
		1667,
		9,
		1646
	],
	"./components/CaseStudy/new-imgs/prev.svg": [
		1663,
		9,
		1647
	],
	"./components/CaseStudy/new-imgs/tick.svg": [
		2288,
		9,
		1648
	],
	"./components/CaseStudyHeader/CaseStudyHeader": [
		670,
		9,
		673
	],
	"./components/CaseStudyHeader/CaseStudyHeader.js": [
		670,
		9,
		673
	],
	"./components/CaseStudyHeader/CaseStudyHeader.scss": [
		1668,
		7,
		872
	],
	"./components/Christmas/Hero/Hero": [
		671,
		9,
		794
	],
	"./components/Christmas/Hero/Hero.js": [
		671,
		9,
		794
	],
	"./components/Christmas/Lights/Lights": [
		672,
		9,
		674
	],
	"./components/Christmas/Lights/Lights.js": [
		672,
		9,
		674
	],
	"./components/Christmas/Lights/Lights.scss": [
		1669,
		7,
		873
	],
	"./components/Christmas/Reindeer/Reindeer": [
		673,
		9,
		675
	],
	"./components/Christmas/Reindeer/Reindeer.js": [
		673,
		9,
		675
	],
	"./components/Christmas/Reindeer/Reindeer.scss": [
		1670,
		7,
		874
	],
	"./components/Christmas/Snow-2021/Snow-2021": [
		675,
		9,
		143,
		795
	],
	"./components/Christmas/Snow-2021/Snow-2021.js": [
		675,
		9,
		143,
		795
	],
	"./components/Christmas/Snow-2021/Snow-2021.scss": [
		2136,
		7,
		143
	],
	"./components/Christmas/Snow/Snow": [
		674,
		9,
		796
	],
	"./components/Christmas/Snow/Snow.js": [
		674,
		9,
		796
	],
	"./components/ClientLogos/ClientLogos": [
		578,
		9,
		407
	],
	"./components/ClientLogos/ClientLogos.js": [
		578,
		9,
		407
	],
	"./components/ClientLogos/imgs/client-logos/athlean-x.svg": [
		1513,
		9,
		1649
	],
	"./components/ClientLogos/imgs/client-logos/baya.svg": [
		1514,
		9,
		1650
	],
	"./components/ClientLogos/imgs/client-logos/go-pro.svg": [
		2289,
		9,
		1651
	],
	"./components/ClientLogos/imgs/client-logos/imdex.svg": [
		1512,
		9,
		1652
	],
	"./components/ClientLogos/imgs/client-logos/justfab.svg": [
		1509,
		9,
		1653
	],
	"./components/ClientLogos/imgs/client-logos/maersk.svg": [
		1510,
		9,
		1654
	],
	"./components/ClientLogos/imgs/client-logos/panasonic.svg": [
		1511,
		9,
		1655
	],
	"./components/ClientLogos/imgs/client-logos/pigi.svg": [
		1515,
		9,
		1656
	],
	"./components/ClientNewLogos/ClientNewLogos": [
		247,
		9,
		3,
		203
	],
	"./components/ClientNewLogos/ClientNewLogos.js": [
		247,
		9,
		3,
		203
	],
	"./components/ClientNewLogos/ClientNewLogos.scss": [
		1051,
		7,
		875
	],
	"./components/ClientNewLogos/Helponymous.png": [
		2290,
		9,
		2956
	],
	"./components/ClientNewLogos/img/athlean-x.svg": [
		2291,
		9,
		1657
	],
	"./components/ClientNewLogos/img/baya.svg": [
		2292,
		9,
		1658
	],
	"./components/ClientNewLogos/img/helponymous.svg": [
		2293,
		9,
		1659
	],
	"./components/ClientNewLogos/img/imdexblack.svg": [
		2294,
		9,
		1660
	],
	"./components/ClientNewLogos/img/justfab.svg": [
		2295,
		9,
		1661
	],
	"./components/ClientNewLogos/img/maersk.svg": [
		2296,
		9,
		1662
	],
	"./components/ClientNewLogos/img/panasonic.svg": [
		2297,
		9,
		1663
	],
	"./components/ClientNewLogos/img/pigi.svg": [
		2298,
		9,
		1664
	],
	"./components/ClientNewLogos/imgs/chefking.svg": [
		1052,
		9,
		1665
	],
	"./components/ClientNewLogos/imgs/creative-food.svg": [
		1053,
		9,
		1666
	],
	"./components/ClientNewLogos/imgs/itc.svg": [
		1054,
		9,
		1667
	],
	"./components/ClientNewLogos/imgs/moneymaker.svg": [
		1058,
		9,
		1668
	],
	"./components/ClientNewLogos/imgs/pioneer.svg": [
		1055,
		9,
		1669
	],
	"./components/ClientNewLogos/imgs/pn-builder.svg": [
		1056,
		9,
		1670
	],
	"./components/ClientNewLogos/imgs/pure.svg": [
		1059,
		9,
		1671
	],
	"./components/ClientNewLogos/imgs/voyage.svg": [
		1057,
		9,
		1672
	],
	"./components/ClientsSection/ClientsSection": [
		676,
		9,
		3,
		164
	],
	"./components/ClientsSection/ClientsSection.js": [
		676,
		9,
		3,
		164
	],
	"./components/ClientsSection/ClientsSection.scss": [
		1671,
		7,
		876
	],
	"./components/CodingStandards/CodingStandards": [
		214,
		9,
		447
	],
	"./components/CodingStandards/CodingStandards.js": [
		214,
		9,
		447
	],
	"./components/CompanyStatistics/CompanyStatistics": [
		210,
		9,
		448
	],
	"./components/CompanyStatistics/CompanyStatistics.js": [
		210,
		9,
		448
	],
	"./components/CompanyStatistics/CompanyStatistics.scss": [
		919,
		7,
		877
	],
	"./components/CookiePopup/CookiePopup": [
		108,
		9,
		141
	],
	"./components/CookiePopup/CookiePopup.js": [
		108,
		9,
		141
	],
	"./components/CookiePopup/CookiePopup.scss": [
		1625,
		7,
		878
	],
	"./components/Cursor/Cursor": [
		677,
		9,
		676
	],
	"./components/Cursor/Cursor.js": [
		677,
		9,
		676
	],
	"./components/Cursor/Cursor.scss": [
		1672,
		7,
		879
	],
	"./components/DecorativeCircles/BigCircle": [
		196,
		9,
		677
	],
	"./components/DecorativeCircles/BigCircle.js": [
		196,
		9,
		677
	],
	"./components/DecorativeCircles/DecorativeCircles.scss": [
		877,
		7,
		880
	],
	"./components/DecorativeCircles/SmallCircle": [
		195,
		9,
		678
	],
	"./components/DecorativeCircles/SmallCircle.js": [
		195,
		9,
		678
	],
	"./components/DevelopmentTypes/DevelopmentTypes": [
		229,
		9,
		679
	],
	"./components/DevelopmentTypes/DevelopmentTypes.js": [
		229,
		9,
		679
	],
	"./components/DevelopmentTypes/DevelopmentTypes.scss": [
		978,
		7,
		881
	],
	"./components/FaqSection/FaqSection": [
		678,
		9,
		210
	],
	"./components/FaqSection/FaqSection.js": [
		678,
		9,
		210
	],
	"./components/FaqSection/FaqSection.scss": [
		1673,
		7,
		882
	],
	"./components/FaqSectionNew/FaqSectionNew": [
		202,
		9,
		178
	],
	"./components/FaqSectionNew/FaqSectionNew.js": [
		202,
		9,
		178
	],
	"./components/FaqSectionNew/FaqSectionNew.scss": [
		884,
		7,
		883
	],
	"./components/Footer/FollowUs/FollowUs": [
		232,
		9,
		401
	],
	"./components/Footer/FollowUs/FollowUs.js": [
		232,
		9,
		401
	],
	"./components/Footer/FollowUs/FollowUs.scss": [
		984,
		7,
		884
	],
	"./components/Footer/Footer": [
		106,
		9,
		81
	],
	"./components/Footer/Footer.js": [
		106,
		9,
		81
	],
	"./components/Footer/Footer.scss": [
		1613,
		7,
		885
	],
	"./components/Footer/ForCareerInquiry/ForCareerInquiry": [
		231,
		9,
		797
	],
	"./components/Footer/ForCareerInquiry/ForCareerInquiry.js": [
		231,
		9,
		797
	],
	"./components/Footer/ForWorkInquiry/ForWorkInquiry": [
		230,
		9,
		798
	],
	"./components/Footer/ForWorkInquiry/ForWorkInquiry.js": [
		230,
		9,
		798
	],
	"./components/Footer/GlobalPresence/GloblePresence": [
		244,
		9,
		680
	],
	"./components/Footer/GlobalPresence/GloblePresence.js": [
		244,
		9,
		680
	],
	"./components/Footer/GlobalPresence/GloblePresence.scss": [
		1041,
		7,
		886
	],
	"./components/Footer/imgs/behance.svg": [
		989,
		9,
		1673
	],
	"./components/Footer/imgs/dribbble.svg": [
		985,
		9,
		1674
	],
	"./components/Footer/imgs/facebook.svg": [
		986,
		9,
		1675
	],
	"./components/Footer/imgs/instagram.svg": [
		988,
		9,
		1676
	],
	"./components/Footer/imgs/linkedIn.svg": [
		987,
		9,
		1677
	],
	"./components/Footer/imgs/medium.svg": [
		2299,
		9,
		1678
	],
	"./components/Footer/imgs/pinterest.svg": [
		2300,
		9,
		1679
	],
	"./components/Footer/imgs/twitter.svg": [
		990,
		9,
		1680
	],
	"./components/Footer/imgs/youtube.svg": [
		2301,
		9,
		1681
	],
	"./components/GridLines/GridLines": [
		19,
		9
	],
	"./components/GridLines/GridLines.js": [
		19,
		9
	],
	"./components/GridLines/GridLines.scss": [
		189,
		7
	],
	"./components/Header/Header": [
		50,
		9
	],
	"./components/Header/Header.js": [
		50,
		9
	],
	"./components/Header/Header.scss": [
		191,
		7
	],
	"./components/Header/img/hiring.svg": [
		75,
		9
	],
	"./components/Header/img/hiring.webp": [
		2302,
		9,
		1682
	],
	"./components/Header/img/right-arrow.svg": [
		76,
		9
	],
	"./components/Header/img/right-arrow.webp": [
		2303,
		9,
		1683
	],
	"./components/HelmetSeo/HelmetSeo": [
		199,
		9,
		0,
		263
	],
	"./components/HelmetSeo/HelmetSeo.js": [
		199,
		9,
		0,
		263
	],
	"./components/HireSection/HireSection": [
		223,
		9,
		267
	],
	"./components/HireSection/HireSection.js": [
		223,
		9,
		267
	],
	"./components/HireSection/HireSection.scss": [
		969,
		7,
		887
	],
	"./components/HiringProcess/HiringProcess": [
		213,
		9,
		298
	],
	"./components/HiringProcess/HiringProcess.js": [
		213,
		9,
		298
	],
	"./components/HiringProcess/HiringProcess.scss": [
		924,
		7,
		888
	],
	"./components/HiringProcess/imgs/inquire.svg": [
		920,
		9,
		1684
	],
	"./components/HiringProcess/imgs/interview.svg": [
		922,
		9,
		1685
	],
	"./components/HiringProcess/imgs/select-cv.svg": [
		921,
		9,
		1686
	],
	"./components/HiringProcess/imgs/team.svg": [
		923,
		9,
		1687
	],
	"./components/IndustriesSection/IndustriesSection": [
		679,
		9,
		167
	],
	"./components/IndustriesSection/IndustriesSection.js": [
		679,
		9,
		167
	],
	"./components/IndustriesSection/IndustriesSection.scss": [
		1674,
		7,
		889
	],
	"./components/IndustriesSection/imgs/banking-1.png": [
		2304,
		9,
		2957
	],
	"./components/IndustriesSection/imgs/banking-2.png": [
		2305,
		9,
		2958
	],
	"./components/IndustriesSection/imgs/ecommerce-1.png": [
		2306,
		9,
		2959
	],
	"./components/IndustriesSection/imgs/ecommerce-2.png": [
		2307,
		9,
		2960
	],
	"./components/IndustriesSection/imgs/education-1.png": [
		2308,
		9,
		2961
	],
	"./components/IndustriesSection/imgs/education-2.png": [
		2309,
		9,
		2962
	],
	"./components/IndustriesSection/imgs/entertainment-1.png": [
		1685,
		9,
		2963
	],
	"./components/IndustriesSection/imgs/entertainment-2.png": [
		2310,
		9,
		2964
	],
	"./components/IndustriesSection/imgs/food-1.png": [
		2311,
		9,
		2965
	],
	"./components/IndustriesSection/imgs/food-1.webp": [
		2312,
		9,
		1688
	],
	"./components/IndustriesSection/imgs/food-2.png": [
		2313,
		9,
		2966
	],
	"./components/IndustriesSection/imgs/food-2.webp": [
		2314,
		9,
		1689
	],
	"./components/IndustriesSection/imgs/health-1.png": [
		2315,
		9,
		2967
	],
	"./components/IndustriesSection/imgs/health-2.png": [
		2316,
		9,
		2968
	],
	"./components/IndustriesSection/imgs/sports-1.png": [
		2317,
		9,
		2969
	],
	"./components/IndustriesSection/imgs/sports-2.png": [
		2318,
		9,
		2970
	],
	"./components/IndustriesSection/imgs/travel-1.png": [
		2319,
		9,
		2971
	],
	"./components/IndustriesSection/imgs/travel-2.png": [
		2320,
		9,
		2972
	],
	"./components/IndustriesSection/updatedImgs/banking-1.webp": [
		1679,
		9,
		1690
	],
	"./components/IndustriesSection/updatedImgs/banking-2.webp": [
		1680,
		9,
		1691
	],
	"./components/IndustriesSection/updatedImgs/e-commerce-2.webp": [
		1682,
		9,
		1692
	],
	"./components/IndustriesSection/updatedImgs/ecommerce-1.webp": [
		1681,
		9,
		1693
	],
	"./components/IndustriesSection/updatedImgs/education-1.webp": [
		1677,
		9,
		1694
	],
	"./components/IndustriesSection/updatedImgs/education-2.webp": [
		1678,
		9,
		1695
	],
	"./components/IndustriesSection/updatedImgs/entertainment-1.webp": [
		1686,
		9,
		1696
	],
	"./components/IndustriesSection/updatedImgs/food-1.webp": [
		1675,
		9,
		1697
	],
	"./components/IndustriesSection/updatedImgs/food-2.webp": [
		1676,
		9,
		1698
	],
	"./components/IndustriesSection/updatedImgs/health-1.webp": [
		1683,
		9,
		1699
	],
	"./components/IndustriesSection/updatedImgs/health-2.webp": [
		1684,
		9,
		1700
	],
	"./components/IndustriesSection/updatedImgs/sport-1.webp": [
		1689,
		9,
		1701
	],
	"./components/IndustriesSection/updatedImgs/sport-2.webp": [
		1690,
		9,
		1702
	],
	"./components/IndustriesSection/updatedImgs/travel-1.webp": [
		1687,
		9,
		1703
	],
	"./components/IndustriesSection/updatedImgs/travel-2.webp": [
		1688,
		9,
		1704
	],
	"./components/LetsDisussYourProject/LetsDisussYourProject": [
		680,
		9,
		482
	],
	"./components/LetsDisussYourProject/LetsDisussYourProject.js": [
		680,
		9,
		482
	],
	"./components/LetsDisussYourProject/LetsDisussYourProject.scss": [
		1691,
		7,
		890
	],
	"./components/Libraries/Libraries": [
		681,
		9,
		211
	],
	"./components/Libraries/Libraries.js": [
		681,
		9,
		211
	],
	"./components/Libraries/Libraries.scss": [
		1692,
		7,
		891
	],
	"./components/Menu/CompanyTab": [
		38,
		9
	],
	"./components/Menu/CompanyTab.js": [
		38,
		9
	],
	"./components/Menu/ExtensionTab": [
		37,
		9
	],
	"./components/Menu/ExtensionTab.js": [
		37,
		9
	],
	"./components/Menu/Menu": [
		49,
		9
	],
	"./components/Menu/Menu.js": [
		49,
		9
	],
	"./components/Menu/Menu.scss": [
		190,
		7
	],
	"./components/Menu/ServicesTab": [
		35,
		9
	],
	"./components/Menu/ServicesTab.js": [
		35,
		9
	],
	"./components/Menu/SolutionsTab": [
		36,
		9
	],
	"./components/Menu/SolutionsTab.js": [
		36,
		9
	],
	"./components/MoreButton/MoreButton": [
		208,
		9,
		681
	],
	"./components/MoreButton/MoreButton.js": [
		208,
		9,
		681
	],
	"./components/MoreButton/MoreButton.scss": [
		916,
		7,
		892
	],
	"./components/NewButtons/NewMoreButton/MoreButton": [
		682,
		9,
		682
	],
	"./components/NewButtons/NewMoreButton/MoreButton.js": [
		682,
		9,
		682
	],
	"./components/NewButtons/NewMoreButton/MoreButton.scss": [
		1693,
		7,
		893
	],
	"./components/NewButtons/NewMoreButton/NewMoreButton": [
		197,
		9,
		683
	],
	"./components/NewButtons/NewMoreButton/NewMoreButton.js": [
		197,
		9,
		683
	],
	"./components/NewButtons/NewMoreButton/NewMoreButton.scss": [
		883,
		7,
		894
	],
	"./components/NewButtons/NewMoreButton/l-arrow.svg": [
		2321,
		9,
		1705
	],
	"./components/NewButtons/NewMoreButton/r-arrow.svg": [
		2322,
		9,
		1706
	],
	"./components/NewFooter/FooterInquiryform/FooterInquiryform": [
		657,
		9,
		5,
		7,
		10,
		13
	],
	"./components/NewFooter/FooterInquiryform/FooterInquiryform.js": [
		657,
		9,
		5,
		7,
		10,
		13
	],
	"./components/NewFooter/FooterInquiryform/FooterInquiryform.scss": [
		1624,
		7,
		895
	],
	"./components/NewFooter/NewFooter": [
		107,
		9,
		5,
		7,
		10,
		13,
		82
	],
	"./components/NewFooter/NewFooter.js": [
		107,
		9,
		5,
		7,
		10,
		13,
		82
	],
	"./components/NewFooter/NewFooter.scss": [
		1614,
		7,
		896
	],
	"./components/NewFooter/img/address.svg": [
		1615,
		9,
		1707
	],
	"./components/NewFooter/img/call.svg": [
		1616,
		9,
		1708
	],
	"./components/NewFooter/img/email.svg": [
		1617,
		9,
		1709
	],
	"./components/NewFooter/img/four.svg": [
		2323,
		9,
		1710
	],
	"./components/NewFooter/img/mi-logo-footer.svg": [
		2324,
		9,
		1711
	],
	"./components/NewFooter/img/oceanshark-footer-logo.svg": [
		2325,
		9,
		1712
	],
	"./components/NewFooter/img/one.svg": [
		2326,
		9,
		1713
	],
	"./components/NewFooter/img/skype.svg": [
		2327,
		9,
		1714
	],
	"./components/NewFooter/img/social-media/behance.svg": [
		1622,
		9,
		1715
	],
	"./components/NewFooter/img/social-media/dribbble.svg": [
		1618,
		9,
		1716
	],
	"./components/NewFooter/img/social-media/facebook.svg": [
		1619,
		9,
		1717
	],
	"./components/NewFooter/img/social-media/instagram.svg": [
		1621,
		9,
		1718
	],
	"./components/NewFooter/img/social-media/linkedIn.svg": [
		1620,
		9,
		1719
	],
	"./components/NewFooter/img/social-media/medium.svg": [
		2328,
		9,
		1720
	],
	"./components/NewFooter/img/social-media/pinterest.svg": [
		2329,
		9,
		1721
	],
	"./components/NewFooter/img/social-media/twitter.svg": [
		1623,
		9,
		1722
	],
	"./components/NewFooter/img/social-media/youtube.svg": [
		2330,
		9,
		1723
	],
	"./components/NewFooter/img/three.svg": [
		2331,
		9,
		1724
	],
	"./components/NewFooter/img/two.svg": [
		2332,
		9,
		1725
	],
	"./components/NewLookingOtherServices/NewLookingOtherServices": [
		209,
		9,
		155
	],
	"./components/NewLookingOtherServices/NewLookingOtherServices.js": [
		209,
		9,
		155
	],
	"./components/NewLookingOtherServices/NewLookingOtherServices.scss": [
		936,
		7,
		897
	],
	"./components/NewLookingOtherServices/img/android.svg": [
		937,
		9,
		1726
	],
	"./components/NewLookingOtherServices/img/angular.svg": [
		953,
		9,
		1727
	],
	"./components/NewLookingOtherServices/img/backbonejs.svg": [
		952,
		9,
		1728
	],
	"./components/NewLookingOtherServices/img/cloud-computing.svg": [
		961,
		9,
		1729
	],
	"./components/NewLookingOtherServices/img/devops.svg": [
		956,
		9,
		1730
	],
	"./components/NewLookingOtherServices/img/digital-transformation.svg": [
		960,
		9,
		1731
	],
	"./components/NewLookingOtherServices/img/enterprise-app.svg": [
		962,
		9,
		1732
	],
	"./components/NewLookingOtherServices/img/flutter.svg": [
		941,
		9,
		1733
	],
	"./components/NewLookingOtherServices/img/full-stack.svg": [
		927,
		9,
		1734
	],
	"./components/NewLookingOtherServices/img/golang.svg": [
		948,
		9,
		1735
	],
	"./components/NewLookingOtherServices/img/hire-dedicated.svg": [
		942,
		9,
		1736
	],
	"./components/NewLookingOtherServices/img/hire-qa.svg": [
		943,
		9,
		1737
	],
	"./components/NewLookingOtherServices/img/ibeacon.svg": [
		958,
		9,
		1738
	],
	"./components/NewLookingOtherServices/img/ionic.svg": [
		945,
		9,
		1739
	],
	"./components/NewLookingOtherServices/img/ios.svg": [
		925,
		9,
		1740
	],
	"./components/NewLookingOtherServices/img/iot.svg": [
		954,
		9,
		1741
	],
	"./components/NewLookingOtherServices/img/javascript.svg": [
		939,
		9,
		1742
	],
	"./components/NewLookingOtherServices/img/laravel.svg": [
		947,
		9,
		1743
	],
	"./components/NewLookingOtherServices/img/meteoter.svg": [
		951,
		9,
		1744
	],
	"./components/NewLookingOtherServices/img/mobile-app-development.svg": [
		946,
		9,
		1745
	],
	"./components/NewLookingOtherServices/img/nodejs.svg": [
		964,
		9,
		1746
	],
	"./components/NewLookingOtherServices/img/otherservice-bg.png": [
		2333,
		9,
		2973
	],
	"./components/NewLookingOtherServices/img/php.svg": [
		950,
		9,
		1747
	],
	"./components/NewLookingOtherServices/img/product-eng.svg": [
		959,
		9,
		1748
	],
	"./components/NewLookingOtherServices/img/python.svg": [
		949,
		9,
		1749
	],
	"./components/NewLookingOtherServices/img/react.svg": [
		944,
		9,
		1750
	],
	"./components/NewLookingOtherServices/img/startup-services.svg": [
		957,
		9,
		1751
	],
	"./components/NewLookingOtherServices/img/swift.svg": [
		926,
		9,
		1752
	],
	"./components/NewLookingOtherServices/img/uiux.svg": [
		940,
		9,
		1753
	],
	"./components/NewLookingOtherServices/img/vue js.svg": [
		963,
		9,
		1754
	],
	"./components/NewLookingOtherServices/img/wearable.svg": [
		955,
		9,
		1755
	],
	"./components/NewLookingOtherServices/img/web-development.svg": [
		938,
		9,
		1756
	],
	"./components/NewMenu/MiHeader": [
		46,
		9
	],
	"./components/NewMenu/MiHeader.js": [
		46,
		9
	],
	"./components/NewMenu/MiHeader.scss": [
		43,
		7
	],
	"./components/NewMenu/MiMobileDropdown": [
		48,
		9
	],
	"./components/NewMenu/MiMobileDropdown.js": [
		48,
		9
	],
	"./components/NewMenu/MiMobileDropdownItem": [
		51,
		9
	],
	"./components/NewMenu/MiMobileDropdownItem.js": [
		51,
		9
	],
	"./components/NewMenu/MiMobileHeader": [
		47,
		9
	],
	"./components/NewMenu/MiMobileHeader.js": [
		47,
		9
	],
	"./components/NewMenu/MiMobileHeader.scss": [
		44,
		7
	],
	"./components/NewMenu/MiNav": [
		18,
		9
	],
	"./components/NewMenu/MiNav.js": [
		18,
		9
	],
	"./components/NewMenu/NavAbout": [
		683,
		9,
		786
	],
	"./components/NewMenu/NavAbout.js": [
		683,
		9,
		786
	],
	"./components/NewMenu/NavHire": [
		27,
		9
	],
	"./components/NewMenu/NavHire.js": [
		27,
		9
	],
	"./components/NewMenu/NavHire.scss": [
		105,
		7
	],
	"./components/NewMenu/NavServices": [
		25,
		9
	],
	"./components/NewMenu/NavServices.js": [
		25,
		9
	],
	"./components/NewMenu/NavSolutions": [
		26,
		9
	],
	"./components/NewMenu/NavSolutions.js": [
		26,
		9
	],
	"./components/NewReviews/NewReviews": [
		248,
		9,
		3,
		264
	],
	"./components/NewReviews/NewReviews.js": [
		248,
		9,
		3,
		264
	],
	"./components/NewReviews/NewReviews.scss": [
		1060,
		7,
		898
	],
	"./components/NewReviews/img/andrej-fister.jpeg": [
		2334,
		9,
		2974
	],
	"./components/NewReviews/img/daniel.png": [
		2335,
		9,
		2975
	],
	"./components/NewReviews/img/employee/bhumika.svg": [
		2336,
		9,
		1757
	],
	"./components/NewReviews/img/employee/darshan.svg": [
		2337,
		9,
		1758
	],
	"./components/NewReviews/img/employee/digvijay.svg": [
		2338,
		9,
		1759
	],
	"./components/NewReviews/img/employee/harsal.svg": [
		2339,
		9,
		1760
	],
	"./components/NewReviews/img/employee/manoj.svg": [
		2340,
		9,
		1761
	],
	"./components/NewReviews/img/employee/neha.svg": [
		2341,
		9,
		1762
	],
	"./components/NewReviews/img/jean.webp": [
		2342,
		9,
		1763
	],
	"./components/NewReviews/img/left-quote.svg": [
		2343,
		9,
		1764
	],
	"./components/NewReviews/img/next-arrow.svg": [
		2344,
		9,
		1765
	],
	"./components/NewReviews/img/prev-arrow.svg": [
		2345,
		9,
		1766
	],
	"./components/NewReviews/img/right-quote.svg": [
		2346,
		9,
		1767
	],
	"./components/NewReviews/img/taylor.jpeg": [
		2347,
		9,
		2976
	],
	"./components/NewReviews/img/user.png": [
		2348,
		9,
		2977
	],
	"./components/NewsLetter/NewsLetter": [
		684,
		9,
		5,
		7,
		626
	],
	"./components/NewsLetter/NewsLetter.js": [
		684,
		9,
		5,
		7,
		626
	],
	"./components/NewsLetter/NewsLetter.scss": [
		1694,
		7,
		899
	],
	"./components/NextCase/NextCase": [
		235,
		9,
		684
	],
	"./components/NextCase/NextCase.js": [
		235,
		9,
		684
	],
	"./components/NextCase/NextCase.scss": [
		1006,
		7,
		900
	],
	"./components/NextCase/daily-deals.png": [
		2349,
		9,
		2978
	],
	"./components/NextCase/right-arrow.svg": [
		2350,
		9,
		1768
	],
	"./components/NumericInfo/NumericInfo": [
		198,
		9,
		632
	],
	"./components/NumericInfo/NumericInfo.js": [
		198,
		9,
		632
	],
	"./components/NumericInfo/NumericInfo.scss": [
		879,
		7,
		901
	],
	"./components/NumericInfoPortfolio/NumericInfoPortfolio": [
		204,
		9,
		633
	],
	"./components/NumericInfoPortfolio/NumericInfoPortfolio.js": [
		204,
		9,
		633
	],
	"./components/NumericInfoPortfolio/NumericInfoPortfolio.scss": [
		913,
		7,
		902
	],
	"./components/OpenSourceLibraries/OpenSourceLibraries": [
		685,
		9,
		179
	],
	"./components/OpenSourceLibraries/OpenSourceLibraries.js": [
		685,
		9,
		179
	],
	"./components/OpenSourceLibraries/OpenSourceLibraries.scss": [
		1695,
		7,
		903
	],
	"./components/OpenSourceLibraries/imgs/1.jpg": [
		1696,
		9,
		2979
	],
	"./components/OpenSourceLibraries/imgs/2.jpg": [
		1697,
		9,
		2980
	],
	"./components/OpenSourceLibraries/imgs/3.jpg": [
		1698,
		9,
		2981
	],
	"./components/OpenSourceLibraries/imgs/4.jpg": [
		1699,
		9,
		2982
	],
	"./components/OurApproach/OurApproach": [
		215,
		9,
		502
	],
	"./components/OurApproach/OurApproach.js": [
		215,
		9,
		502
	],
	"./components/OurNewIndustry/OurNewIndustry": [
		221,
		9,
		3,
		237
	],
	"./components/OurNewIndustry/OurNewIndustry.js": [
		221,
		9,
		3,
		237
	],
	"./components/OurNewIndustry/OurNewIndustry.scss": [
		935,
		7,
		904
	],
	"./components/OurNewIndustry/SolutionSection": [
		218,
		9,
		3,
		613
	],
	"./components/OurNewIndustry/SolutionSection.js": [
		218,
		9,
		3,
		613
	],
	"./components/OurNewIndustry/SolutionSection.scss": [
		934,
		7,
		905
	],
	"./components/OurNewIndustry/img/right-arrow.svg": [
		2351,
		9,
		1769
	],
	"./components/OurNewIndustry/industry-img/Meditation.webp": [
		2352,
		9,
		1770
	],
	"./components/OurNewIndustry/industry-img/big-one.png": [
		2353,
		9,
		2983
	],
	"./components/OurNewIndustry/industry-img/small-one.png": [
		2354,
		9,
		2984
	],
	"./components/OurNewIndustry/industry-img/small-two.png": [
		2355,
		9,
		2985
	],
	"./components/OurWorksOthers/OurWorksOther": [
		203,
		9,
		6,
		811
	],
	"./components/OurWorksOthers/OurWorksOther.js": [
		203,
		9,
		6,
		811
	],
	"./components/OurWorksOthers/OurWorksOther.scss": [
		915,
		7,
		906
	],
	"./components/PointsContent/PointsContent": [
		207,
		9,
		685
	],
	"./components/PointsContent/PointsContent.js": [
		207,
		9,
		685
	],
	"./components/PointsContent/PointsContent.scss": [
		918,
		7,
		907
	],
	"./components/PortfolioSection/MoreWorkInfo": [
		219,
		9,
		787
	],
	"./components/PortfolioSection/MoreWorkInfo.js": [
		219,
		9,
		787
	],
	"./components/PortfolioSection/PortfolioList": [
		56,
		9
	],
	"./components/PortfolioSection/PortfolioList.js": [
		56,
		9
	],
	"./components/PortfolioSection/PortfolioSection": [
		222,
		9,
		176
	],
	"./components/PortfolioSection/PortfolioSection.js": [
		222,
		9,
		176
	],
	"./components/PortfolioSection/PortfolioSection.scss": [
		965,
		7,
		908
	],
	"./components/PortfolioSection/PortfolioVideo": [
		30,
		9
	],
	"./components/PortfolioSection/PortfolioVideo.js": [
		30,
		9
	],
	"./components/PortfolioSection/graphic/10k-followers-thumb.png": [
		2356,
		9,
		2986
	],
	"./components/PortfolioSection/graphic/ajc-construction-thumb.png": [
		2357,
		9,
		2987
	],
	"./components/PortfolioSection/graphic/at-work-illustration-thumb.png": [
		2358,
		9,
		2988
	],
	"./components/PortfolioSection/graphic/beauty_app_desig.jpg": [
		2359,
		9,
		2989
	],
	"./components/PortfolioSection/graphic/blockchain-system-thumb.png": [
		2360,
		9,
		2990
	],
	"./components/PortfolioSection/graphic/books_wallet_app.jpg": [
		2361,
		9,
		2991
	],
	"./components/PortfolioSection/graphic/broking_website.jpg": [
		2362,
		9,
		2992
	],
	"./components/PortfolioSection/graphic/city_building_app.jpg": [
		2363,
		9,
		2993
	],
	"./components/PortfolioSection/graphic/comet-thumb.png": [
		2364,
		9,
		2994
	],
	"./components/PortfolioSection/graphic/cosmetics_app.jpg": [
		2365,
		9,
		2995
	],
	"./components/PortfolioSection/graphic/cryptocurrency-converter-thumb.png": [
		2366,
		9,
		2996
	],
	"./components/PortfolioSection/graphic/cryptocurrency-wallet-thumb.png": [
		2367,
		9,
		2997
	],
	"./components/PortfolioSection/graphic/delivery-boy-thumb.png": [
		2368,
		9,
		2998
	],
	"./components/PortfolioSection/graphic/engineer's-book-app-icon-thumb.png": [
		2369,
		9,
		2999
	],
	"./components/PortfolioSection/graphic/fitness_app.jpg": [
		2370,
		9,
		3000
	],
	"./components/PortfolioSection/graphic/flight_web_dashboard.jpg": [
		2371,
		9,
		3001
	],
	"./components/PortfolioSection/graphic/food-delivery-thumb.png": [
		2372,
		9,
		3002
	],
	"./components/PortfolioSection/graphic/food_app.jpg": [
		2373,
		9,
		3003
	],
	"./components/PortfolioSection/graphic/food_app01.jpg": [
		2374,
		9,
		3004
	],
	"./components/PortfolioSection/graphic/food_app02.jpg": [
		2375,
		9,
		3005
	],
	"./components/PortfolioSection/graphic/football_world_cup_app.jpg": [
		2376,
		9,
		3006
	],
	"./components/PortfolioSection/graphic/furniture_landing_page.jpg": [
		2377,
		9,
		3007
	],
	"./components/PortfolioSection/graphic/great_Jamaican_app_beer.jpg": [
		2378,
		9,
		3008
	],
	"./components/PortfolioSection/graphic/health_app.jpg": [
		2379,
		9,
		3009
	],
	"./components/PortfolioSection/graphic/hello-dribbble-thumb.png": [
		2380,
		9,
		3010
	],
	"./components/PortfolioSection/graphic/ibeacon-based-app-thumb.png": [
		2381,
		9,
		3011
	],
	"./components/PortfolioSection/graphic/insurance-service-thumb.png": [
		2382,
		9,
		3012
	],
	"./components/PortfolioSection/graphic/ipl-app-redesign.jpg": [
		2383,
		9,
		3013
	],
	"./components/PortfolioSection/graphic/ipl_cricket_app.jpg": [
		2384,
		9,
		3014
	],
	"./components/PortfolioSection/graphic/kids_app.jpg": [
		2385,
		9,
		3015
	],
	"./components/PortfolioSection/graphic/kids_learning_app.jpg": [
		2386,
		9,
		3016
	],
	"./components/PortfolioSection/graphic/landing-page-thumb.png": [
		2387,
		9,
		3017
	],
	"./components/PortfolioSection/graphic/money_banking_app.jpg": [
		2388,
		9,
		3018
	],
	"./components/PortfolioSection/graphic/money_transfer.jpg": [
		2389,
		9,
		3019
	],
	"./components/PortfolioSection/graphic/movie_app_design01.jpg": [
		2390,
		9,
		3020
	],
	"./components/PortfolioSection/graphic/my_new_education_app.jpg": [
		2391,
		9,
		3021
	],
	"./components/PortfolioSection/graphic/on_demand_service_app.jpg": [
		2392,
		9,
		3022
	],
	"./components/PortfolioSection/graphic/on_demand_taxi_booking_app.jpg": [
		2393,
		9,
		3023
	],
	"./components/PortfolioSection/graphic/payment_app.jpg": [
		2394,
		9,
		3024
	],
	"./components/PortfolioSection/graphic/pitchers_app.jpg": [
		2395,
		9,
		3025
	],
	"./components/PortfolioSection/graphic/real_estate_website.jpg": [
		2396,
		9,
		3026
	],
	"./components/PortfolioSection/graphic/review-page-interaction-thumb.png": [
		2397,
		9,
		3027
	],
	"./components/PortfolioSection/graphic/running-panther-thumb.png": [
		2398,
		9,
		3028
	],
	"./components/PortfolioSection/graphic/skyline-thumb.png": [
		2399,
		9,
		3029
	],
	"./components/PortfolioSection/graphic/sport_app.jpg": [
		2400,
		9,
		3030
	],
	"./components/PortfolioSection/graphic/toggle-thumb.png": [
		2401,
		9,
		3031
	],
	"./components/PortfolioSection/graphic/tracking-data-website-animation-thumb.png": [
		2402,
		9,
		3032
	],
	"./components/PortfolioSection/graphic/travel-app-thumb.png": [
		2403,
		9,
		3033
	],
	"./components/PortfolioSection/graphic/travel-web-design001.jpg": [
		2404,
		9,
		3034
	],
	"./components/PortfolioSection/graphic/travel_app.jpg": [
		2405,
		9,
		3035
	],
	"./components/PortfolioSection/graphic/travel_app_design.jpg": [
		2406,
		9,
		3036
	],
	"./components/PortfolioSection/graphic/travel_web_platform.jpg": [
		2407,
		9,
		3037
	],
	"./components/PortfolioSection/graphic/travel_web_platform_1.jpg": [
		2408,
		9,
		3038
	],
	"./components/PortfolioSection/graphic/virtual-meeting-thumb.png": [
		2409,
		9,
		3039
	],
	"./components/PortfolioSection/graphic/virtual-reality-thumb.png": [
		2410,
		9,
		3040
	],
	"./components/PortfolioSection/graphic/voice_recorder_app.jpg": [
		2411,
		9,
		3041
	],
	"./components/PortfolioSection/graphic/yoga_dashboard.jpg": [
		2412,
		9,
		3042
	],
	"./components/PortfolioSection/graphic/yoga_web.jpg": [
		2413,
		9,
		3043
	],
	"./components/PortfolioSection/imgs/7-minute-morning-routine-thumb.jpg": [
		2414,
		9,
		3044
	],
	"./components/PortfolioSection/imgs/ab-workout-app-thumb.png": [
		2415,
		9,
		3045
	],
	"./components/PortfolioSection/imgs/airstylz-thumb.jpg": [
		2416,
		9,
		3046
	],
	"./components/PortfolioSection/imgs/airstylz-thumb.png": [
		2417,
		9,
		3047
	],
	"./components/PortfolioSection/imgs/beacon-based-deals-app-thumb.jpg": [
		2418,
		9,
		3048
	],
	"./components/PortfolioSection/imgs/bread-and-bagels-thumb.jpg": [
		2419,
		9,
		3049
	],
	"./components/PortfolioSection/imgs/camera-store-app-thumb.png": [
		2420,
		9,
		3050
	],
	"./components/PortfolioSection/imgs/coupons-&-deals-app-thumb.jpg": [
		2421,
		9,
		3051
	],
	"./components/PortfolioSection/imgs/creator-thumb.jpg": [
		2422,
		9,
		3052
	],
	"./components/PortfolioSection/imgs/creator.png": [
		2423,
		9,
		3053
	],
	"./components/PortfolioSection/imgs/crew-love---social-network-app-thumb.jpg": [
		2424,
		9,
		3054
	],
	"./components/PortfolioSection/imgs/datakb.png": [
		2425,
		9,
		3055
	],
	"./components/PortfolioSection/imgs/dentalcare_thumb.jpg": [
		2426,
		9,
		3056
	],
	"./components/PortfolioSection/imgs/direct-ad.png": [
		2427,
		9,
		3057
	],
	"./components/PortfolioSection/imgs/drawing-app-thumb.png": [
		2428,
		9,
		3058
	],
	"./components/PortfolioSection/imgs/drood---drive-thrus-nearby-thumb.jpg": [
		2429,
		9,
		3059
	],
	"./components/PortfolioSection/imgs/edsmart---education-app-thumb.png": [
		2430,
		9,
		3060
	],
	"./components/PortfolioSection/imgs/engage-music-app-thumb.png": [
		2431,
		9,
		3061
	],
	"./components/PortfolioSection/imgs/enneaapp-thumb.png": [
		2432,
		9,
		3062
	],
	"./components/PortfolioSection/imgs/everly-design-thumb.jpg": [
		2433,
		9,
		3063
	],
	"./components/PortfolioSection/imgs/exchange-thumb.jpg": [
		2434,
		9,
		3064
	],
	"./components/PortfolioSection/imgs/fairswap---currency-exchange-app-thumb.png": [
		2435,
		9,
		3065
	],
	"./components/PortfolioSection/imgs/favr-leverage-your-network-thumb.jpg": [
		2436,
		9,
		3066
	],
	"./components/PortfolioSection/imgs/find-a-to-z-thumb.jpg": [
		2437,
		9,
		3067
	],
	"./components/PortfolioSection/imgs/fitness-&-cardiac-health-app-thumb.jpg": [
		2438,
		9,
		3068
	],
	"./components/PortfolioSection/imgs/flightpic-thumb.jpg": [
		2439,
		9,
		3069
	],
	"./components/PortfolioSection/imgs/food-delivery-app-thumbnail-thumb.png": [
		2440,
		9,
		3070
	],
	"./components/PortfolioSection/imgs/foodlander-thumb.jpg": [
		2441,
		9,
		3071
	],
	"./components/PortfolioSection/imgs/friendsongs-app-thumb.png": [
		2442,
		9,
		3072
	],
	"./components/PortfolioSection/imgs/friendsongs-thumb.png": [
		2443,
		9,
		3073
	],
	"./components/PortfolioSection/imgs/geargallery-app-thumb-thumb.png": [
		2444,
		9,
		3074
	],
	"./components/PortfolioSection/imgs/grocery-deals-app-thumb.png": [
		2445,
		9,
		3075
	],
	"./components/PortfolioSection/imgs/helponymo_thumb.jpg": [
		2446,
		9,
		3076
	],
	"./components/PortfolioSection/imgs/holoment.png": [
		2447,
		9,
		3077
	],
	"./components/PortfolioSection/imgs/ibeacon-deals-and-rewards-app-thumb.jpg": [
		2448,
		9,
		3078
	],
	"./components/PortfolioSection/imgs/ibeacon-deals-and-rewards-app-thumb.png": [
		2449,
		9,
		3079
	],
	"./components/PortfolioSection/imgs/ikyden-thumb.jpg": [
		2450,
		9,
		3080
	],
	"./components/PortfolioSection/imgs/in-kind-tracking-and-management-app-thumb.jpg": [
		2451,
		9,
		3081
	],
	"./components/PortfolioSection/imgs/journey-thumb.jpg": [
		2452,
		9,
		3082
	],
	"./components/PortfolioSection/imgs/kermisweert-thumb.png": [
		2453,
		9,
		3083
	],
	"./components/PortfolioSection/imgs/knockiz-deals-app-thumb-thumb.jpeg": [
		2454,
		9,
		3084
	],
	"./components/PortfolioSection/imgs/local-product-searching-app-thumb.png": [
		1700,
		9,
		3085
	],
	"./components/PortfolioSection/imgs/match-making-app-thumb.jpg": [
		2455,
		9,
		3086
	],
	"./components/PortfolioSection/imgs/math-works-thumb.jpg": [
		2456,
		9,
		3087
	],
	"./components/PortfolioSection/imgs/meet-some.png": [
		2457,
		9,
		3088
	],
	"./components/PortfolioSection/imgs/moneyger-thumb.jpg": [
		2458,
		9,
		3089
	],
	"./components/PortfolioSection/imgs/mosque-prayer-app-thumb.png": [
		2459,
		9,
		3090
	],
	"./components/PortfolioSection/imgs/my-shul-app-thumb.jpg": [
		2460,
		9,
		3091
	],
	"./components/PortfolioSection/imgs/my-wedding-venue-finder-thumb.jpg": [
		2461,
		9,
		3092
	],
	"./components/PortfolioSection/imgs/mybus-thumb-thumb.png": [
		2462,
		9,
		3093
	],
	"./components/PortfolioSection/imgs/ocean-fm-thumb.jpg": [
		2463,
		9,
		3094
	],
	"./components/PortfolioSection/imgs/our-work-poster.jpg": [
		2464,
		9,
		3095
	],
	"./components/PortfolioSection/imgs/our-work-poster.webp": [
		58,
		9
	],
	"./components/PortfolioSection/imgs/p-smpl.jpeg": [
		2465,
		9,
		3096
	],
	"./components/PortfolioSection/imgs/paintbrush-thumb.jpg": [
		2466,
		9,
		3097
	],
	"./components/PortfolioSection/imgs/pengeapod-app-thumb.jpg": [
		2467,
		9,
		3098
	],
	"./components/PortfolioSection/imgs/pigi-thumb.png": [
		2468,
		9,
		3099
	],
	"./components/PortfolioSection/imgs/pigi-web.png": [
		2469,
		9,
		3100
	],
	"./components/PortfolioSection/imgs/planit-style-thumb.jpg": [
		2470,
		9,
		3101
	],
	"./components/PortfolioSection/imgs/realtime-running-app-thumb.png": [
		2471,
		9,
		3102
	],
	"./components/PortfolioSection/imgs/sellyhoo-thumb.jpg": [
		2472,
		9,
		3103
	],
	"./components/PortfolioSection/imgs/send-postcards-app-thumb.jpg": [
		2473,
		9,
		3104
	],
	"./components/PortfolioSection/imgs/service-calibrate-thumb.jpg": [
		2474,
		9,
		3105
	],
	"./components/PortfolioSection/imgs/simple-draft-thumb.jpg": [
		2475,
		9,
		3106
	],
	"./components/PortfolioSection/imgs/sip-thumb.jpg": [
		2476,
		9,
		3107
	],
	"./components/PortfolioSection/imgs/smashers-collectors-app-thumb.png": [
		2477,
		9,
		3108
	],
	"./components/PortfolioSection/imgs/snaports---sports-social-media-app-thumb.png": [
		2478,
		9,
		3109
	],
	"./components/PortfolioSection/imgs/social-shopping-app-thumb.jpg": [
		2479,
		9,
		3110
	],
	"./components/PortfolioSection/imgs/solar-marketplace-app-thumb.jpg": [
		2480,
		9,
		3111
	],
	"./components/PortfolioSection/imgs/spordy-thumb.jpg": [
		2481,
		9,
		3112
	],
	"./components/PortfolioSection/imgs/syntaxtechs-thumb.png": [
		2482,
		9,
		3113
	],
	"./components/PortfolioSection/imgs/texttou-thumb.jpg": [
		2483,
		9,
		3114
	],
	"./components/PortfolioSection/imgs/the-baya-app-thumb.png": [
		2484,
		9,
		3115
	],
	"./components/PortfolioSection/imgs/threebuzz-thumb.png": [
		2485,
		9,
		3116
	],
	"./components/PortfolioSection/imgs/travel-social-network-app-thumb.jpg": [
		2486,
		9,
		3117
	],
	"./components/PortfolioSection/imgs/tripie-thumb.jpg": [
		2487,
		9,
		3118
	],
	"./components/PortfolioSection/imgs/ublast-thumb.jpg": [
		2488,
		9,
		3119
	],
	"./components/PortfolioSection/imgs/ufm-thumb.jpg": [
		2489,
		9,
		3120
	],
	"./components/PortfolioSection/imgs/uhp-alarm-clock-pro-thumb.jpg": [
		2490,
		9,
		3121
	],
	"./components/PortfolioSection/imgs/urbana-thumb.jpg": [
		2491,
		9,
		3122
	],
	"./components/PortfolioSection/imgs/uvite-thumb.jpg": [
		2492,
		9,
		3123
	],
	"./components/PortfolioSection/imgs/video-sharing-app-thumb.png": [
		2493,
		9,
		3124
	],
	"./components/PortfolioSection/imgs/voxpop---survey-and-opinion-app-thumb.jpg": [
		2494,
		9,
		3125
	],
	"./components/PortfolioSection/imgs/weact-thumb.jpg": [
		2495,
		9,
		3126
	],
	"./components/PortfolioSection/imgs/yuuud---social-network-app-thumb.jpg": [
		2496,
		9,
		3127
	],
	"./components/PortfolioSection/imgs/zoharii-thumb.jpg": [
		2497,
		9,
		3128
	],
	"./components/PortfolioSection/imgs/zoomer-app-thumb.jpg": [
		2498,
		9,
		3129
	],
	"./components/PortfolioSection/imgs/zoomin-thumb.png": [
		2499,
		9,
		3130
	],
	"./components/PortfolioSection/video/our-work.mp4": [
		72,
		9
	],
	"./components/PortfolioSection/web/bounch_thumbnail_1.jpg": [
		2500,
		9,
		3131
	],
	"./components/PortfolioSection/web/bread-and-bagels-thumb.png": [
		2501,
		9,
		3132
	],
	"./components/PortfolioSection/web/dafiti-thumb.png": [
		2502,
		9,
		3133
	],
	"./components/PortfolioSection/web/descubrebelleza-thumb.png": [
		2503,
		9,
		3134
	],
	"./components/PortfolioSection/web/donzendekbed-thumb.png": [
		2504,
		9,
		3135
	],
	"./components/PortfolioSection/web/homes-by-haris-thumb.png": [
		2505,
		9,
		3136
	],
	"./components/PortfolioSection/web/idobbs-thumb.png": [
		2506,
		9,
		3137
	],
	"./components/PortfolioSection/web/justfab-thumb.png": [
		2507,
		9,
		3138
	],
	"./components/PortfolioSection/web/legacy-rental-thumb.png": [
		2508,
		9,
		3139
	],
	"./components/PortfolioSection/web/mercedes-salazar-thumb.png": [
		2509,
		9,
		3140
	],
	"./components/PortfolioSection/web/petroindustrial-thumb.png": [
		2510,
		9,
		3141
	],
	"./components/PortfolioSection/web/service-calibrate-thumb.png": [
		2511,
		9,
		3142
	],
	"./components/PortfolioSection/web/shoedazzle-thumb.png": [
		2512,
		9,
		3143
	],
	"./components/PortfolioSection/web/skipcr-thumb.png": [
		2513,
		9,
		3144
	],
	"./components/PortfolioSection/web/snaports---sports-social-media-app-thumb.png": [
		2514,
		9,
		3145
	],
	"./components/PortfolioSection/web/syntaxtechs-thumb.png": [
		2515,
		9,
		3146
	],
	"./components/PortfolioSection/web/tessaro-thumb.png": [
		2516,
		9,
		3147
	],
	"./components/PortfolioSection/web/ufmradio-thumb.png": [
		2517,
		9,
		3148
	],
	"./components/PortfolioSection/web/video-sharing-app-thumb.png": [
		2518,
		9,
		3149
	],
	"./components/PortfolioSection/web/zhi-thumb.png": [
		2519,
		9,
		3150
	],
	"./components/SectionTitle/SectionTitle": [
		194,
		9,
		686
	],
	"./components/SectionTitle/SectionTitle.js": [
		194,
		9,
		686
	],
	"./components/SectionTitle/SectionTitle.scss": [
		878,
		7,
		909
	],
	"./components/ServicesSection/ServicesSection": [
		686,
		9,
		3,
		190
	],
	"./components/ServicesSection/ServicesSection.js": [
		686,
		9,
		3,
		190
	],
	"./components/ServicesSection/ServicesSection.scss": [
		1701,
		7,
		910
	],
	"./components/Slider-SuccesStories/Slider-SuccessStories": [
		225,
		9,
		3,
		8,
		320
	],
	"./components/Slider-SuccesStories/Slider-SuccessStories.js": [
		225,
		9,
		3,
		8,
		320
	],
	"./components/Slider-SuccesStories/Slider-SuccessStories.scss": [
		971,
		7,
		911
	],
	"./components/SolutionsPortfolio/SolutionsPortfolio": [
		216,
		9,
		616
	],
	"./components/SolutionsPortfolio/SolutionsPortfolio.js": [
		216,
		9,
		616
	],
	"./components/SolutionsPortfolio/SolutionsPortfolio.scss": [
		933,
		7,
		912
	],
	"./components/SolutionsPortfolio/imgs/soln1.jpg": [
		2520,
		9,
		3151
	],
	"./components/SolutionsPortfolio/imgs/soln2.jpg": [
		2521,
		9,
		3152
	],
	"./components/SolutionsPortfolio/imgs/soln3.jpg": [
		2522,
		9,
		3153
	],
	"./components/SolutionsPortfolio/imgs/soln4.jpg": [
		2523,
		9,
		3154
	],
	"./components/SolutionsPortfolio/imgs/soln5.jpg": [
		2524,
		9,
		3155
	],
	"./components/StaticPageWrapper/StaticPageWrapper": [
		181,
		9,
		142
	],
	"./components/StaticPageWrapper/StaticPageWrapper.js": [
		181,
		9,
		142
	],
	"./components/StaticPageWrapper/StaticPageWrapper.scss": [
		1644,
		7,
		913
	],
	"./components/SuccessStoriesSlider/SuccessStoriesSlider": [
		687,
		9,
		3,
		402
	],
	"./components/SuccessStoriesSlider/SuccessStoriesSlider.js": [
		687,
		9,
		3,
		402
	],
	"./components/SuccessStoriesSlider/SuccessStoriesSlider.scss": [
		1702,
		7,
		914
	],
	"./components/SuccessStoriesSlider/img/6PP.webp": [
		2525,
		9,
		1771
	],
	"./components/SuccessStoriesSlider/img/bhoj.webp": [
		2526,
		9,
		1772
	],
	"./components/SuccessStoriesSlider/img/ennea.webp": [
		2527,
		9,
		1773
	],
	"./components/SuccessStoriesSlider/img/pigi.webp": [
		2528,
		9,
		1774
	],
	"./components/SuccessStoriesSlider/img/zoomin.webp": [
		2529,
		9,
		1775
	],
	"./components/SuccessStoriesSlider/imgs/6pp-ab-workout.jpg": [
		2530,
		9,
		3156
	],
	"./components/SuccessStoriesSlider/imgs/6pp-ab-workout.png": [
		1703,
		9,
		3157
	],
	"./components/SuccessStoriesSlider/imgs/6pp-ab-workout.webp": [
		2531,
		9,
		1776
	],
	"./components/SuccessStoriesSlider/imgs/bhoj.jpg": [
		2532,
		9,
		3158
	],
	"./components/SuccessStoriesSlider/imgs/bhoj.png": [
		1704,
		9,
		3159
	],
	"./components/SuccessStoriesSlider/imgs/bhoj.webp": [
		2533,
		9,
		1777
	],
	"./components/SuccessStoriesSlider/imgs/enneaapp.jpg": [
		2534,
		9,
		3160
	],
	"./components/SuccessStoriesSlider/imgs/enneaapp.png": [
		1705,
		9,
		3161
	],
	"./components/SuccessStoriesSlider/imgs/enneaapp.webp": [
		2535,
		9,
		1778
	],
	"./components/SuccessStoriesSlider/imgs/left-white.svg": [
		2536,
		9,
		1779
	],
	"./components/SuccessStoriesSlider/imgs/left.svg": [
		2537,
		9,
		1780
	],
	"./components/SuccessStoriesSlider/imgs/pangea.png": [
		2538,
		9,
		3162
	],
	"./components/SuccessStoriesSlider/imgs/pigi.jpg": [
		2539,
		9,
		3163
	],
	"./components/SuccessStoriesSlider/imgs/pigi.png": [
		1706,
		9,
		3164
	],
	"./components/SuccessStoriesSlider/imgs/pigi.webp": [
		2540,
		9,
		1781
	],
	"./components/SuccessStoriesSlider/imgs/right-white.svg": [
		2541,
		9,
		1782
	],
	"./components/SuccessStoriesSlider/imgs/right.svg": [
		2542,
		9,
		1783
	],
	"./components/SuccessStoriesSlider/imgs/ssdemo.png": [
		2543,
		9,
		3165
	],
	"./components/SuccessStoriesSlider/imgs/ssdemo.webp": [
		2544,
		9,
		1784
	],
	"./components/SuccessStoriesSlider/imgs/zoomin.jpg": [
		2545,
		9,
		3166
	],
	"./components/SuccessStoriesSlider/imgs/zoomin.png": [
		1707,
		9,
		3167
	],
	"./components/SuccessStoriesSlider/imgs/zoomin.webp": [
		2546,
		9,
		1785
	],
	"./components/TextTestimonials/TextTestimonials": [
		579,
		9,
		3,
		403
	],
	"./components/TextTestimonials/TextTestimonials.js": [
		579,
		9,
		3,
		403
	],
	"./components/TextTestimonials/imgs/clients/caesarfernandes.png": [
		1518,
		9,
		3168
	],
	"./components/TextTestimonials/imgs/clients/client.jpg": [
		2547,
		9,
		3169
	],
	"./components/TextTestimonials/imgs/clients/jesse-dakis.png": [
		1517,
		9,
		3170
	],
	"./components/TextTestimonials/imgs/clients/kristoffer.png": [
		1521,
		9,
		3171
	],
	"./components/TextTestimonials/imgs/clients/mohamand.jpg": [
		1516,
		9,
		3172
	],
	"./components/TextTestimonials/imgs/clients/thailandclient.png": [
		1520,
		9,
		3173
	],
	"./components/TextTestimonials/imgs/clients/tim.png": [
		1519,
		9,
		3174
	],
	"./config/api": [
		220,
		9,
		5,
		799
	],
	"./config/api.js": [
		220,
		9,
		5,
		799
	],
	"./config/handleGridService": [
		688,
		7,
		800
	],
	"./config/handleGridService.js": [
		688,
		7,
		800
	],
	"./index": [
		31,
		9
	],
	"./index.js": [
		31,
		9
	],
	"./index.scss": [
		184,
		7
	],
	"./jiyosoft-logo.svg": [
		33,
		9
	],
	"./logo-mind-inventory-w.svg": [
		74,
		9
	],
	"./logo-mind-inventory.svg": [
		73,
		9
	],
	"./oceanshark-logo.svg": [
		2548,
		9,
		1786
	],
	"./pages/AndroidAppDevelopment/AboutSection/AboutSection": [
		272,
		9,
		214
	],
	"./pages/AndroidAppDevelopment/AboutSection/AboutSection.js": [
		272,
		9,
		214
	],
	"./pages/AndroidAppDevelopment/AboutSection/AboutSection.scss": [
		1165,
		7,
		915
	],
	"./pages/AndroidAppDevelopment/AndroidAppDevelopment": [
		114,
		9,
		0,
		95,
		1,
		2,
		22
	],
	"./pages/AndroidAppDevelopment/AndroidAppDevelopment.js": [
		114,
		9,
		0,
		95,
		1,
		2,
		22
	],
	"./pages/AndroidAppDevelopment/Approaches/Approaches": [
		274,
		9,
		272
	],
	"./pages/AndroidAppDevelopment/Approaches/Approaches.js": [
		274,
		9,
		272
	],
	"./pages/AndroidAppDevelopment/BenefitsSection/BenefitsSection": [
		689,
		9,
		299
	],
	"./pages/AndroidAppDevelopment/BenefitsSection/BenefitsSection.js": [
		689,
		9,
		299
	],
	"./pages/AndroidAppDevelopment/BenefitsSection/BenefitsSection.scss": [
		1708,
		7,
		916
	],
	"./pages/AndroidAppDevelopment/HeroSection/HeroSection": [
		271,
		9,
		449
	],
	"./pages/AndroidAppDevelopment/HeroSection/HeroSection.js": [
		271,
		9,
		449
	],
	"./pages/AndroidAppDevelopment/HeroSection/HeroSection.scss": [
		1164,
		7,
		917
	],
	"./pages/AndroidAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2549,
		7,
		918
	],
	"./pages/AndroidAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2550,
		7,
		919
	],
	"./pages/AndroidAppDevelopment/Platforms/Platforms": [
		273,
		9,
		433
	],
	"./pages/AndroidAppDevelopment/Platforms/Platforms.js": [
		273,
		9,
		433
	],
	"./pages/AndroidAppDevelopment/Platforms/Platforms.scss": [
		1166,
		7,
		920
	],
	"./pages/AndroidAppDevelopment/ServicesSection/ServicesSection": [
		276,
		9,
		511
	],
	"./pages/AndroidAppDevelopment/ServicesSection/ServicesSection.js": [
		276,
		9,
		511
	],
	"./pages/AndroidAppDevelopment/ServicesSection/ServicesSection.scss": [
		1167,
		7,
		921
	],
	"./pages/AndroidAppDevelopment/TechnologiesSection/TechnologiesSection": [
		275,
		9,
		408
	],
	"./pages/AndroidAppDevelopment/TechnologiesSection/TechnologiesSection.js": [
		275,
		9,
		408
	],
	"./pages/AndroidAppDevelopment/WhyChooseMi/WhyChooseMi": [
		278,
		9,
		321
	],
	"./pages/AndroidAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		278,
		9,
		321
	],
	"./pages/AndroidAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1169,
		7,
		922
	],
	"./pages/AndroidAppDevelopment/WhyChooseSection/WhyChooseSection": [
		277,
		9,
		588
	],
	"./pages/AndroidAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		277,
		9,
		588
	],
	"./pages/AndroidAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1168,
		7,
		923
	],
	"./pages/AngularDevelopment/AboutSection/AboutSection": [
		308,
		9,
		215
	],
	"./pages/AngularDevelopment/AboutSection/AboutSection.js": [
		308,
		9,
		215
	],
	"./pages/AngularDevelopment/AboutSection/AboutSection.scss": [
		1198,
		7,
		924
	],
	"./pages/AngularDevelopment/AngularDevelopment": [
		119,
		9,
		0,
		100,
		1,
		2,
		34
	],
	"./pages/AngularDevelopment/AngularDevelopment.js": [
		119,
		9,
		0,
		100,
		1,
		2,
		34
	],
	"./pages/AngularDevelopment/Benefits/Benefits": [
		690,
		9,
		503
	],
	"./pages/AngularDevelopment/Benefits/Benefits.js": [
		690,
		9,
		503
	],
	"./pages/AngularDevelopment/Features/Features": [
		691,
		9,
		463
	],
	"./pages/AngularDevelopment/Features/Features.js": [
		691,
		9,
		463
	],
	"./pages/AngularDevelopment/HeroSection/HeroSection": [
		307,
		9,
		512
	],
	"./pages/AngularDevelopment/HeroSection/HeroSection.js": [
		307,
		9,
		512
	],
	"./pages/AngularDevelopment/HeroSection/HeroSection.scss": [
		1197,
		7,
		925
	],
	"./pages/AngularDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2551,
		7,
		926
	],
	"./pages/AngularDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2552,
		7,
		927
	],
	"./pages/AngularDevelopment/ServicesSection/ServicesSection": [
		309,
		9,
		513
	],
	"./pages/AngularDevelopment/ServicesSection/ServicesSection.js": [
		309,
		9,
		513
	],
	"./pages/AngularDevelopment/ServicesSection/ServicesSection.scss": [
		1199,
		7,
		928
	],
	"./pages/AngularDevelopment/WhatIsSection/WhatIsSection": [
		692,
		9,
		634
	],
	"./pages/AngularDevelopment/WhatIsSection/WhatIsSection.js": [
		692,
		9,
		634
	],
	"./pages/AngularDevelopment/WhyChooseMi/WhyChooseMi": [
		311,
		9,
		322
	],
	"./pages/AngularDevelopment/WhyChooseMi/WhyChooseMi.js": [
		311,
		9,
		322
	],
	"./pages/AngularDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1201,
		7,
		929
	],
	"./pages/AngularDevelopment/WhyChooseSection/WhyChooseSection": [
		310,
		9,
		589
	],
	"./pages/AngularDevelopment/WhyChooseSection/WhyChooseSection.js": [
		310,
		9,
		589
	],
	"./pages/AngularDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1200,
		7,
		930
	],
	"./pages/BackboneJsDevelopment/AboutSection/AboutSection": [
		328,
		9,
		216
	],
	"./pages/BackboneJsDevelopment/AboutSection/AboutSection.js": [
		328,
		9,
		216
	],
	"./pages/BackboneJsDevelopment/AboutSection/AboutSection.scss": [
		1218,
		7,
		931
	],
	"./pages/BackboneJsDevelopment/BackboneJsDevelopment": [
		123,
		9,
		0,
		104,
		1,
		2,
		35
	],
	"./pages/BackboneJsDevelopment/BackboneJsDevelopment.js": [
		123,
		9,
		0,
		104,
		1,
		2,
		35
	],
	"./pages/BackboneJsDevelopment/BenefitsSection/BenefitsSection": [
		693,
		9,
		464
	],
	"./pages/BackboneJsDevelopment/BenefitsSection/BenefitsSection.js": [
		693,
		9,
		464
	],
	"./pages/BackboneJsDevelopment/HeroSection/HeroSection": [
		327,
		9,
		514
	],
	"./pages/BackboneJsDevelopment/HeroSection/HeroSection.js": [
		327,
		9,
		514
	],
	"./pages/BackboneJsDevelopment/HeroSection/HeroSection.scss": [
		1217,
		7,
		932
	],
	"./pages/BackboneJsDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2553,
		7,
		933
	],
	"./pages/BackboneJsDevelopment/LookingOtherServices/LookingOtherServices": [
		694,
		9,
		506
	],
	"./pages/BackboneJsDevelopment/LookingOtherServices/LookingOtherServices.js": [
		694,
		9,
		506
	],
	"./pages/BackboneJsDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		1709,
		7,
		934
	],
	"./pages/BackboneJsDevelopment/ServicesSection/ServicesSection": [
		329,
		9,
		515
	],
	"./pages/BackboneJsDevelopment/ServicesSection/ServicesSection.js": [
		329,
		9,
		515
	],
	"./pages/BackboneJsDevelopment/ServicesSection/ServicesSection.scss": [
		1219,
		7,
		935
	],
	"./pages/BackboneJsDevelopment/WhatIs/WhatIs": [
		695,
		9,
		635
	],
	"./pages/BackboneJsDevelopment/WhatIs/WhatIs.js": [
		695,
		9,
		635
	],
	"./pages/BackboneJsDevelopment/WhyChooseMi/WhyChooseMi": [
		331,
		9,
		323
	],
	"./pages/BackboneJsDevelopment/WhyChooseMi/WhyChooseMi.js": [
		331,
		9,
		323
	],
	"./pages/BackboneJsDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1221,
		7,
		936
	],
	"./pages/BackboneJsDevelopment/WhyChooseSection/WhyChooseSection": [
		330,
		9,
		590
	],
	"./pages/BackboneJsDevelopment/WhyChooseSection/WhyChooseSection.js": [
		330,
		9,
		590
	],
	"./pages/BackboneJsDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1220,
		7,
		937
	],
	"./pages/CompanyOverview/AboutSection/AboutSection": [
		571,
		9,
		11,
		324
	],
	"./pages/CompanyOverview/AboutSection/AboutSection.js": [
		571,
		9,
		11,
		324
	],
	"./pages/CompanyOverview/AboutSection/AboutSection.scss": [
		1491,
		7,
		938
	],
	"./pages/CompanyOverview/AtMi/AtMi": [
		696,
		9,
		687
	],
	"./pages/CompanyOverview/AtMi/AtMi.js": [
		696,
		9,
		687
	],
	"./pages/CompanyOverview/AtMi/AtMi.scss": [
		1710,
		7,
		939
	],
	"./pages/CompanyOverview/CircleAnimation/CircleAnimation": [
		242,
		9,
		668
	],
	"./pages/CompanyOverview/CircleAnimation/CircleAnimation.js": [
		242,
		9,
		668
	],
	"./pages/CompanyOverview/CircleAnimation/CircleAnimation.scss": [
		1035,
		7,
		940
	],
	"./pages/CompanyOverview/CircleAnimation/img/bhoj.svg": [
		1036,
		9,
		1787
	],
	"./pages/CompanyOverview/CompanyOverview": [
		174,
		9,
		0,
		11,
		1,
		80
	],
	"./pages/CompanyOverview/CompanyOverview.js": [
		174,
		9,
		0,
		11,
		1,
		80
	],
	"./pages/CompanyOverview/CompanyOverview.scss": [
		1642,
		7,
		941
	],
	"./pages/CompanyOverview/DevOpsProcess/DevOpsProcess": [
		697,
		9,
		627
	],
	"./pages/CompanyOverview/DevOpsProcess/DevOpsProcess.js": [
		697,
		9,
		627
	],
	"./pages/CompanyOverview/DevOpsProcess/imgs/dev-ops-process.svg": [
		1711,
		9,
		1788
	],
	"./pages/CompanyOverview/HeroSection/HeroSection": [
		570,
		9,
		260
	],
	"./pages/CompanyOverview/HeroSection/HeroSection.js": [
		570,
		9,
		260
	],
	"./pages/CompanyOverview/HeroSection/HeroSection.scss": [
		1490,
		7,
		942
	],
	"./pages/CompanyOverview/MiJourney/MiJourney": [
		698,
		9,
		241
	],
	"./pages/CompanyOverview/MiJourney/MiJourney.js": [
		698,
		9,
		241
	],
	"./pages/CompanyOverview/MiJourney/MiJourney.scss": [
		1712,
		7,
		943
	],
	"./pages/CompanyOverview/MiJourney/img/10years.svg": [
		1713,
		9,
		1789
	],
	"./pages/CompanyOverview/MiJourney/img/aug-twenty-one-one.png": [
		2554,
		9,
		3175
	],
	"./pages/CompanyOverview/MiJourney/img/aug-twenty-one-two.png": [
		2555,
		9,
		3176
	],
	"./pages/CompanyOverview/MiJourney/img/jan-eleven-one.png": [
		2556,
		9,
		3177
	],
	"./pages/CompanyOverview/MiJourney/img/jan-eleven-two.png": [
		2557,
		9,
		3178
	],
	"./pages/CompanyOverview/MiJourney/img/pinkround.svg": [
		2558,
		9,
		1790
	],
	"./pages/CompanyOverview/MiJourney/img/planting-one.png": [
		2559,
		9,
		3179
	],
	"./pages/CompanyOverview/MiJourney/img/png/aug-twenty-one-one.png": [
		2560,
		9,
		3180
	],
	"./pages/CompanyOverview/MiJourney/img/png/aug-twenty-one-two.png": [
		2561,
		9,
		3181
	],
	"./pages/CompanyOverview/MiJourney/img/png/jan-eleven-one.png": [
		2562,
		9,
		3182
	],
	"./pages/CompanyOverview/MiJourney/img/png/jan-eleven-two.png": [
		2563,
		9,
		3183
	],
	"./pages/CompanyOverview/MiJourney/img/tree.png": [
		2564,
		9,
		3184
	],
	"./pages/CompanyOverview/MiJourney/img/webp/aug-twenty-one-one.webp": [
		2565,
		9,
		1791
	],
	"./pages/CompanyOverview/MiJourney/img/webp/aug-twenty-one-two.png": [
		2566,
		9,
		3185
	],
	"./pages/CompanyOverview/MiJourney/img/webp/aug-twenty-one-two.webp": [
		2567,
		9,
		1792
	],
	"./pages/CompanyOverview/MiJourney/img/webp/jan-eleven-one.webp": [
		2568,
		9,
		1793
	],
	"./pages/CompanyOverview/MiJourney/img/webp/jan-eleven-two.webp": [
		2569,
		9,
		1794
	],
	"./pages/CompanyOverview/MiJourney/solution": [
		581,
		9,
		688
	],
	"./pages/CompanyOverview/MiJourney/solution.js": [
		581,
		9,
		688
	],
	"./pages/CompanyOverview/MiJourney/solution.scss": [
		1522,
		7,
		944
	],
	"./pages/CompanyOverview/VisionMission/VisionMission": [
		572,
		9,
		628
	],
	"./pages/CompanyOverview/VisionMission/VisionMission.js": [
		572,
		9,
		628
	],
	"./pages/CompanyOverview/VisionMission/VisionMission.scss": [
		1492,
		7,
		945
	],
	"./pages/CompanyOverview/VisionMission/img/mission.svg": [
		1494,
		9,
		1795
	],
	"./pages/CompanyOverview/VisionMission/img/vision.svg": [
		1493,
		9,
		1796
	],
	"./pages/ContactUs/ContactUs": [
		176,
		9,
		0,
		5,
		7,
		10,
		67
	],
	"./pages/ContactUs/ContactUs.js": [
		176,
		9,
		0,
		5,
		7,
		10,
		67
	],
	"./pages/ContactUs/GetInTouch/GetInTouch": [
		576,
		9,
		5,
		7,
		10,
		169
	],
	"./pages/ContactUs/GetInTouch/GetInTouch.js": [
		576,
		9,
		5,
		7,
		10,
		169
	],
	"./pages/ContactUs/GetInTouch/GetInTouch.scss": [
		1498,
		7,
		946
	],
	"./pages/ContactUs/GloblePresence/GloblePresence": [
		243,
		9,
		325
	],
	"./pages/ContactUs/GloblePresence/GloblePresence.js": [
		243,
		9,
		325
	],
	"./pages/ContactUs/GloblePresence/GloblePresence.scss": [
		1037,
		7,
		947
	],
	"./pages/ContactUs/HeroSection/HeroSection": [
		575,
		9,
		591
	],
	"./pages/ContactUs/HeroSection/HeroSection.js": [
		575,
		9,
		591
	],
	"./pages/ContactUs/HeroSection/HeroSection.scss": [
		1497,
		7,
		948
	],
	"./pages/Design/AboutSection/AboutSection": [
		388,
		9,
		269
	],
	"./pages/Design/AboutSection/AboutSection.js": [
		388,
		9,
		269
	],
	"./pages/Design/AboutSection/AboutSection.scss": [
		1289,
		7,
		949
	],
	"./pages/Design/CantFindTechnology/CantFindTechnology": [
		237,
		9,
		689
	],
	"./pages/Design/CantFindTechnology/CantFindTechnology.js": [
		237,
		9,
		689
	],
	"./pages/Design/CantFindTechnology/CantFindTechnology.scss": [
		1021,
		7,
		950
	],
	"./pages/Design/Design": [
		134,
		9,
		0,
		114,
		1,
		2,
		54
	],
	"./pages/Design/Design.js": [
		134,
		9,
		0,
		114,
		1,
		2,
		54
	],
	"./pages/Design/HeroSection/HeroSection": [
		387,
		9,
		450
	],
	"./pages/Design/HeroSection/HeroSection.js": [
		387,
		9,
		450
	],
	"./pages/Design/HeroSection/HeroSection.scss": [
		1288,
		7,
		951
	],
	"./pages/Design/LookingDevelopers/LookingDevelopers.scss": [
		2570,
		7,
		952
	],
	"./pages/Design/LookingOtherServices/LookingOtherServices": [
		699,
		9,
		507
	],
	"./pages/Design/LookingOtherServices/LookingOtherServices.js": [
		699,
		9,
		507
	],
	"./pages/Design/LookingOtherServices/LookingOtherServices.scss": [
		1714,
		7,
		953
	],
	"./pages/Design/Services/Services": [
		389,
		9,
		183
	],
	"./pages/Design/Services/Services.js": [
		389,
		9,
		183
	],
	"./pages/Design/Services/Services.scss": [
		1290,
		7,
		954
	],
	"./pages/Design/Services/images/17/graphics/24.webp": [
		2571,
		9,
		1797
	],
	"./pages/Design/Services/images/17/uiux/25.webp": [
		2572,
		9,
		1798
	],
	"./pages/Design/Services/images/17/uiux/26.webp": [
		2573,
		9,
		1799
	],
	"./pages/Design/Services/images/17/uiux/27.webp": [
		2574,
		9,
		1800
	],
	"./pages/Design/Services/images/17/uiux/28.webp": [
		2575,
		9,
		1801
	],
	"./pages/Design/Services/images/17/uiux/29.webp": [
		2576,
		9,
		1802
	],
	"./pages/Design/Services/images/17/uiux/30.webp": [
		2577,
		9,
		1803
	],
	"./pages/Design/Services/images/17/uiux/31.webp": [
		2578,
		9,
		1804
	],
	"./pages/Design/Services/images/17/uiux/32.webp": [
		2579,
		9,
		1805
	],
	"./pages/Design/Services/images/17/uiux/33.webp": [
		2580,
		9,
		1806
	],
	"./pages/Design/Services/images/17/uiux/34.webp": [
		2581,
		9,
		1807
	],
	"./pages/Design/Services/images/17/uiux/35.webp": [
		2582,
		9,
		1808
	],
	"./pages/Design/Services/images/17/uiux/36.webp": [
		2583,
		9,
		1809
	],
	"./pages/Design/Services/images/17/uiux/37.webp": [
		2584,
		9,
		1810
	],
	"./pages/Design/Services/images/17/uiux/38.webp": [
		2585,
		9,
		1811
	],
	"./pages/Design/Services/images/17/uiux/39.webp": [
		2586,
		9,
		1812
	],
	"./pages/Design/Services/images/17/uiux/40.webp": [
		2587,
		9,
		1813
	],
	"./pages/Design/Services/images/17/uiux/41.webp": [
		2588,
		9,
		1814
	],
	"./pages/Design/Services/images/17/uiux/42.webp": [
		2589,
		9,
		1815
	],
	"./pages/Design/Services/images/graphics/10.webp": [
		2590,
		9,
		1816
	],
	"./pages/Design/Services/images/graphics/17.webp": [
		2591,
		9,
		1817
	],
	"./pages/Design/Services/images/graphics/18.webp": [
		2592,
		9,
		1818
	],
	"./pages/Design/Services/images/graphics/19.webp": [
		2593,
		9,
		1819
	],
	"./pages/Design/Services/images/graphics/20.webp": [
		2594,
		9,
		1820
	],
	"./pages/Design/Services/images/uiux/11.webp": [
		2595,
		9,
		1821
	],
	"./pages/Design/Services/images/uiux/12.webp": [
		2596,
		9,
		1822
	],
	"./pages/Design/Services/images/uiux/13.webp": [
		2597,
		9,
		1823
	],
	"./pages/Design/Services/images/uiux/14.webp": [
		2598,
		9,
		1824
	],
	"./pages/Design/Services/images/uiux/15.webp": [
		2599,
		9,
		1825
	],
	"./pages/Design/Services/images/uiux/16.webp": [
		2600,
		9,
		1826
	],
	"./pages/Design/Services/images/uiux/21.webp": [
		2601,
		9,
		1827
	],
	"./pages/Design/Services/images/uiux/22.webp": [
		2602,
		9,
		1828
	],
	"./pages/Design/Services/images/uiux/23.webp": [
		2603,
		9,
		1829
	],
	"./pages/Design/Services/images/uiux/7.webp": [
		2604,
		9,
		1830
	],
	"./pages/Design/Services/images/uiux/8.webp": [
		2605,
		9,
		1831
	],
	"./pages/Design/Services/images/uiux/9.webp": [
		2606,
		9,
		1832
	],
	"./pages/Design/Services/imgs/app1.jpg": [
		2607,
		9,
		3186
	],
	"./pages/Design/Services/imgs/app2.jpg": [
		2608,
		9,
		3187
	],
	"./pages/Design/Services/imgs/app3.jpg": [
		2609,
		9,
		3188
	],
	"./pages/Design/Services/imgs/app4.jpg": [
		2610,
		9,
		3189
	],
	"./pages/Design/Services/imgs/graphics/1.webp": [
		2611,
		9,
		1833
	],
	"./pages/Design/Services/imgs/graphics/2.webp": [
		2612,
		9,
		1834
	],
	"./pages/Design/Services/imgs/graphics/3.webp": [
		2613,
		9,
		1835
	],
	"./pages/Design/Services/imgs/graphics/4.webp": [
		2614,
		9,
		1836
	],
	"./pages/Design/Services/imgs/graphics/5.webp": [
		2615,
		9,
		1837
	],
	"./pages/Design/Services/imgs/graphics/6.webp": [
		2616,
		9,
		1838
	],
	"./pages/Design/Services/imgs/illustration1.jpg": [
		2617,
		9,
		3190
	],
	"./pages/Design/Services/imgs/illustration2.jpg": [
		2618,
		9,
		3191
	],
	"./pages/Design/Services/imgs/illustration3.jpg": [
		2619,
		9,
		3192
	],
	"./pages/Design/Services/imgs/illustration4.jpg": [
		2620,
		9,
		3193
	],
	"./pages/Design/Services/imgs/img.jpg": [
		2621,
		9,
		3194
	],
	"./pages/Design/Services/imgs/motion1.jpg": [
		2622,
		9,
		3195
	],
	"./pages/Design/Services/imgs/motion2.jpg": [
		2623,
		9,
		3196
	],
	"./pages/Design/Services/imgs/motion3.jpg": [
		2624,
		9,
		3197
	],
	"./pages/Design/Services/imgs/motion4.jpg": [
		2625,
		9,
		3198
	],
	"./pages/Design/Services/imgs/ui/1.webp": [
		2626,
		9,
		1839
	],
	"./pages/Design/Services/imgs/ui/2.webp": [
		2627,
		9,
		1840
	],
	"./pages/Design/Services/imgs/ui/3.webp": [
		2628,
		9,
		1841
	],
	"./pages/Design/Services/imgs/ui/4.webp": [
		2629,
		9,
		1842
	],
	"./pages/Design/Services/imgs/ui/5.webp": [
		2630,
		9,
		1843
	],
	"./pages/Design/Services/imgs/ui/6.webp": [
		2631,
		9,
		1844
	],
	"./pages/Design/Services/imgs/ui/7.webp": [
		2632,
		9,
		1845
	],
	"./pages/Design/Services/oceanImg/graphics-five.webp": [
		1300,
		9,
		1846
	],
	"./pages/Design/Services/oceanImg/graphics-four.webp": [
		1299,
		9,
		1847
	],
	"./pages/Design/Services/oceanImg/graphics-one.webp": [
		1296,
		9,
		1848
	],
	"./pages/Design/Services/oceanImg/graphics-six.webp": [
		1301,
		9,
		1849
	],
	"./pages/Design/Services/oceanImg/graphics-three.webp": [
		1298,
		9,
		1850
	],
	"./pages/Design/Services/oceanImg/graphics-two.webp": [
		1297,
		9,
		1851
	],
	"./pages/Design/Services/oceanImg/ui-ux-five.webp": [
		1295,
		9,
		1852
	],
	"./pages/Design/Services/oceanImg/ui-ux-four.webp": [
		1294,
		9,
		1853
	],
	"./pages/Design/Services/oceanImg/ui-ux-one.webp": [
		1291,
		9,
		1854
	],
	"./pages/Design/Services/oceanImg/ui-ux-six.webp": [
		2633,
		9,
		1855
	],
	"./pages/Design/Services/oceanImg/ui-ux-three.webp": [
		1293,
		9,
		1856
	],
	"./pages/Design/Services/oceanImg/ui-ux-two.webp": [
		1292,
		9,
		1857
	],
	"./pages/Design/TechnologiesSection/TechnologiesSection": [
		240,
		9,
		236
	],
	"./pages/Design/TechnologiesSection/TechnologiesSection.js": [
		240,
		9,
		236
	],
	"./pages/Design/TechnologiesSection/TechnologiesSection.scss": [
		1026,
		7,
		955
	],
	"./pages/Design/TechnologiesSection/img/adobe-illustrator.webp": [
		2634,
		9,
		1858
	],
	"./pages/Design/TechnologiesSection/img/after-effect.webp": [
		2635,
		9,
		1859
	],
	"./pages/Design/TechnologiesSection/img/tools/adobe-illustrator.webp": [
		1030,
		9,
		1860
	],
	"./pages/Design/TechnologiesSection/img/tools/after-effect.webp": [
		1032,
		9,
		1861
	],
	"./pages/Design/TechnologiesSection/img/tools/figma.webp": [
		1027,
		9,
		1862
	],
	"./pages/Design/TechnologiesSection/img/tools/photoshop.webp": [
		1031,
		9,
		1863
	],
	"./pages/Design/TechnologiesSection/img/tools/sketch.webp": [
		1028,
		9,
		1864
	],
	"./pages/Design/TechnologiesSection/img/tools/xd.webp": [
		1029,
		9,
		1865
	],
	"./pages/Design/TechnologiesSection/img/tools/zeplin.webp": [
		1033,
		9,
		1866
	],
	"./pages/Design/WeCanHelp/WeCanHelp": [
		390,
		9,
		261
	],
	"./pages/Design/WeCanHelp/WeCanHelp.js": [
		390,
		9,
		261
	],
	"./pages/Design/WeCanHelp/WeCanHelp.scss": [
		1302,
		7,
		956
	],
	"./pages/Design/WeCanHelp/img/android.svg": [
		1305,
		9,
		1867
	],
	"./pages/Design/WeCanHelp/img/ios.svg": [
		1304,
		9,
		1868
	],
	"./pages/Design/WeCanHelp/img/wearable.svg": [
		1306,
		9,
		1869
	],
	"./pages/Design/WeCanHelp/img/web.svg": [
		1303,
		9,
		1870
	],
	"./pages/Design/WhyChooseMi/WhyChooseMi": [
		391,
		9,
		326
	],
	"./pages/Design/WhyChooseMi/WhyChooseMi.js": [
		391,
		9,
		326
	],
	"./pages/Design/WhyChooseMi/WhyChooseMi.scss": [
		1307,
		7,
		957
	],
	"./pages/Design/imgs/android.webp": [
		2636,
		9,
		1871
	],
	"./pages/Design/imgs/branding.svg": [
		2637,
		9,
		1872
	],
	"./pages/Design/imgs/cross.svg": [
		2638,
		9,
		1873
	],
	"./pages/Design/imgs/ios.webp": [
		2639,
		9,
		1874
	],
	"./pages/Design/imgs/product-designing.svg": [
		2640,
		9,
		1875
	],
	"./pages/Design/imgs/product-research.svg": [
		2641,
		9,
		1876
	],
	"./pages/Design/imgs/tick.svg": [
		2642,
		9,
		1877
	],
	"./pages/Design/imgs/wearable.webp": [
		2643,
		9,
		1878
	],
	"./pages/Design/imgs/web.webp": [
		2644,
		9,
		1879
	],
	"./pages/FAQ/FAQ": [
		700,
		9,
		0,
		1,
		434
	],
	"./pages/FAQ/FAQ.js": [
		700,
		9,
		0,
		1,
		434
	],
	"./pages/FAQ/FAQ.scss": [
		1715,
		7,
		958
	],
	"./pages/FAQ/HeroSection/HeroSection": [
		582,
		9,
		690
	],
	"./pages/FAQ/HeroSection/HeroSection.js": [
		582,
		9,
		690
	],
	"./pages/FAQ/HeroSection/HeroSection.scss": [
		1523,
		7,
		959
	],
	"./pages/FAQ/imgs/plus.svg": [
		1716,
		9,
		1880
	],
	"./pages/FlutterAppDevelopment/AboutSection/AboutSection": [
		294,
		9,
		217
	],
	"./pages/FlutterAppDevelopment/AboutSection/AboutSection.js": [
		294,
		9,
		217
	],
	"./pages/FlutterAppDevelopment/AboutSection/AboutSection.scss": [
		1184,
		7,
		960
	],
	"./pages/FlutterAppDevelopment/BenefitsSection/BenefitsSection": [
		701,
		9,
		636
	],
	"./pages/FlutterAppDevelopment/BenefitsSection/BenefitsSection.js": [
		701,
		9,
		636
	],
	"./pages/FlutterAppDevelopment/FlutterAppDevelopment": [
		117,
		9,
		0,
		98,
		1,
		2,
		24
	],
	"./pages/FlutterAppDevelopment/FlutterAppDevelopment.js": [
		117,
		9,
		0,
		98,
		1,
		2,
		24
	],
	"./pages/FlutterAppDevelopment/HeroSection/HeroSection": [
		293,
		9,
		451
	],
	"./pages/FlutterAppDevelopment/HeroSection/HeroSection.js": [
		293,
		9,
		451
	],
	"./pages/FlutterAppDevelopment/HeroSection/HeroSection.scss": [
		1183,
		7,
		961
	],
	"./pages/FlutterAppDevelopment/KeyFeatures/KeyFeatures": [
		299,
		9,
		327
	],
	"./pages/FlutterAppDevelopment/KeyFeatures/KeyFeatures.js": [
		299,
		9,
		327
	],
	"./pages/FlutterAppDevelopment/KeyFeatures/KeyFeatures.scss": [
		1189,
		7,
		962
	],
	"./pages/FlutterAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2645,
		7,
		963
	],
	"./pages/FlutterAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2646,
		7,
		964
	],
	"./pages/FlutterAppDevelopment/Platforms/Platforms": [
		295,
		9,
		435
	],
	"./pages/FlutterAppDevelopment/Platforms/Platforms.js": [
		295,
		9,
		435
	],
	"./pages/FlutterAppDevelopment/Platforms/Platforms.scss": [
		1185,
		7,
		965
	],
	"./pages/FlutterAppDevelopment/ServicesSection/ServicesSection": [
		296,
		9,
		516
	],
	"./pages/FlutterAppDevelopment/ServicesSection/ServicesSection.js": [
		296,
		9,
		516
	],
	"./pages/FlutterAppDevelopment/ServicesSection/ServicesSection.scss": [
		1186,
		7,
		966
	],
	"./pages/FlutterAppDevelopment/WhyChooseMi/WhyChooseMi": [
		298,
		9,
		328
	],
	"./pages/FlutterAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		298,
		9,
		328
	],
	"./pages/FlutterAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1188,
		7,
		967
	],
	"./pages/FlutterAppDevelopment/WhyChooseSection/WhyChooseSection": [
		297,
		9,
		592
	],
	"./pages/FlutterAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		297,
		9,
		592
	],
	"./pages/FlutterAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1187,
		7,
		968
	],
	"./pages/GameDevelopment/AboutSection/AboutSection": [
		372,
		9,
		329
	],
	"./pages/GameDevelopment/AboutSection/AboutSection.js": [
		372,
		9,
		329
	],
	"./pages/GameDevelopment/AboutSection/AboutSection.scss": [
		1259,
		7,
		969
	],
	"./pages/GameDevelopment/AboutSection/game-car.svg": [
		2647,
		9,
		1881
	],
	"./pages/GameDevelopment/AboutSection/img/game-car.svg": [
		2648,
		9,
		1882
	],
	"./pages/GameDevelopment/AnimationByke/AnimationByke": [
		376,
		9,
		404
	],
	"./pages/GameDevelopment/AnimationByke/AnimationByke.js": [
		376,
		9,
		404
	],
	"./pages/GameDevelopment/AnimationByke/AnimationByke.scss": [
		1271,
		7,
		970
	],
	"./pages/GameDevelopment/AnimationByke/img/biker.svg": [
		1276,
		9,
		1883
	],
	"./pages/GameDevelopment/AnimationByke/img/city-reflect.svg": [
		1274,
		9,
		1884
	],
	"./pages/GameDevelopment/AnimationByke/img/city.svg": [
		1273,
		9,
		1885
	],
	"./pages/GameDevelopment/AnimationByke/img/land.svg": [
		1277,
		9,
		1886
	],
	"./pages/GameDevelopment/AnimationByke/img/moon.svg": [
		2649,
		9,
		1887
	],
	"./pages/GameDevelopment/AnimationByke/img/sky.svg": [
		1272,
		9,
		1888
	],
	"./pages/GameDevelopment/AnimationByke/img/stripe.svg": [
		1275,
		9,
		1889
	],
	"./pages/GameDevelopment/CantFindTechnology/CantFindTechnology": [
		377,
		9,
		691
	],
	"./pages/GameDevelopment/CantFindTechnology/CantFindTechnology.js": [
		377,
		9,
		691
	],
	"./pages/GameDevelopment/CantFindTechnology/CantFindTechnology.scss": [
		1278,
		7,
		971
	],
	"./pages/GameDevelopment/GameDevelopment": [
		131,
		9,
		0,
		3,
		86,
		1,
		17
	],
	"./pages/GameDevelopment/GameDevelopment.js": [
		131,
		9,
		0,
		3,
		86,
		1,
		17
	],
	"./pages/GameDevelopment/GameDevelopment.scss": [
		1628,
		7,
		972
	],
	"./pages/GameDevelopment/Genres/Genres": [
		375,
		9,
		3,
		432
	],
	"./pages/GameDevelopment/Genres/Genres.js": [
		375,
		9,
		3,
		432
	],
	"./pages/GameDevelopment/Genres/Genres.scss": [
		1270,
		7,
		973
	],
	"./pages/GameDevelopment/HeroSection/HeroSection": [
		371,
		9,
		452
	],
	"./pages/GameDevelopment/HeroSection/HeroSection.js": [
		371,
		9,
		452
	],
	"./pages/GameDevelopment/HeroSection/HeroSection.scss": [
		1258,
		7,
		974
	],
	"./pages/GameDevelopment/HeroSection/imgs/appium.svg": [
		2650,
		9,
		1890
	],
	"./pages/GameDevelopment/HeroSection/imgs/browserstack.svg": [
		2651,
		9,
		1891
	],
	"./pages/GameDevelopment/HeroSection/imgs/git.svg": [
		2652,
		9,
		1892
	],
	"./pages/GameDevelopment/HeroSection/imgs/jira.svg": [
		2653,
		9,
		1893
	],
	"./pages/GameDevelopment/HeroSection/imgs/microsoft-azure.svg": [
		2654,
		9,
		1894
	],
	"./pages/GameDevelopment/HeroSection/imgs/postman.svg": [
		2655,
		9,
		1895
	],
	"./pages/GameDevelopment/HeroSection/imgs/redmine.svg": [
		2656,
		9,
		1896
	],
	"./pages/GameDevelopment/HeroSection/imgs/selenium.svg": [
		2657,
		9,
		1897
	],
	"./pages/GameDevelopment/OtherServices/OtherServices": [
		378,
		9,
		517
	],
	"./pages/GameDevelopment/OtherServices/OtherServices.js": [
		378,
		9,
		517
	],
	"./pages/GameDevelopment/OtherServices/OtherServices.scss": [
		1279,
		7,
		975
	],
	"./pages/GameDevelopment/ServicesSection/ServicesSection": [
		370,
		9,
		319
	],
	"./pages/GameDevelopment/ServicesSection/ServicesSection.js": [
		370,
		9,
		319
	],
	"./pages/GameDevelopment/ServicesSection/ServicesSection.scss": [
		1257,
		7,
		976
	],
	"./pages/GameDevelopment/Tools/Tools": [
		374,
		9,
		181
	],
	"./pages/GameDevelopment/Tools/Tools.js": [
		374,
		9,
		181
	],
	"./pages/GameDevelopment/Tools/Tools.scss": [
		1261,
		7,
		977
	],
	"./pages/GameDevelopment/Tools/img/ai.svg": [
		1269,
		9,
		1898
	],
	"./pages/GameDevelopment/Tools/img/blender.svg": [
		1266,
		9,
		1899
	],
	"./pages/GameDevelopment/Tools/img/cocos.svg": [
		1263,
		9,
		1900
	],
	"./pages/GameDevelopment/Tools/img/html.svg": [
		1265,
		9,
		1901
	],
	"./pages/GameDevelopment/Tools/img/phaser.svg": [
		1267,
		9,
		1902
	],
	"./pages/GameDevelopment/Tools/img/sketch.svg": [
		1268,
		9,
		1903
	],
	"./pages/GameDevelopment/Tools/img/unity.svg": [
		1262,
		9,
		1904
	],
	"./pages/GameDevelopment/Tools/img/unreal.svg": [
		1264,
		9,
		1905
	],
	"./pages/GameDevelopment/WhyChooseMi/WhyChooseMi": [
		373,
		9,
		330
	],
	"./pages/GameDevelopment/WhyChooseMi/WhyChooseMi.js": [
		373,
		9,
		330
	],
	"./pages/GameDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1260,
		7,
		978
	],
	"./pages/GameDevelopment/imgs/bikeride.png": [
		2658,
		9,
		3199
	],
	"./pages/GameDevelopment/imgs/unity.png": [
		2659,
		9,
		3200
	],
	"./pages/GameDevelopment/imgs/vr.png": [
		2660,
		9,
		3201
	],
	"./pages/GoLangDevelopment/AboutSection/AboutSection": [
		355,
		9,
		218
	],
	"./pages/GoLangDevelopment/AboutSection/AboutSection.js": [
		355,
		9,
		218
	],
	"./pages/GoLangDevelopment/AboutSection/AboutSection.scss": [
		1244,
		7,
		979
	],
	"./pages/GoLangDevelopment/GoLangDevelopment": [
		128,
		9,
		0,
		109,
		1,
		2,
		30
	],
	"./pages/GoLangDevelopment/GoLangDevelopment.js": [
		128,
		9,
		0,
		109,
		1,
		2,
		30
	],
	"./pages/GoLangDevelopment/HeroSection/HeroSection": [
		354,
		9,
		518
	],
	"./pages/GoLangDevelopment/HeroSection/HeroSection.js": [
		354,
		9,
		518
	],
	"./pages/GoLangDevelopment/HeroSection/HeroSection.scss": [
		1243,
		7,
		980
	],
	"./pages/GoLangDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2661,
		7,
		981
	],
	"./pages/GoLangDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2662,
		7,
		982
	],
	"./pages/GoLangDevelopment/Platforms/Platforms": [
		702,
		9,
		436
	],
	"./pages/GoLangDevelopment/Platforms/Platforms.js": [
		702,
		9,
		436
	],
	"./pages/GoLangDevelopment/Platforms/Platforms.scss": [
		1717,
		7,
		983
	],
	"./pages/GoLangDevelopment/ServicesSection/ServicesSection": [
		358,
		9,
		593
	],
	"./pages/GoLangDevelopment/ServicesSection/ServicesSection.js": [
		358,
		9,
		593
	],
	"./pages/GoLangDevelopment/ServicesSection/ServicesSection.scss": [
		1247,
		7,
		984
	],
	"./pages/GoLangDevelopment/TechnologiesSection/TechnologiesSection": [
		703,
		9,
		637
	],
	"./pages/GoLangDevelopment/TechnologiesSection/TechnologiesSection.js": [
		703,
		9,
		637
	],
	"./pages/GoLangDevelopment/WhyChooseMi/WhyChooseMi": [
		357,
		9,
		331
	],
	"./pages/GoLangDevelopment/WhyChooseMi/WhyChooseMi.js": [
		357,
		9,
		331
	],
	"./pages/GoLangDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1246,
		7,
		985
	],
	"./pages/GoLangDevelopment/WhyChooseSection/WhyChooseSection": [
		356,
		9,
		692
	],
	"./pages/GoLangDevelopment/WhyChooseSection/WhyChooseSection.js": [
		356,
		9,
		692
	],
	"./pages/GoLangDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1245,
		7,
		986
	],
	"./pages/Hire/BenefitsSection/BenefitsSection": [
		704,
		9,
		276
	],
	"./pages/Hire/BenefitsSection/BenefitsSection.js": [
		704,
		9,
		276
	],
	"./pages/Hire/HireAndroidDevelopers/AboutSection/AboutSection": [
		502,
		9,
		332
	],
	"./pages/Hire/HireAndroidDevelopers/AboutSection/AboutSection.js": [
		502,
		9,
		332
	],
	"./pages/Hire/HireAndroidDevelopers/AboutSection/AboutSection.scss": [
		1419,
		7,
		987
	],
	"./pages/Hire/HireAndroidDevelopers/HeroSection/HeroSection": [
		503,
		9,
		302
	],
	"./pages/Hire/HireAndroidDevelopers/HeroSection/HeroSection.js": [
		503,
		9,
		302
	],
	"./pages/Hire/HireAndroidDevelopers/HeroSection/HeroSection.scss": [
		1420,
		7,
		988
	],
	"./pages/Hire/HireAndroidDevelopers/HireAndroidDevelopers": [
		157,
		9,
		0,
		129,
		1,
		2,
		39
	],
	"./pages/Hire/HireAndroidDevelopers/HireAndroidDevelopers.js": [
		157,
		9,
		0,
		129,
		1,
		2,
		39
	],
	"./pages/Hire/HireAndroidDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2663,
		7,
		989
	],
	"./pages/Hire/HireAndroidDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2664,
		7,
		990
	],
	"./pages/Hire/HireAndroidDevelopers/OurRecentWork/OurRecentWork": [
		705,
		9,
		279
	],
	"./pages/Hire/HireAndroidDevelopers/OurRecentWork/OurRecentWork.js": [
		705,
		9,
		279
	],
	"./pages/Hire/HireAndroidDevelopers/OurRecentWork/OurRecentWork.scss": [
		1718,
		7,
		991
	],
	"./pages/Hire/HireAndroidDevelopers/ServicesSection/ServicesSection": [
		504,
		9,
		519
	],
	"./pages/Hire/HireAndroidDevelopers/ServicesSection/ServicesSection.js": [
		504,
		9,
		519
	],
	"./pages/Hire/HireAndroidDevelopers/ServicesSection/ServicesSection.scss": [
		1421,
		7,
		992
	],
	"./pages/Hire/HireAndroidDevelopers/WhatWeProvide/WhatWeProvide": [
		505,
		9,
		465
	],
	"./pages/Hire/HireAndroidDevelopers/WhatWeProvide/WhatWeProvide.js": [
		505,
		9,
		465
	],
	"./pages/Hire/HireAndroidDevelopers/WhatWeProvide/WhatWeProvide.scss": [
		2665,
		7,
		993
	],
	"./pages/Hire/HireAndroidDevelopers/WhyChoose/WhyChoose": [
		706,
		9,
		409
	],
	"./pages/Hire/HireAndroidDevelopers/WhyChoose/WhyChoose.js": [
		706,
		9,
		409
	],
	"./pages/Hire/HireAndroidDevelopers/WhyChooseMi/WhyChooseMi": [
		506,
		9,
		333
	],
	"./pages/Hire/HireAndroidDevelopers/WhyChooseMi/WhyChooseMi.js": [
		506,
		9,
		333
	],
	"./pages/Hire/HireAndroidDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1422,
		7,
		994
	],
	"./pages/Hire/HireAngularDevelopers/AboutSection/AboutSection": [
		529,
		9,
		334
	],
	"./pages/Hire/HireAngularDevelopers/AboutSection/AboutSection.js": [
		529,
		9,
		334
	],
	"./pages/Hire/HireAngularDevelopers/AboutSection/AboutSection.scss": [
		1443,
		7,
		995
	],
	"./pages/Hire/HireAngularDevelopers/HeroSection/HeroSection": [
		530,
		9,
		303
	],
	"./pages/Hire/HireAngularDevelopers/HeroSection/HeroSection.js": [
		530,
		9,
		303
	],
	"./pages/Hire/HireAngularDevelopers/HeroSection/HeroSection.scss": [
		1444,
		7,
		996
	],
	"./pages/Hire/HireAngularDevelopers/HireAngularDevelopers": [
		163,
		9,
		0,
		135,
		1,
		2,
		40
	],
	"./pages/Hire/HireAngularDevelopers/HireAngularDevelopers.js": [
		163,
		9,
		0,
		135,
		1,
		2,
		40
	],
	"./pages/Hire/HireAngularDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2666,
		7,
		997
	],
	"./pages/Hire/HireAngularDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2667,
		7,
		998
	],
	"./pages/Hire/HireAngularDevelopers/OurRecentWork/OurRecentWork": [
		707,
		9,
		280
	],
	"./pages/Hire/HireAngularDevelopers/OurRecentWork/OurRecentWork.js": [
		707,
		9,
		280
	],
	"./pages/Hire/HireAngularDevelopers/OurRecentWork/OurRecentWork.scss": [
		1719,
		7,
		999
	],
	"./pages/Hire/HireAngularDevelopers/ServicesSection/ServicesSection": [
		531,
		9,
		520
	],
	"./pages/Hire/HireAngularDevelopers/ServicesSection/ServicesSection.js": [
		531,
		9,
		520
	],
	"./pages/Hire/HireAngularDevelopers/ServicesSection/ServicesSection.scss": [
		1445,
		7,
		1000
	],
	"./pages/Hire/HireAngularDevelopers/WhyChooseMi/WhyChooseMi": [
		532,
		9,
		335
	],
	"./pages/Hire/HireAngularDevelopers/WhyChooseMi/WhyChooseMi.js": [
		532,
		9,
		335
	],
	"./pages/Hire/HireAngularDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1446,
		7,
		1001
	],
	"./pages/Hire/HireDevelopers/AboutSection/AboutSection": [
		487,
		9,
		336
	],
	"./pages/Hire/HireDevelopers/AboutSection/AboutSection.js": [
		487,
		9,
		336
	],
	"./pages/Hire/HireDevelopers/AboutSection/AboutSection.scss": [
		1386,
		7,
		1002
	],
	"./pages/Hire/HireDevelopers/HeroSection/HeroSection": [
		488,
		9,
		304
	],
	"./pages/Hire/HireDevelopers/HeroSection/HeroSection.js": [
		488,
		9,
		304
	],
	"./pages/Hire/HireDevelopers/HeroSection/HeroSection.scss": [
		1387,
		7,
		1003
	],
	"./pages/Hire/HireDevelopers/HireDevelopers": [
		154,
		9,
		0,
		3,
		9,
		85,
		16
	],
	"./pages/Hire/HireDevelopers/HireDevelopers.js": [
		154,
		9,
		0,
		3,
		9,
		85,
		16
	],
	"./pages/Hire/HireDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2668,
		7,
		1004
	],
	"./pages/Hire/HireDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2669,
		7,
		1005
	],
	"./pages/Hire/HireDevelopers/ServicesSection/ServicesSection": [
		490,
		9,
		9,
		173
	],
	"./pages/Hire/HireDevelopers/ServicesSection/ServicesSection.js": [
		490,
		9,
		9,
		173
	],
	"./pages/Hire/HireDevelopers/ServicesSection/ServicesSection.scss": [
		1389,
		7,
		1006
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/android.svg": [
		1391,
		9,
		1906
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/angular.svg": [
		1394,
		9,
		1907
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/flutter.svg": [
		1392,
		9,
		1908
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/fullstack.svg": [
		1398,
		9,
		1909
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/golang.svg": [
		1399,
		9,
		1910
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/ionic.svg": [
		2670,
		9,
		1911
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/ios.svg": [
		1390,
		9,
		1912
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/nodejs.svg": [
		1397,
		9,
		1913
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/php.svg": [
		1401,
		9,
		1914
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/python.svg": [
		1400,
		9,
		1915
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/reactnative.svg": [
		1395,
		9,
		1916
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/swift.svg": [
		1393,
		9,
		1917
	],
	"./pages/Hire/HireDevelopers/ServicesSection/dev-img/vuejs.svg": [
		1396,
		9,
		1918
	],
	"./pages/Hire/HireDevelopers/WhyChooseMi/WhyChooseMi": [
		489,
		9,
		337
	],
	"./pages/Hire/HireDevelopers/WhyChooseMi/WhyChooseMi.js": [
		489,
		9,
		337
	],
	"./pages/Hire/HireDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1388,
		7,
		1007
	],
	"./pages/Hire/HireFlutterDevelopers/AboutSecondarySection/AboutSecondarySection": [
		708,
		9,
		466
	],
	"./pages/Hire/HireFlutterDevelopers/AboutSecondarySection/AboutSecondarySection.js": [
		708,
		9,
		466
	],
	"./pages/Hire/HireFlutterDevelopers/AboutSection/AboutSection": [
		512,
		9,
		338
	],
	"./pages/Hire/HireFlutterDevelopers/AboutSection/AboutSection.js": [
		512,
		9,
		338
	],
	"./pages/Hire/HireFlutterDevelopers/AboutSection/AboutSection.scss": [
		1427,
		7,
		1008
	],
	"./pages/Hire/HireFlutterDevelopers/HeroSection/HeroSection": [
		516,
		9,
		305
	],
	"./pages/Hire/HireFlutterDevelopers/HeroSection/HeroSection.js": [
		516,
		9,
		305
	],
	"./pages/Hire/HireFlutterDevelopers/HeroSection/HeroSection.scss": [
		1430,
		7,
		1009
	],
	"./pages/Hire/HireFlutterDevelopers/HireFlutterDevelopers": [
		159,
		9,
		0,
		131,
		1,
		2,
		41
	],
	"./pages/Hire/HireFlutterDevelopers/HireFlutterDevelopers.js": [
		159,
		9,
		0,
		131,
		1,
		2,
		41
	],
	"./pages/Hire/HireFlutterDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2671,
		7,
		1010
	],
	"./pages/Hire/HireFlutterDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2672,
		7,
		1011
	],
	"./pages/Hire/HireFlutterDevelopers/OurRecentWork/OurRecentWork": [
		709,
		9,
		281
	],
	"./pages/Hire/HireFlutterDevelopers/OurRecentWork/OurRecentWork.js": [
		709,
		9,
		281
	],
	"./pages/Hire/HireFlutterDevelopers/OurRecentWork/OurRecentWork.scss": [
		1720,
		7,
		1012
	],
	"./pages/Hire/HireFlutterDevelopers/ServicesSection/ServicesSection": [
		513,
		9,
		521
	],
	"./pages/Hire/HireFlutterDevelopers/ServicesSection/ServicesSection.js": [
		513,
		9,
		521
	],
	"./pages/Hire/HireFlutterDevelopers/ServicesSection/ServicesSection.scss": [
		1428,
		7,
		1013
	],
	"./pages/Hire/HireFlutterDevelopers/WhatWeProvide/WhatWeProvide": [
		515,
		9,
		467
	],
	"./pages/Hire/HireFlutterDevelopers/WhatWeProvide/WhatWeProvide.js": [
		515,
		9,
		467
	],
	"./pages/Hire/HireFlutterDevelopers/WhatWeProvide/WhatWeProvide.scss": [
		2673,
		7,
		1014
	],
	"./pages/Hire/HireFlutterDevelopers/WhyChooseMi/WhyChooseMi": [
		514,
		9,
		339
	],
	"./pages/Hire/HireFlutterDevelopers/WhyChooseMi/WhyChooseMi.js": [
		514,
		9,
		339
	],
	"./pages/Hire/HireFlutterDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1429,
		7,
		1015
	],
	"./pages/Hire/HireFullStackDevelopers/AboutSecondarySection/AboutSecondarySection": [
		710,
		9,
		483
	],
	"./pages/Hire/HireFullStackDevelopers/AboutSecondarySection/AboutSecondarySection.js": [
		710,
		9,
		483
	],
	"./pages/Hire/HireFullStackDevelopers/AboutSection/AboutSection": [
		545,
		9,
		340
	],
	"./pages/Hire/HireFullStackDevelopers/AboutSection/AboutSection.js": [
		545,
		9,
		340
	],
	"./pages/Hire/HireFullStackDevelopers/AboutSection/AboutSection.scss": [
		1459,
		7,
		1016
	],
	"./pages/Hire/HireFullStackDevelopers/HeroSection/HeroSection": [
		546,
		9,
		306
	],
	"./pages/Hire/HireFullStackDevelopers/HeroSection/HeroSection.js": [
		546,
		9,
		306
	],
	"./pages/Hire/HireFullStackDevelopers/HeroSection/HeroSection.scss": [
		1460,
		7,
		1017
	],
	"./pages/Hire/HireFullStackDevelopers/HireFullStackDevelopers": [
		167,
		9,
		0,
		139,
		1,
		2,
		42
	],
	"./pages/Hire/HireFullStackDevelopers/HireFullStackDevelopers.js": [
		167,
		9,
		0,
		139,
		1,
		2,
		42
	],
	"./pages/Hire/HireFullStackDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2674,
		7,
		1018
	],
	"./pages/Hire/HireFullStackDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2675,
		7,
		1019
	],
	"./pages/Hire/HireFullStackDevelopers/OurRecentWork/OurRecentWork": [
		711,
		9,
		282
	],
	"./pages/Hire/HireFullStackDevelopers/OurRecentWork/OurRecentWork.js": [
		711,
		9,
		282
	],
	"./pages/Hire/HireFullStackDevelopers/OurRecentWork/OurRecentWork.scss": [
		1721,
		7,
		1020
	],
	"./pages/Hire/HireFullStackDevelopers/ServicesSection/ServicesSection": [
		547,
		9,
		522
	],
	"./pages/Hire/HireFullStackDevelopers/ServicesSection/ServicesSection.js": [
		547,
		9,
		522
	],
	"./pages/Hire/HireFullStackDevelopers/ServicesSection/ServicesSection.scss": [
		1461,
		7,
		1021
	],
	"./pages/Hire/HireFullStackDevelopers/WhyChooseMi/WhyChooseMi": [
		548,
		9,
		341
	],
	"./pages/Hire/HireFullStackDevelopers/WhyChooseMi/WhyChooseMi.js": [
		548,
		9,
		341
	],
	"./pages/Hire/HireFullStackDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1462,
		7,
		1022
	],
	"./pages/Hire/HireGameDevelopers/AboutSection/AboutSection": [
		491,
		9,
		342
	],
	"./pages/Hire/HireGameDevelopers/AboutSection/AboutSection.js": [
		491,
		9,
		342
	],
	"./pages/Hire/HireGameDevelopers/AboutSection/AboutSection.scss": [
		1402,
		7,
		1023
	],
	"./pages/Hire/HireGameDevelopers/HeroSection/HeroSection": [
		492,
		9,
		307
	],
	"./pages/Hire/HireGameDevelopers/HeroSection/HeroSection.js": [
		492,
		9,
		307
	],
	"./pages/Hire/HireGameDevelopers/HeroSection/HeroSection.scss": [
		1403,
		7,
		1024
	],
	"./pages/Hire/HireGameDevelopers/HireGameDevelopers": [
		155,
		9,
		0,
		127,
		1,
		2,
		27
	],
	"./pages/Hire/HireGameDevelopers/HireGameDevelopers.js": [
		155,
		9,
		0,
		127,
		1,
		2,
		27
	],
	"./pages/Hire/HireGameDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2676,
		7,
		1025
	],
	"./pages/Hire/HireGameDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2677,
		7,
		1026
	],
	"./pages/Hire/HireGameDevelopers/OurRecentWork/OurRecentWork": [
		712,
		9,
		283
	],
	"./pages/Hire/HireGameDevelopers/OurRecentWork/OurRecentWork.js": [
		712,
		9,
		283
	],
	"./pages/Hire/HireGameDevelopers/OurRecentWork/OurRecentWork.scss": [
		1722,
		7,
		1027
	],
	"./pages/Hire/HireGameDevelopers/ServicesSection/ServicesSection": [
		493,
		9,
		523
	],
	"./pages/Hire/HireGameDevelopers/ServicesSection/ServicesSection.js": [
		493,
		9,
		523
	],
	"./pages/Hire/HireGameDevelopers/ServicesSection/ServicesSection.scss": [
		1404,
		7,
		1028
	],
	"./pages/Hire/HireGameDevelopers/Tools/Tools": [
		496,
		9,
		182
	],
	"./pages/Hire/HireGameDevelopers/Tools/Tools.js": [
		496,
		9,
		182
	],
	"./pages/Hire/HireGameDevelopers/Tools/Tools.scss": [
		1406,
		7,
		1029
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/ai.svg": [
		1414,
		9,
		1919
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/blender.svg": [
		1411,
		9,
		1920
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/cocos.svg": [
		1408,
		9,
		1921
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/html.svg": [
		1410,
		9,
		1922
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/phaser.svg": [
		1412,
		9,
		1923
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/sketch.svg": [
		1413,
		9,
		1924
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/unity.svg": [
		1407,
		9,
		1925
	],
	"./pages/Hire/HireGameDevelopers/Tools/img/unreal.svg": [
		1409,
		9,
		1926
	],
	"./pages/Hire/HireGameDevelopers/WhatWeProvide/WhatWeProvide": [
		713,
		7,
		801
	],
	"./pages/Hire/HireGameDevelopers/WhatWeProvide/WhatWeProvide.js": [
		713,
		7,
		801
	],
	"./pages/Hire/HireGameDevelopers/WhatWeProvide/WhatWeProvide.scss": [
		2678,
		7,
		1030
	],
	"./pages/Hire/HireGameDevelopers/WhyChoose/WhyChoose": [
		714,
		9,
		410
	],
	"./pages/Hire/HireGameDevelopers/WhyChoose/WhyChoose.js": [
		714,
		9,
		410
	],
	"./pages/Hire/HireGameDevelopers/WhyChooseMi/WhyChooseMi": [
		494,
		9,
		343
	],
	"./pages/Hire/HireGameDevelopers/WhyChooseMi/WhyChooseMi.js": [
		494,
		9,
		343
	],
	"./pages/Hire/HireGameDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1405,
		7,
		1031
	],
	"./pages/Hire/HireGolangDevelopers/AboutSecondarySection/AboutSecondarySection": [
		715,
		9,
		468
	],
	"./pages/Hire/HireGolangDevelopers/AboutSecondarySection/AboutSecondarySection.js": [
		715,
		9,
		468
	],
	"./pages/Hire/HireGolangDevelopers/AboutSection/AboutSection": [
		517,
		9,
		344
	],
	"./pages/Hire/HireGolangDevelopers/AboutSection/AboutSection.js": [
		517,
		9,
		344
	],
	"./pages/Hire/HireGolangDevelopers/AboutSection/AboutSection.scss": [
		1431,
		7,
		1032
	],
	"./pages/Hire/HireGolangDevelopers/HeroSection/HeroSection": [
		518,
		9,
		308
	],
	"./pages/Hire/HireGolangDevelopers/HeroSection/HeroSection.js": [
		518,
		9,
		308
	],
	"./pages/Hire/HireGolangDevelopers/HeroSection/HeroSection.scss": [
		1432,
		7,
		1033
	],
	"./pages/Hire/HireGolangDevelopers/HireGolangDevelopers": [
		160,
		9,
		0,
		132,
		1,
		2,
		43
	],
	"./pages/Hire/HireGolangDevelopers/HireGolangDevelopers.js": [
		160,
		9,
		0,
		132,
		1,
		2,
		43
	],
	"./pages/Hire/HireGolangDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2679,
		7,
		1034
	],
	"./pages/Hire/HireGolangDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2680,
		7,
		1035
	],
	"./pages/Hire/HireGolangDevelopers/OurRecentWork/OurRecentWork": [
		716,
		9,
		284
	],
	"./pages/Hire/HireGolangDevelopers/OurRecentWork/OurRecentWork.js": [
		716,
		9,
		284
	],
	"./pages/Hire/HireGolangDevelopers/OurRecentWork/OurRecentWork.scss": [
		1723,
		7,
		1036
	],
	"./pages/Hire/HireGolangDevelopers/ServicesSection/ServicesSection": [
		519,
		9,
		524
	],
	"./pages/Hire/HireGolangDevelopers/ServicesSection/ServicesSection.js": [
		519,
		9,
		524
	],
	"./pages/Hire/HireGolangDevelopers/ServicesSection/ServicesSection.scss": [
		1433,
		7,
		1037
	],
	"./pages/Hire/HireGolangDevelopers/WhyChooseMi/WhyChooseMi": [
		520,
		9,
		345
	],
	"./pages/Hire/HireGolangDevelopers/WhyChooseMi/WhyChooseMi.js": [
		520,
		9,
		345
	],
	"./pages/Hire/HireGolangDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1434,
		7,
		1038
	],
	"./pages/Hire/HireIphoneDevelopers/AboutSection/AboutSection": [
		497,
		9,
		346
	],
	"./pages/Hire/HireIphoneDevelopers/AboutSection/AboutSection.js": [
		497,
		9,
		346
	],
	"./pages/Hire/HireIphoneDevelopers/AboutSection/AboutSection.scss": [
		1415,
		7,
		1039
	],
	"./pages/Hire/HireIphoneDevelopers/HeroSection/HeroSection": [
		498,
		9,
		309
	],
	"./pages/Hire/HireIphoneDevelopers/HeroSection/HeroSection.js": [
		498,
		9,
		309
	],
	"./pages/Hire/HireIphoneDevelopers/HeroSection/HeroSection.scss": [
		1416,
		7,
		1040
	],
	"./pages/Hire/HireIphoneDevelopers/HireIphoneDevelopers": [
		156,
		9,
		0,
		128,
		1,
		2,
		44
	],
	"./pages/Hire/HireIphoneDevelopers/HireIphoneDevelopers.js": [
		156,
		9,
		0,
		128,
		1,
		2,
		44
	],
	"./pages/Hire/HireIphoneDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2681,
		7,
		1041
	],
	"./pages/Hire/HireIphoneDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2682,
		7,
		1042
	],
	"./pages/Hire/HireIphoneDevelopers/OurRecentWork/OurRecentWork": [
		717,
		9,
		285
	],
	"./pages/Hire/HireIphoneDevelopers/OurRecentWork/OurRecentWork.js": [
		717,
		9,
		285
	],
	"./pages/Hire/HireIphoneDevelopers/OurRecentWork/OurRecentWork.scss": [
		1724,
		7,
		1043
	],
	"./pages/Hire/HireIphoneDevelopers/ServicesSection/ServicesSection": [
		499,
		9,
		525
	],
	"./pages/Hire/HireIphoneDevelopers/ServicesSection/ServicesSection.js": [
		499,
		9,
		525
	],
	"./pages/Hire/HireIphoneDevelopers/ServicesSection/ServicesSection.scss": [
		1417,
		7,
		1044
	],
	"./pages/Hire/HireIphoneDevelopers/WhatWeProvide/WhatWeProvide": [
		500,
		9,
		469
	],
	"./pages/Hire/HireIphoneDevelopers/WhatWeProvide/WhatWeProvide.js": [
		500,
		9,
		469
	],
	"./pages/Hire/HireIphoneDevelopers/WhatWeProvide/WhatWeProvide.scss": [
		2683,
		7,
		1045
	],
	"./pages/Hire/HireIphoneDevelopers/WhyChoose/WhyChoose": [
		718,
		9,
		411
	],
	"./pages/Hire/HireIphoneDevelopers/WhyChoose/WhyChoose.js": [
		718,
		9,
		411
	],
	"./pages/Hire/HireIphoneDevelopers/WhyChooseMi/WhyChooseMi": [
		501,
		9,
		347
	],
	"./pages/Hire/HireIphoneDevelopers/WhyChooseMi/WhyChooseMi.js": [
		501,
		9,
		347
	],
	"./pages/Hire/HireIphoneDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1418,
		7,
		1046
	],
	"./pages/Hire/HireNodeJsDevelopers/AboutSection/AboutSection": [
		533,
		9,
		348
	],
	"./pages/Hire/HireNodeJsDevelopers/AboutSection/AboutSection.js": [
		533,
		9,
		348
	],
	"./pages/Hire/HireNodeJsDevelopers/AboutSection/AboutSection.scss": [
		1447,
		7,
		1047
	],
	"./pages/Hire/HireNodeJsDevelopers/HeroSection/HeroSection": [
		534,
		9,
		310
	],
	"./pages/Hire/HireNodeJsDevelopers/HeroSection/HeroSection.js": [
		534,
		9,
		310
	],
	"./pages/Hire/HireNodeJsDevelopers/HeroSection/HeroSection.scss": [
		1448,
		7,
		1048
	],
	"./pages/Hire/HireNodeJsDevelopers/HireNodeJsDevelopers": [
		164,
		9,
		0,
		136,
		1,
		2,
		45
	],
	"./pages/Hire/HireNodeJsDevelopers/HireNodeJsDevelopers.js": [
		164,
		9,
		0,
		136,
		1,
		2,
		45
	],
	"./pages/Hire/HireNodeJsDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2684,
		7,
		1049
	],
	"./pages/Hire/HireNodeJsDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2685,
		7,
		1050
	],
	"./pages/Hire/HireNodeJsDevelopers/OurRecentWork/OurRecentWork": [
		719,
		9,
		286
	],
	"./pages/Hire/HireNodeJsDevelopers/OurRecentWork/OurRecentWork.js": [
		719,
		9,
		286
	],
	"./pages/Hire/HireNodeJsDevelopers/OurRecentWork/OurRecentWork.scss": [
		1725,
		7,
		1051
	],
	"./pages/Hire/HireNodeJsDevelopers/ServicesSection/ServicesSection": [
		535,
		9,
		526
	],
	"./pages/Hire/HireNodeJsDevelopers/ServicesSection/ServicesSection.js": [
		535,
		9,
		526
	],
	"./pages/Hire/HireNodeJsDevelopers/ServicesSection/ServicesSection.scss": [
		1449,
		7,
		1052
	],
	"./pages/Hire/HireNodeJsDevelopers/WhyChooseMi/WhyChooseMi": [
		536,
		9,
		349
	],
	"./pages/Hire/HireNodeJsDevelopers/WhyChooseMi/WhyChooseMi.js": [
		536,
		9,
		349
	],
	"./pages/Hire/HireNodeJsDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1450,
		7,
		1053
	],
	"./pages/Hire/HirePhpDevelopers/AboutSection/AboutSection": [
		549,
		9,
		350
	],
	"./pages/Hire/HirePhpDevelopers/AboutSection/AboutSection.js": [
		549,
		9,
		350
	],
	"./pages/Hire/HirePhpDevelopers/AboutSection/AboutSection.scss": [
		1463,
		7,
		1054
	],
	"./pages/Hire/HirePhpDevelopers/HeroSection/HeroSection": [
		550,
		9,
		311
	],
	"./pages/Hire/HirePhpDevelopers/HeroSection/HeroSection.js": [
		550,
		9,
		311
	],
	"./pages/Hire/HirePhpDevelopers/HeroSection/HeroSection.scss": [
		1464,
		7,
		1055
	],
	"./pages/Hire/HirePhpDevelopers/HirePhpDevelopers": [
		168,
		9,
		0,
		140,
		1,
		2,
		46
	],
	"./pages/Hire/HirePhpDevelopers/HirePhpDevelopers.js": [
		168,
		9,
		0,
		140,
		1,
		2,
		46
	],
	"./pages/Hire/HirePhpDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2686,
		7,
		1056
	],
	"./pages/Hire/HirePhpDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2687,
		7,
		1057
	],
	"./pages/Hire/HirePhpDevelopers/OurRecentWork/OurRecentWork": [
		720,
		9,
		287
	],
	"./pages/Hire/HirePhpDevelopers/OurRecentWork/OurRecentWork.js": [
		720,
		9,
		287
	],
	"./pages/Hire/HirePhpDevelopers/OurRecentWork/OurRecentWork.scss": [
		1726,
		7,
		1058
	],
	"./pages/Hire/HirePhpDevelopers/ServicesSection/ServicesSection": [
		551,
		9,
		527
	],
	"./pages/Hire/HirePhpDevelopers/ServicesSection/ServicesSection.js": [
		551,
		9,
		527
	],
	"./pages/Hire/HirePhpDevelopers/ServicesSection/ServicesSection.scss": [
		1465,
		7,
		1059
	],
	"./pages/Hire/HirePhpDevelopers/WhyChooseMi/WhyChooseMi": [
		552,
		9,
		351
	],
	"./pages/Hire/HirePhpDevelopers/WhyChooseMi/WhyChooseMi.js": [
		552,
		9,
		351
	],
	"./pages/Hire/HirePhpDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1466,
		7,
		1060
	],
	"./pages/Hire/HirePythonDevelopers/AboutSection/AboutSection": [
		521,
		9,
		352
	],
	"./pages/Hire/HirePythonDevelopers/AboutSection/AboutSection.js": [
		521,
		9,
		352
	],
	"./pages/Hire/HirePythonDevelopers/AboutSection/AboutSection.scss": [
		1435,
		7,
		1061
	],
	"./pages/Hire/HirePythonDevelopers/HeroSection/HeroSection": [
		524,
		9,
		312
	],
	"./pages/Hire/HirePythonDevelopers/HeroSection/HeroSection.js": [
		524,
		9,
		312
	],
	"./pages/Hire/HirePythonDevelopers/HeroSection/HeroSection.scss": [
		1438,
		7,
		1062
	],
	"./pages/Hire/HirePythonDevelopers/HirePythonDevelopers": [
		161,
		9,
		0,
		133,
		1,
		2,
		47
	],
	"./pages/Hire/HirePythonDevelopers/HirePythonDevelopers.js": [
		161,
		9,
		0,
		133,
		1,
		2,
		47
	],
	"./pages/Hire/HirePythonDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2688,
		7,
		1063
	],
	"./pages/Hire/HirePythonDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2689,
		7,
		1064
	],
	"./pages/Hire/HirePythonDevelopers/OurRecentWork/OurRecentWork": [
		721,
		9,
		288
	],
	"./pages/Hire/HirePythonDevelopers/OurRecentWork/OurRecentWork.js": [
		721,
		9,
		288
	],
	"./pages/Hire/HirePythonDevelopers/OurRecentWork/OurRecentWork.scss": [
		1727,
		7,
		1065
	],
	"./pages/Hire/HirePythonDevelopers/ServicesSection/ServicesSection": [
		522,
		9,
		528
	],
	"./pages/Hire/HirePythonDevelopers/ServicesSection/ServicesSection.js": [
		522,
		9,
		528
	],
	"./pages/Hire/HirePythonDevelopers/ServicesSection/ServicesSection.scss": [
		1436,
		7,
		1066
	],
	"./pages/Hire/HirePythonDevelopers/WhyChooseMi/WhyChooseMi": [
		523,
		9,
		353
	],
	"./pages/Hire/HirePythonDevelopers/WhyChooseMi/WhyChooseMi.js": [
		523,
		9,
		353
	],
	"./pages/Hire/HirePythonDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1437,
		7,
		1067
	],
	"./pages/Hire/HireQAEngineers/AboutSection/AboutSection": [
		558,
		9,
		354
	],
	"./pages/Hire/HireQAEngineers/AboutSection/AboutSection.js": [
		558,
		9,
		354
	],
	"./pages/Hire/HireQAEngineers/AboutSection/AboutSection.scss": [
		1472,
		7,
		1068
	],
	"./pages/Hire/HireQAEngineers/HeroSection/HeroSection": [
		559,
		9,
		313
	],
	"./pages/Hire/HireQAEngineers/HeroSection/HeroSection.js": [
		559,
		9,
		313
	],
	"./pages/Hire/HireQAEngineers/HeroSection/HeroSection.scss": [
		1473,
		7,
		1069
	],
	"./pages/Hire/HireQAEngineers/HireQAEngineers": [
		170,
		9,
		0,
		1,
		2,
		78
	],
	"./pages/Hire/HireQAEngineers/HireQAEngineers.js": [
		170,
		9,
		0,
		1,
		2,
		78
	],
	"./pages/Hire/HireQAEngineers/LookingDevelopers/LookingDevelopers.scss": [
		2690,
		7,
		1070
	],
	"./pages/Hire/HireQAEngineers/NewOpenSourceLibraries/NewOpenSourceLibraries": [
		722,
		9,
		193
	],
	"./pages/Hire/HireQAEngineers/NewOpenSourceLibraries/NewOpenSourceLibraries.js": [
		722,
		9,
		193
	],
	"./pages/Hire/HireQAEngineers/NewOpenSourceLibraries/NewOpenSourceLibraries.scss": [
		1728,
		7,
		1071
	],
	"./pages/Hire/HireQAEngineers/OurRecentWork/OurRecentWork": [
		723,
		9,
		289
	],
	"./pages/Hire/HireQAEngineers/OurRecentWork/OurRecentWork.js": [
		723,
		9,
		289
	],
	"./pages/Hire/HireQAEngineers/OurRecentWork/OurRecentWork.scss": [
		1729,
		7,
		1072
	],
	"./pages/Hire/HireQAEngineers/ServicesSection/ServicesSection": [
		560,
		9,
		529
	],
	"./pages/Hire/HireQAEngineers/ServicesSection/ServicesSection.js": [
		560,
		9,
		529
	],
	"./pages/Hire/HireQAEngineers/ServicesSection/ServicesSection.scss": [
		1474,
		7,
		1073
	],
	"./pages/Hire/HireQAEngineers/WhatWeProvide/WhatWeProvide": [
		495,
		9,
		470
	],
	"./pages/Hire/HireQAEngineers/WhatWeProvide/WhatWeProvide.js": [
		495,
		9,
		470
	],
	"./pages/Hire/HireQAEngineers/WhatWeProvide/WhatWeProvide.scss": [
		2691,
		7,
		1074
	],
	"./pages/Hire/HireQAEngineers/WhyChoose/WhyChoose": [
		724,
		9,
		412
	],
	"./pages/Hire/HireQAEngineers/WhyChoose/WhyChoose.js": [
		724,
		9,
		412
	],
	"./pages/Hire/HireQAEngineers/WhyChooseMi/WhyChooseMi": [
		561,
		9,
		355
	],
	"./pages/Hire/HireQAEngineers/WhyChooseMi/WhyChooseMi.js": [
		561,
		9,
		355
	],
	"./pages/Hire/HireQAEngineers/WhyChooseMi/WhyChooseMi.scss": [
		1475,
		7,
		1075
	],
	"./pages/Hire/HireReactJsDevelopers/AboutSection/AboutSection": [
		537,
		9,
		356
	],
	"./pages/Hire/HireReactJsDevelopers/AboutSection/AboutSection.js": [
		537,
		9,
		356
	],
	"./pages/Hire/HireReactJsDevelopers/AboutSection/AboutSection.scss": [
		1451,
		7,
		1076
	],
	"./pages/Hire/HireReactJsDevelopers/HeroSection/HeroSection": [
		538,
		9,
		314
	],
	"./pages/Hire/HireReactJsDevelopers/HeroSection/HeroSection.js": [
		538,
		9,
		314
	],
	"./pages/Hire/HireReactJsDevelopers/HeroSection/HeroSection.scss": [
		1452,
		7,
		1077
	],
	"./pages/Hire/HireReactJsDevelopers/HireReactJsDevelopers": [
		165,
		9,
		0,
		137,
		1,
		2,
		48
	],
	"./pages/Hire/HireReactJsDevelopers/HireReactJsDevelopers.js": [
		165,
		9,
		0,
		137,
		1,
		2,
		48
	],
	"./pages/Hire/HireReactJsDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2692,
		7,
		1078
	],
	"./pages/Hire/HireReactJsDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2693,
		7,
		1079
	],
	"./pages/Hire/HireReactJsDevelopers/OurRecentWork/OurRecentWork": [
		725,
		9,
		290
	],
	"./pages/Hire/HireReactJsDevelopers/OurRecentWork/OurRecentWork.js": [
		725,
		9,
		290
	],
	"./pages/Hire/HireReactJsDevelopers/OurRecentWork/OurRecentWork.scss": [
		1730,
		7,
		1080
	],
	"./pages/Hire/HireReactJsDevelopers/ServicesSection/ServicesSection": [
		539,
		9,
		530
	],
	"./pages/Hire/HireReactJsDevelopers/ServicesSection/ServicesSection.js": [
		539,
		9,
		530
	],
	"./pages/Hire/HireReactJsDevelopers/ServicesSection/ServicesSection.scss": [
		1453,
		7,
		1081
	],
	"./pages/Hire/HireReactJsDevelopers/WhyChooseMi/WhyChooseMi": [
		540,
		9,
		357
	],
	"./pages/Hire/HireReactJsDevelopers/WhyChooseMi/WhyChooseMi.js": [
		540,
		9,
		357
	],
	"./pages/Hire/HireReactJsDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1454,
		7,
		1082
	],
	"./pages/Hire/HireReactNativeDevelopers/AboutSection/AboutSection": [
		507,
		9,
		358
	],
	"./pages/Hire/HireReactNativeDevelopers/AboutSection/AboutSection.js": [
		507,
		9,
		358
	],
	"./pages/Hire/HireReactNativeDevelopers/AboutSection/AboutSection.scss": [
		1423,
		7,
		1083
	],
	"./pages/Hire/HireReactNativeDevelopers/HeroSection/HeroSection": [
		508,
		9,
		315
	],
	"./pages/Hire/HireReactNativeDevelopers/HeroSection/HeroSection.js": [
		508,
		9,
		315
	],
	"./pages/Hire/HireReactNativeDevelopers/HeroSection/HeroSection.scss": [
		1424,
		7,
		1084
	],
	"./pages/Hire/HireReactNativeDevelopers/HireReactNativeDevelopers": [
		158,
		9,
		0,
		130,
		1,
		2,
		49
	],
	"./pages/Hire/HireReactNativeDevelopers/HireReactNativeDevelopers.js": [
		158,
		9,
		0,
		130,
		1,
		2,
		49
	],
	"./pages/Hire/HireReactNativeDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2694,
		7,
		1085
	],
	"./pages/Hire/HireReactNativeDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2695,
		7,
		1086
	],
	"./pages/Hire/HireReactNativeDevelopers/OurRecentWork/OurRecentWork": [
		726,
		9,
		291
	],
	"./pages/Hire/HireReactNativeDevelopers/OurRecentWork/OurRecentWork.js": [
		726,
		9,
		291
	],
	"./pages/Hire/HireReactNativeDevelopers/OurRecentWork/OurRecentWork.scss": [
		1731,
		7,
		1087
	],
	"./pages/Hire/HireReactNativeDevelopers/ServicesSection/ServicesSection": [
		509,
		9,
		531
	],
	"./pages/Hire/HireReactNativeDevelopers/ServicesSection/ServicesSection.js": [
		509,
		9,
		531
	],
	"./pages/Hire/HireReactNativeDevelopers/ServicesSection/ServicesSection.scss": [
		1425,
		7,
		1088
	],
	"./pages/Hire/HireReactNativeDevelopers/WhatWeProvide/WhatWeProvide": [
		510,
		9,
		471
	],
	"./pages/Hire/HireReactNativeDevelopers/WhatWeProvide/WhatWeProvide.js": [
		510,
		9,
		471
	],
	"./pages/Hire/HireReactNativeDevelopers/WhatWeProvide/WhatWeProvide.scss": [
		2696,
		7,
		1089
	],
	"./pages/Hire/HireReactNativeDevelopers/WhyChoose/WhyChoose": [
		727,
		9,
		413
	],
	"./pages/Hire/HireReactNativeDevelopers/WhyChoose/WhyChoose.js": [
		727,
		9,
		413
	],
	"./pages/Hire/HireReactNativeDevelopers/WhyChooseMi/WhyChooseMi": [
		511,
		9,
		359
	],
	"./pages/Hire/HireReactNativeDevelopers/WhyChooseMi/WhyChooseMi.js": [
		511,
		9,
		359
	],
	"./pages/Hire/HireReactNativeDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1426,
		7,
		1090
	],
	"./pages/Hire/HireSwiftDevelopers/AboutSection/AboutSection": [
		525,
		9,
		360
	],
	"./pages/Hire/HireSwiftDevelopers/AboutSection/AboutSection.js": [
		525,
		9,
		360
	],
	"./pages/Hire/HireSwiftDevelopers/AboutSection/AboutSection.scss": [
		1439,
		7,
		1091
	],
	"./pages/Hire/HireSwiftDevelopers/HeroSection/HeroSection": [
		526,
		9,
		316
	],
	"./pages/Hire/HireSwiftDevelopers/HeroSection/HeroSection.js": [
		526,
		9,
		316
	],
	"./pages/Hire/HireSwiftDevelopers/HeroSection/HeroSection.scss": [
		1440,
		7,
		1092
	],
	"./pages/Hire/HireSwiftDevelopers/HireSwiftDevelopers": [
		162,
		9,
		0,
		134,
		1,
		2,
		50
	],
	"./pages/Hire/HireSwiftDevelopers/HireSwiftDevelopers.js": [
		162,
		9,
		0,
		134,
		1,
		2,
		50
	],
	"./pages/Hire/HireSwiftDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2697,
		7,
		1093
	],
	"./pages/Hire/HireSwiftDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2698,
		7,
		1094
	],
	"./pages/Hire/HireSwiftDevelopers/OurRecentWork/OurRecentWork": [
		728,
		9,
		292
	],
	"./pages/Hire/HireSwiftDevelopers/OurRecentWork/OurRecentWork.js": [
		728,
		9,
		292
	],
	"./pages/Hire/HireSwiftDevelopers/OurRecentWork/OurRecentWork.scss": [
		1732,
		7,
		1095
	],
	"./pages/Hire/HireSwiftDevelopers/ServicesSection/ServicesSection": [
		527,
		9,
		532
	],
	"./pages/Hire/HireSwiftDevelopers/ServicesSection/ServicesSection.js": [
		527,
		9,
		532
	],
	"./pages/Hire/HireSwiftDevelopers/ServicesSection/ServicesSection.scss": [
		1441,
		7,
		1096
	],
	"./pages/Hire/HireSwiftDevelopers/WhatWeProvide/WhatWeProvide": [
		217,
		9,
		472
	],
	"./pages/Hire/HireSwiftDevelopers/WhatWeProvide/WhatWeProvide.js": [
		217,
		9,
		472
	],
	"./pages/Hire/HireSwiftDevelopers/WhatWeProvide/WhatWeProvide.scss": [
		2699,
		7,
		1097
	],
	"./pages/Hire/HireSwiftDevelopers/WhyChoose/WhyChoose": [
		729,
		9,
		414
	],
	"./pages/Hire/HireSwiftDevelopers/WhyChoose/WhyChoose.js": [
		729,
		9,
		414
	],
	"./pages/Hire/HireSwiftDevelopers/WhyChooseMi/WhyChooseMi": [
		528,
		9,
		361
	],
	"./pages/Hire/HireSwiftDevelopers/WhyChooseMi/WhyChooseMi.js": [
		528,
		9,
		361
	],
	"./pages/Hire/HireSwiftDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1442,
		7,
		1098
	],
	"./pages/Hire/HireUIUXDesigner/AboutSection/AboutSection": [
		553,
		9,
		362
	],
	"./pages/Hire/HireUIUXDesigner/AboutSection/AboutSection.js": [
		553,
		9,
		362
	],
	"./pages/Hire/HireUIUXDesigner/AboutSection/AboutSection.scss": [
		1467,
		7,
		1099
	],
	"./pages/Hire/HireUIUXDesigner/HeroSection/HeroSection": [
		554,
		9,
		317
	],
	"./pages/Hire/HireUIUXDesigner/HeroSection/HeroSection.js": [
		554,
		9,
		317
	],
	"./pages/Hire/HireUIUXDesigner/HeroSection/HeroSection.scss": [
		1468,
		7,
		1100
	],
	"./pages/Hire/HireUIUXDesigner/HireUIUXDesigner": [
		169,
		9,
		0,
		5,
		87,
		1,
		29
	],
	"./pages/Hire/HireUIUXDesigner/HireUIUXDesigner.js": [
		169,
		9,
		0,
		5,
		87,
		1,
		29
	],
	"./pages/Hire/HireUIUXDesigner/NewOpenSourceLibraries/NewOpenSourceLibraries": [
		730,
		9,
		194
	],
	"./pages/Hire/HireUIUXDesigner/NewOpenSourceLibraries/NewOpenSourceLibraries.js": [
		730,
		9,
		194
	],
	"./pages/Hire/HireUIUXDesigner/NewOpenSourceLibraries/NewOpenSourceLibraries.scss": [
		1733,
		7,
		1101
	],
	"./pages/Hire/HireUIUXDesigner/OurRecentWork/OurRecentWork": [
		731,
		9,
		293
	],
	"./pages/Hire/HireUIUXDesigner/OurRecentWork/OurRecentWork.js": [
		731,
		9,
		293
	],
	"./pages/Hire/HireUIUXDesigner/OurRecentWork/OurRecentWork.scss": [
		1734,
		7,
		1102
	],
	"./pages/Hire/HireUIUXDesigner/OurWork/OurWork": [
		557,
		9,
		5,
		191
	],
	"./pages/Hire/HireUIUXDesigner/OurWork/OurWork.js": [
		557,
		9,
		5,
		191
	],
	"./pages/Hire/HireUIUXDesigner/OurWork/OurWork.scss": [
		1471,
		7,
		1103
	],
	"./pages/Hire/HireUIUXDesigner/OurWork/img/corporate-character.png": [
		2700,
		9,
		3202
	],
	"./pages/Hire/HireUIUXDesigner/OurWork/img/finance-dashboard.png": [
		2701,
		9,
		3203
	],
	"./pages/Hire/HireUIUXDesigner/ServicesSection/ServicesSection": [
		555,
		9,
		533
	],
	"./pages/Hire/HireUIUXDesigner/ServicesSection/ServicesSection.js": [
		555,
		9,
		533
	],
	"./pages/Hire/HireUIUXDesigner/ServicesSection/ServicesSection.scss": [
		1469,
		7,
		1104
	],
	"./pages/Hire/HireUIUXDesigner/WhatWeProvide/WhatWeProvide": [
		732,
		9,
		473
	],
	"./pages/Hire/HireUIUXDesigner/WhatWeProvide/WhatWeProvide.js": [
		732,
		9,
		473
	],
	"./pages/Hire/HireUIUXDesigner/WhatWeProvide/WhatWeProvide.scss": [
		2702,
		7,
		1105
	],
	"./pages/Hire/HireUIUXDesigner/WhyChoose/WhyChoose": [
		733,
		9,
		415
	],
	"./pages/Hire/HireUIUXDesigner/WhyChoose/WhyChoose.js": [
		733,
		9,
		415
	],
	"./pages/Hire/HireUIUXDesigner/WhyChooseMi/WhyChooseMi": [
		556,
		9,
		363
	],
	"./pages/Hire/HireUIUXDesigner/WhyChooseMi/WhyChooseMi.js": [
		556,
		9,
		363
	],
	"./pages/Hire/HireUIUXDesigner/WhyChooseMi/WhyChooseMi.scss": [
		1470,
		7,
		1106
	],
	"./pages/Hire/HireVueJsDevelopers/AboutSection/AboutSection": [
		541,
		9,
		364
	],
	"./pages/Hire/HireVueJsDevelopers/AboutSection/AboutSection.js": [
		541,
		9,
		364
	],
	"./pages/Hire/HireVueJsDevelopers/AboutSection/AboutSection.scss": [
		1455,
		7,
		1107
	],
	"./pages/Hire/HireVueJsDevelopers/HeroSection/HeroSection": [
		542,
		9,
		318
	],
	"./pages/Hire/HireVueJsDevelopers/HeroSection/HeroSection.js": [
		542,
		9,
		318
	],
	"./pages/Hire/HireVueJsDevelopers/HeroSection/HeroSection.scss": [
		1456,
		7,
		1108
	],
	"./pages/Hire/HireVueJsDevelopers/HireVueJsDevelopers": [
		166,
		9,
		0,
		138,
		1,
		2,
		51
	],
	"./pages/Hire/HireVueJsDevelopers/HireVueJsDevelopers.js": [
		166,
		9,
		0,
		138,
		1,
		2,
		51
	],
	"./pages/Hire/HireVueJsDevelopers/LookingDevelopers/LookingDevelopers.scss": [
		2703,
		7,
		1109
	],
	"./pages/Hire/HireVueJsDevelopers/LookingOtherServices/LookingOtherServices.scss": [
		2704,
		7,
		1110
	],
	"./pages/Hire/HireVueJsDevelopers/OurRecentWork/OurRecentWork": [
		734,
		9,
		294
	],
	"./pages/Hire/HireVueJsDevelopers/OurRecentWork/OurRecentWork.js": [
		734,
		9,
		294
	],
	"./pages/Hire/HireVueJsDevelopers/OurRecentWork/OurRecentWork.scss": [
		1735,
		7,
		1111
	],
	"./pages/Hire/HireVueJsDevelopers/ServicesSection/ServicesSection": [
		543,
		9,
		534
	],
	"./pages/Hire/HireVueJsDevelopers/ServicesSection/ServicesSection.js": [
		543,
		9,
		534
	],
	"./pages/Hire/HireVueJsDevelopers/ServicesSection/ServicesSection.scss": [
		1457,
		7,
		1112
	],
	"./pages/Hire/HireVueJsDevelopers/WhyChooseMi/WhyChooseMi": [
		544,
		9,
		365
	],
	"./pages/Hire/HireVueJsDevelopers/WhyChooseMi/WhyChooseMi.js": [
		544,
		9,
		365
	],
	"./pages/Hire/HireVueJsDevelopers/WhyChooseMi/WhyChooseMi.scss": [
		1458,
		7,
		1113
	],
	"./pages/Hire/WhatWeProvideSection/WhatWeProvideSection": [
		735,
		9,
		474
	],
	"./pages/Hire/WhatWeProvideSection/WhatWeProvideSection.js": [
		735,
		9,
		474
	],
	"./pages/Home/AboutSection/AboutSection": [
		245,
		9,
		235
	],
	"./pages/Home/AboutSection/AboutSection.js": [
		245,
		9,
		235
	],
	"./pages/Home/AboutSection/AboutSection.scss": [
		1043,
		7,
		1114
	],
	"./pages/Home/CantFindTechnology/CantFindTechnology": [
		228,
		9,
		614
	],
	"./pages/Home/CantFindTechnology/CantFindTechnology.js": [
		228,
		9,
		614
	],
	"./pages/Home/CantFindTechnology/CantFindTechnology.scss": [
		977,
		7,
		1115
	],
	"./pages/Home/HeroHomeSection/HeroHomeSection": [
		250,
		9,
		535
	],
	"./pages/Home/HeroHomeSection/HeroHomeSection.js": [
		250,
		9,
		535
	],
	"./pages/Home/HeroHomeSection/HeroHomeSection.scss": [
		1082,
		7,
		1116
	],
	"./pages/Home/HeroSection/HeroSection": [
		736,
		9,
		405
	],
	"./pages/Home/HeroSection/HeroSection.js": [
		736,
		9,
		405
	],
	"./pages/Home/HeroSection/HeroSection.scss": [
		1736,
		7,
		1117
	],
	"./pages/Home/HeroSection/bg-img-one.svg": [
		2705,
		9,
		1927
	],
	"./pages/Home/HeroSection/bg-img.svg": [
		2706,
		9,
		1928
	],
	"./pages/Home/HeroSection/bg-one.svg": [
		2707,
		9,
		1929
	],
	"./pages/Home/HeroSection/cart.png": [
		2708,
		9,
		3204
	],
	"./pages/Home/HeroSection/christmas-tree.png": [
		2709,
		9,
		3205
	],
	"./pages/Home/HeroSection/cloud-final-responsive.png": [
		2710,
		9,
		3206
	],
	"./pages/Home/HeroSection/cloud-final.png": [
		2711,
		9,
		3207
	],
	"./pages/Home/HeroSection/cloud-final.svg": [
		2712,
		9,
		1930
	],
	"./pages/Home/HeroSection/cloud-without-shadow.png": [
		2713,
		9,
		3208
	],
	"./pages/Home/HeroSection/cloud.png": [
		2714,
		9,
		3209
	],
	"./pages/Home/HeroSection/cloud.svg": [
		2715,
		9,
		1931
	],
	"./pages/Home/HeroSection/house.png": [
		2716,
		9,
		3210
	],
	"./pages/Home/HeroSection/img/orb1.png": [
		1737,
		9,
		3211
	],
	"./pages/Home/HeroSection/img/orb2.png": [
		1738,
		9,
		3212
	],
	"./pages/Home/HeroSection/img/orb3.png": [
		1739,
		9,
		3213
	],
	"./pages/Home/HeroSection/img/orb4.png": [
		1740,
		9,
		3214
	],
	"./pages/Home/HeroSection/imgs/orb1.png": [
		2717,
		9,
		3215
	],
	"./pages/Home/HeroSection/imgs/orb2.png": [
		2718,
		9,
		3216
	],
	"./pages/Home/HeroSection/imgs/orb3.png": [
		2719,
		9,
		3217
	],
	"./pages/Home/HeroSection/imgs/orb4.png": [
		2720,
		9,
		3218
	],
	"./pages/Home/HeroSection/imgs/snowmanimg.png": [
		2721,
		9,
		3219
	],
	"./pages/Home/HeroSection/santa.png": [
		2722,
		9,
		3220
	],
	"./pages/Home/HeroSection/snowman-img.svg": [
		2723,
		9,
		1932
	],
	"./pages/Home/HeroSection/snowman.png": [
		2724,
		9,
		3221
	],
	"./pages/Home/HeroSection/snowmanimg.svg": [
		2725,
		9,
		1933
	],
	"./pages/Home/Home": [
		109,
		9,
		0,
		3,
		9,
		1,
		15
	],
	"./pages/Home/Home.js": [
		109,
		9,
		0,
		3,
		9,
		1,
		15
	],
	"./pages/Home/Home.scss": [
		1042,
		7,
		1118
	],
	"./pages/Home/HomeOurWorks/HomeOurWorks": [
		737,
		9,
		151
	],
	"./pages/Home/HomeOurWorks/HomeOurWorks.js": [
		737,
		9,
		151
	],
	"./pages/Home/HomeOurWorks/HomeOurWorks.scss": [
		1741,
		7,
		1119
	],
	"./pages/Home/HomeOurWorks/big-circle.svg": [
		2726,
		9,
		1934
	],
	"./pages/Home/HomeOurWorks/view-more-arrow.svg": [
		2727,
		9,
		1935
	],
	"./pages/Home/HomeOurWorks/view-more-pf.png": [
		2728,
		9,
		3222
	],
	"./pages/Home/HomeServices/HomeServices": [
		738,
		9,
		163
	],
	"./pages/Home/HomeServices/HomeServices.js": [
		738,
		9,
		163
	],
	"./pages/Home/HomeServices/HomeServices.scss": [
		1742,
		7,
		1120
	],
	"./pages/Home/HomeServices/img/Flutter.webp": [
		2729,
		9,
		1936
	],
	"./pages/Home/HomeServices/img/Ionic.webp": [
		2730,
		9,
		1937
	],
	"./pages/Home/HomeServices/img/android.webp": [
		2731,
		9,
		1938
	],
	"./pages/Home/HomeServices/img/angular.webp": [
		2732,
		9,
		1939
	],
	"./pages/Home/HomeServices/img/docker.webp": [
		2733,
		9,
		1940
	],
	"./pages/Home/HomeServices/img/figma.webp": [
		2734,
		9,
		1941
	],
	"./pages/Home/HomeServices/img/git.webp": [
		2735,
		9,
		1942
	],
	"./pages/Home/HomeServices/img/go.webp": [
		2736,
		9,
		1943
	],
	"./pages/Home/HomeServices/img/iOS.webp": [
		2737,
		9,
		1944
	],
	"./pages/Home/HomeServices/img/invision.webp": [
		2738,
		9,
		1945
	],
	"./pages/Home/HomeServices/img/jenkins.webp": [
		2739,
		9,
		1946
	],
	"./pages/Home/HomeServices/img/kubernetes.webp": [
		2740,
		9,
		1947
	],
	"./pages/Home/HomeServices/img/laravel.webp": [
		2741,
		9,
		1948
	],
	"./pages/Home/HomeServices/img/node.webp": [
		2742,
		9,
		1949
	],
	"./pages/Home/HomeServices/img/php.webp": [
		2743,
		9,
		1950
	],
	"./pages/Home/HomeServices/img/react.webp": [
		2744,
		9,
		1951
	],
	"./pages/Home/HomeServices/img/selenium.webp": [
		2745,
		9,
		1952
	],
	"./pages/Home/HomeServices/img/service-arrow.png": [
		2746,
		9,
		3223
	],
	"./pages/Home/HomeServices/img/service-arrow.svg": [
		2747,
		9,
		1953
	],
	"./pages/Home/HomeServices/img/xd.webp": [
		2748,
		9,
		1954
	],
	"./pages/Home/HomeServices/img/zeplin.webp": [
		2749,
		9,
		1955
	],
	"./pages/Home/HomeServices/imgs/android.webp": [
		1744,
		9,
		1956
	],
	"./pages/Home/HomeServices/imgs/angular.webp": [
		1748,
		9,
		1957
	],
	"./pages/Home/HomeServices/imgs/docker.webp": [
		1754,
		9,
		1958
	],
	"./pages/Home/HomeServices/imgs/figma.webp": [
		1758,
		9,
		1959
	],
	"./pages/Home/HomeServices/imgs/flutter.webp": [
		1745,
		9,
		1960
	],
	"./pages/Home/HomeServices/imgs/git.webp": [
		1753,
		9,
		1961
	],
	"./pages/Home/HomeServices/imgs/go.webp": [
		1750,
		9,
		1962
	],
	"./pages/Home/HomeServices/imgs/iOS.webp": [
		1743,
		9,
		1963
	],
	"./pages/Home/HomeServices/imgs/invision.webp": [
		1761,
		9,
		1964
	],
	"./pages/Home/HomeServices/imgs/ionic.webp": [
		1747,
		9,
		1965
	],
	"./pages/Home/HomeServices/imgs/jenkins.webp": [
		1755,
		9,
		1966
	],
	"./pages/Home/HomeServices/imgs/kubernetes.webp": [
		1757,
		9,
		1967
	],
	"./pages/Home/HomeServices/imgs/laravel.webp": [
		1752,
		9,
		1968
	],
	"./pages/Home/HomeServices/imgs/node.webp": [
		1749,
		9,
		1969
	],
	"./pages/Home/HomeServices/imgs/php.webp": [
		1751,
		9,
		1970
	],
	"./pages/Home/HomeServices/imgs/react.webp": [
		1746,
		9,
		1971
	],
	"./pages/Home/HomeServices/imgs/selenium.webp": [
		1756,
		9,
		1972
	],
	"./pages/Home/HomeServices/imgs/service-arrow.svg": [
		882,
		9,
		1973
	],
	"./pages/Home/HomeServices/imgs/xd.webp": [
		1759,
		9,
		1974
	],
	"./pages/Home/HomeServices/imgs/zeplin.webp": [
		1760,
		9,
		1975
	],
	"./pages/Home/NewBusinessModels/NewBusinessModels": [
		739,
		9,
		617
	],
	"./pages/Home/NewBusinessModels/NewBusinessModels.js": [
		739,
		9,
		617
	],
	"./pages/Home/NewBusinessModels/NewBusinessModels.scss": [
		1762,
		7,
		1121
	],
	"./pages/Home/ServicesSlider/ServicesSlider": [
		249,
		9,
		3,
		152
	],
	"./pages/Home/ServicesSlider/ServicesSlider.js": [
		249,
		9,
		3,
		152
	],
	"./pages/Home/ServicesSlider/ServicesSlider.scss": [
		1061,
		7,
		1122
	],
	"./pages/Home/ServicesSlider/docker.svg": [
		1068,
		9,
		1976
	],
	"./pages/Home/ServicesSlider/game-development/4d.svg": [
		2750,
		9,
		1977
	],
	"./pages/Home/ServicesSlider/game-development/aftereffect.svg": [
		2751,
		9,
		1978
	],
	"./pages/Home/ServicesSlider/game-development/ai-logo.svg": [
		1080,
		9,
		1979
	],
	"./pages/Home/ServicesSlider/game-development/blender.svg": [
		1079,
		9,
		1980
	],
	"./pages/Home/ServicesSlider/game-development/game-dev.svg": [
		2752,
		9,
		1981
	],
	"./pages/Home/ServicesSlider/game-development/game.svg": [
		1077,
		9,
		1982
	],
	"./pages/Home/ServicesSlider/game-development/html5.svg": [
		2753,
		9,
		1983
	],
	"./pages/Home/ServicesSlider/game-development/ps-logo.svg": [
		2754,
		9,
		1984
	],
	"./pages/Home/ServicesSlider/game-development/unity.svg": [
		1078,
		9,
		1985
	],
	"./pages/Home/ServicesSlider/game-development/unreal-eng.svg": [
		1081,
		9,
		1986
	],
	"./pages/Home/ServicesSlider/kubernets.svg": [
		1071,
		9,
		1987
	],
	"./pages/Home/ServicesSlider/services-icons/devops.svg": [
		1065,
		9,
		1988
	],
	"./pages/Home/ServicesSlider/services-icons/mobile.svg": [
		1062,
		9,
		1989
	],
	"./pages/Home/ServicesSlider/services-icons/right-arrow.svg": [
		2755,
		9,
		1990
	],
	"./pages/Home/ServicesSlider/services-icons/ui.svg": [
		1063,
		9,
		1991
	],
	"./pages/Home/ServicesSlider/services-icons/web.svg": [
		1064,
		9,
		1992
	],
	"./pages/Home/ServicesSlider/services-shapes/circle.png": [
		2756,
		9,
		3224
	],
	"./pages/Home/ServicesSlider/services-shapes/cross.png": [
		2757,
		9,
		3225
	],
	"./pages/Home/ServicesSlider/services-shapes/penta.png": [
		2758,
		9,
		3226
	],
	"./pages/Home/ServicesSlider/services-shapes/square.png": [
		2759,
		9,
		3227
	],
	"./pages/Home/ServicesSlider/services-shapes/triangle.png": [
		2760,
		9,
		3228
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/aftereffect.svg": [
		2761,
		9,
		1993
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/figma.svg": [
		1073,
		9,
		1994
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/illustrator.svg": [
		2762,
		9,
		1995
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/invinsion.svg": [
		1076,
		9,
		1996
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/phtoshop.svg": [
		2763,
		9,
		1997
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/sketch.svg": [
		2764,
		9,
		1998
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/xd.svg": [
		1074,
		9,
		1999
	],
	"./pages/Home/ServicesSlider/ui-ux-icons/zeplin.svg": [
		1075,
		9,
		2000
	],
	"./pages/IbeaconAppDevelopment/AboutSection/AboutSection": [
		384,
		9,
		219
	],
	"./pages/IbeaconAppDevelopment/AboutSection/AboutSection.js": [
		384,
		9,
		219
	],
	"./pages/IbeaconAppDevelopment/AboutSection/AboutSection.scss": [
		1285,
		7,
		1123
	],
	"./pages/IbeaconAppDevelopment/HeroSection/HeroSection": [
		383,
		9,
		536
	],
	"./pages/IbeaconAppDevelopment/HeroSection/HeroSection.js": [
		383,
		9,
		536
	],
	"./pages/IbeaconAppDevelopment/HeroSection/HeroSection.scss": [
		1284,
		7,
		1124
	],
	"./pages/IbeaconAppDevelopment/IbeaconAppDevelopment": [
		133,
		9,
		0,
		113,
		1,
		2,
		53
	],
	"./pages/IbeaconAppDevelopment/IbeaconAppDevelopment.js": [
		133,
		9,
		0,
		113,
		1,
		2,
		53
	],
	"./pages/IbeaconAppDevelopment/LookingOtherServices/LookingOtherServices": [
		740,
		9,
		508
	],
	"./pages/IbeaconAppDevelopment/LookingOtherServices/LookingOtherServices.js": [
		740,
		9,
		508
	],
	"./pages/IbeaconAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		1763,
		7,
		1125
	],
	"./pages/IbeaconAppDevelopment/ServicesSection/ServicesSection": [
		385,
		9,
		537
	],
	"./pages/IbeaconAppDevelopment/ServicesSection/ServicesSection.js": [
		385,
		9,
		537
	],
	"./pages/IbeaconAppDevelopment/ServicesSection/ServicesSection.scss": [
		1286,
		7,
		1126
	],
	"./pages/IbeaconAppDevelopment/WhyChooseMi/WhyChooseMi": [
		386,
		9,
		366
	],
	"./pages/IbeaconAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		386,
		9,
		366
	],
	"./pages/IbeaconAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1287,
		7,
		1127
	],
	"./pages/IbeaconAppDevelopment/WhyChooseSection/WhyChooseSection": [
		741,
		9,
		594
	],
	"./pages/IbeaconAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		741,
		9,
		594
	],
	"./pages/IbeaconAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1764,
		7,
		1128
	],
	"./pages/IotAppDevelopment/AboutSection/AboutSection": [
		366,
		9,
		220
	],
	"./pages/IotAppDevelopment/AboutSection/AboutSection.js": [
		366,
		9,
		220
	],
	"./pages/IotAppDevelopment/AboutSection/AboutSection.scss": [
		1254,
		7,
		1129
	],
	"./pages/IotAppDevelopment/HeroSection/HeroSection": [
		365,
		9,
		538
	],
	"./pages/IotAppDevelopment/HeroSection/HeroSection.js": [
		365,
		9,
		538
	],
	"./pages/IotAppDevelopment/HeroSection/HeroSection.scss": [
		1253,
		7,
		1130
	],
	"./pages/IotAppDevelopment/IotAppDevelopment": [
		130,
		9,
		0,
		111,
		1,
		2,
		66
	],
	"./pages/IotAppDevelopment/IotAppDevelopment.js": [
		130,
		9,
		0,
		111,
		1,
		2,
		66
	],
	"./pages/IotAppDevelopment/LookingDevelopers/LookingDevelopers": [
		742,
		9,
		491
	],
	"./pages/IotAppDevelopment/LookingDevelopers/LookingDevelopers.js": [
		742,
		9,
		491
	],
	"./pages/IotAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		1765,
		7,
		1131
	],
	"./pages/IotAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2765,
		7,
		1132
	],
	"./pages/IotAppDevelopment/ServicesSection/ServicesSection": [
		367,
		9,
		539
	],
	"./pages/IotAppDevelopment/ServicesSection/ServicesSection.js": [
		367,
		9,
		539
	],
	"./pages/IotAppDevelopment/ServicesSection/ServicesSection.scss": [
		1255,
		7,
		1133
	],
	"./pages/IotAppDevelopment/TechnologiesSection/TechnologiesSection": [
		368,
		9,
		638
	],
	"./pages/IotAppDevelopment/TechnologiesSection/TechnologiesSection.js": [
		368,
		9,
		638
	],
	"./pages/IotAppDevelopment/WhyChooseMi/WhyChooseMi": [
		369,
		9,
		367
	],
	"./pages/IotAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		369,
		9,
		367
	],
	"./pages/IotAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1256,
		7,
		1134
	],
	"./pages/IphoneAppDevelopment/AboutSection/AboutSection": [
		264,
		9,
		221
	],
	"./pages/IphoneAppDevelopment/AboutSection/AboutSection.js": [
		264,
		9,
		221
	],
	"./pages/IphoneAppDevelopment/AboutSection/AboutSection.scss": [
		1159,
		7,
		1135
	],
	"./pages/IphoneAppDevelopment/Approaches/Approaches": [
		266,
		9,
		273
	],
	"./pages/IphoneAppDevelopment/Approaches/Approaches.js": [
		266,
		9,
		273
	],
	"./pages/IphoneAppDevelopment/HeroSection/HeroSection": [
		263,
		9,
		540
	],
	"./pages/IphoneAppDevelopment/HeroSection/HeroSection.js": [
		263,
		9,
		540
	],
	"./pages/IphoneAppDevelopment/HeroSection/HeroSection.scss": [
		1158,
		7,
		1136
	],
	"./pages/IphoneAppDevelopment/IphoneAppDevelopment": [
		113,
		9,
		0,
		94,
		1,
		2,
		23
	],
	"./pages/IphoneAppDevelopment/IphoneAppDevelopment.js": [
		113,
		9,
		0,
		94,
		1,
		2,
		23
	],
	"./pages/IphoneAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2766,
		7,
		1137
	],
	"./pages/IphoneAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2767,
		7,
		1138
	],
	"./pages/IphoneAppDevelopment/Platforms/Platforms": [
		265,
		9,
		437
	],
	"./pages/IphoneAppDevelopment/Platforms/Platforms.js": [
		265,
		9,
		437
	],
	"./pages/IphoneAppDevelopment/Platforms/Platforms.scss": [
		1160,
		7,
		1139
	],
	"./pages/IphoneAppDevelopment/ServicesSection/ServicesSection": [
		268,
		9,
		541
	],
	"./pages/IphoneAppDevelopment/ServicesSection/ServicesSection.js": [
		268,
		9,
		541
	],
	"./pages/IphoneAppDevelopment/ServicesSection/ServicesSection.scss": [
		1161,
		7,
		1140
	],
	"./pages/IphoneAppDevelopment/TechnologiesSection/TechnologiesSection": [
		267,
		9,
		639
	],
	"./pages/IphoneAppDevelopment/TechnologiesSection/TechnologiesSection.js": [
		267,
		9,
		639
	],
	"./pages/IphoneAppDevelopment/WhyChooseMi/WhyChooseMi": [
		270,
		9,
		368
	],
	"./pages/IphoneAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		270,
		9,
		368
	],
	"./pages/IphoneAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1163,
		7,
		1141
	],
	"./pages/IphoneAppDevelopment/WhyChooseSection/WhyChooseSection": [
		269,
		9,
		595
	],
	"./pages/IphoneAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		269,
		9,
		595
	],
	"./pages/IphoneAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1162,
		7,
		1142
	],
	"./pages/JavaScriptDevelopment/AboutSection/AboutSection": [
		301,
		9,
		222
	],
	"./pages/JavaScriptDevelopment/AboutSection/AboutSection.js": [
		301,
		9,
		222
	],
	"./pages/JavaScriptDevelopment/AboutSection/AboutSection.scss": [
		1191,
		7,
		1143
	],
	"./pages/JavaScriptDevelopment/HeroSection/HeroSection": [
		300,
		9,
		542
	],
	"./pages/JavaScriptDevelopment/HeroSection/HeroSection.js": [
		300,
		9,
		542
	],
	"./pages/JavaScriptDevelopment/HeroSection/HeroSection.scss": [
		1190,
		7,
		1144
	],
	"./pages/JavaScriptDevelopment/JavaScriptDevelopment": [
		118,
		9,
		0,
		3,
		99,
		1,
		18
	],
	"./pages/JavaScriptDevelopment/JavaScriptDevelopment.js": [
		118,
		9,
		0,
		3,
		99,
		1,
		18
	],
	"./pages/JavaScriptDevelopment/JsServices/JsServices": [
		743,
		9,
		640
	],
	"./pages/JavaScriptDevelopment/JsServices/JsServices.js": [
		743,
		9,
		640
	],
	"./pages/JavaScriptDevelopment/LookingDevelopers/LookingDevelopers": [
		744,
		9,
		492
	],
	"./pages/JavaScriptDevelopment/LookingDevelopers/LookingDevelopers.js": [
		744,
		9,
		492
	],
	"./pages/JavaScriptDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		1766,
		7,
		1145
	],
	"./pages/JavaScriptDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2768,
		7,
		1146
	],
	"./pages/JavaScriptDevelopment/NewWhatWeDo/NewWhatWeDo": [
		302,
		9,
		242
	],
	"./pages/JavaScriptDevelopment/NewWhatWeDo/NewWhatWeDo.js": [
		302,
		9,
		242
	],
	"./pages/JavaScriptDevelopment/NewWhatWeDo/NewWhatWeDo.scss": [
		1193,
		7,
		1147
	],
	"./pages/JavaScriptDevelopment/OurRecentWork/OurRecentWork": [
		745,
		9,
		295
	],
	"./pages/JavaScriptDevelopment/OurRecentWork/OurRecentWork.js": [
		745,
		9,
		295
	],
	"./pages/JavaScriptDevelopment/OurRecentWork/OurRecentWork.scss": [
		1767,
		7,
		1148
	],
	"./pages/JavaScriptDevelopment/Platforms/Platforms": [
		746,
		9,
		238
	],
	"./pages/JavaScriptDevelopment/Platforms/Platforms.js": [
		746,
		9,
		238
	],
	"./pages/JavaScriptDevelopment/Platforms/Platforms.scss": [
		1768,
		7,
		1149
	],
	"./pages/JavaScriptDevelopment/ServicesSection/ServicesSection": [
		303,
		9,
		543
	],
	"./pages/JavaScriptDevelopment/ServicesSection/ServicesSection.js": [
		303,
		9,
		543
	],
	"./pages/JavaScriptDevelopment/ServicesSection/ServicesSection.scss": [
		1194,
		7,
		1150
	],
	"./pages/JavaScriptDevelopment/TechnologiesSection/TechnologiesSection": [
		306,
		9,
		641
	],
	"./pages/JavaScriptDevelopment/TechnologiesSection/TechnologiesSection.js": [
		306,
		9,
		641
	],
	"./pages/JavaScriptDevelopment/WhyChooseMi/WhyChooseMi": [
		304,
		9,
		369
	],
	"./pages/JavaScriptDevelopment/WhyChooseMi/WhyChooseMi.js": [
		304,
		9,
		369
	],
	"./pages/JavaScriptDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1195,
		7,
		1151
	],
	"./pages/JavaScriptDevelopment/WhyChooseSection/WhyChooseSection": [
		305,
		9,
		596
	],
	"./pages/JavaScriptDevelopment/WhyChooseSection/WhyChooseSection.js": [
		305,
		9,
		596
	],
	"./pages/JavaScriptDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1196,
		7,
		1152
	],
	"./pages/LaravelDevelopment/AboutSection/AboutSection": [
		345,
		9,
		223
	],
	"./pages/LaravelDevelopment/AboutSection/AboutSection.js": [
		345,
		9,
		223
	],
	"./pages/LaravelDevelopment/AboutSection/AboutSection.scss": [
		1234,
		7,
		1153
	],
	"./pages/LaravelDevelopment/HeroSection/HeroSection": [
		344,
		9,
		544
	],
	"./pages/LaravelDevelopment/HeroSection/HeroSection.js": [
		344,
		9,
		544
	],
	"./pages/LaravelDevelopment/HeroSection/HeroSection.scss": [
		1233,
		7,
		1154
	],
	"./pages/LaravelDevelopment/LaravelDevelopment": [
		126,
		9,
		0,
		107,
		1,
		2,
		31
	],
	"./pages/LaravelDevelopment/LaravelDevelopment.js": [
		126,
		9,
		0,
		107,
		1,
		2,
		31
	],
	"./pages/LaravelDevelopment/LookingDevelopers/LookingDevelopers": [
		747,
		9,
		493
	],
	"./pages/LaravelDevelopment/LookingDevelopers/LookingDevelopers.js": [
		747,
		9,
		493
	],
	"./pages/LaravelDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		1769,
		7,
		1155
	],
	"./pages/LaravelDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2769,
		7,
		1156
	],
	"./pages/LaravelDevelopment/Platforms/Platforms": [
		748,
		9,
		438
	],
	"./pages/LaravelDevelopment/Platforms/Platforms.js": [
		748,
		9,
		438
	],
	"./pages/LaravelDevelopment/Platforms/Platforms.scss": [
		1770,
		7,
		1157
	],
	"./pages/LaravelDevelopment/ServicesSection/ServicesSection": [
		346,
		9,
		597
	],
	"./pages/LaravelDevelopment/ServicesSection/ServicesSection.js": [
		346,
		9,
		597
	],
	"./pages/LaravelDevelopment/ServicesSection/ServicesSection.scss": [
		1235,
		7,
		1158
	],
	"./pages/LaravelDevelopment/TechnologiesSection/TechnologiesSection": [
		749,
		9,
		642
	],
	"./pages/LaravelDevelopment/TechnologiesSection/TechnologiesSection.js": [
		749,
		9,
		642
	],
	"./pages/LaravelDevelopment/WhyChooseMi/WhyChooseMi": [
		348,
		9,
		370
	],
	"./pages/LaravelDevelopment/WhyChooseMi/WhyChooseMi.js": [
		348,
		9,
		370
	],
	"./pages/LaravelDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1237,
		7,
		1159
	],
	"./pages/LaravelDevelopment/WhyChooseSection/WhyChooseSection": [
		347,
		9,
		693
	],
	"./pages/LaravelDevelopment/WhyChooseSection/WhyChooseSection.js": [
		347,
		9,
		693
	],
	"./pages/LaravelDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1236,
		7,
		1160
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Black.ttf": [
		2770,
		9,
		2001
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Bold.ttf": [
		2771,
		9,
		2002
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Extrabold.ttf": [
		2772,
		9,
		2003
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Light.ttf": [
		2773,
		9,
		2004
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Medium.ttf": [
		2774,
		9,
		2005
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Regular.ttf": [
		2775,
		9,
		2006
	],
	"./pages/LocalProductSearching/fonts/Gilroy-Semibold.ttf": [
		2776,
		9,
		2007
	],
	"./pages/LocalProductSearching/fonts/OpenSans-Bold.ttf": [
		2777,
		9,
		2008
	],
	"./pages/LocalProductSearching/fonts/OpenSans-Extrabold.ttf": [
		2778,
		9,
		2009
	],
	"./pages/LocalProductSearching/fonts/OpenSans-Light.ttf": [
		2779,
		9,
		2010
	],
	"./pages/LocalProductSearching/fonts/OpenSans-Regular.ttf": [
		2780,
		9,
		2011
	],
	"./pages/LocalProductSearching/fonts/OpenSans-Semibold.ttf": [
		2781,
		9,
		2012
	],
	"./pages/LocalProductSearching/images/app-store.png": [
		1771,
		9,
		3229
	],
	"./pages/LocalProductSearching/images/border.png": [
		1772,
		9,
		3230
	],
	"./pages/LocalProductSearching/images/bottom-shape.png": [
		2782,
		9,
		3231
	],
	"./pages/LocalProductSearching/images/dispensary-rating.png": [
		1773,
		9,
		3232
	],
	"./pages/LocalProductSearching/images/dispensary.png": [
		1774,
		9,
		3233
	],
	"./pages/LocalProductSearching/images/explore.png": [
		1775,
		9,
		3234
	],
	"./pages/LocalProductSearching/images/featured_screen.png": [
		1776,
		9,
		3235
	],
	"./pages/LocalProductSearching/images/icons-img.png": [
		1777,
		9,
		3236
	],
	"./pages/LocalProductSearching/images/like-bg.png": [
		2783,
		9,
		3237
	],
	"./pages/LocalProductSearching/images/like-btn.png": [
		1778,
		9,
		3238
	],
	"./pages/LocalProductSearching/images/map.png": [
		1779,
		9,
		3239
	],
	"./pages/LocalProductSearching/images/organix-screen.png": [
		1780,
		9,
		3240
	],
	"./pages/LocalProductSearching/images/product.png": [
		1781,
		9,
		3241
	],
	"./pages/LocalProductSearching/images/record.png": [
		1782,
		9,
		3242
	],
	"./pages/LocalProductSearching/images/shape-left.png": [
		2784,
		9,
		3243
	],
	"./pages/LocalProductSearching/images/shape-right.png": [
		2785,
		9,
		3244
	],
	"./pages/LocalProductSearching/images/share.png": [
		1783,
		9,
		3245
	],
	"./pages/LocalProductSearching/images/splash-screen.png": [
		1784,
		9,
		3246
	],
	"./pages/LocalProductSearching/images/tablet-img.png": [
		1785,
		9,
		3247
	],
	"./pages/LocalProductSearching/images/top-banner.png": [
		2786,
		9,
		3248
	],
	"./pages/LocalProductSearching/images/view-profile.png": [
		1786,
		9,
		3249
	],
	"./pages/LocalProductSearching/localProductSearching": [
		750,
		9,
		0,
		1,
		144,
		177
	],
	"./pages/LocalProductSearching/localProductSearching.js": [
		750,
		9,
		0,
		1,
		144,
		177
	],
	"./pages/LocalProductSearching/scss/localProductSearching.scss": [
		2137,
		7,
		144
	],
	"./pages/MeteorJsDevelopment/AboutSection/AboutSection": [
		323,
		9,
		224
	],
	"./pages/MeteorJsDevelopment/AboutSection/AboutSection.js": [
		323,
		9,
		224
	],
	"./pages/MeteorJsDevelopment/AboutSection/AboutSection.scss": [
		1213,
		7,
		1161
	],
	"./pages/MeteorJsDevelopment/BenefitsSection/BenefitsSection": [
		751,
		9,
		643
	],
	"./pages/MeteorJsDevelopment/BenefitsSection/BenefitsSection.js": [
		751,
		9,
		643
	],
	"./pages/MeteorJsDevelopment/HeroSection/HeroSection": [
		322,
		9,
		545
	],
	"./pages/MeteorJsDevelopment/HeroSection/HeroSection.js": [
		322,
		9,
		545
	],
	"./pages/MeteorJsDevelopment/HeroSection/HeroSection.scss": [
		1212,
		7,
		1162
	],
	"./pages/MeteorJsDevelopment/LookingDevelopers/LookingDevelopers": [
		752,
		9,
		494
	],
	"./pages/MeteorJsDevelopment/LookingDevelopers/LookingDevelopers.js": [
		752,
		9,
		494
	],
	"./pages/MeteorJsDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		1787,
		7,
		1163
	],
	"./pages/MeteorJsDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2787,
		7,
		1164
	],
	"./pages/MeteorJsDevelopment/MeteorJsDevelopment": [
		122,
		9,
		0,
		103,
		1,
		2,
		36
	],
	"./pages/MeteorJsDevelopment/MeteorJsDevelopment.js": [
		122,
		9,
		0,
		103,
		1,
		2,
		36
	],
	"./pages/MeteorJsDevelopment/ServicesSection/ServicesSection": [
		324,
		9,
		546
	],
	"./pages/MeteorJsDevelopment/ServicesSection/ServicesSection.js": [
		324,
		9,
		546
	],
	"./pages/MeteorJsDevelopment/ServicesSection/ServicesSection.scss": [
		1214,
		7,
		1165
	],
	"./pages/MeteorJsDevelopment/WhyChooseMi/WhyChooseMi": [
		326,
		9,
		371
	],
	"./pages/MeteorJsDevelopment/WhyChooseMi/WhyChooseMi.js": [
		326,
		9,
		371
	],
	"./pages/MeteorJsDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1216,
		7,
		1166
	],
	"./pages/MeteorJsDevelopment/WhyChooseSection/WhyChooseSection": [
		325,
		9,
		598
	],
	"./pages/MeteorJsDevelopment/WhyChooseSection/WhyChooseSection.js": [
		325,
		9,
		598
	],
	"./pages/MeteorJsDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1215,
		7,
		1167
	],
	"./pages/MobileAppDevelopment/AboutSection/AboutSection": [
		257,
		9,
		225
	],
	"./pages/MobileAppDevelopment/AboutSection/AboutSection.js": [
		257,
		9,
		225
	],
	"./pages/MobileAppDevelopment/AboutSection/AboutSection.scss": [
		1148,
		7,
		1168
	],
	"./pages/MobileAppDevelopment/HeroSection/HeroSection": [
		256,
		9,
		547
	],
	"./pages/MobileAppDevelopment/HeroSection/HeroSection.js": [
		256,
		9,
		547
	],
	"./pages/MobileAppDevelopment/HeroSection/HeroSection.scss": [
		1147,
		7,
		1169
	],
	"./pages/MobileAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2788,
		7,
		1170
	],
	"./pages/MobileAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2789,
		7,
		1171
	],
	"./pages/MobileAppDevelopment/MobileAppDevelopment": [
		112,
		9,
		0,
		3,
		93,
		1,
		20
	],
	"./pages/MobileAppDevelopment/MobileAppDevelopment.js": [
		112,
		9,
		0,
		3,
		93,
		1,
		20
	],
	"./pages/MobileAppDevelopment/NewOpenSourceLibraries/NewOpenSourceLibraries": [
		753,
		9,
		180
	],
	"./pages/MobileAppDevelopment/NewOpenSourceLibraries/NewOpenSourceLibraries.js": [
		753,
		9,
		180
	],
	"./pages/MobileAppDevelopment/NewOpenSourceLibraries/NewOpenSourceLibraries.scss": [
		1788,
		7,
		1172
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/NewWhatWeDo": [
		259,
		9,
		265
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/NewWhatWeDo.js": [
		259,
		9,
		265
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/NewWhatWeDo.scss": [
		1154,
		7,
		1173
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/imgs/Apple_logo.svg": [
		1149,
		9,
		2013
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/imgs/android-logo.svg": [
		1150,
		9,
		2014
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/imgs/flutter-logo.svg": [
		1152,
		9,
		2015
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/imgs/ionic-logo.svg": [
		2790,
		9,
		2016
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/imgs/react-logo.svg": [
		1153,
		9,
		2017
	],
	"./pages/MobileAppDevelopment/NewWhatWeDo/imgs/swift-logo.svg": [
		1151,
		9,
		2018
	],
	"./pages/MobileAppDevelopment/ServicesSection/ServicesSection": [
		260,
		9,
		548
	],
	"./pages/MobileAppDevelopment/ServicesSection/ServicesSection.js": [
		260,
		9,
		548
	],
	"./pages/MobileAppDevelopment/ServicesSection/ServicesSection.scss": [
		1155,
		7,
		1174
	],
	"./pages/MobileAppDevelopment/TechnologiesSection/TechnologiesSection": [
		258,
		9,
		416
	],
	"./pages/MobileAppDevelopment/TechnologiesSection/TechnologiesSection.js": [
		258,
		9,
		416
	],
	"./pages/MobileAppDevelopment/WhyChooseMi/WhyChooseMi": [
		262,
		9,
		372
	],
	"./pages/MobileAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		262,
		9,
		372
	],
	"./pages/MobileAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1157,
		7,
		1175
	],
	"./pages/MobileAppDevelopment/WhyChooseSection/WhyChooseSection": [
		261,
		9,
		599
	],
	"./pages/MobileAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		261,
		9,
		599
	],
	"./pages/MobileAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1156,
		7,
		1176
	],
	"./pages/New-Faq/NewFaq": [
		224,
		9,
		270
	],
	"./pages/New-Faq/NewFaq.js": [
		224,
		9,
		270
	],
	"./pages/New-Faq/NewFaq.scss": [
		970,
		7,
		1177
	],
	"./pages/NodeJsDevelopment/AboutSection/AboutSection": [
		350,
		9,
		196
	],
	"./pages/NodeJsDevelopment/AboutSection/AboutSection.js": [
		350,
		9,
		196
	],
	"./pages/NodeJsDevelopment/AboutSection/AboutSection.scss": [
		1239,
		7,
		1178
	],
	"./pages/NodeJsDevelopment/HeroSection/HeroSection": [
		349,
		9,
		600
	],
	"./pages/NodeJsDevelopment/HeroSection/HeroSection.js": [
		349,
		9,
		600
	],
	"./pages/NodeJsDevelopment/HeroSection/HeroSection.scss": [
		1238,
		7,
		1179
	],
	"./pages/NodeJsDevelopment/LookingDevelopers/LookingDevelopers": [
		754,
		9,
		495
	],
	"./pages/NodeJsDevelopment/LookingDevelopers/LookingDevelopers.js": [
		754,
		9,
		495
	],
	"./pages/NodeJsDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		1789,
		7,
		1180
	],
	"./pages/NodeJsDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2791,
		7,
		1181
	],
	"./pages/NodeJsDevelopment/NodeJsDevelopment": [
		127,
		9,
		0,
		108,
		1,
		2,
		32
	],
	"./pages/NodeJsDevelopment/NodeJsDevelopment.js": [
		127,
		9,
		0,
		108,
		1,
		2,
		32
	],
	"./pages/NodeJsDevelopment/Platforms/Platforms": [
		755,
		9,
		439
	],
	"./pages/NodeJsDevelopment/Platforms/Platforms.js": [
		755,
		9,
		439
	],
	"./pages/NodeJsDevelopment/Platforms/Platforms.scss": [
		1790,
		7,
		1182
	],
	"./pages/NodeJsDevelopment/ServicesSection/ServicesSection": [
		351,
		9,
		694
	],
	"./pages/NodeJsDevelopment/ServicesSection/ServicesSection.js": [
		351,
		9,
		694
	],
	"./pages/NodeJsDevelopment/ServicesSection/ServicesSection.scss": [
		1240,
		7,
		1183
	],
	"./pages/NodeJsDevelopment/TechnologiesSection/TechnologiesSection": [
		756,
		9,
		644
	],
	"./pages/NodeJsDevelopment/TechnologiesSection/TechnologiesSection.js": [
		756,
		9,
		644
	],
	"./pages/NodeJsDevelopment/WhyChooseMi/WhyChooseMi": [
		353,
		9,
		373
	],
	"./pages/NodeJsDevelopment/WhyChooseMi/WhyChooseMi.js": [
		353,
		9,
		373
	],
	"./pages/NodeJsDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1242,
		7,
		1184
	],
	"./pages/NodeJsDevelopment/WhyChooseSection/WhyChooseSection": [
		352,
		9,
		695
	],
	"./pages/NodeJsDevelopment/WhyChooseSection/WhyChooseSection.js": [
		352,
		9,
		695
	],
	"./pages/NodeJsDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1241,
		7,
		1185
	],
	"./pages/OurSolutions/AboutSection/AboutSection": [
		658,
		9,
		12
	],
	"./pages/OurSolutions/AboutSection/AboutSection.js": [
		658,
		9,
		12
	],
	"./pages/OurSolutions/AboutSection/AboutSection.scss": [
		1630,
		7,
		1186
	],
	"./pages/OurSolutions/AboutSection/img/cloud-computing-solutions.svg": [
		1635,
		9,
		2019
	],
	"./pages/OurSolutions/AboutSection/img/devOps-services.svg": [
		1636,
		9,
		2020
	],
	"./pages/OurSolutions/AboutSection/img/digital-tansformation-services.svg": [
		1637,
		9,
		2021
	],
	"./pages/OurSolutions/AboutSection/img/enterprise-mobility-solutions.svg": [
		1639,
		9,
		2022
	],
	"./pages/OurSolutions/AboutSection/img/enterprise.svg": [
		1631,
		9,
		2023
	],
	"./pages/OurSolutions/AboutSection/img/individuals.svg": [
		1634,
		9,
		2024
	],
	"./pages/OurSolutions/AboutSection/img/organizations.svg": [
		1632,
		9,
		2025
	],
	"./pages/OurSolutions/AboutSection/img/product-engineering-services.svg": [
		1638,
		9,
		2026
	],
	"./pages/OurSolutions/AboutSection/img/startups-ventures.svg": [
		1640,
		9,
		2027
	],
	"./pages/OurSolutions/AboutSection/img/startups.svg": [
		1633,
		9,
		2028
	],
	"./pages/OurSolutions/AboutSection/n-images/android.svg": [
		2792,
		9,
		2029
	],
	"./pages/OurSolutions/AboutSection/n-images/flutter.svg": [
		2793,
		9,
		2030
	],
	"./pages/OurSolutions/AboutSection/n-images/ios.svg": [
		2794,
		9,
		2031
	],
	"./pages/OurSolutions/AboutSection/n-images/react.svg": [
		2795,
		9,
		2032
	],
	"./pages/OurSolutions/AboutSection/n-images/right-arrow.svg": [
		2796,
		9,
		2033
	],
	"./pages/OurSolutions/CantFindTechnology/CantFindTechnology": [
		568,
		9,
		696
	],
	"./pages/OurSolutions/CantFindTechnology/CantFindTechnology.js": [
		568,
		9,
		696
	],
	"./pages/OurSolutions/CantFindTechnology/CantFindTechnology.scss": [
		1488,
		7,
		1187
	],
	"./pages/OurSolutions/HeroSection/HeroSection": [
		567,
		9,
		453
	],
	"./pages/OurSolutions/HeroSection/HeroSection.js": [
		567,
		9,
		453
	],
	"./pages/OurSolutions/HeroSection/HeroSection.scss": [
		1487,
		7,
		1188
	],
	"./pages/OurSolutions/OnDemandSolutions/OnDemandSolutions": [
		569,
		9,
		268
	],
	"./pages/OurSolutions/OnDemandSolutions/OnDemandSolutions.js": [
		569,
		9,
		268
	],
	"./pages/OurSolutions/OnDemandSolutions/OnDemandSolutions.scss": [
		1489,
		7,
		1189
	],
	"./pages/OurSolutions/OurSolutions": [
		172,
		9,
		0,
		3,
		1,
		12,
		83
	],
	"./pages/OurSolutions/OurSolutions.js": [
		172,
		9,
		0,
		3,
		1,
		12,
		83
	],
	"./pages/OurSolutions/OurSolutions.scss": [
		1629,
		7,
		1190
	],
	"./pages/OurSolutions/imgs/android.webp": [
		2797,
		9,
		2034
	],
	"./pages/OurSolutions/imgs/branding.svg": [
		2798,
		9,
		2035
	],
	"./pages/OurSolutions/imgs/cross.svg": [
		2799,
		9,
		2036
	],
	"./pages/OurSolutions/imgs/ios.webp": [
		2800,
		9,
		2037
	],
	"./pages/OurSolutions/imgs/product-designing.svg": [
		2801,
		9,
		2038
	],
	"./pages/OurSolutions/imgs/product-research.svg": [
		2802,
		9,
		2039
	],
	"./pages/OurSolutions/imgs/tick.svg": [
		2803,
		9,
		2040
	],
	"./pages/OurSolutions/imgs/wearable.webp": [
		2804,
		9,
		2041
	],
	"./pages/OurSolutions/imgs/web.webp": [
		2805,
		9,
		2042
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/beacon-home-rewards-old.webp": [
		2806,
		9,
		2043
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/beacon-home-rewards.webp": [
		2807,
		9,
		2044
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/beacon-pay.webp": [
		2808,
		9,
		2045
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/coins.webp": [
		2809,
		9,
		2046
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/credit-card.webp": [
		2810,
		9,
		2047
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/detail-view-old.webp": [
		2811,
		9,
		2048
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/detail-view.webp": [
		2812,
		9,
		2049
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/download-coins.webp": [
		2813,
		9,
		2050
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/feeling-insecure.webp": [
		2814,
		9,
		2051
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/feeling-test.png": [
		2815,
		9,
		3250
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/money-matters.webp": [
		2816,
		9,
		2052
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/popular-reward-visual-old.webp": [
		2817,
		9,
		2053
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/popular-reward-visual.webp": [
		2818,
		9,
		2054
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/popular-reward.webp": [
		2819,
		9,
		2055
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/rewards-bills.webp": [
		2820,
		9,
		2056
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/subscribers-coins.webp": [
		2821,
		9,
		2057
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/tablet-header-mob.webp": [
		2822,
		9,
		2058
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/tablet-header-old.webp": [
		2823,
		9,
		2059
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/tablet-header.webp": [
		2824,
		9,
		2060
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/wall-art.webp": [
		2825,
		9,
		2061
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/wireframe-design.webp": [
		2826,
		9,
		2062
	],
	"./pages/OurWorks/OurPortfolios/Beacon/img/wireframe.webp": [
		2827,
		9,
		2063
	],
	"./pages/PageNotFound/PageNotFound": [
		182,
		9,
		0,
		1,
		91
	],
	"./pages/PageNotFound/PageNotFound.js": [
		182,
		9,
		0,
		1,
		91
	],
	"./pages/PageNotFound/PageNotFound.scss": [
		1645,
		7,
		1191
	],
	"./pages/PhpDevelopment/AboutSection/AboutSection": [
		340,
		9,
		226
	],
	"./pages/PhpDevelopment/AboutSection/AboutSection.js": [
		340,
		9,
		226
	],
	"./pages/PhpDevelopment/AboutSection/AboutSection.scss": [
		1229,
		7,
		1192
	],
	"./pages/PhpDevelopment/HeroSection/HeroSection": [
		339,
		9,
		549
	],
	"./pages/PhpDevelopment/HeroSection/HeroSection.js": [
		339,
		9,
		549
	],
	"./pages/PhpDevelopment/HeroSection/HeroSection.scss": [
		1228,
		7,
		1193
	],
	"./pages/PhpDevelopment/LookingDevelopers/LookingDevelopers": [
		757,
		9,
		496
	],
	"./pages/PhpDevelopment/LookingDevelopers/LookingDevelopers.js": [
		757,
		9,
		496
	],
	"./pages/PhpDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		1791,
		7,
		1194
	],
	"./pages/PhpDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2828,
		7,
		1195
	],
	"./pages/PhpDevelopment/PhpDevelopment": [
		125,
		9,
		0,
		106,
		1,
		2,
		33
	],
	"./pages/PhpDevelopment/PhpDevelopment.js": [
		125,
		9,
		0,
		106,
		1,
		2,
		33
	],
	"./pages/PhpDevelopment/ServicesSection/ServicesSection": [
		341,
		9,
		550
	],
	"./pages/PhpDevelopment/ServicesSection/ServicesSection.js": [
		341,
		9,
		550
	],
	"./pages/PhpDevelopment/ServicesSection/ServicesSection.scss": [
		1230,
		7,
		1196
	],
	"./pages/PhpDevelopment/TechnologiesSection/TechnologiesSection": [
		758,
		9,
		645
	],
	"./pages/PhpDevelopment/TechnologiesSection/TechnologiesSection.js": [
		758,
		9,
		645
	],
	"./pages/PhpDevelopment/WhyChooseMi/WhyChooseMi": [
		343,
		9,
		374
	],
	"./pages/PhpDevelopment/WhyChooseMi/WhyChooseMi.js": [
		343,
		9,
		374
	],
	"./pages/PhpDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1232,
		7,
		1197
	],
	"./pages/PhpDevelopment/WhyChooseSection/WhyChooseSection": [
		342,
		9,
		601
	],
	"./pages/PhpDevelopment/WhyChooseSection/WhyChooseSection.js": [
		342,
		9,
		601
	],
	"./pages/PhpDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1231,
		7,
		1198
	],
	"./pages/Portfolio/HeroSection/HeroSection": [
		583,
		9,
		697
	],
	"./pages/Portfolio/HeroSection/HeroSection.js": [
		583,
		9,
		697
	],
	"./pages/Portfolio/HeroSection/HeroSection.scss": [
		1524,
		7,
		1199
	],
	"./pages/Portfolio/HeroSection/img/dropdown.svg": [
		2829,
		9,
		2064
	],
	"./pages/Portfolio/HeroSection/img/left-back-arrow.svg": [
		2830,
		9,
		2065
	],
	"./pages/Portfolio/List/List": [
		584,
		9,
		14,
		8,
		698
	],
	"./pages/Portfolio/List/List.js": [
		584,
		9,
		14,
		8,
		698
	],
	"./pages/Portfolio/List/List.scss": [
		1525,
		7,
		1200
	],
	"./pages/Portfolio/Portfolio": [
		759,
		9,
		0,
		5,
		14,
		1,
		175
	],
	"./pages/Portfolio/Portfolio.js": [
		759,
		9,
		0,
		5,
		14,
		1,
		175
	],
	"./pages/Portfolio/PortfolioDetailPopup/PortfolioDetailPopup": [
		234,
		9,
		620
	],
	"./pages/Portfolio/PortfolioDetailPopup/PortfolioDetailPopup.js": [
		234,
		9,
		620
	],
	"./pages/Portfolio/PortfolioDetailPopup/PortfolioDetailPopup.scss": [
		1003,
		7,
		1201
	],
	"./pages/Portfolio/PortfolioDetailPopup/img/mi-logo.png": [
		2831,
		9,
		3251
	],
	"./pages/Portfolio/PortfolioDetailPopup/img/pfdetail.png": [
		2832,
		9,
		3252
	],
	"./pages/PortfolioDetail/Ab6ppStory/Ab6ppStory": [
		760,
		9,
		0,
		1,
		153
	],
	"./pages/PortfolioDetail/Ab6ppStory/Ab6ppStory.js": [
		760,
		9,
		0,
		1,
		153
	],
	"./pages/PortfolioDetail/Ab6ppStory/Ab6ppStory.scss": [
		1792,
		7,
		1202
	],
	"./pages/PortfolioDetail/Ab6ppStory/About/About": [
		586,
		9,
		699
	],
	"./pages/PortfolioDetail/Ab6ppStory/About/About.js": [
		586,
		9,
		699
	],
	"./pages/PortfolioDetail/Ab6ppStory/About/About.scss": [
		1527,
		7,
		1203
	],
	"./pages/PortfolioDetail/Ab6ppStory/Banner/6pp-video.mp4": [
		2833,
		9,
		2066
	],
	"./pages/PortfolioDetail/Ab6ppStory/Banner/Banner": [
		585,
		9,
		700
	],
	"./pages/PortfolioDetail/Ab6ppStory/Banner/Banner.js": [
		585,
		9,
		700
	],
	"./pages/PortfolioDetail/Ab6ppStory/Banner/Banner.scss": [
		1526,
		7,
		1204
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/BigImgOne": [
		587,
		9,
		701
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/BigImgOne.js": [
		587,
		9,
		701
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/BigImgOne.scss": [
		1528,
		7,
		1205
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/dummy.mp4": [
		2834,
		9,
		2067
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/pause-icon.svg": [
		2835,
		9,
		2068
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/video-icon.svg": [
		2836,
		9,
		2069
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgOne/video.png": [
		2837,
		9,
		3253
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgThree/BigImgThree": [
		591,
		9,
		702
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgThree/BigImgThree.js": [
		591,
		9,
		702
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgThree/BigImgThree.scss": [
		1532,
		7,
		1206
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgTwo/BigImgTwo": [
		589,
		9,
		703
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgTwo/BigImgTwo.js": [
		589,
		9,
		703
	],
	"./pages/PortfolioDetail/Ab6ppStory/BigImgTwo/BigImgTwo.scss": [
		1530,
		7,
		1207
	],
	"./pages/PortfolioDetail/Ab6ppStory/Features/Features": [
		588,
		9,
		704
	],
	"./pages/PortfolioDetail/Ab6ppStory/Features/Features.js": [
		588,
		9,
		704
	],
	"./pages/PortfolioDetail/Ab6ppStory/Features/Features.scss": [
		1529,
		7,
		1208
	],
	"./pages/PortfolioDetail/Ab6ppStory/FeaturesTwo/FeaturesTwo": [
		590,
		9,
		705
	],
	"./pages/PortfolioDetail/Ab6ppStory/FeaturesTwo/FeaturesTwo.js": [
		590,
		9,
		705
	],
	"./pages/PortfolioDetail/Ab6ppStory/FeaturesTwo/FeaturesTwo.scss": [
		1531,
		7,
		1209
	],
	"./pages/PortfolioDetail/Ab6ppStory/Result/Result": [
		594,
		9,
		706
	],
	"./pages/PortfolioDetail/Ab6ppStory/Result/Result.js": [
		594,
		9,
		706
	],
	"./pages/PortfolioDetail/Ab6ppStory/Result/Result.scss": [
		1536,
		7,
		1210
	],
	"./pages/PortfolioDetail/Ab6ppStory/TechnologyStack/TechnologyStack": [
		592,
		9,
		621
	],
	"./pages/PortfolioDetail/Ab6ppStory/TechnologyStack/TechnologyStack.js": [
		592,
		9,
		621
	],
	"./pages/PortfolioDetail/Ab6ppStory/TechnologyStack/TechnologyStack.scss": [
		1533,
		7,
		1211
	],
	"./pages/PortfolioDetail/Ab6ppStory/Testimonial/Testimonial": [
		593,
		9,
		707
	],
	"./pages/PortfolioDetail/Ab6ppStory/Testimonial/Testimonial.js": [
		593,
		9,
		707
	],
	"./pages/PortfolioDetail/Ab6ppStory/Testimonial/Testimonial.scss": [
		1535,
		7,
		1212
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Barlow-Italic.woff": [
		2838,
		9,
		2070
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Barlow-Italic.woff2": [
		2839,
		9,
		2071
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Barlow-Regular.woff": [
		2840,
		9,
		2072
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Barlow-Regular.woff2": [
		2841,
		9,
		2073
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Sen-Bold.woff": [
		2842,
		9,
		2074
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Sen-Bold.woff2": [
		2843,
		9,
		2075
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Sen-Regular.woff": [
		2844,
		9,
		2076
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/Sen-Regular.woff2": [
		2845,
		9,
		2077
	],
	"./pages/PortfolioDetail/Ab6ppStory/fonts/stylesheet.css": [
		2846,
		7,
		845
	],
	"./pages/PortfolioDetail/Ab6ppStory/img/6pp-banner.png": [
		2847,
		9,
		3254
	],
	"./pages/PortfolioDetail/Ab6ppStory/img/bhoj-banner-screen.png": [
		2848,
		9,
		3255
	],
	"./pages/PortfolioDetail/Ab6ppStory/img/left-quote.svg": [
		2849,
		9,
		2078
	],
	"./pages/PortfolioDetail/Ab6ppStory/img/ridesharing-banner-screen.png": [
		2850,
		9,
		3256
	],
	"./pages/PortfolioDetail/Ab6ppStory/img/right-quote.svg": [
		2851,
		9,
		2079
	],
	"./pages/PortfolioDetail/BayaApp/BayaApp": [
		761,
		9,
		0,
		4,
		1,
		708
	],
	"./pages/PortfolioDetail/BayaApp/BayaApp.js": [
		761,
		9,
		0,
		4,
		1,
		708
	],
	"./pages/PortfolioDetail/BayaApp/fonts/Old/d-din.regular.woff": [
		2852,
		9,
		2080
	],
	"./pages/PortfolioDetail/BayaApp/fonts/Old/d-din.regular.woff2": [
		2853,
		9,
		2081
	],
	"./pages/PortfolioDetail/BayaApp/fonts/Old/playfairdisplay-bold.woff": [
		2854,
		9,
		2082
	],
	"./pages/PortfolioDetail/BayaApp/fonts/Old/playfairdisplay-bold.woff2": [
		2855,
		9,
		2083
	],
	"./pages/PortfolioDetail/BayaApp/fonts/SFUIText-Bold.ttf": [
		2856,
		9,
		2084
	],
	"./pages/PortfolioDetail/BayaApp/fonts/SFUIText-Regular.ttf": [
		2857,
		9,
		2085
	],
	"./pages/PortfolioDetail/BayaApp/scss/BayaApp.scss": [
		1793,
		7,
		1213
	],
	"./pages/PortfolioDetail/BhojNew/About/About": [
		595,
		9,
		709
	],
	"./pages/PortfolioDetail/BhojNew/About/About.js": [
		595,
		9,
		709
	],
	"./pages/PortfolioDetail/BhojNew/About/About.scss": [
		1537,
		7,
		1214
	],
	"./pages/PortfolioDetail/BhojNew/Banner/Banner": [
		596,
		9,
		710
	],
	"./pages/PortfolioDetail/BhojNew/Banner/Banner.js": [
		596,
		9,
		710
	],
	"./pages/PortfolioDetail/BhojNew/Banner/Banner.scss": [
		1538,
		7,
		1215
	],
	"./pages/PortfolioDetail/BhojNew/BhojNew": [
		762,
		9,
		0,
		1,
		148
	],
	"./pages/PortfolioDetail/BhojNew/BhojNew.js": [
		762,
		9,
		0,
		1,
		148
	],
	"./pages/PortfolioDetail/BhojNew/BhojNew.scss": [
		1794,
		7,
		1216
	],
	"./pages/PortfolioDetail/BhojNew/BigImgFour/BigImgFour": [
		606,
		9,
		711
	],
	"./pages/PortfolioDetail/BhojNew/BigImgFour/BigImgFour.js": [
		606,
		9,
		711
	],
	"./pages/PortfolioDetail/BhojNew/BigImgFour/BigImgFour.scss": [
		1552,
		7,
		1217
	],
	"./pages/PortfolioDetail/BhojNew/BigImgOne/BigImgOne": [
		600,
		9,
		712
	],
	"./pages/PortfolioDetail/BhojNew/BigImgOne/BigImgOne.js": [
		600,
		9,
		712
	],
	"./pages/PortfolioDetail/BhojNew/BigImgOne/BigImgOne.scss": [
		1544,
		7,
		1218
	],
	"./pages/PortfolioDetail/BhojNew/BigImgThree/BigImgThree": [
		603,
		9,
		713
	],
	"./pages/PortfolioDetail/BhojNew/BigImgThree/BigImgThree.js": [
		603,
		9,
		713
	],
	"./pages/PortfolioDetail/BhojNew/BigImgThree/BigImgThree.scss": [
		1549,
		7,
		1219
	],
	"./pages/PortfolioDetail/BhojNew/BigImgTwo/BigImgTwo": [
		599,
		9,
		714
	],
	"./pages/PortfolioDetail/BhojNew/BigImgTwo/BigImgTwo.js": [
		599,
		9,
		714
	],
	"./pages/PortfolioDetail/BhojNew/BigImgTwo/BigImgTwo.scss": [
		1543,
		7,
		1220
	],
	"./pages/PortfolioDetail/BhojNew/Features/Features": [
		601,
		9,
		715
	],
	"./pages/PortfolioDetail/BhojNew/Features/Features.js": [
		601,
		9,
		715
	],
	"./pages/PortfolioDetail/BhojNew/Features/Features.scss": [
		1545,
		7,
		1221
	],
	"./pages/PortfolioDetail/BhojNew/FeaturesThree/FeaturesThree": [
		605,
		9,
		716
	],
	"./pages/PortfolioDetail/BhojNew/FeaturesThree/FeaturesThree.js": [
		605,
		9,
		716
	],
	"./pages/PortfolioDetail/BhojNew/FeaturesThree/FeaturesThree.scss": [
		1551,
		7,
		1222
	],
	"./pages/PortfolioDetail/BhojNew/FeaturesTwo/FeaturesTwo": [
		604,
		9,
		717
	],
	"./pages/PortfolioDetail/BhojNew/FeaturesTwo/FeaturesTwo.js": [
		604,
		9,
		717
	],
	"./pages/PortfolioDetail/BhojNew/FeaturesTwo/FeaturesTwo.scss": [
		1550,
		7,
		1223
	],
	"./pages/PortfolioDetail/BhojNew/Result/Result": [
		598,
		9,
		718
	],
	"./pages/PortfolioDetail/BhojNew/Result/Result.js": [
		598,
		9,
		718
	],
	"./pages/PortfolioDetail/BhojNew/Result/Result.scss": [
		1542,
		7,
		1224
	],
	"./pages/PortfolioDetail/BhojNew/TechnologyStack/TechnologyStack": [
		602,
		9,
		440
	],
	"./pages/PortfolioDetail/BhojNew/TechnologyStack/TechnologyStack.js": [
		602,
		9,
		440
	],
	"./pages/PortfolioDetail/BhojNew/TechnologyStack/TechnologyStack.scss": [
		1546,
		7,
		1225
	],
	"./pages/PortfolioDetail/BhojNew/Testimonial/Testimonial": [
		597,
		9,
		629
	],
	"./pages/PortfolioDetail/BhojNew/Testimonial/Testimonial.js": [
		597,
		9,
		629
	],
	"./pages/PortfolioDetail/BhojNew/Testimonial/Testimonial.scss": [
		1539,
		7,
		1226
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Barlow-Italic.woff": [
		2858,
		9,
		2086
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Barlow-Italic.woff2": [
		2859,
		9,
		2087
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Barlow-Regular.woff": [
		2860,
		9,
		2088
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Barlow-Regular.woff2": [
		2861,
		9,
		2089
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Sen-Bold.woff": [
		2862,
		9,
		2090
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Sen-Bold.woff2": [
		2863,
		9,
		2091
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Sen-Regular.woff": [
		2864,
		9,
		2092
	],
	"./pages/PortfolioDetail/BhojNew/fonts/Sen-Regular.woff2": [
		2865,
		9,
		2093
	],
	"./pages/PortfolioDetail/BhojNew/fonts/stylesheet.css": [
		2866,
		7,
		846
	],
	"./pages/PortfolioDetail/BhojNew/img/bhoj-banner-screen.png": [
		2867,
		9,
		3257
	],
	"./pages/PortfolioDetail/BhojNew/img/left-quote.svg": [
		1540,
		9,
		2094
	],
	"./pages/PortfolioDetail/BhojNew/img/right-quote.svg": [
		1541,
		9,
		2095
	],
	"./pages/PortfolioDetail/Cam4Sell/About/About": [
		607,
		9,
		719
	],
	"./pages/PortfolioDetail/Cam4Sell/About/About.js": [
		607,
		9,
		719
	],
	"./pages/PortfolioDetail/Cam4Sell/About/About.scss": [
		1553,
		7,
		1227
	],
	"./pages/PortfolioDetail/Cam4Sell/Banner/Banner": [
		608,
		9,
		720
	],
	"./pages/PortfolioDetail/Cam4Sell/Banner/Banner.js": [
		608,
		9,
		720
	],
	"./pages/PortfolioDetail/Cam4Sell/Banner/Banner.scss": [
		1554,
		7,
		1228
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgOne/BigImgOne": [
		609,
		9,
		721
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgOne/BigImgOne.js": [
		609,
		9,
		721
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgOne/BigImgOne.scss": [
		1555,
		7,
		1229
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgThree/BigImgThree": [
		610,
		9,
		722
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgThree/BigImgThree.js": [
		610,
		9,
		722
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgThree/BigImgThree.scss": [
		1556,
		7,
		1230
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgTwo/BigImgTwo": [
		611,
		9,
		723
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgTwo/BigImgTwo.js": [
		611,
		9,
		723
	],
	"./pages/PortfolioDetail/Cam4Sell/BigImgTwo/BigImgTwo.scss": [
		1557,
		7,
		1231
	],
	"./pages/PortfolioDetail/Cam4Sell/CamForSell": [
		763,
		9,
		0,
		1,
		154
	],
	"./pages/PortfolioDetail/Cam4Sell/CamForSell.js": [
		763,
		9,
		0,
		1,
		154
	],
	"./pages/PortfolioDetail/Cam4Sell/CamForSell.scss": [
		1795,
		7,
		1232
	],
	"./pages/PortfolioDetail/Cam4Sell/Features/Features": [
		612,
		9,
		724
	],
	"./pages/PortfolioDetail/Cam4Sell/Features/Features.js": [
		612,
		9,
		724
	],
	"./pages/PortfolioDetail/Cam4Sell/Features/Features.scss": [
		1558,
		7,
		1233
	],
	"./pages/PortfolioDetail/Cam4Sell/FeaturesThree/FeaturesThree": [
		764,
		9,
		725
	],
	"./pages/PortfolioDetail/Cam4Sell/FeaturesThree/FeaturesThree.js": [
		764,
		9,
		725
	],
	"./pages/PortfolioDetail/Cam4Sell/FeaturesThree/FeaturesThree.scss": [
		1796,
		7,
		1234
	],
	"./pages/PortfolioDetail/Cam4Sell/FeaturesTwo/FeaturesTwo": [
		616,
		9,
		726
	],
	"./pages/PortfolioDetail/Cam4Sell/FeaturesTwo/FeaturesTwo.js": [
		616,
		9,
		726
	],
	"./pages/PortfolioDetail/Cam4Sell/FeaturesTwo/FeaturesTwo.scss": [
		1563,
		7,
		1235
	],
	"./pages/PortfolioDetail/Cam4Sell/Result/Result": [
		615,
		9,
		727
	],
	"./pages/PortfolioDetail/Cam4Sell/Result/Result.js": [
		615,
		9,
		727
	],
	"./pages/PortfolioDetail/Cam4Sell/Result/Result.scss": [
		1562,
		7,
		1236
	],
	"./pages/PortfolioDetail/Cam4Sell/TechnologyStack/TechnologyStack": [
		613,
		9,
		622
	],
	"./pages/PortfolioDetail/Cam4Sell/TechnologyStack/TechnologyStack.js": [
		613,
		9,
		622
	],
	"./pages/PortfolioDetail/Cam4Sell/TechnologyStack/TechnologyStack.scss": [
		1559,
		7,
		1237
	],
	"./pages/PortfolioDetail/Cam4Sell/Testimonial/Testimonial": [
		614,
		9,
		728
	],
	"./pages/PortfolioDetail/Cam4Sell/Testimonial/Testimonial.js": [
		614,
		9,
		728
	],
	"./pages/PortfolioDetail/Cam4Sell/Testimonial/Testimonial.scss": [
		1561,
		7,
		1238
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Barlow-Italic.woff": [
		2868,
		9,
		2096
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Barlow-Italic.woff2": [
		2869,
		9,
		2097
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Barlow-Regular.woff": [
		2870,
		9,
		2098
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Barlow-Regular.woff2": [
		2871,
		9,
		2099
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Sen-Bold.woff": [
		2872,
		9,
		2100
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Sen-Bold.woff2": [
		2873,
		9,
		2101
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Sen-Regular.woff": [
		2874,
		9,
		2102
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/Sen-Regular.woff2": [
		2875,
		9,
		2103
	],
	"./pages/PortfolioDetail/Cam4Sell/fonts/stylesheet.css": [
		2876,
		7,
		847
	],
	"./pages/PortfolioDetail/Cam4Sell/img/cam4sell-hero-image.png": [
		2877,
		9,
		3258
	],
	"./pages/PortfolioDetail/CricFantasy/CricFantasy": [
		765,
		9,
		0,
		4,
		1,
		729
	],
	"./pages/PortfolioDetail/CricFantasy/CricFantasy.js": [
		765,
		9,
		0,
		4,
		1,
		729
	],
	"./pages/PortfolioDetail/CricFantasy/CricFantasy.scss": [
		1797,
		7,
		1239
	],
	"./pages/PortfolioDetail/CricFantasy/fonts/lota-grotesque-regular.otf": [
		2878,
		9,
		2104
	],
	"./pages/PortfolioDetail/CricFantasy/fonts/recoleta-regular.ttf": [
		2879,
		9,
		2105
	],
	"./pages/PortfolioDetail/DentalCare/DentalCare": [
		766,
		9,
		0,
		4,
		1,
		623
	],
	"./pages/PortfolioDetail/DentalCare/DentalCare.js": [
		766,
		9,
		0,
		4,
		1,
		623
	],
	"./pages/PortfolioDetail/DentalCare/DentalCare.scss": [
		1798,
		7,
		1240
	],
	"./pages/PortfolioDetail/DentalCare/fonts/DMSerifDisplay-Regular.ttf": [
		2880,
		9,
		2106
	],
	"./pages/PortfolioDetail/DentalCare/fonts/DMSerifDisplay-Regular.woff": [
		2881,
		9,
		2107
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-Bold.ttf": [
		2882,
		9,
		2108
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-Bold.woff": [
		2883,
		9,
		2109
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-Medium.ttf": [
		2884,
		9,
		2110
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-Medium.woff": [
		2885,
		9,
		2111
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-Regular.ttf": [
		2886,
		9,
		2112
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-Regular.woff": [
		2887,
		9,
		2113
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-SemiBold.ttf": [
		2888,
		9,
		2114
	],
	"./pages/PortfolioDetail/DentalCare/fonts/Raleway-SemiBold.woff": [
		2889,
		9,
		2115
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/banner-right-img.png": [
		2890,
		9,
		3259
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/big-banner.png": [
		2891,
		9,
		3260
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/both-screen.png": [
		2892,
		9,
		3261
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/confidence.png": [
		2893,
		9,
		3262
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/feature-img.png": [
		2894,
		9,
		3263
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/features-screen.png": [
		2895,
		9,
		3264
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/jeniffer.png": [
		2896,
		9,
		3265
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/reminder.png": [
		2897,
		9,
		3266
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/signup.png": [
		2898,
		9,
		3267
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/smile.png": [
		2899,
		9,
		3268
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/time-slot.png": [
		2900,
		9,
		3269
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/top-features.png": [
		2901,
		9,
		3270
	],
	"./pages/PortfolioDetail/DentalCare/img/DentalCare/png/treatment-record.png": [
		2902,
		9,
		3271
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/circle.svg": [
		2903,
		9,
		2116
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/foursquare.svg": [
		1800,
		9,
		2117
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/go.svg": [
		1801,
		9,
		2118
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/point.svg": [
		2904,
		9,
		2119
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/quote.svg": [
		2905,
		9,
		2120
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/react.svg": [
		1799,
		9,
		2121
	],
	"./pages/PortfolioDetail/DentalCare/img/svg/teeth.svg": [
		2906,
		9,
		2122
	],
	"./pages/PortfolioDetail/Dopamine/About/About": [
		767,
		9,
		730
	],
	"./pages/PortfolioDetail/Dopamine/About/About.js": [
		767,
		9,
		730
	],
	"./pages/PortfolioDetail/Dopamine/About/About.scss": [
		1802,
		7,
		1241
	],
	"./pages/PortfolioDetail/Dopamine/Banner/Banner": [
		768,
		9,
		731
	],
	"./pages/PortfolioDetail/Dopamine/Banner/Banner.js": [
		768,
		9,
		731
	],
	"./pages/PortfolioDetail/Dopamine/Banner/Banner.scss": [
		1803,
		7,
		1242
	],
	"./pages/PortfolioDetail/Dopamine/BigImgOne/BigImgOne": [
		769,
		9,
		732
	],
	"./pages/PortfolioDetail/Dopamine/BigImgOne/BigImgOne.js": [
		769,
		9,
		732
	],
	"./pages/PortfolioDetail/Dopamine/BigImgOne/BigImgOne.scss": [
		1804,
		7,
		1243
	],
	"./pages/PortfolioDetail/Dopamine/BigImgTwo/BigImgTwo": [
		770,
		9,
		733
	],
	"./pages/PortfolioDetail/Dopamine/BigImgTwo/BigImgTwo.js": [
		770,
		9,
		733
	],
	"./pages/PortfolioDetail/Dopamine/BigImgTwo/BigImgTwo.scss": [
		1805,
		7,
		1244
	],
	"./pages/PortfolioDetail/Dopamine/Dopamine": [
		771,
		9,
		0,
		4,
		1,
		734
	],
	"./pages/PortfolioDetail/Dopamine/Dopamine.js": [
		771,
		9,
		0,
		4,
		1,
		734
	],
	"./pages/PortfolioDetail/Dopamine/Dopamine.scss": [
		1806,
		7,
		1245
	],
	"./pages/PortfolioDetail/Dopamine/Features/Features": [
		772,
		9,
		735
	],
	"./pages/PortfolioDetail/Dopamine/Features/Features.js": [
		772,
		9,
		735
	],
	"./pages/PortfolioDetail/Dopamine/Features/Features.scss": [
		1807,
		7,
		1246
	],
	"./pages/PortfolioDetail/Dopamine/FeaturesThree/FeaturesThree": [
		773,
		9,
		736
	],
	"./pages/PortfolioDetail/Dopamine/FeaturesThree/FeaturesThree.js": [
		773,
		9,
		736
	],
	"./pages/PortfolioDetail/Dopamine/FeaturesThree/FeaturesThree.scss": [
		1808,
		7,
		1247
	],
	"./pages/PortfolioDetail/Dopamine/FeaturesTwo/FeaturesTwo": [
		774,
		9,
		737
	],
	"./pages/PortfolioDetail/Dopamine/FeaturesTwo/FeaturesTwo.js": [
		774,
		9,
		737
	],
	"./pages/PortfolioDetail/Dopamine/FeaturesTwo/FeaturesTwo.scss": [
		1809,
		7,
		1248
	],
	"./pages/PortfolioDetail/Dopamine/Result/Result": [
		775,
		9,
		738
	],
	"./pages/PortfolioDetail/Dopamine/Result/Result.js": [
		775,
		9,
		738
	],
	"./pages/PortfolioDetail/Dopamine/Result/Result.scss": [
		1810,
		7,
		1249
	],
	"./pages/PortfolioDetail/Dopamine/TechnologyStack/TechnologyStack": [
		776,
		9,
		441
	],
	"./pages/PortfolioDetail/Dopamine/TechnologyStack/TechnologyStack.js": [
		776,
		9,
		441
	],
	"./pages/PortfolioDetail/Dopamine/TechnologyStack/TechnologyStack.scss": [
		1811,
		7,
		1250
	],
	"./pages/PortfolioDetail/Dopamine/Testimonial/Testimonial": [
		777,
		9,
		739
	],
	"./pages/PortfolioDetail/Dopamine/Testimonial/Testimonial.js": [
		777,
		9,
		739
	],
	"./pages/PortfolioDetail/Dopamine/Testimonial/Testimonial.scss": [
		1812,
		7,
		1251
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Barlow-Italic.woff": [
		2907,
		9,
		2123
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Barlow-Italic.woff2": [
		2908,
		9,
		2124
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Barlow-Regular.woff": [
		2909,
		9,
		2125
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Barlow-Regular.woff2": [
		2910,
		9,
		2126
	],
	"./pages/PortfolioDetail/Dopamine/fonts/KronaOne-Regular.ttf": [
		2911,
		9,
		2127
	],
	"./pages/PortfolioDetail/Dopamine/fonts/KronaOne-Regular.woff": [
		2912,
		9,
		2128
	],
	"./pages/PortfolioDetail/Dopamine/fonts/KronaOne-Regular.woff2": [
		2913,
		9,
		2129
	],
	"./pages/PortfolioDetail/Dopamine/fonts/KumbhSans-Regular.ttf": [
		2914,
		9,
		2130
	],
	"./pages/PortfolioDetail/Dopamine/fonts/KumbhSans-Regular.woff": [
		2915,
		9,
		2131
	],
	"./pages/PortfolioDetail/Dopamine/fonts/KumbhSans-Regular.woff2": [
		2916,
		9,
		2132
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Sen-Bold.woff": [
		2917,
		9,
		2133
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Sen-Bold.woff2": [
		2918,
		9,
		2134
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Sen-Regular.woff": [
		2919,
		9,
		2135
	],
	"./pages/PortfolioDetail/Dopamine/fonts/Sen-Regular.woff2": [
		2920,
		9,
		2136
	],
	"./pages/PortfolioDetail/Dopamine/fonts/stylesheet.css": [
		2921,
		7,
		848
	],
	"./pages/PortfolioDetail/Dopamine/images/achievements.png": [
		2922,
		9,
		3272
	],
	"./pages/PortfolioDetail/Dopamine/images/all_screen.png": [
		2923,
		9,
		3273
	],
	"./pages/PortfolioDetail/Dopamine/images/banner-bg-left.png": [
		2924,
		9,
		3274
	],
	"./pages/PortfolioDetail/Dopamine/images/banner-img.png": [
		2925,
		9,
		3275
	],
	"./pages/PortfolioDetail/Dopamine/images/bg-design1.png": [
		2926,
		9,
		3276
	],
	"./pages/PortfolioDetail/Dopamine/images/bg.png": [
		2927,
		9,
		3277
	],
	"./pages/PortfolioDetail/Dopamine/images/design-bg.png": [
		2928,
		9,
		3278
	],
	"./pages/PortfolioDetail/Dopamine/images/hand.png": [
		2929,
		9,
		3279
	],
	"./pages/PortfolioDetail/Dopamine/images/hero-bg.png": [
		2930,
		9,
		3280
	],
	"./pages/PortfolioDetail/Dopamine/images/hero.png": [
		2931,
		9,
		3281
	],
	"./pages/PortfolioDetail/Dopamine/images/mockup1.png": [
		2932,
		9,
		3282
	],
	"./pages/PortfolioDetail/Dopamine/images/solution_we_provided.png": [
		2933,
		9,
		3283
	],
	"./pages/PortfolioDetail/Dopamine/images/swift.png": [
		2934,
		9,
		3284
	],
	"./pages/PortfolioDetail/Dopamine/img/bhoj-banner-screen.png": [
		2935,
		9,
		3285
	],
	"./pages/PortfolioDetail/Dopamine/img/dopamine-banner-screen.png": [
		2936,
		9,
		3286
	],
	"./pages/PortfolioDetail/Dopamine/img/left-quote.svg": [
		2937,
		9,
		2137
	],
	"./pages/PortfolioDetail/Dopamine/img/ridesharing-banner-screen.png": [
		2938,
		9,
		3287
	],
	"./pages/PortfolioDetail/Dopamine/img/right-quote.svg": [
		2939,
		9,
		2138
	],
	"./pages/PortfolioDetail/Dudepins/Dudepins": [
		778,
		9,
		0,
		1,
		246
	],
	"./pages/PortfolioDetail/Dudepins/Dudepins.js": [
		778,
		9,
		0,
		1,
		246
	],
	"./pages/PortfolioDetail/Dudepins/Dudepins.scss": [
		1813,
		7,
		1252
	],
	"./pages/PortfolioDetail/Dudepins/fonts/DMSans-Bold.ttf": [
		2940,
		9,
		2139
	],
	"./pages/PortfolioDetail/Dudepins/fonts/DMSans-Bold.woff2": [
		2941,
		9,
		2140
	],
	"./pages/PortfolioDetail/Dudepins/fonts/DMSans-Regular.ttf": [
		2942,
		9,
		2141
	],
	"./pages/PortfolioDetail/Dudepins/fonts/DMSans-Regular.woff2": [
		2943,
		9,
		2142
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Bold.ttf": [
		2944,
		9,
		2143
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Bold.woff2": [
		2945,
		9,
		2144
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Light.ttf": [
		2946,
		9,
		2145
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Light.woff2": [
		2947,
		9,
		2146
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Medium.ttf": [
		2948,
		9,
		2147
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Medium.woff2": [
		2949,
		9,
		2148
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Regular.ttf": [
		2950,
		9,
		2149
	],
	"./pages/PortfolioDetail/Dudepins/fonts/NeueMontreal-Regular.woff2": [
		2951,
		9,
		2150
	],
	"./pages/PortfolioDetail/Dudepins/images/bg-noice.svg": [
		2952,
		9,
		2151
	],
	"./pages/PortfolioDetail/Dudepins/images/dudepins.png": [
		1822,
		9,
		3288
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/clientimage.webp": [
		1815,
		9,
		2152
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/gallay-image-01.webp": [
		1816,
		9,
		2153
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/gallay-image-02.webp": [
		1817,
		9,
		2154
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/gallay-image-03.webp": [
		1818,
		9,
		2155
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/gallay-image-04.webp": [
		1819,
		9,
		2156
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/gallay-image-05.webp": [
		1820,
		9,
		2157
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/gallay-image-06.webp": [
		1821,
		9,
		2158
	],
	"./pages/PortfolioDetail/Dudepins/images/webp/wide-image.webp": [
		1814,
		9,
		2159
	],
	"./pages/PortfolioDetail/Ennea/Ennea": [
		779,
		9,
		0,
		3,
		4,
		1,
		669
	],
	"./pages/PortfolioDetail/Ennea/Ennea.js": [
		779,
		9,
		0,
		3,
		4,
		1,
		669
	],
	"./pages/PortfolioDetail/Ennea/Ennea.scss": [
		1823,
		7,
		831
	],
	"./pages/PortfolioDetail/Ennea/fonts/AvertaDemoPE-ExtraBold.woff": [
		2953,
		9,
		2160
	],
	"./pages/PortfolioDetail/Ennea/fonts/AvertaDemoPE-ExtraBold.woff2": [
		2954,
		9,
		2161
	],
	"./pages/PortfolioDetail/Ennea/fonts/AvertaDemoPECuttedDemo-Regular.woff": [
		2955,
		9,
		2162
	],
	"./pages/PortfolioDetail/Ennea/fonts/AvertaDemoPECuttedDemo-Regular.woff2": [
		2956,
		9,
		2163
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Black.woff": [
		2957,
		9,
		2164
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Black.woff2": [
		2958,
		9,
		2165
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-BlackItalic.woff": [
		2959,
		9,
		2166
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-BlackItalic.woff2": [
		2960,
		9,
		2167
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Bold.woff": [
		2961,
		9,
		2168
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Bold.woff2": [
		2962,
		9,
		2169
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-BoldItalic.woff": [
		2963,
		9,
		2170
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-BoldItalic.woff2": [
		2964,
		9,
		2171
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Italic.woff": [
		2965,
		9,
		2172
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Italic.woff2": [
		2966,
		9,
		2173
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Medium.woff": [
		2967,
		9,
		2174
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Medium.woff2": [
		2968,
		9,
		2175
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-MediumItalic.woff": [
		2969,
		9,
		2176
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-MediumItalic.woff2": [
		2970,
		9,
		2177
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Regular.woff": [
		2971,
		9,
		2178
	],
	"./pages/PortfolioDetail/Ennea/fonts/RedHatDisplay-Regular.woff2": [
		2972,
		9,
		2179
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Bold.woff": [
		2973,
		9,
		2180
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Bold.woff2": [
		2974,
		9,
		2181
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-BoldItalic.woff": [
		2975,
		9,
		2182
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-BoldItalic.woff2": [
		2976,
		9,
		2183
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraBold.woff": [
		2977,
		9,
		2184
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraBold.woff2": [
		2978,
		9,
		2185
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraBoldItalic.woff": [
		2979,
		9,
		2186
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraBoldItalic.woff2": [
		2980,
		9,
		2187
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraLight.woff": [
		2981,
		9,
		2188
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraLight.woff2": [
		2982,
		9,
		2189
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraLightItalic.woff": [
		2983,
		9,
		2190
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ExtraLightItalic.woff2": [
		2984,
		9,
		2191
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Italic.woff": [
		2985,
		9,
		2192
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Italic.woff2": [
		2986,
		9,
		2193
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Light.woff": [
		2987,
		9,
		2194
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Light.woff2": [
		2988,
		9,
		2195
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-LightItalic.woff": [
		2989,
		9,
		2196
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-LightItalic.woff2": [
		2990,
		9,
		2197
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Medium.woff": [
		2991,
		9,
		2198
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Medium.woff2": [
		2992,
		9,
		2199
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-MediumItalic.woff": [
		2993,
		9,
		2200
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-MediumItalic.woff2": [
		2994,
		9,
		2201
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Regular.woff": [
		2995,
		9,
		2202
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Regular.woff2": [
		2996,
		9,
		2203
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-SemiBold.woff": [
		2997,
		9,
		2204
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-SemiBold.woff2": [
		2998,
		9,
		2205
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-SemiBoldItalic.woff": [
		2999,
		9,
		2206
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-SemiBoldItalic.woff2": [
		3000,
		9,
		2207
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Thin.woff": [
		3001,
		9,
		2208
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-Thin.woff2": [
		3002,
		9,
		2209
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ThinItalic.woff": [
		3003,
		9,
		2210
	],
	"./pages/PortfolioDetail/Ennea/fonts/Sarabun-ThinItalic.woff2": [
		3004,
		9,
		2211
	],
	"./pages/PortfolioDetail/Ennea/fonts/stylesheet.css": [
		3005,
		7,
		849
	],
	"./pages/PortfolioDetail/GPGolf/GPGolf": [
		780,
		9,
		0,
		4,
		1,
		145,
		802
	],
	"./pages/PortfolioDetail/GPGolf/GPGolf.js": [
		780,
		9,
		0,
		4,
		1,
		145,
		802
	],
	"./pages/PortfolioDetail/GPGolf/GPGolf.scss": [
		2138,
		7,
		145
	],
	"./pages/PortfolioDetail/GPGolf/fonts/krona-one-regular.ttf": [
		3006,
		9,
		2212
	],
	"./pages/PortfolioDetail/GPGolf/fonts/open-sans-regular.ttf": [
		3007,
		9,
		2213
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/HeadphoneControllerApp": [
		781,
		9,
		0,
		1,
		247
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/HeadphoneControllerApp.js": [
		781,
		9,
		0,
		1,
		247
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/HeadphoneControllerApp.scss": [
		1824,
		7,
		1253
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/DMSans-Bold.ttf": [
		3008,
		9,
		2214
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/DMSans-Bold.woff2": [
		3009,
		9,
		2215
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/DMSans-Regular.ttf": [
		3010,
		9,
		2216
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/DMSans-Regular.woff2": [
		3011,
		9,
		2217
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Bold.ttf": [
		3012,
		9,
		2218
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Bold.woff2": [
		3013,
		9,
		2219
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Light.ttf": [
		3014,
		9,
		2220
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Light.woff2": [
		3015,
		9,
		2221
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Medium.ttf": [
		3016,
		9,
		2222
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Medium.woff2": [
		3017,
		9,
		2223
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Regular.ttf": [
		3018,
		9,
		2224
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/fonts/NeueMontreal-Regular.woff2": [
		3019,
		9,
		2225
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/bg-noice.svg": [
		3020,
		9,
		2226
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/headphone-controller-app.png": [
		1833,
		9,
		3289
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/clientimage.webp": [
		1826,
		9,
		2227
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/gallay-image-01.webp": [
		1827,
		9,
		2228
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/gallay-image-02.webp": [
		1828,
		9,
		2229
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/gallay-image-03.webp": [
		1829,
		9,
		2230
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/gallay-image-04.webp": [
		1830,
		9,
		2231
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/gallay-image-05.webp": [
		1831,
		9,
		2232
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/gallay-image-06.webp": [
		1832,
		9,
		2233
	],
	"./pages/PortfolioDetail/HeadphoneControllerApp/images/webp/wide-image.webp": [
		1825,
		9,
		2234
	],
	"./pages/PortfolioDetail/Helponymous/Helponymous": [
		782,
		9,
		0,
		3,
		4,
		1,
		156
	],
	"./pages/PortfolioDetail/Helponymous/Helponymous.js": [
		782,
		9,
		0,
		3,
		4,
		1,
		156
	],
	"./pages/PortfolioDetail/Helponymous/Helponymous.scss": [
		1834,
		7,
		1254
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Bold.ttf": [
		3021,
		9,
		2235
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Bold.woff": [
		3022,
		9,
		2236
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Heavy.ttf": [
		3023,
		9,
		2237
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Heavy.woff": [
		3024,
		9,
		2238
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Medium.ttf": [
		3025,
		9,
		2239
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Medium.woff": [
		3026,
		9,
		2240
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Regular.ttf": [
		3027,
		9,
		2241
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Regular.woff": [
		3028,
		9,
		2242
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Semibold.ttf": [
		3029,
		9,
		2243
	],
	"./pages/PortfolioDetail/Helponymous/fonts/SFUIText-Semibold.woff": [
		3030,
		9,
		2244
	],
	"./pages/PortfolioDetail/Helponymous/fonts/stylesheet.css": [
		3031,
		7,
		850
	],
	"./pages/PortfolioDetail/Helponymous/img/avtar-img.png": [
		3032,
		9,
		3290
	],
	"./pages/PortfolioDetail/Helponymous/img/banner-right.png": [
		3033,
		9,
		3291
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/animate-gif/five.gif": [
		1846,
		9,
		3292
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/animate-gif/four.gif": [
		1845,
		9,
		3293
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/animate-gif/one.gif": [
		1842,
		9,
		3294
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/animate-gif/six.gif": [
		1847,
		9,
		3295
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/animate-gif/three.gif": [
		1844,
		9,
		3296
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/animate-gif/two.gif": [
		1843,
		9,
		3297
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/feature-gif/about-topics.gif": [
		1837,
		9,
		3298
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/feature-gif/find-help.gif": [
		1839,
		9,
		3299
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/feature-gif/quick-post.gif": [
		1838,
		9,
		3300
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/feature-gif/secure-app.gif": [
		1836,
		9,
		3301
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/section-gif/app-dev.gif": [
		1841,
		9,
		3302
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/section-gif/topic-served.gif": [
		1840,
		9,
		3303
	],
	"./pages/PortfolioDetail/Helponymous/img/gif/why-helponymous.gif": [
		1835,
		9,
		3304
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/alamofire.svg": [
		1854,
		9,
		2245
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/app-store.svg": [
		1860,
		9,
		2246
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/core-data.svg": [
		1851,
		9,
		2247
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/eye.svg": [
		1856,
		9,
		2248
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/fire-store.svg": [
		1864,
		9,
		2249
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/firebase-backend.svg": [
		1863,
		9,
		2250
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/firebase.svg": [
		1850,
		9,
		2251
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/getstream.svg": [
		1852,
		9,
		2252
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/heart.svg": [
		1862,
		9,
		2253
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/left.svg": [
		3034,
		9,
		2254
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/logo.svg": [
		1861,
		9,
		2255
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/lottie.svg": [
		1855,
		9,
		2256
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/nodejs.svg": [
		1859,
		9,
		2257
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/right.svg": [
		3035,
		9,
		2258
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/sdwebImage.svg": [
		1853,
		9,
		2259
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/star.svg": [
		3036,
		9,
		2260
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/swift.svg": [
		1849,
		9,
		2261
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/synco.svg": [
		1857,
		9,
		2262
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/webstrom.svg": [
		1858,
		9,
		2263
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/why-bg.svg": [
		3037,
		9,
		2264
	],
	"./pages/PortfolioDetail/Helponymous/img/svg/xcode.svg": [
		1848,
		9,
		2265
	],
	"./pages/PortfolioDetail/Ignite/About/About": [
		617,
		9,
		740
	],
	"./pages/PortfolioDetail/Ignite/About/About.js": [
		617,
		9,
		740
	],
	"./pages/PortfolioDetail/Ignite/About/About.scss": [
		1564,
		7,
		1255
	],
	"./pages/PortfolioDetail/Ignite/Banner/Banner": [
		618,
		9,
		741
	],
	"./pages/PortfolioDetail/Ignite/Banner/Banner.js": [
		618,
		9,
		741
	],
	"./pages/PortfolioDetail/Ignite/Banner/Banner.scss": [
		1565,
		7,
		1256
	],
	"./pages/PortfolioDetail/Ignite/BigImgOne/BigImgOne": [
		619,
		9,
		742
	],
	"./pages/PortfolioDetail/Ignite/BigImgOne/BigImgOne.js": [
		619,
		9,
		742
	],
	"./pages/PortfolioDetail/Ignite/BigImgOne/BigImgOne.scss": [
		1566,
		7,
		1257
	],
	"./pages/PortfolioDetail/Ignite/BigImgTwo/BigImgTwo": [
		620,
		9,
		743
	],
	"./pages/PortfolioDetail/Ignite/BigImgTwo/BigImgTwo.js": [
		620,
		9,
		743
	],
	"./pages/PortfolioDetail/Ignite/BigImgTwo/BigImgTwo.scss": [
		1567,
		7,
		1258
	],
	"./pages/PortfolioDetail/Ignite/Features/Features": [
		621,
		9,
		744
	],
	"./pages/PortfolioDetail/Ignite/Features/Features.js": [
		621,
		9,
		744
	],
	"./pages/PortfolioDetail/Ignite/Features/Features.scss": [
		1568,
		7,
		1259
	],
	"./pages/PortfolioDetail/Ignite/Ignite": [
		783,
		9,
		0,
		1,
		159
	],
	"./pages/PortfolioDetail/Ignite/Ignite.js": [
		783,
		9,
		0,
		1,
		159
	],
	"./pages/PortfolioDetail/Ignite/Ignite.scss": [
		1865,
		7,
		1260
	],
	"./pages/PortfolioDetail/Ignite/Result/Result": [
		623,
		9,
		745
	],
	"./pages/PortfolioDetail/Ignite/Result/Result.js": [
		623,
		9,
		745
	],
	"./pages/PortfolioDetail/Ignite/Result/Result.scss": [
		1570,
		7,
		1261
	],
	"./pages/PortfolioDetail/Ignite/TechnologyStack/TechnologyStack": [
		624,
		9,
		624
	],
	"./pages/PortfolioDetail/Ignite/TechnologyStack/TechnologyStack.js": [
		624,
		9,
		624
	],
	"./pages/PortfolioDetail/Ignite/TechnologyStack/TechnologyStack.scss": [
		1571,
		7,
		1262
	],
	"./pages/PortfolioDetail/Ignite/Testimonial/Testimonial": [
		622,
		9,
		746
	],
	"./pages/PortfolioDetail/Ignite/Testimonial/Testimonial.js": [
		622,
		9,
		746
	],
	"./pages/PortfolioDetail/Ignite/Testimonial/Testimonial.scss": [
		1569,
		7,
		1263
	],
	"./pages/PortfolioDetail/Ignite/fonts/Barlow-Italic.woff": [
		3038,
		9,
		2266
	],
	"./pages/PortfolioDetail/Ignite/fonts/Barlow-Italic.woff2": [
		3039,
		9,
		2267
	],
	"./pages/PortfolioDetail/Ignite/fonts/Barlow-Regular.woff": [
		3040,
		9,
		2268
	],
	"./pages/PortfolioDetail/Ignite/fonts/Barlow-Regular.woff2": [
		3041,
		9,
		2269
	],
	"./pages/PortfolioDetail/Ignite/fonts/Sen-Bold.woff": [
		3042,
		9,
		2270
	],
	"./pages/PortfolioDetail/Ignite/fonts/Sen-Bold.woff2": [
		3043,
		9,
		2271
	],
	"./pages/PortfolioDetail/Ignite/fonts/Sen-Regular.woff": [
		3044,
		9,
		2272
	],
	"./pages/PortfolioDetail/Ignite/fonts/Sen-Regular.woff2": [
		3045,
		9,
		2273
	],
	"./pages/PortfolioDetail/Ignite/fonts/stylesheet.css": [
		3046,
		7,
		851
	],
	"./pages/PortfolioDetail/Ignite/img/fitness-couple.png": [
		3047,
		9,
		3305
	],
	"./pages/PortfolioDetail/Ignite/img/fitness-man.png": [
		3048,
		9,
		3306
	],
	"./pages/PortfolioDetail/Ignite/img/fitness-woman-screen.png": [
		3049,
		9,
		3307
	],
	"./pages/PortfolioDetail/Ignite/img/fitness-woman.png": [
		3050,
		9,
		3308
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-activity.png": [
		3051,
		9,
		3309
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-banner.png": [
		3052,
		9,
		3310
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-brand-text.png": [
		3053,
		9,
		3311
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-broucher.png": [
		3054,
		9,
		3312
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-colors.png": [
		3055,
		9,
		3313
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-dashboard.png": [
		3056,
		9,
		3314
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-name-logo.png": [
		3057,
		9,
		3315
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-poster.png": [
		3058,
		9,
		3316
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-running-activity.png": [
		3059,
		9,
		3317
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-screen.png": [
		3060,
		9,
		3318
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-stationery.png": [
		3061,
		9,
		3319
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-typeface.png": [
		3062,
		9,
		3320
	],
	"./pages/PortfolioDetail/Ignite/img/ignite-web-banner.png": [
		3063,
		9,
		3321
	],
	"./pages/PortfolioDetail/Ignite/img/jim.png": [
		3064,
		9,
		3322
	],
	"./pages/PortfolioDetail/Ignite/img/quote.svg": [
		3065,
		9,
		2274
	],
	"./pages/PortfolioDetail/Lunar/Lunar": [
		784,
		9,
		0,
		4,
		1,
		747
	],
	"./pages/PortfolioDetail/Lunar/Lunar.js": [
		784,
		9,
		0,
		4,
		1,
		747
	],
	"./pages/PortfolioDetail/Lunar/Lunar.scss": [
		1866,
		7,
		1264
	],
	"./pages/PortfolioDetail/Lunar/fonts/open-sans-regular.ttf": [
		3066,
		9,
		2275
	],
	"./pages/PortfolioDetail/Lunar/fonts/rosario-regular.ttf": [
		3067,
		9,
		2276
	],
	"./pages/PortfolioDetail/Medsure/Medsure": [
		785,
		9,
		0,
		1,
		248
	],
	"./pages/PortfolioDetail/Medsure/Medsure.js": [
		785,
		9,
		0,
		1,
		248
	],
	"./pages/PortfolioDetail/Medsure/Medsure.scss": [
		1867,
		7,
		1265
	],
	"./pages/PortfolioDetail/Medsure/fonts/DMSans-Bold.ttf": [
		3068,
		9,
		2277
	],
	"./pages/PortfolioDetail/Medsure/fonts/DMSans-Bold.woff2": [
		3069,
		9,
		2278
	],
	"./pages/PortfolioDetail/Medsure/fonts/DMSans-Regular.ttf": [
		3070,
		9,
		2279
	],
	"./pages/PortfolioDetail/Medsure/fonts/DMSans-Regular.woff2": [
		3071,
		9,
		2280
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Bold.ttf": [
		3072,
		9,
		2281
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Bold.woff2": [
		3073,
		9,
		2282
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Light.ttf": [
		3074,
		9,
		2283
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Light.woff2": [
		3075,
		9,
		2284
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Medium.ttf": [
		3076,
		9,
		2285
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Medium.woff2": [
		3077,
		9,
		2286
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Regular.ttf": [
		3078,
		9,
		2287
	],
	"./pages/PortfolioDetail/Medsure/fonts/NeueMontreal-Regular.woff2": [
		3079,
		9,
		2288
	],
	"./pages/PortfolioDetail/Medsure/images/bg-noice.svg": [
		3080,
		9,
		2289
	],
	"./pages/PortfolioDetail/Medsure/images/medsure.png": [
		1876,
		9,
		3323
	],
	"./pages/PortfolioDetail/Medsure/images/webp/clientimage.webp": [
		1869,
		9,
		2290
	],
	"./pages/PortfolioDetail/Medsure/images/webp/gallay-image-01.webp": [
		1870,
		9,
		2291
	],
	"./pages/PortfolioDetail/Medsure/images/webp/gallay-image-02.webp": [
		1871,
		9,
		2292
	],
	"./pages/PortfolioDetail/Medsure/images/webp/gallay-image-03.webp": [
		1872,
		9,
		2293
	],
	"./pages/PortfolioDetail/Medsure/images/webp/gallay-image-04.webp": [
		1873,
		9,
		2294
	],
	"./pages/PortfolioDetail/Medsure/images/webp/gallay-image-05.webp": [
		1874,
		9,
		2295
	],
	"./pages/PortfolioDetail/Medsure/images/webp/gallay-image-06.webp": [
		1875,
		9,
		2296
	],
	"./pages/PortfolioDetail/Medsure/images/webp/wide-image.webp": [
		1868,
		9,
		2297
	],
	"./pages/PortfolioDetail/MoneyMaker/MoneyMaker": [
		786,
		9,
		0,
		4,
		1,
		171
	],
	"./pages/PortfolioDetail/MoneyMaker/MoneyMaker.js": [
		786,
		9,
		0,
		4,
		1,
		171
	],
	"./pages/PortfolioDetail/MoneyMaker/MoneyMaker.scss": [
		1877,
		7,
		1266
	],
	"./pages/PortfolioDetail/MoneyMaker/fonts/ArchivoBlack-Regular.ttf": [
		3081,
		9,
		2298
	],
	"./pages/PortfolioDetail/MoneyMaker/fonts/ArchivoBlack-Regular.woff": [
		3082,
		9,
		2299
	],
	"./pages/PortfolioDetail/MoneyMaker/fonts/TTNormsPro-Regular.ttf": [
		3083,
		9,
		2300
	],
	"./pages/PortfolioDetail/MoneyMaker/fonts/TTNormsPro-Regular.woff": [
		3084,
		9,
		2301
	],
	"./pages/PortfolioDetail/MoneyMaker/images/moneymaker-s.png": [
		1897,
		9,
		3324
	],
	"./pages/PortfolioDetail/MoneyMaker/images/nft-text.svg": [
		3085,
		9,
		2302
	],
	"./pages/PortfolioDetail/MoneyMaker/images/thinking-bg.svg": [
		3086,
		9,
		2303
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/all-screens.webp": [
		1896,
		9,
		2304
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/brand-identity.webp": [
		1882,
		9,
		2305
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/cards.webp": [
		1884,
		9,
		2306
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/concept.webp": [
		1881,
		9,
		2307
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/empathize.webp": [
		1887,
		9,
		2308
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/fonts-colors.webp": [
		1891,
		9,
		2309
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/hero-image.webp": [
		1878,
		9,
		2310
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/ideate.webp": [
		1888,
		9,
		2311
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/landing-collections.webp": [
		1894,
		9,
		2312
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/landing-list.webp": [
		1893,
		9,
		2313
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/landing-listold.webp": [
		3087,
		9,
		2314
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/landing-page.webp": [
		1892,
		9,
		2315
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/logo-with-bg.webp": [
		1883,
		9,
		2316
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/logo-with-nft.webp": [
		1885,
		9,
		2317
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/nft-cards.webp": [
		1895,
		9,
		2318
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/overview.webp": [
		1880,
		9,
		2319
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/test.webp": [
		1889,
		9,
		2320
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/thinking-process.webp": [
		1886,
		9,
		2321
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/unlimited-nfts-art.webp": [
		1879,
		9,
		2322
	],
	"./pages/PortfolioDetail/MoneyMaker/images/webp/user-flow.webp": [
		1890,
		9,
		2323
	],
	"./pages/PortfolioDetail/MyBus/About/About": [
		625,
		9,
		748
	],
	"./pages/PortfolioDetail/MyBus/About/About.js": [
		625,
		9,
		748
	],
	"./pages/PortfolioDetail/MyBus/About/About.scss": [
		1574,
		7,
		1267
	],
	"./pages/PortfolioDetail/MyBus/Banner/Banner": [
		626,
		9,
		749
	],
	"./pages/PortfolioDetail/MyBus/Banner/Banner.js": [
		626,
		9,
		749
	],
	"./pages/PortfolioDetail/MyBus/Banner/Banner.scss": [
		1575,
		7,
		1268
	],
	"./pages/PortfolioDetail/MyBus/BigImgFour/BigImgFour": [
		627,
		9,
		750
	],
	"./pages/PortfolioDetail/MyBus/BigImgFour/BigImgFour.js": [
		627,
		9,
		750
	],
	"./pages/PortfolioDetail/MyBus/BigImgFour/BigImgFour.scss": [
		1576,
		7,
		1269
	],
	"./pages/PortfolioDetail/MyBus/BigImgOne/BigImgOne": [
		628,
		9,
		751
	],
	"./pages/PortfolioDetail/MyBus/BigImgOne/BigImgOne.js": [
		628,
		9,
		751
	],
	"./pages/PortfolioDetail/MyBus/BigImgOne/BigImgOne.scss": [
		1577,
		7,
		1270
	],
	"./pages/PortfolioDetail/MyBus/BigImgThree/BigImgThree": [
		629,
		9,
		752
	],
	"./pages/PortfolioDetail/MyBus/BigImgThree/BigImgThree.js": [
		629,
		9,
		752
	],
	"./pages/PortfolioDetail/MyBus/BigImgThree/BigImgThree.scss": [
		1578,
		7,
		1271
	],
	"./pages/PortfolioDetail/MyBus/BigImgTwo/BigImgTwo": [
		630,
		9,
		753
	],
	"./pages/PortfolioDetail/MyBus/BigImgTwo/BigImgTwo.js": [
		630,
		9,
		753
	],
	"./pages/PortfolioDetail/MyBus/BigImgTwo/BigImgTwo.scss": [
		1579,
		7,
		1272
	],
	"./pages/PortfolioDetail/MyBus/Features/Features": [
		631,
		9,
		754
	],
	"./pages/PortfolioDetail/MyBus/Features/Features.js": [
		631,
		9,
		754
	],
	"./pages/PortfolioDetail/MyBus/Features/Features.scss": [
		1580,
		7,
		1273
	],
	"./pages/PortfolioDetail/MyBus/FeaturesThree/FeaturesThree": [
		632,
		9,
		755
	],
	"./pages/PortfolioDetail/MyBus/FeaturesThree/FeaturesThree.js": [
		632,
		9,
		755
	],
	"./pages/PortfolioDetail/MyBus/FeaturesThree/FeaturesThree.scss": [
		1581,
		7,
		1274
	],
	"./pages/PortfolioDetail/MyBus/FeaturesTwo/FeaturesTwo": [
		633,
		9,
		756
	],
	"./pages/PortfolioDetail/MyBus/FeaturesTwo/FeaturesTwo.js": [
		633,
		9,
		756
	],
	"./pages/PortfolioDetail/MyBus/FeaturesTwo/FeaturesTwo.scss": [
		1582,
		7,
		1275
	],
	"./pages/PortfolioDetail/MyBus/MyBus": [
		787,
		9,
		0,
		1,
		149
	],
	"./pages/PortfolioDetail/MyBus/MyBus.js": [
		787,
		9,
		0,
		1,
		149
	],
	"./pages/PortfolioDetail/MyBus/MyBus.scss": [
		1898,
		7,
		1276
	],
	"./pages/PortfolioDetail/MyBus/Result/Result": [
		636,
		9,
		757
	],
	"./pages/PortfolioDetail/MyBus/Result/Result.js": [
		636,
		9,
		757
	],
	"./pages/PortfolioDetail/MyBus/Result/Result.scss": [
		1589,
		7,
		1277
	],
	"./pages/PortfolioDetail/MyBus/TechnologyStack/TechnologyStack": [
		634,
		9,
		442
	],
	"./pages/PortfolioDetail/MyBus/TechnologyStack/TechnologyStack.js": [
		634,
		9,
		442
	],
	"./pages/PortfolioDetail/MyBus/TechnologyStack/TechnologyStack.scss": [
		1583,
		7,
		1278
	],
	"./pages/PortfolioDetail/MyBus/Testimonial/Testimonial": [
		635,
		9,
		630
	],
	"./pages/PortfolioDetail/MyBus/Testimonial/Testimonial.js": [
		635,
		9,
		630
	],
	"./pages/PortfolioDetail/MyBus/Testimonial/Testimonial.scss": [
		1586,
		7,
		1279
	],
	"./pages/PortfolioDetail/MyBus/fonts/Barlow-Italic.woff": [
		3088,
		9,
		2324
	],
	"./pages/PortfolioDetail/MyBus/fonts/Barlow-Italic.woff2": [
		3089,
		9,
		2325
	],
	"./pages/PortfolioDetail/MyBus/fonts/Barlow-Regular.woff": [
		3090,
		9,
		2326
	],
	"./pages/PortfolioDetail/MyBus/fonts/Barlow-Regular.woff2": [
		3091,
		9,
		2327
	],
	"./pages/PortfolioDetail/MyBus/fonts/Sen-Bold.woff": [
		3092,
		9,
		2328
	],
	"./pages/PortfolioDetail/MyBus/fonts/Sen-Bold.woff2": [
		3093,
		9,
		2329
	],
	"./pages/PortfolioDetail/MyBus/fonts/Sen-Regular.woff": [
		3094,
		9,
		2330
	],
	"./pages/PortfolioDetail/MyBus/fonts/Sen-Regular.woff2": [
		3095,
		9,
		2331
	],
	"./pages/PortfolioDetail/MyBus/fonts/stylesheet.css": [
		3096,
		7,
		852
	],
	"./pages/PortfolioDetail/MyBus/img/bus-banner.png": [
		3097,
		9,
		3325
	],
	"./pages/PortfolioDetail/MyBus/img/left-quote.svg": [
		1587,
		9,
		2332
	],
	"./pages/PortfolioDetail/MyBus/img/right-quote.svg": [
		1588,
		9,
		2333
	],
	"./pages/PortfolioDetail/OnDemandTelehealthApp/OnDemandTelehealthApp": [
		788,
		9,
		0,
		4,
		1,
		758
	],
	"./pages/PortfolioDetail/OnDemandTelehealthApp/OnDemandTelehealthApp.js": [
		788,
		9,
		0,
		4,
		1,
		758
	],
	"./pages/PortfolioDetail/OnDemandTelehealthApp/OnDemandTelehealthApp.scss": [
		1899,
		7,
		1280
	],
	"./pages/PortfolioDetail/OnDemandTelehealthApp/fonts/BeVietnam/BeVietnam-Regular.ttf": [
		3098,
		9,
		2334
	],
	"./pages/PortfolioDetail/OnDemandTelehealthApp/fonts/DmFonts/DMSerifText-Regular.ttf": [
		3099,
		9,
		2335
	],
	"./pages/PortfolioDetail/Pangea/Pangea": [
		789,
		9,
		0,
		4,
		1,
		759
	],
	"./pages/PortfolioDetail/Pangea/Pangea.js": [
		789,
		9,
		0,
		4,
		1,
		759
	],
	"./pages/PortfolioDetail/Pangea/Pangea.scss": [
		1900,
		7,
		1281
	],
	"./pages/PortfolioDetail/ParentalControlApp/ParentalControlApp": [
		790,
		9,
		0,
		1,
		249
	],
	"./pages/PortfolioDetail/ParentalControlApp/ParentalControlApp.js": [
		790,
		9,
		0,
		1,
		249
	],
	"./pages/PortfolioDetail/ParentalControlApp/ParentalControlApp.scss": [
		1901,
		7,
		1282
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/DMSans-Bold.ttf": [
		3100,
		9,
		2336
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/DMSans-Bold.woff2": [
		3101,
		9,
		2337
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/DMSans-Regular.ttf": [
		3102,
		9,
		2338
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/DMSans-Regular.woff2": [
		3103,
		9,
		2339
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Bold.ttf": [
		3104,
		9,
		2340
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Bold.woff2": [
		3105,
		9,
		2341
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Light.ttf": [
		3106,
		9,
		2342
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Light.woff2": [
		3107,
		9,
		2343
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Medium.ttf": [
		3108,
		9,
		2344
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Medium.woff2": [
		3109,
		9,
		2345
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Regular.ttf": [
		3110,
		9,
		2346
	],
	"./pages/PortfolioDetail/ParentalControlApp/fonts/NeueMontreal-Regular.woff2": [
		3111,
		9,
		2347
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/bg-noice.svg": [
		3112,
		9,
		2348
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/parental-control-app.png": [
		1910,
		9,
		3326
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/clientimage.webp": [
		1903,
		9,
		2349
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/gallay-image-01.webp": [
		1904,
		9,
		2350
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/gallay-image-02.webp": [
		1905,
		9,
		2351
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/gallay-image-03.webp": [
		1906,
		9,
		2352
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/gallay-image-04.webp": [
		1907,
		9,
		2353
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/gallay-image-05.webp": [
		1908,
		9,
		2354
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/gallay-image-06.webp": [
		1909,
		9,
		2355
	],
	"./pages/PortfolioDetail/ParentalControlApp/images/webp/wide-image.webp": [
		1902,
		9,
		2356
	],
	"./pages/PortfolioDetail/Pigi/Pigi": [
		791,
		9,
		0,
		4,
		1,
		146,
		803
	],
	"./pages/PortfolioDetail/Pigi/Pigi.js": [
		791,
		9,
		0,
		4,
		1,
		146,
		803
	],
	"./pages/PortfolioDetail/Pigi/Pigi.scss": [
		2139,
		7,
		146
	],
	"./pages/PortfolioDetail/Pigi/fonts/FrankRuhlLibre-Bold.ttf": [
		3113,
		9,
		2357
	],
	"./pages/PortfolioDetail/Pigi/fonts/FrankRuhlLibre-Regular.ttf": [
		3114,
		9,
		2358
	],
	"./pages/PortfolioDetail/Pigi/fonts/NotoSans-BoldItalic.ttf": [
		3115,
		9,
		2359
	],
	"./pages/PortfolioDetail/Pigi/fonts/Sen-Bold.otf": [
		3116,
		9,
		2360
	],
	"./pages/PortfolioDetail/Pigi/fonts/Sen-ExtraBold.otf": [
		3117,
		9,
		2361
	],
	"./pages/PortfolioDetail/Pigi/fonts/Sen-Regular.otf": [
		3118,
		9,
		2362
	],
	"./pages/PortfolioDetail/PlantShop/PlantShop": [
		792,
		9,
		0,
		1,
		250
	],
	"./pages/PortfolioDetail/PlantShop/PlantShop.js": [
		792,
		9,
		0,
		1,
		250
	],
	"./pages/PortfolioDetail/PlantShop/PlantShop.scss": [
		1911,
		7,
		1283
	],
	"./pages/PortfolioDetail/PlantShop/fonts/DMSans-Bold.ttf": [
		3119,
		9,
		2363
	],
	"./pages/PortfolioDetail/PlantShop/fonts/DMSans-Bold.woff2": [
		3120,
		9,
		2364
	],
	"./pages/PortfolioDetail/PlantShop/fonts/DMSans-Regular.ttf": [
		3121,
		9,
		2365
	],
	"./pages/PortfolioDetail/PlantShop/fonts/DMSans-Regular.woff2": [
		3122,
		9,
		2366
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Bold.ttf": [
		3123,
		9,
		2367
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Bold.woff2": [
		3124,
		9,
		2368
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Light.ttf": [
		3125,
		9,
		2369
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Light.woff2": [
		3126,
		9,
		2370
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Medium.ttf": [
		3127,
		9,
		2371
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Medium.woff2": [
		3128,
		9,
		2372
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Regular.ttf": [
		3129,
		9,
		2373
	],
	"./pages/PortfolioDetail/PlantShop/fonts/NeueMontreal-Regular.woff2": [
		3130,
		9,
		2374
	],
	"./pages/PortfolioDetail/PlantShop/images/bg-noice.svg": [
		3131,
		9,
		2375
	],
	"./pages/PortfolioDetail/PlantShop/images/nft-text.svg": [
		3132,
		9,
		2376
	],
	"./pages/PortfolioDetail/PlantShop/images/plant-shop.png": [
		1920,
		9,
		3327
	],
	"./pages/PortfolioDetail/PlantShop/images/thinking-bg.svg": [
		3133,
		9,
		2377
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/clientimage.webp": [
		1913,
		9,
		2378
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/greenify.webp": [
		1912,
		9,
		2379
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study-2.webp": [
		3134,
		9,
		2380
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study-3.webp": [
		1915,
		9,
		2381
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study-4.webp": [
		1916,
		9,
		2382
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study-5.webp": [
		1917,
		9,
		2383
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study-6.webp": [
		1918,
		9,
		2384
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study-7.webp": [
		1919,
		9,
		2385
	],
	"./pages/PortfolioDetail/PlantShop/images/webp/smart-home-case-study.webp": [
		1914,
		9,
		2386
	],
	"./pages/PortfolioDetail/PureBeauty/PureBeauty": [
		793,
		9,
		0,
		4,
		1,
		160
	],
	"./pages/PortfolioDetail/PureBeauty/PureBeauty.js": [
		793,
		9,
		0,
		4,
		1,
		160
	],
	"./pages/PortfolioDetail/PureBeauty/PureBeauty.scss": [
		1921,
		7,
		1284
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/ArchivoBlack-Regular.ttf": [
		3135,
		9,
		2387
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/ArchivoBlack-Regular.woff": [
		3136,
		9,
		2388
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/Gotham-Bold.ttf": [
		3137,
		9,
		2389
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/Gotham-Bold.woff": [
		3138,
		9,
		2390
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/Gotham-Light.ttf": [
		3139,
		9,
		2391
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/Gotham-Light.woff": [
		3140,
		9,
		2392
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/Gotham-Medium.ttf": [
		3141,
		9,
		2393
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/Gotham-Medium.woff": [
		3142,
		9,
		2394
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNorms-ExtraLightItalic.ttf": [
		3143,
		9,
		2395
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNorms-ExtraLightItalic.woff": [
		3144,
		9,
		2396
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNorms-Thin.ttf": [
		3145,
		9,
		2397
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNorms-Thin.woff": [
		3146,
		9,
		2398
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Bold.ttf": [
		3147,
		9,
		2399
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Bold.woff": [
		3148,
		9,
		2400
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-ExtraBold.woff": [
		3149,
		9,
		2401
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Light.ttf": [
		3150,
		9,
		2402
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Light.woff": [
		3151,
		9,
		2403
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Medium.ttf": [
		3152,
		9,
		2404
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Medium.woff": [
		3153,
		9,
		2405
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Regular.ttf": [
		3154,
		9,
		2406
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-Regular.woff": [
		3155,
		9,
		2407
	],
	"./pages/PortfolioDetail/PureBeauty/fonts/TTNormsPro-ThinItalic.woff": [
		3156,
		9,
		2408
	],
	"./pages/PortfolioDetail/PureBeauty/images/banner.svg": [
		3157,
		9,
		2409
	],
	"./pages/PortfolioDetail/PureBeauty/images/bg-effect.svg": [
		3158,
		9,
		2410
	],
	"./pages/PortfolioDetail/PureBeauty/images/pure-s.png": [
		1950,
		9,
		3328
	],
	"./pages/PortfolioDetail/PureBeauty/images/pure-star.svg": [
		3159,
		9,
		2411
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/accessoriesbanner.webp": [
		1944,
		9,
		2412
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/animatedboy.webp": [
		1927,
		9,
		2413
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/animatedgirl.webp": [
		1928,
		9,
		2414
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/bubble.webp": [
		1935,
		9,
		2415
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/challenge-bg.png": [
		3160,
		9,
		3329
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/clientimage.webp": [
		1948,
		9,
		2416
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/herobanner.webp": [
		1924,
		9,
		2417
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/heroheader.webp": [
		1922,
		9,
		2418
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/homefullview.webp": [
		1932,
		9,
		2419
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/instahero.webp": [
		1942,
		9,
		2420
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/instahome.webp": [
		1941,
		9,
		2421
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/instahomestory.webp": [
		1940,
		9,
		2422
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/instaproduct.webp": [
		1943,
		9,
		2423
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/instaproductstory.webp": [
		1933,
		9,
		2424
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/ipadcart.webp": [
		1931,
		9,
		2425
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/ipadchallenges.webp": [
		1929,
		9,
		2426
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/ipadwithpaperbag.webp": [
		3161,
		9,
		2427
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/lusetabiotin.webp": [
		1936,
		9,
		2428
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/lusetahempoil.webp": [
		1934,
		9,
		2429
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/mycartmobile.webp": [
		1949,
		9,
		2430
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/originalproducts.webp": [
		1926,
		9,
		2431
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/porductmockupfull.webp": [
		1937,
		9,
		2432
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/process.webp": [
		1925,
		9,
		2433
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/productdetails.webp": [
		1939,
		9,
		2434
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/productlisting.webp": [
		1946,
		9,
		2435
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/productlistingpage.webp": [
		3162,
		9,
		2436
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/productmockup.webp": [
		1947,
		9,
		2437
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/purelogomockup.webp": [
		3163,
		9,
		2438
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/pureribbon.webp": [
		3164,
		9,
		2439
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/userflow.webp": [
		1930,
		9,
		2440
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/userimage.webp": [
		1945,
		9,
		2441
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/userwithproduct.webp": [
		3165,
		9,
		2442
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/womenimage.webp": [
		1938,
		9,
		2443
	],
	"./pages/PortfolioDetail/PureBeauty/images/webp/womenwithproduct.webp": [
		1923,
		9,
		2444
	],
	"./pages/PortfolioDetail/RideSharingApp/About/About": [
		637,
		9,
		760
	],
	"./pages/PortfolioDetail/RideSharingApp/About/About.js": [
		637,
		9,
		760
	],
	"./pages/PortfolioDetail/RideSharingApp/About/About.scss": [
		1590,
		7,
		1285
	],
	"./pages/PortfolioDetail/RideSharingApp/Banner/Banner": [
		638,
		9,
		761
	],
	"./pages/PortfolioDetail/RideSharingApp/Banner/Banner.js": [
		638,
		9,
		761
	],
	"./pages/PortfolioDetail/RideSharingApp/Banner/Banner.scss": [
		1591,
		7,
		1286
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgFour/BigImgFour": [
		639,
		9,
		762
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgFour/BigImgFour.js": [
		639,
		9,
		762
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgFour/BigImgFour.scss": [
		1592,
		7,
		1287
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/BigImgOne": [
		640,
		9,
		763
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/BigImgOne.js": [
		640,
		9,
		763
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/BigImgOne.scss": [
		1593,
		7,
		1288
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/dummy.mp4": [
		3166,
		9,
		2445
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/pause-icon.svg": [
		3167,
		9,
		2446
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/video-icon.svg": [
		3168,
		9,
		2447
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgOne/video.png": [
		3169,
		9,
		3330
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgThree/BigImgThree": [
		641,
		9,
		764
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgThree/BigImgThree.js": [
		641,
		9,
		764
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgThree/BigImgThree.scss": [
		1594,
		7,
		1289
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgTwo/BigImgTwo": [
		642,
		9,
		765
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgTwo/BigImgTwo.js": [
		642,
		9,
		765
	],
	"./pages/PortfolioDetail/RideSharingApp/BigImgTwo/BigImgTwo.scss": [
		1595,
		7,
		1290
	],
	"./pages/PortfolioDetail/RideSharingApp/Features/Features": [
		643,
		9,
		766
	],
	"./pages/PortfolioDetail/RideSharingApp/Features/Features.js": [
		643,
		9,
		766
	],
	"./pages/PortfolioDetail/RideSharingApp/Features/Features.scss": [
		1596,
		7,
		1291
	],
	"./pages/PortfolioDetail/RideSharingApp/FeaturesThree/FeaturesThree": [
		644,
		9,
		767
	],
	"./pages/PortfolioDetail/RideSharingApp/FeaturesThree/FeaturesThree.js": [
		644,
		9,
		767
	],
	"./pages/PortfolioDetail/RideSharingApp/FeaturesThree/FeaturesThree.scss": [
		1597,
		7,
		1292
	],
	"./pages/PortfolioDetail/RideSharingApp/FeaturesTwo/FeaturesTwo": [
		645,
		9,
		768
	],
	"./pages/PortfolioDetail/RideSharingApp/FeaturesTwo/FeaturesTwo.js": [
		645,
		9,
		768
	],
	"./pages/PortfolioDetail/RideSharingApp/FeaturesTwo/FeaturesTwo.scss": [
		1598,
		7,
		1293
	],
	"./pages/PortfolioDetail/RideSharingApp/Result/Result": [
		646,
		9,
		769
	],
	"./pages/PortfolioDetail/RideSharingApp/Result/Result.js": [
		646,
		9,
		769
	],
	"./pages/PortfolioDetail/RideSharingApp/Result/Result.scss": [
		1599,
		7,
		1294
	],
	"./pages/PortfolioDetail/RideSharingApp/RideSharingApp": [
		794,
		9,
		0,
		1,
		150
	],
	"./pages/PortfolioDetail/RideSharingApp/RideSharingApp.js": [
		794,
		9,
		0,
		1,
		150
	],
	"./pages/PortfolioDetail/RideSharingApp/RideSharingApp.scss": [
		1951,
		7,
		1295
	],
	"./pages/PortfolioDetail/RideSharingApp/TechnologyStack/TechnologyStack": [
		647,
		9,
		443
	],
	"./pages/PortfolioDetail/RideSharingApp/TechnologyStack/TechnologyStack.js": [
		647,
		9,
		443
	],
	"./pages/PortfolioDetail/RideSharingApp/TechnologyStack/TechnologyStack.scss": [
		1600,
		7,
		1296
	],
	"./pages/PortfolioDetail/RideSharingApp/Testimonial/Testimonial": [
		648,
		9,
		770
	],
	"./pages/PortfolioDetail/RideSharingApp/Testimonial/Testimonial.js": [
		648,
		9,
		770
	],
	"./pages/PortfolioDetail/RideSharingApp/Testimonial/Testimonial.scss": [
		1601,
		7,
		1297
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Barlow-Italic.woff": [
		3170,
		9,
		2448
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Barlow-Italic.woff2": [
		3171,
		9,
		2449
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Barlow-Regular.woff": [
		3172,
		9,
		2450
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Barlow-Regular.woff2": [
		3173,
		9,
		2451
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Sen-Bold.woff": [
		3174,
		9,
		2452
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Sen-Bold.woff2": [
		3175,
		9,
		2453
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Sen-Regular.woff": [
		3176,
		9,
		2454
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/Sen-Regular.woff2": [
		3177,
		9,
		2455
	],
	"./pages/PortfolioDetail/RideSharingApp/fonts/stylesheet.css": [
		3178,
		7,
		853
	],
	"./pages/PortfolioDetail/RideSharingApp/img/bhoj-banner-screen.png": [
		3179,
		9,
		3331
	],
	"./pages/PortfolioDetail/RideSharingApp/img/left-quote.svg": [
		3180,
		9,
		2456
	],
	"./pages/PortfolioDetail/RideSharingApp/img/ridesharing-banner-screen.png": [
		3181,
		9,
		3332
	],
	"./pages/PortfolioDetail/RideSharingApp/img/right-quote.svg": [
		3182,
		9,
		2457
	],
	"./pages/PortfolioDetail/Rosita/Rosita": [
		795,
		9,
		0,
		4,
		1,
		771
	],
	"./pages/PortfolioDetail/Rosita/Rosita.js": [
		795,
		9,
		0,
		4,
		1,
		771
	],
	"./pages/PortfolioDetail/Rosita/Rosita.scss": [
		1952,
		7,
		1298
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-Bold.ttf": [
		3183,
		9,
		2458
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-Bold.woff": [
		3184,
		9,
		2459
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-Bold.woff2": [
		3185,
		9,
		2460
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-ExtraBold.ttf": [
		3186,
		9,
		2461
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-ExtraBold.woff": [
		3187,
		9,
		2462
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-ExtraBold.woff2": [
		3188,
		9,
		2463
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-Regular.ttf": [
		3189,
		9,
		2464
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-Regular.woff": [
		3190,
		9,
		2465
	],
	"./pages/PortfolioDetail/Rosita/fonts/Sen-Regular.woff2": [
		3191,
		9,
		2466
	],
	"./pages/PortfolioDetail/Rosita/images/bg-design1.png": [
		3192,
		9,
		3333
	],
	"./pages/PortfolioDetail/Rosita/images/design-bg.png": [
		3193,
		9,
		3334
	],
	"./pages/PortfolioDetail/SalonApp/SalonApp": [
		796,
		9,
		0,
		1,
		251
	],
	"./pages/PortfolioDetail/SalonApp/SalonApp.js": [
		796,
		9,
		0,
		1,
		251
	],
	"./pages/PortfolioDetail/SalonApp/SalonApp.scss": [
		1953,
		7,
		1299
	],
	"./pages/PortfolioDetail/SalonApp/fonts/DMSans-Bold.ttf": [
		3194,
		9,
		2467
	],
	"./pages/PortfolioDetail/SalonApp/fonts/DMSans-Bold.woff2": [
		3195,
		9,
		2468
	],
	"./pages/PortfolioDetail/SalonApp/fonts/DMSans-Regular.ttf": [
		3196,
		9,
		2469
	],
	"./pages/PortfolioDetail/SalonApp/fonts/DMSans-Regular.woff2": [
		3197,
		9,
		2470
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Bold.ttf": [
		3198,
		9,
		2471
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Bold.woff2": [
		3199,
		9,
		2472
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Light.ttf": [
		3200,
		9,
		2473
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Light.woff2": [
		3201,
		9,
		2474
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Medium.ttf": [
		3202,
		9,
		2475
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Medium.woff2": [
		3203,
		9,
		2476
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Regular.ttf": [
		3204,
		9,
		2477
	],
	"./pages/PortfolioDetail/SalonApp/fonts/NeueMontreal-Regular.woff2": [
		3205,
		9,
		2478
	],
	"./pages/PortfolioDetail/SalonApp/images/bg-noice.svg": [
		3206,
		9,
		2479
	],
	"./pages/PortfolioDetail/SalonApp/images/salon-app.png": [
		1962,
		9,
		3335
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/clientimage.webp": [
		1955,
		9,
		2480
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/gallay-image-01.webp": [
		1956,
		9,
		2481
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/gallay-image-02.webp": [
		1957,
		9,
		2482
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/gallay-image-03.webp": [
		1958,
		9,
		2483
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/gallay-image-04.webp": [
		1959,
		9,
		2484
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/gallay-image-05.webp": [
		1960,
		9,
		2485
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/gallay-image-06.webp": [
		1961,
		9,
		2486
	],
	"./pages/PortfolioDetail/SalonApp/images/webp/wide-image.webp": [
		1954,
		9,
		2487
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/SmartHomeNuemorphism": [
		797,
		9,
		0,
		1,
		252
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/SmartHomeNuemorphism.js": [
		797,
		9,
		0,
		1,
		252
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/SmartHomeNuemorphism.scss": [
		1963,
		7,
		1300
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/DMSans-Bold.ttf": [
		3207,
		9,
		2488
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/DMSans-Bold.woff2": [
		3208,
		9,
		2489
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/DMSans-Regular.ttf": [
		3209,
		9,
		2490
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/DMSans-Regular.woff2": [
		3210,
		9,
		2491
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Bold.ttf": [
		3211,
		9,
		2492
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Bold.woff2": [
		3212,
		9,
		2493
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Light.ttf": [
		3213,
		9,
		2494
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Light.woff2": [
		3214,
		9,
		2495
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Medium.ttf": [
		3215,
		9,
		2496
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Medium.woff2": [
		3216,
		9,
		2497
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Regular.ttf": [
		3217,
		9,
		2498
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/fonts/NeueMontreal-Regular.woff2": [
		3218,
		9,
		2499
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/bg-noice.svg": [
		3219,
		9,
		2500
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/smart-home-nuemorphism.png": [
		1972,
		9,
		3336
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/clientimage.webp": [
		1965,
		9,
		2501
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/gallay-image-01.webp": [
		1966,
		9,
		2502
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/gallay-image-02.webp": [
		1967,
		9,
		2503
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/gallay-image-03.webp": [
		1968,
		9,
		2504
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/gallay-image-04.webp": [
		1969,
		9,
		2505
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/gallay-image-05.webp": [
		1970,
		9,
		2506
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/gallay-image-06.webp": [
		1971,
		9,
		2507
	],
	"./pages/PortfolioDetail/SmartHomeNuemorphism/images/webp/wide-image.webp": [
		1964,
		9,
		2508
	],
	"./pages/PortfolioDetail/Smashers/Smashers": [
		798,
		9,
		0,
		4,
		1,
		772
	],
	"./pages/PortfolioDetail/Smashers/Smashers.js": [
		798,
		9,
		0,
		4,
		1,
		772
	],
	"./pages/PortfolioDetail/Smashers/fonts/FontAwesome.otf": [
		3220,
		9,
		2509
	],
	"./pages/PortfolioDetail/Smashers/fonts/comic/ComicSansMS-Bold.ttf": [
		3221,
		9,
		2510
	],
	"./pages/PortfolioDetail/Smashers/fonts/comic/ComicSansMS-BoldItalic.ttf": [
		3222,
		9,
		2511
	],
	"./pages/PortfolioDetail/Smashers/fonts/comic/ComicSansMS-Italic.ttf": [
		3223,
		9,
		2512
	],
	"./pages/PortfolioDetail/Smashers/fonts/comic/ComicSansMS.ttf": [
		3224,
		9,
		2513
	],
	"./pages/PortfolioDetail/Smashers/fonts/comic/GROBOLD.ttf": [
		3225,
		9,
		2514
	],
	"./pages/PortfolioDetail/Smashers/fonts/comic/stylesheet.css": [
		3226,
		7,
		854
	],
	"./pages/PortfolioDetail/Smashers/fonts/fontawesome-webfont.eot": [
		3227,
		9,
		2515
	],
	"./pages/PortfolioDetail/Smashers/fonts/fontawesome-webfont.svg": [
		3228,
		9,
		2516
	],
	"./pages/PortfolioDetail/Smashers/fonts/fontawesome-webfont.ttf": [
		3229,
		9,
		2517
	],
	"./pages/PortfolioDetail/Smashers/fonts/fontawesome-webfont.woff": [
		3230,
		9,
		2518
	],
	"./pages/PortfolioDetail/Smashers/fonts/fontawesome-webfont.woff2": [
		3231,
		9,
		2519
	],
	"./pages/PortfolioDetail/Smashers/scss/Smashers.scss": [
		1973,
		7,
		1301
	],
	"./pages/PortfolioDetail/StockMarket/StockMarket": [
		799,
		9,
		0,
		1,
		253
	],
	"./pages/PortfolioDetail/StockMarket/StockMarket.js": [
		799,
		9,
		0,
		1,
		253
	],
	"./pages/PortfolioDetail/StockMarket/StockMarket.scss": [
		1974,
		7,
		1302
	],
	"./pages/PortfolioDetail/StockMarket/fonts/DMSans-Bold.ttf": [
		3232,
		9,
		2520
	],
	"./pages/PortfolioDetail/StockMarket/fonts/DMSans-Bold.woff2": [
		3233,
		9,
		2521
	],
	"./pages/PortfolioDetail/StockMarket/fonts/DMSans-Regular.ttf": [
		3234,
		9,
		2522
	],
	"./pages/PortfolioDetail/StockMarket/fonts/DMSans-Regular.woff2": [
		3235,
		9,
		2523
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Bold.ttf": [
		3236,
		9,
		2524
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Bold.woff2": [
		3237,
		9,
		2525
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Light.ttf": [
		3238,
		9,
		2526
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Light.woff2": [
		3239,
		9,
		2527
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Medium.ttf": [
		3240,
		9,
		2528
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Medium.woff2": [
		3241,
		9,
		2529
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Regular.ttf": [
		3242,
		9,
		2530
	],
	"./pages/PortfolioDetail/StockMarket/fonts/NeueMontreal-Regular.woff2": [
		3243,
		9,
		2531
	],
	"./pages/PortfolioDetail/StockMarket/images/bg-noice.svg": [
		3244,
		9,
		2532
	],
	"./pages/PortfolioDetail/StockMarket/images/stock-market.png": [
		1983,
		9,
		3337
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/clientimage.webp": [
		1976,
		9,
		2533
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/gallay-image-01.webp": [
		1977,
		9,
		2534
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/gallay-image-02.webp": [
		1978,
		9,
		2535
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/gallay-image-03.webp": [
		1979,
		9,
		2536
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/gallay-image-04.webp": [
		1980,
		9,
		2537
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/gallay-image-05.webp": [
		1981,
		9,
		2538
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/gallay-image-06.webp": [
		1982,
		9,
		2539
	],
	"./pages/PortfolioDetail/StockMarket/images/webp/wide-image.webp": [
		1975,
		9,
		2540
	],
	"./pages/PortfolioDetail/TaskManagement/TaskManagement": [
		800,
		9,
		0,
		1,
		254
	],
	"./pages/PortfolioDetail/TaskManagement/TaskManagement.js": [
		800,
		9,
		0,
		1,
		254
	],
	"./pages/PortfolioDetail/TaskManagement/TaskManagement.scss": [
		1984,
		7,
		1303
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/DMSans-Bold.ttf": [
		3245,
		9,
		2541
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/DMSans-Bold.woff2": [
		3246,
		9,
		2542
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/DMSans-Regular.ttf": [
		3247,
		9,
		2543
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/DMSans-Regular.woff2": [
		3248,
		9,
		2544
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Bold.ttf": [
		3249,
		9,
		2545
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Bold.woff2": [
		3250,
		9,
		2546
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Light.ttf": [
		3251,
		9,
		2547
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Light.woff2": [
		3252,
		9,
		2548
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Medium.ttf": [
		3253,
		9,
		2549
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Medium.woff2": [
		3254,
		9,
		2550
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Regular.ttf": [
		3255,
		9,
		2551
	],
	"./pages/PortfolioDetail/TaskManagement/fonts/NeueMontreal-Regular.woff2": [
		3256,
		9,
		2552
	],
	"./pages/PortfolioDetail/TaskManagement/images/bg-noice.svg": [
		3257,
		9,
		2553
	],
	"./pages/PortfolioDetail/TaskManagement/images/task-management.png": [
		1993,
		9,
		3338
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/clientimage.webp": [
		1986,
		9,
		2554
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/gallay-image-01.webp": [
		1987,
		9,
		2555
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/gallay-image-02.webp": [
		1988,
		9,
		2556
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/gallay-image-03.webp": [
		1989,
		9,
		2557
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/gallay-image-04.webp": [
		1990,
		9,
		2558
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/gallay-image-05.webp": [
		1991,
		9,
		2559
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/gallay-image-06.webp": [
		1992,
		9,
		2560
	],
	"./pages/PortfolioDetail/TaskManagement/images/webp/wide-image.webp": [
		1985,
		9,
		2561
	],
	"./pages/PortfolioDetail/TechnologyStackImg/Flutter.svg": [
		1572,
		9,
		2562
	],
	"./pages/PortfolioDetail/TechnologyStackImg/android.svg": [
		1584,
		9,
		2563
	],
	"./pages/PortfolioDetail/TechnologyStackImg/angular.svg": [
		982,
		9,
		2564
	],
	"./pages/PortfolioDetail/TechnologyStackImg/cs.cart.svg": [
		1560,
		9,
		2565
	],
	"./pages/PortfolioDetail/TechnologyStackImg/firebase.svg": [
		1602,
		9,
		2566
	],
	"./pages/PortfolioDetail/TechnologyStackImg/ios.svg": [
		1585,
		9,
		2567
	],
	"./pages/PortfolioDetail/TechnologyStackImg/kotlin.svg": [
		966,
		9,
		2568
	],
	"./pages/PortfolioDetail/TechnologyStackImg/laravel.svg": [
		1547,
		9,
		2569
	],
	"./pages/PortfolioDetail/TechnologyStackImg/mongodb.svg": [
		1038,
		9,
		2570
	],
	"./pages/PortfolioDetail/TechnologyStackImg/mysql.svg": [
		972,
		9,
		2571
	],
	"./pages/PortfolioDetail/TechnologyStackImg/nodejs.svg": [
		981,
		9,
		2572
	],
	"./pages/PortfolioDetail/TechnologyStackImg/php.svg": [
		1573,
		9,
		2573
	],
	"./pages/PortfolioDetail/TechnologyStackImg/sqlite.svg": [
		1534,
		9,
		2574
	],
	"./pages/PortfolioDetail/TechnologyStackImg/swift.svg": [
		967,
		9,
		2575
	],
	"./pages/PortfolioDetail/TechnologyStackImg/vue.svg": [
		1548,
		9,
		2576
	],
	"./pages/PortfolioDetail/TicketBookingApp/TicketBookingApp": [
		801,
		9,
		0,
		1,
		255
	],
	"./pages/PortfolioDetail/TicketBookingApp/TicketBookingApp.js": [
		801,
		9,
		0,
		1,
		255
	],
	"./pages/PortfolioDetail/TicketBookingApp/TicketBookingApp.scss": [
		1994,
		7,
		1304
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/DMSans-Bold.ttf": [
		3258,
		9,
		2577
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/DMSans-Bold.woff2": [
		3259,
		9,
		2578
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/DMSans-Regular.ttf": [
		3260,
		9,
		2579
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/DMSans-Regular.woff2": [
		3261,
		9,
		2580
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Bold.ttf": [
		3262,
		9,
		2581
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Bold.woff2": [
		3263,
		9,
		2582
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Light.ttf": [
		3264,
		9,
		2583
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Light.woff2": [
		3265,
		9,
		2584
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Medium.ttf": [
		3266,
		9,
		2585
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Medium.woff2": [
		3267,
		9,
		2586
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Regular.ttf": [
		3268,
		9,
		2587
	],
	"./pages/PortfolioDetail/TicketBookingApp/fonts/NeueMontreal-Regular.woff2": [
		3269,
		9,
		2588
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/bg-noice.svg": [
		3270,
		9,
		2589
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/ticket-booking-app.png": [
		2003,
		9,
		3339
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/clientimage.webp": [
		1996,
		9,
		2590
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/gallay-image-01.webp": [
		1997,
		9,
		2591
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/gallay-image-02.webp": [
		1998,
		9,
		2592
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/gallay-image-03.webp": [
		1999,
		9,
		2593
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/gallay-image-04.webp": [
		2000,
		9,
		2594
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/gallay-image-05.webp": [
		2001,
		9,
		2595
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/gallay-image-06.webp": [
		2002,
		9,
		2596
	],
	"./pages/PortfolioDetail/TicketBookingApp/images/webp/wide-image.webp": [
		1995,
		9,
		2597
	],
	"./pages/PortfolioDetail/TimeManagement/TimeManagement": [
		802,
		9,
		0,
		1,
		256
	],
	"./pages/PortfolioDetail/TimeManagement/TimeManagement.js": [
		802,
		9,
		0,
		1,
		256
	],
	"./pages/PortfolioDetail/TimeManagement/TimeManagement.scss": [
		2004,
		7,
		1305
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/DMSans-Bold.ttf": [
		3271,
		9,
		2598
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/DMSans-Bold.woff2": [
		3272,
		9,
		2599
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/DMSans-Regular.ttf": [
		3273,
		9,
		2600
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/DMSans-Regular.woff2": [
		3274,
		9,
		2601
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Bold.ttf": [
		3275,
		9,
		2602
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Bold.woff2": [
		3276,
		9,
		2603
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Light.ttf": [
		3277,
		9,
		2604
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Light.woff2": [
		3278,
		9,
		2605
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Medium.ttf": [
		3279,
		9,
		2606
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Medium.woff2": [
		3280,
		9,
		2607
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Regular.ttf": [
		3281,
		9,
		2608
	],
	"./pages/PortfolioDetail/TimeManagement/fonts/NeueMontreal-Regular.woff2": [
		3282,
		9,
		2609
	],
	"./pages/PortfolioDetail/TimeManagement/images/bg-noice.svg": [
		3283,
		9,
		2610
	],
	"./pages/PortfolioDetail/TimeManagement/images/time-management.png": [
		2013,
		9,
		3340
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/clientimage.webp": [
		2006,
		9,
		2611
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/gallay-image-01.webp": [
		2007,
		9,
		2612
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/gallay-image-02.webp": [
		2008,
		9,
		2613
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/gallay-image-03.webp": [
		2009,
		9,
		2614
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/gallay-image-04.webp": [
		2010,
		9,
		2615
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/gallay-image-05.webp": [
		2011,
		9,
		2616
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/gallay-image-06.webp": [
		2012,
		9,
		2617
	],
	"./pages/PortfolioDetail/TimeManagement/images/webp/wide-image.webp": [
		2005,
		9,
		2618
	],
	"./pages/PortfolioDetail/TravelAgency/TravelAgency": [
		803,
		9,
		0,
		1,
		257
	],
	"./pages/PortfolioDetail/TravelAgency/TravelAgency.js": [
		803,
		9,
		0,
		1,
		257
	],
	"./pages/PortfolioDetail/TravelAgency/TravelAgency.scss": [
		2014,
		7,
		1306
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/DMSans-Bold.ttf": [
		3284,
		9,
		2619
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/DMSans-Bold.woff2": [
		3285,
		9,
		2620
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/DMSans-Regular.ttf": [
		3286,
		9,
		2621
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/DMSans-Regular.woff2": [
		3287,
		9,
		2622
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Bold.ttf": [
		3288,
		9,
		2623
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Bold.woff2": [
		3289,
		9,
		2624
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Light.ttf": [
		3290,
		9,
		2625
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Light.woff2": [
		3291,
		9,
		2626
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Medium.ttf": [
		3292,
		9,
		2627
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Medium.woff2": [
		3293,
		9,
		2628
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Regular.ttf": [
		3294,
		9,
		2629
	],
	"./pages/PortfolioDetail/TravelAgency/fonts/NeueMontreal-Regular.woff2": [
		3295,
		9,
		2630
	],
	"./pages/PortfolioDetail/TravelAgency/images/bg-noice.svg": [
		3296,
		9,
		2631
	],
	"./pages/PortfolioDetail/TravelAgency/images/travel-agency.png": [
		2023,
		9,
		3341
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/clientimage.webp": [
		2016,
		9,
		2632
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/gallay-image-01.webp": [
		2017,
		9,
		2633
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/gallay-image-02.webp": [
		2018,
		9,
		2634
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/gallay-image-03.webp": [
		2019,
		9,
		2635
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/gallay-image-04.webp": [
		2020,
		9,
		2636
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/gallay-image-05.webp": [
		2021,
		9,
		2637
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/gallay-image-06.webp": [
		2022,
		9,
		2638
	],
	"./pages/PortfolioDetail/TravelAgency/images/webp/wide-image.webp": [
		2015,
		9,
		2639
	],
	"./pages/PortfolioDetail/Zoomer/About/About": [
		649,
		9,
		773
	],
	"./pages/PortfolioDetail/Zoomer/About/About.js": [
		649,
		9,
		773
	],
	"./pages/PortfolioDetail/Zoomer/About/About.scss": [
		1603,
		7,
		1307
	],
	"./pages/PortfolioDetail/Zoomer/Banner/Banner": [
		650,
		9,
		774
	],
	"./pages/PortfolioDetail/Zoomer/Banner/Banner.js": [
		650,
		9,
		774
	],
	"./pages/PortfolioDetail/Zoomer/Banner/Banner.scss": [
		1604,
		7,
		1308
	],
	"./pages/PortfolioDetail/Zoomer/BigImgOne/BigImgOne": [
		651,
		9,
		775
	],
	"./pages/PortfolioDetail/Zoomer/BigImgOne/BigImgOne.js": [
		651,
		9,
		775
	],
	"./pages/PortfolioDetail/Zoomer/BigImgOne/BigImgOne.scss": [
		1605,
		7,
		1309
	],
	"./pages/PortfolioDetail/Zoomer/BigImgTwo/BigImgTwo": [
		652,
		9,
		776
	],
	"./pages/PortfolioDetail/Zoomer/BigImgTwo/BigImgTwo.js": [
		652,
		9,
		776
	],
	"./pages/PortfolioDetail/Zoomer/BigImgTwo/BigImgTwo.scss": [
		1606,
		7,
		1310
	],
	"./pages/PortfolioDetail/Zoomer/Features/Features": [
		653,
		9,
		777
	],
	"./pages/PortfolioDetail/Zoomer/Features/Features.js": [
		653,
		9,
		777
	],
	"./pages/PortfolioDetail/Zoomer/Features/Features.scss": [
		1607,
		7,
		1311
	],
	"./pages/PortfolioDetail/Zoomer/Result/Result": [
		654,
		9,
		778
	],
	"./pages/PortfolioDetail/Zoomer/Result/Result.js": [
		654,
		9,
		778
	],
	"./pages/PortfolioDetail/Zoomer/Result/Result.scss": [
		1608,
		7,
		1312
	],
	"./pages/PortfolioDetail/Zoomer/TechnologyStack/TechnologyStack": [
		655,
		9,
		631
	],
	"./pages/PortfolioDetail/Zoomer/TechnologyStack/TechnologyStack.js": [
		655,
		9,
		631
	],
	"./pages/PortfolioDetail/Zoomer/TechnologyStack/TechnologyStack.scss": [
		1609,
		7,
		1313
	],
	"./pages/PortfolioDetail/Zoomer/Testimonial/Testimonial": [
		656,
		9,
		779
	],
	"./pages/PortfolioDetail/Zoomer/Testimonial/Testimonial.js": [
		656,
		9,
		779
	],
	"./pages/PortfolioDetail/Zoomer/Testimonial/Testimonial.scss": [
		1610,
		7,
		1314
	],
	"./pages/PortfolioDetail/Zoomer/Zoomer": [
		804,
		9,
		0,
		1,
		161
	],
	"./pages/PortfolioDetail/Zoomer/Zoomer.js": [
		804,
		9,
		0,
		1,
		161
	],
	"./pages/PortfolioDetail/Zoomer/Zoomer.scss": [
		2024,
		7,
		832
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Barlow-Italic.woff": [
		3297,
		9,
		2640
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Barlow-Italic.woff2": [
		3298,
		9,
		2641
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Barlow-Regular.woff": [
		3299,
		9,
		2642
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Barlow-Regular.woff2": [
		3300,
		9,
		2643
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Sen-Bold.woff": [
		3301,
		9,
		2644
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Sen-Bold.woff2": [
		3302,
		9,
		2645
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Sen-Regular.woff": [
		3303,
		9,
		2646
	],
	"./pages/PortfolioDetail/Zoomer/fonts/Sen-Regular.woff2": [
		3304,
		9,
		2647
	],
	"./pages/PortfolioDetail/Zoomer/fonts/stylesheet.css": [
		3305,
		7,
		855
	],
	"./pages/PortfolioDetail/Zoomer/img/banner.png": [
		3306,
		9,
		3342
	],
	"./pages/PortfolioDetail/Zoomer/img/left-quote.svg": [
		3307,
		9,
		2648
	],
	"./pages/PortfolioDetail/Zoomer/img/r-banner.png": [
		3308,
		9,
		3343
	],
	"./pages/PortfolioDetail/Zoomer/img/responsive-banner.png": [
		3309,
		9,
		3344
	],
	"./pages/PortfolioDetail/Zoomer/img/right-quote.svg": [
		3310,
		9,
		2649
	],
	"./pages/PortfolioDetail/copomap/Copomap": [
		805,
		9,
		0,
		3,
		4,
		1,
		780
	],
	"./pages/PortfolioDetail/copomap/Copomap.js": [
		805,
		9,
		0,
		3,
		4,
		1,
		780
	],
	"./pages/PortfolioDetail/copomap/Copomap.scss": [
		2025,
		7,
		1315
	],
	"./pages/PortfolioDetail/copomap/fonts/LotaGrotesque-Regular.woff": [
		3311,
		9,
		2650
	],
	"./pages/PortfolioDetail/copomap/fonts/LotaGrotesque-Regular.woff2": [
		3312,
		9,
		2651
	],
	"./pages/PortfolioDetail/copomap/fonts/Sentinel-Medium.woff": [
		3313,
		9,
		2652
	],
	"./pages/PortfolioDetail/copomap/fonts/Sentinel-Medium.woff2": [
		3314,
		9,
		2653
	],
	"./pages/PortfolioDetail/copomap/fonts/stylesheet.css": [
		3315,
		7,
		856
	],
	"./pages/PortfolioDetail/copomap/images/quotes.svg": [
		3316,
		9,
		2654
	],
	"./pages/PortfolioDetail/hooks/useWindowSize": [
		806,
		9,
		804
	],
	"./pages/PortfolioDetail/hooks/useWindowSize.js": [
		806,
		9,
		804
	],
	"./pages/PortfolioDetail/portfoliodetail.scss": [
		3317,
		7,
		1316
	],
	"./pages/PortfolioDetail/src/portfolio-common.scss": [
		974,
		7,
		1317
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Bold.ttf": [
		3318,
		9,
		2655
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Bold.woff": [
		3319,
		9,
		2656
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-ExtraBold.ttf": [
		3320,
		9,
		2657
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-ExtraBold.woff": [
		3321,
		9,
		2658
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Light.ttf": [
		3322,
		9,
		2659
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Light.woff": [
		3323,
		9,
		2660
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Medium.ttf": [
		3324,
		9,
		2661
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Medium.woff": [
		3325,
		9,
		2662
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Regular.ttf": [
		3326,
		9,
		2663
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-Regular.woff": [
		3327,
		9,
		2664
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-SemiBold.ttf": [
		3328,
		9,
		2665
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Poppins-SemiBold.woff": [
		3329,
		9,
		2666
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Black.ttf": [
		3330,
		9,
		2667
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Black.woff": [
		3331,
		9,
		2668
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Bold.ttf": [
		3332,
		9,
		2669
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Bold.woff": [
		3333,
		9,
		2670
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Light.ttf": [
		3334,
		9,
		2671
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Light.woff": [
		3335,
		9,
		2672
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Medium.ttf": [
		3336,
		9,
		2673
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Medium.woff": [
		3337,
		9,
		2674
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Regular.ttf": [
		3338,
		9,
		2675
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/Roboto-Regular.woff": [
		3339,
		9,
		2676
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/demo.html": [
		3340,
		7,
		3466
	],
	"./pages/PortfolioDetail/src/portfolio-fontfamily/stylesheet.css": [
		3341,
		7,
		857
	],
	"./pages/PortfolioListing/GameList": [
		206,
		9,
		805
	],
	"./pages/PortfolioListing/GameList.js": [
		206,
		9,
		805
	],
	"./pages/PortfolioListing/NewPortfolioList": [
		200,
		9,
		166
	],
	"./pages/PortfolioListing/NewPortfolioList.js": [
		200,
		9,
		166
	],
	"./pages/PortfolioListing/PortfolioListing": [
		173,
		9,
		0,
		4,
		1,
		70
	],
	"./pages/PortfolioListing/PortfolioListing.js": [
		173,
		9,
		0,
		4,
		1,
		70
	],
	"./pages/PortfolioListing/PortfolioListing.scss": [
		1641,
		7,
		1318
	],
	"./pages/PortfolioListing/images/dudepins-circle.png": [
		80,
		9
	],
	"./pages/PortfolioListing/images/dudepins-circle.webp": [
		81,
		9
	],
	"./pages/PortfolioListing/images/dudepins.png": [
		893,
		9,
		3345
	],
	"./pages/PortfolioListing/images/dudepins.webp": [
		894,
		9,
		2677
	],
	"./pages/PortfolioListing/images/headphone-controller-app-circle.png": [
		96,
		9
	],
	"./pages/PortfolioListing/images/headphone-controller-app-circle.webp": [
		97,
		9
	],
	"./pages/PortfolioListing/images/headphone-controller-app.png": [
		909,
		9,
		3346
	],
	"./pages/PortfolioListing/images/headphone-controller-app.webp": [
		910,
		9,
		2678
	],
	"./pages/PortfolioListing/images/medsure-circle.png": [
		86,
		9
	],
	"./pages/PortfolioListing/images/medsure-circle.webp": [
		87,
		9
	],
	"./pages/PortfolioListing/images/medsure.png": [
		899,
		9,
		3347
	],
	"./pages/PortfolioListing/images/medsure.webp": [
		900,
		9,
		2679
	],
	"./pages/PortfolioListing/images/moneymaker-r.webp": [
		53,
		9
	],
	"./pages/PortfolioListing/images/moneymaker-s.png": [
		886,
		9,
		3348
	],
	"./pages/PortfolioListing/images/moneymaker-s.webp": [
		885,
		9,
		2680
	],
	"./pages/PortfolioListing/images/moneymaker-thumbnail.webp": [
		77,
		9
	],
	"./pages/PortfolioListing/images/parental-control-app-circle.png": [
		82,
		9
	],
	"./pages/PortfolioListing/images/parental-control-app-circle.webp": [
		83,
		9
	],
	"./pages/PortfolioListing/images/parental-control-app.png": [
		895,
		9,
		3349
	],
	"./pages/PortfolioListing/images/parental-control-app.webp": [
		896,
		9,
		2681
	],
	"./pages/PortfolioListing/images/plant-shop-circle.png": [
		39,
		9
	],
	"./pages/PortfolioListing/images/plant-shop-circle.webp": [
		3342,
		9,
		2682
	],
	"./pages/PortfolioListing/images/plant-shop.png": [
		889,
		9,
		3350
	],
	"./pages/PortfolioListing/images/plant-shop.webp": [
		890,
		9,
		2683
	],
	"./pages/PortfolioListing/images/pure-r.webp": [
		54,
		9
	],
	"./pages/PortfolioListing/images/pure-s.png": [
		888,
		9,
		3351
	],
	"./pages/PortfolioListing/images/pure-s.webp": [
		887,
		9,
		2684
	],
	"./pages/PortfolioListing/images/pure-thumbnail.webp": [
		13,
		9
	],
	"./pages/PortfolioListing/images/salon-app-circle.png": [
		88,
		9
	],
	"./pages/PortfolioListing/images/salon-app-circle.webp": [
		89,
		9
	],
	"./pages/PortfolioListing/images/salon-app.png": [
		901,
		9,
		3352
	],
	"./pages/PortfolioListing/images/salon-app.webp": [
		902,
		9,
		2685
	],
	"./pages/PortfolioListing/images/smart-home-nuemorphism-circle.png": [
		84,
		9
	],
	"./pages/PortfolioListing/images/smart-home-nuemorphism-circle.webp": [
		85,
		9
	],
	"./pages/PortfolioListing/images/smart-home-nuemorphism.png": [
		897,
		9,
		3353
	],
	"./pages/PortfolioListing/images/smart-home-nuemorphism.webp": [
		898,
		9,
		2686
	],
	"./pages/PortfolioListing/images/stock-market-circle.png": [
		92,
		9
	],
	"./pages/PortfolioListing/images/stock-market-circle.webp": [
		93,
		9
	],
	"./pages/PortfolioListing/images/stock-market.png": [
		905,
		9,
		3354
	],
	"./pages/PortfolioListing/images/stock-market.webp": [
		906,
		9,
		2687
	],
	"./pages/PortfolioListing/images/task-management-circle.png": [
		94,
		9
	],
	"./pages/PortfolioListing/images/task-management-circle.webp": [
		95,
		9
	],
	"./pages/PortfolioListing/images/task-management.png": [
		907,
		9,
		3355
	],
	"./pages/PortfolioListing/images/task-management.webp": [
		908,
		9,
		2688
	],
	"./pages/PortfolioListing/images/ticket-booking-app-circle.png": [
		3343,
		9,
		3356
	],
	"./pages/PortfolioListing/images/ticket-booking-app-circle.webp": [
		40,
		9
	],
	"./pages/PortfolioListing/images/ticket-booking-app.png": [
		911,
		9,
		3357
	],
	"./pages/PortfolioListing/images/ticket-booking-app.webp": [
		912,
		9,
		2689
	],
	"./pages/PortfolioListing/images/time-management-circle.png": [
		90,
		9
	],
	"./pages/PortfolioListing/images/time-management-circle.webp": [
		91,
		9
	],
	"./pages/PortfolioListing/images/time-management.png": [
		903,
		9,
		3358
	],
	"./pages/PortfolioListing/images/time-management.webp": [
		904,
		9,
		2690
	],
	"./pages/PortfolioListing/images/travel-agency-circle.png": [
		78,
		9
	],
	"./pages/PortfolioListing/images/travel-agency-circle.webp": [
		79,
		9
	],
	"./pages/PortfolioListing/images/travel-agency.png": [
		891,
		9,
		3359
	],
	"./pages/PortfolioListing/images/travel-agency.webp": [
		892,
		9,
		2691
	],
	"./pages/PortfolioListing/img/common-ux.svg": [
		3344,
		9,
		2692
	],
	"./pages/PortfolioListing/img/illustration.svg": [
		3345,
		9,
		2693
	],
	"./pages/PrivacyPolicy/PrivacyPolicy": [
		178,
		9,
		0,
		1,
		92
	],
	"./pages/PrivacyPolicy/PrivacyPolicy.js": [
		178,
		9,
		0,
		1,
		92
	],
	"./pages/PrivacyPolicy/PrivacyPolicy.scss": [
		1643,
		7,
		1319
	],
	"./pages/PythonWebDevelopment/AboutSection/AboutSection": [
		360,
		9,
		227
	],
	"./pages/PythonWebDevelopment/AboutSection/AboutSection.js": [
		360,
		9,
		227
	],
	"./pages/PythonWebDevelopment/AboutSection/AboutSection.scss": [
		1249,
		7,
		1320
	],
	"./pages/PythonWebDevelopment/AboutSectionSecondary/AboutSectionSecondary": [
		807,
		9,
		266
	],
	"./pages/PythonWebDevelopment/AboutSectionSecondary/AboutSectionSecondary.js": [
		807,
		9,
		266
	],
	"./pages/PythonWebDevelopment/HeroSection/HeroSection": [
		359,
		9,
		551
	],
	"./pages/PythonWebDevelopment/HeroSection/HeroSection.js": [
		359,
		9,
		551
	],
	"./pages/PythonWebDevelopment/HeroSection/HeroSection.scss": [
		1248,
		7,
		1321
	],
	"./pages/PythonWebDevelopment/LookingDevelopers/LookingDevelopers": [
		808,
		9,
		497
	],
	"./pages/PythonWebDevelopment/LookingDevelopers/LookingDevelopers.js": [
		808,
		9,
		497
	],
	"./pages/PythonWebDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2026,
		7,
		1322
	],
	"./pages/PythonWebDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3346,
		7,
		1323
	],
	"./pages/PythonWebDevelopment/PythonServices/PythonServices": [
		809,
		9,
		484
	],
	"./pages/PythonWebDevelopment/PythonServices/PythonServices.js": [
		809,
		9,
		484
	],
	"./pages/PythonWebDevelopment/PythonWebDevelopment": [
		129,
		9,
		0,
		110,
		1,
		2,
		52
	],
	"./pages/PythonWebDevelopment/PythonWebDevelopment.js": [
		129,
		9,
		0,
		110,
		1,
		2,
		52
	],
	"./pages/PythonWebDevelopment/ServicesSection/ServicesSection": [
		363,
		9,
		552
	],
	"./pages/PythonWebDevelopment/ServicesSection/ServicesSection.js": [
		363,
		9,
		552
	],
	"./pages/PythonWebDevelopment/ServicesSection/ServicesSection.scss": [
		1251,
		7,
		1324
	],
	"./pages/PythonWebDevelopment/TechnologiesSection/TechnologiesSection": [
		361,
		9,
		646
	],
	"./pages/PythonWebDevelopment/TechnologiesSection/TechnologiesSection.js": [
		361,
		9,
		646
	],
	"./pages/PythonWebDevelopment/WhyChooseMi/WhyChooseMi": [
		362,
		9,
		375
	],
	"./pages/PythonWebDevelopment/WhyChooseMi/WhyChooseMi.js": [
		362,
		9,
		375
	],
	"./pages/PythonWebDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1250,
		7,
		1325
	],
	"./pages/PythonWebDevelopment/WhyChooseSection/WhyChooseSection": [
		364,
		9,
		602
	],
	"./pages/PythonWebDevelopment/WhyChooseSection/WhyChooseSection.js": [
		364,
		9,
		602
	],
	"./pages/PythonWebDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1252,
		7,
		1326
	],
	"./pages/ReactJsDevelopment/AboutSection/AboutSection": [
		313,
		9,
		228
	],
	"./pages/ReactJsDevelopment/AboutSection/AboutSection.js": [
		313,
		9,
		228
	],
	"./pages/ReactJsDevelopment/AboutSection/AboutSection.scss": [
		1203,
		7,
		1327
	],
	"./pages/ReactJsDevelopment/BenefitsSection/BenefitsSection": [
		810,
		9,
		417
	],
	"./pages/ReactJsDevelopment/BenefitsSection/BenefitsSection.js": [
		810,
		9,
		417
	],
	"./pages/ReactJsDevelopment/HeroSection/HeroSection": [
		312,
		9,
		553
	],
	"./pages/ReactJsDevelopment/HeroSection/HeroSection.js": [
		312,
		9,
		553
	],
	"./pages/ReactJsDevelopment/HeroSection/HeroSection.scss": [
		1202,
		7,
		1328
	],
	"./pages/ReactJsDevelopment/LookingDevelopers/LookingDevelopers": [
		811,
		9,
		498
	],
	"./pages/ReactJsDevelopment/LookingDevelopers/LookingDevelopers.js": [
		811,
		9,
		498
	],
	"./pages/ReactJsDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2027,
		7,
		1329
	],
	"./pages/ReactJsDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3347,
		7,
		1330
	],
	"./pages/ReactJsDevelopment/ReactJsDevelopment": [
		120,
		9,
		0,
		101,
		1,
		2,
		37
	],
	"./pages/ReactJsDevelopment/ReactJsDevelopment.js": [
		120,
		9,
		0,
		101,
		1,
		2,
		37
	],
	"./pages/ReactJsDevelopment/ServicesSection/ServicesSection": [
		314,
		9,
		554
	],
	"./pages/ReactJsDevelopment/ServicesSection/ServicesSection.js": [
		314,
		9,
		554
	],
	"./pages/ReactJsDevelopment/ServicesSection/ServicesSection.scss": [
		1204,
		7,
		1331
	],
	"./pages/ReactJsDevelopment/WhyChooseMi/WhyChooseMi": [
		316,
		9,
		376
	],
	"./pages/ReactJsDevelopment/WhyChooseMi/WhyChooseMi.js": [
		316,
		9,
		376
	],
	"./pages/ReactJsDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1206,
		7,
		1332
	],
	"./pages/ReactJsDevelopment/WhyChooseSection/WhyChooseSection": [
		315,
		9,
		603
	],
	"./pages/ReactJsDevelopment/WhyChooseSection/WhyChooseSection.js": [
		315,
		9,
		603
	],
	"./pages/ReactJsDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1205,
		7,
		1333
	],
	"./pages/ReactNativeDevelopment/AboutSection/AboutSection": [
		287,
		9,
		229
	],
	"./pages/ReactNativeDevelopment/AboutSection/AboutSection.js": [
		287,
		9,
		229
	],
	"./pages/ReactNativeDevelopment/AboutSection/AboutSection.scss": [
		1177,
		7,
		1334
	],
	"./pages/ReactNativeDevelopment/BenefitsSection/BenefitsSection": [
		812,
		9,
		239
	],
	"./pages/ReactNativeDevelopment/BenefitsSection/BenefitsSection.js": [
		812,
		9,
		239
	],
	"./pages/ReactNativeDevelopment/BenefitsSection/BenefitsSection.scss": [
		2028,
		7,
		1335
	],
	"./pages/ReactNativeDevelopment/HeroSection/HeroSection": [
		286,
		9,
		454
	],
	"./pages/ReactNativeDevelopment/HeroSection/HeroSection.js": [
		286,
		9,
		454
	],
	"./pages/ReactNativeDevelopment/HeroSection/HeroSection.scss": [
		1176,
		7,
		1336
	],
	"./pages/ReactNativeDevelopment/KeyFeatures/KeyFeatures": [
		292,
		9,
		377
	],
	"./pages/ReactNativeDevelopment/KeyFeatures/KeyFeatures.js": [
		292,
		9,
		377
	],
	"./pages/ReactNativeDevelopment/KeyFeatures/KeyFeatures.scss": [
		1182,
		7,
		1337
	],
	"./pages/ReactNativeDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		3348,
		7,
		1338
	],
	"./pages/ReactNativeDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3349,
		7,
		1339
	],
	"./pages/ReactNativeDevelopment/Platforms/Platforms": [
		289,
		9,
		444
	],
	"./pages/ReactNativeDevelopment/Platforms/Platforms.js": [
		289,
		9,
		444
	],
	"./pages/ReactNativeDevelopment/Platforms/Platforms.scss": [
		1179,
		7,
		1340
	],
	"./pages/ReactNativeDevelopment/ReactNativeDevelopment": [
		116,
		9,
		0,
		97,
		1,
		2,
		25
	],
	"./pages/ReactNativeDevelopment/ReactNativeDevelopment.js": [
		116,
		9,
		0,
		97,
		1,
		2,
		25
	],
	"./pages/ReactNativeDevelopment/ServicesSection/ServicesSection": [
		288,
		9,
		555
	],
	"./pages/ReactNativeDevelopment/ServicesSection/ServicesSection.js": [
		288,
		9,
		555
	],
	"./pages/ReactNativeDevelopment/ServicesSection/ServicesSection.scss": [
		1178,
		7,
		1341
	],
	"./pages/ReactNativeDevelopment/TechnologiesSection/TechnologiesSection": [
		239,
		9,
		418
	],
	"./pages/ReactNativeDevelopment/TechnologiesSection/TechnologiesSection.js": [
		239,
		9,
		418
	],
	"./pages/ReactNativeDevelopment/WhyChooseMi/WhyChooseMi": [
		291,
		9,
		378
	],
	"./pages/ReactNativeDevelopment/WhyChooseMi/WhyChooseMi.js": [
		291,
		9,
		378
	],
	"./pages/ReactNativeDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1181,
		7,
		1342
	],
	"./pages/ReactNativeDevelopment/WhyChooseSection/WhyChooseSection": [
		290,
		9,
		604
	],
	"./pages/ReactNativeDevelopment/WhyChooseSection/WhyChooseSection.js": [
		290,
		9,
		604
	],
	"./pages/ReactNativeDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1180,
		7,
		1343
	],
	"./pages/Services/BusinessModels/BusinessModels": [
		813,
		9,
		504
	],
	"./pages/Services/BusinessModels/BusinessModels.js": [
		813,
		9,
		504
	],
	"./pages/Services/CantFindTechnology/CantFindTechnology": [
		814,
		9,
		781
	],
	"./pages/Services/CantFindTechnology/CantFindTechnology.js": [
		814,
		9,
		781
	],
	"./pages/Services/CantFindTechnology/CantFindTechnology.scss": [
		2029,
		7,
		1344
	],
	"./pages/Services/Development/Development": [
		815,
		9,
		806
	],
	"./pages/Services/Development/Development.js": [
		815,
		9,
		806
	],
	"./pages/Services/Development/Development.scss": [
		3350,
		7,
		1345
	],
	"./pages/Services/Development/MobileAppDevelopment/MobileAppDevelopment": [
		252,
		9,
		147
	],
	"./pages/Services/Development/MobileAppDevelopment/MobileAppDevelopment.js": [
		252,
		9,
		147
	],
	"./pages/Services/Development/MobileAppDevelopment/MobileAppDevelopment.scss": [
		1084,
		7,
		1346
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/aws.svg": [
		1107,
		9,
		2694
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/digital-ocean.svg": [
		1110,
		9,
		2695
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/docker.svg": [
		3351,
		9,
		2696
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/google-cloud.svg": [
		1111,
		9,
		2697
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/kubernetes.svg": [
		1109,
		9,
		2698
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/microsoft-azure.svg": [
		1108,
		9,
		2699
	],
	"./pages/Services/Development/MobileAppDevelopment/Mobileapp-img/sss.svg": [
		3352,
		9,
		2700
	],
	"./pages/Services/Development/MobileAppDevelopment/checkElementHook": [
		816,
		9,
		807
	],
	"./pages/Services/Development/MobileAppDevelopment/checkElementHook.js": [
		816,
		9,
		807
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-eight.webp": [
		1127,
		9,
		2701
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-five.webp": [
		1124,
		9,
		2702
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-four.webp": [
		1123,
		9,
		2703
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-nine.webp": [
		1128,
		9,
		2704
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-one.webp": [
		1120,
		9,
		2705
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-seven.webp": [
		1126,
		9,
		2706
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-six.webp": [
		1125,
		9,
		2707
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-ten.webp": [
		1129,
		9,
		2708
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-three.webp": [
		1122,
		9,
		2709
	],
	"./pages/Services/Development/MobileAppDevelopment/images/app-images/mobile-app-two.webp": [
		1121,
		9,
		2710
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-eight.png": [
		1137,
		9,
		3360
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-five.png": [
		1134,
		9,
		3361
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-four.png": [
		1133,
		9,
		3362
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-nine.png": [
		1138,
		9,
		3363
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-one.png": [
		1130,
		9,
		3364
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-seven.png": [
		1136,
		9,
		3365
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-six.png": [
		1135,
		9,
		3366
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-ten.png": [
		1139,
		9,
		3367
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-three.png": [
		1132,
		9,
		3368
	],
	"./pages/Services/Development/MobileAppDevelopment/images/web-images/web-two.png": [
		1131,
		9,
		3369
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/android.svg": [
		1086,
		9,
		2711
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/angular.svg": [
		1095,
		9,
		2712
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/app-research.svg": [
		1088,
		9,
		2713
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/flutter.svg": [
		1087,
		9,
		2714
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/golang.svg": [
		1100,
		9,
		2715
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/ios.svg": [
		1085,
		9,
		2716
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/laravel.svg": [
		1099,
		9,
		2717
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/metror-js.svg": [
		1097,
		9,
		2718
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/nodejs.svg": [
		1098,
		9,
		2719
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/prototype-design.svg": [
		1091,
		9,
		2720
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/python.svg": [
		1101,
		9,
		2721
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/react-native.svg": [
		1020,
		9,
		2722
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/responsive-design.svg": [
		1093,
		9,
		2723
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/ui-interaction.svg": [
		1090,
		9,
		2724
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/ui-ux-web.svg": [
		1094,
		9,
		2725
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/ui-ux.svg": [
		1089,
		9,
		2726
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/vuejs.svg": [
		1096,
		9,
		2727
	],
	"./pages/Services/Development/MobileAppDevelopment/services-icons/web-interaction.svg": [
		1092,
		9,
		2728
	],
	"./pages/Services/Development/game-development/aftereffect.svg": [
		1118,
		9,
		2729
	],
	"./pages/Services/Development/game-development/blender.svg": [
		1117,
		9,
		2730
	],
	"./pages/Services/Development/game-development/buildbox.svg": [
		1116,
		9,
		2731
	],
	"./pages/Services/Development/game-development/html5.svg": [
		3353,
		9,
		2732
	],
	"./pages/Services/Development/game-development/illustrator.svg": [
		1119,
		9,
		2733
	],
	"./pages/Services/Development/game-development/photoshop.svg": [
		3354,
		9,
		2734
	],
	"./pages/Services/Development/game-development/unity.svg": [
		1114,
		9,
		2735
	],
	"./pages/Services/Development/game-development/unreal-eng.svg": [
		1115,
		9,
		2736
	],
	"./pages/Services/HeroSection/HeroSection": [
		251,
		9,
		455
	],
	"./pages/Services/HeroSection/HeroSection.js": [
		251,
		9,
		455
	],
	"./pages/Services/HeroSection/HeroSection.scss": [
		1083,
		7,
		1347
	],
	"./pages/Services/MethodologySection/MethodologySection": [
		817,
		9,
		618
	],
	"./pages/Services/MethodologySection/MethodologySection.js": [
		817,
		9,
		618
	],
	"./pages/Services/MethodologySection/MethodologySection.scss": [
		2030,
		7,
		1348
	],
	"./pages/Services/Services": [
		110,
		9,
		0,
		3,
		9,
		1,
		21
	],
	"./pages/Services/Services.js": [
		110,
		9,
		0,
		3,
		9,
		1,
		21
	],
	"./pages/Services/Services.scss": [
		1626,
		7,
		1349
	],
	"./pages/Services/ServicesListSection/ServicesListSection": [
		818,
		9,
		262
	],
	"./pages/Services/ServicesListSection/ServicesListSection.js": [
		818,
		9,
		262
	],
	"./pages/Services/design-img/adobe-Illustrator.svg": [
		1106,
		9,
		2737
	],
	"./pages/Services/design-img/after-effects.svg": [
		1104,
		9,
		2738
	],
	"./pages/Services/design-img/aws.svg": [
		3355,
		9,
		2739
	],
	"./pages/Services/design-img/digital-ocean.svg": [
		3356,
		9,
		2740
	],
	"./pages/Services/design-img/down-arrow.svg": [
		3357,
		9,
		2741
	],
	"./pages/Services/design-img/figma.svg": [
		1113,
		9,
		2742
	],
	"./pages/Services/design-img/google-cloud.svg": [
		3358,
		9,
		2743
	],
	"./pages/Services/design-img/kubernetes.svg": [
		3359,
		9,
		2744
	],
	"./pages/Services/design-img/microsoft-azure.svg": [
		3360,
		9,
		2745
	],
	"./pages/Services/design-img/photoshop.svg": [
		1105,
		9,
		2746
	],
	"./pages/Services/design-img/sketch.svg": [
		1102,
		9,
		2747
	],
	"./pages/Services/design-img/slogan-img.svg": [
		1112,
		9,
		2748
	],
	"./pages/Services/design-img/xd.svg": [
		1103,
		9,
		2749
	],
	"./pages/Services/n-images/android.svg": [
		3361,
		9,
		2750
	],
	"./pages/Services/n-images/flutter.svg": [
		3362,
		9,
		2751
	],
	"./pages/Services/n-images/ios.svg": [
		3363,
		9,
		2752
	],
	"./pages/Services/n-images/react.svg": [
		3364,
		9,
		2753
	],
	"./pages/Services/n-images/right-arrow.svg": [
		3365,
		9,
		2754
	],
	"./pages/Sitemap/HeroSection/HeroSection": [
		577,
		9,
		782
	],
	"./pages/Sitemap/HeroSection/HeroSection.js": [
		577,
		9,
		782
	],
	"./pages/Sitemap/HeroSection/HeroSection.scss": [
		1499,
		7,
		1350
	],
	"./pages/Sitemap/Sitemap": [
		177,
		9,
		0,
		1,
		88
	],
	"./pages/Sitemap/Sitemap.js": [
		177,
		9,
		0,
		1,
		88
	],
	"./pages/Solutions/BusinessAppDevelopment/AboutSection/AboutSection": [
		473,
		9,
		198
	],
	"./pages/Solutions/BusinessAppDevelopment/AboutSection/AboutSection.js": [
		473,
		9,
		198
	],
	"./pages/Solutions/BusinessAppDevelopment/BusinessAppDevelopment": [
		151,
		9,
		0,
		1,
		71
	],
	"./pages/Solutions/BusinessAppDevelopment/BusinessAppDevelopment.js": [
		151,
		9,
		0,
		1,
		71
	],
	"./pages/Solutions/BusinessAppDevelopment/Features/Features": [
		475,
		9,
		475
	],
	"./pages/Solutions/BusinessAppDevelopment/Features/Features.js": [
		475,
		9,
		475
	],
	"./pages/Solutions/BusinessAppDevelopment/HeroSection/HeroSection": [
		472,
		9,
		556
	],
	"./pages/Solutions/BusinessAppDevelopment/HeroSection/HeroSection.js": [
		472,
		9,
		556
	],
	"./pages/Solutions/BusinessAppDevelopment/HeroSection/HeroSection.scss": [
		1383,
		7,
		1351
	],
	"./pages/Solutions/BusinessAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		474,
		9,
		419
	],
	"./pages/Solutions/BusinessAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		474,
		9,
		419
	],
	"./pages/Solutions/BusinessAppDevelopment/WhyChoose/WhyChoose": [
		476,
		9,
		647
	],
	"./pages/Solutions/BusinessAppDevelopment/WhyChoose/WhyChoose.js": [
		476,
		9,
		647
	],
	"./pages/Solutions/CloudComputingSolutions/AboutSection/AboutSection": [
		442,
		9,
		184
	],
	"./pages/Solutions/CloudComputingSolutions/AboutSection/AboutSection.js": [
		442,
		9,
		184
	],
	"./pages/Solutions/CloudComputingSolutions/AboutSection/AboutSection.scss": [
		1368,
		7,
		1352
	],
	"./pages/Solutions/CloudComputingSolutions/Benefits/Benefits": [
		819,
		9,
		420
	],
	"./pages/Solutions/CloudComputingSolutions/Benefits/Benefits.js": [
		819,
		9,
		420
	],
	"./pages/Solutions/CloudComputingSolutions/CloudComputingSolutions": [
		145,
		9,
		0,
		125,
		1,
		2,
		55
	],
	"./pages/Solutions/CloudComputingSolutions/CloudComputingSolutions.js": [
		145,
		9,
		0,
		125,
		1,
		2,
		55
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/HeroSection": [
		441,
		9,
		212
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/HeroSection.js": [
		441,
		9,
		212
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/HeroSection.scss": [
		1361,
		7,
		1353
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/amazon-web-services-aws.svg": [
		1362,
		9,
		2755
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/digital-ocean.svg": [
		1365,
		9,
		2756
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/docker.svg": [
		1366,
		9,
		2757
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/google-cloud.svg": [
		1364,
		9,
		2758
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/heroku.svg": [
		3366,
		9,
		2759
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/kubernetes.svg": [
		1367,
		9,
		2760
	],
	"./pages/Solutions/CloudComputingSolutions/HeroSection/imgs/microsoft-azure.svg": [
		1363,
		9,
		2761
	],
	"./pages/Solutions/CloudComputingSolutions/LookingDevelopers/LookingDevelopers.scss": [
		3367,
		7,
		1354
	],
	"./pages/Solutions/CloudComputingSolutions/LookingOtherServices/LookingOtherServices.scss": [
		3368,
		7,
		1355
	],
	"./pages/Solutions/CloudComputingSolutions/ServicesSection/ServicesSection": [
		444,
		9,
		557
	],
	"./pages/Solutions/CloudComputingSolutions/ServicesSection/ServicesSection.js": [
		444,
		9,
		557
	],
	"./pages/Solutions/CloudComputingSolutions/ServicesSection/ServicesSection.scss": [
		1371,
		7,
		1356
	],
	"./pages/Solutions/CloudComputingSolutions/Types/Types": [
		443,
		9,
		505
	],
	"./pages/Solutions/CloudComputingSolutions/Types/Types.js": [
		443,
		9,
		505
	],
	"./pages/Solutions/CloudComputingSolutions/Types/Types.scss": [
		1369,
		7,
		1357
	],
	"./pages/Solutions/CloudComputingSolutions/Types/imgs/types.svg": [
		1370,
		9,
		2762
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChoose/WhyChoose": [
		820,
		9,
		485
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChoose/WhyChoose.js": [
		820,
		9,
		485
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChooseMi/WhyChooseMi": [
		445,
		9,
		379
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChooseMi/WhyChooseMi.js": [
		445,
		9,
		379
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChooseMi/WhyChooseMi.scss": [
		1372,
		7,
		1358
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChooseSection/WhyChooseSection": [
		446,
		9,
		605
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChooseSection/WhyChooseSection.js": [
		446,
		9,
		605
	],
	"./pages/Solutions/CloudComputingSolutions/WhyChooseSection/WhyChooseSection.scss": [
		1373,
		7,
		1359
	],
	"./pages/Solutions/DevOpsSplutions/AboutSection/AboutSection": [
		407,
		9,
		185
	],
	"./pages/Solutions/DevOpsSplutions/AboutSection/AboutSection.js": [
		407,
		9,
		185
	],
	"./pages/Solutions/DevOpsSplutions/AboutSection/AboutSection.scss": [
		1323,
		7,
		1360
	],
	"./pages/Solutions/DevOpsSplutions/DevOpsSplutions": [
		138,
		9,
		0,
		118,
		1,
		2,
		56
	],
	"./pages/Solutions/DevOpsSplutions/DevOpsSplutions.js": [
		138,
		9,
		0,
		118,
		1,
		2,
		56
	],
	"./pages/Solutions/DevOpsSplutions/HeroSection/HeroSection": [
		406,
		9,
		456
	],
	"./pages/Solutions/DevOpsSplutions/HeroSection/HeroSection.js": [
		406,
		9,
		456
	],
	"./pages/Solutions/DevOpsSplutions/HeroSection/HeroSection.scss": [
		1322,
		7,
		1361
	],
	"./pages/Solutions/DevOpsSplutions/LookingDevelopers/LookingDevelopers": [
		821,
		9,
		499
	],
	"./pages/Solutions/DevOpsSplutions/LookingDevelopers/LookingDevelopers.js": [
		821,
		9,
		499
	],
	"./pages/Solutions/DevOpsSplutions/LookingDevelopers/LookingDevelopers.scss": [
		2031,
		7,
		1362
	],
	"./pages/Solutions/DevOpsSplutions/LookingOtherServices/LookingOtherServices.scss": [
		3369,
		7,
		1363
	],
	"./pages/Solutions/DevOpsSplutions/ServicesSection/ServicesSection": [
		408,
		9,
		558
	],
	"./pages/Solutions/DevOpsSplutions/ServicesSection/ServicesSection.js": [
		408,
		9,
		558
	],
	"./pages/Solutions/DevOpsSplutions/ServicesSection/ServicesSection.scss": [
		1324,
		7,
		1364
	],
	"./pages/Solutions/DevOpsSplutions/TechnologiesSection/TechnologiesSection": [
		822,
		9,
		648
	],
	"./pages/Solutions/DevOpsSplutions/TechnologiesSection/TechnologiesSection.js": [
		822,
		9,
		648
	],
	"./pages/Solutions/DevOpsSplutions/WhatWeOffer/WhatWeOffer": [
		823,
		9,
		277
	],
	"./pages/Solutions/DevOpsSplutions/WhatWeOffer/WhatWeOffer.js": [
		823,
		9,
		277
	],
	"./pages/Solutions/DevOpsSplutions/WhyChooseMi/WhyChooseMi": [
		410,
		9,
		380
	],
	"./pages/Solutions/DevOpsSplutions/WhyChooseMi/WhyChooseMi.js": [
		410,
		9,
		380
	],
	"./pages/Solutions/DevOpsSplutions/WhyChooseMi/WhyChooseMi.scss": [
		1326,
		7,
		1365
	],
	"./pages/Solutions/DevOpsSplutions/WhyChooseSection/WhyChooseSection": [
		409,
		9,
		606
	],
	"./pages/Solutions/DevOpsSplutions/WhyChooseSection/WhyChooseSection.js": [
		409,
		9,
		606
	],
	"./pages/Solutions/DevOpsSplutions/WhyChooseSection/WhyChooseSection.scss": [
		1325,
		7,
		1366
	],
	"./pages/Solutions/DigitalTransformation/AboutSection/AboutSection": [
		412,
		9,
		186
	],
	"./pages/Solutions/DigitalTransformation/AboutSection/AboutSection.js": [
		412,
		9,
		186
	],
	"./pages/Solutions/DigitalTransformation/AboutSection/AboutSection.scss": [
		1328,
		7,
		1367
	],
	"./pages/Solutions/DigitalTransformation/DigitalTransformation": [
		139,
		9,
		0,
		3,
		119,
		1,
		26
	],
	"./pages/Solutions/DigitalTransformation/DigitalTransformation.js": [
		139,
		9,
		0,
		3,
		119,
		1,
		26
	],
	"./pages/Solutions/DigitalTransformation/HeroSection/HeroSection": [
		411,
		9,
		457
	],
	"./pages/Solutions/DigitalTransformation/HeroSection/HeroSection.js": [
		411,
		9,
		457
	],
	"./pages/Solutions/DigitalTransformation/HeroSection/HeroSection.scss": [
		1327,
		7,
		1368
	],
	"./pages/Solutions/DigitalTransformation/LookingDevelopers/LookingDevelopers.scss": [
		3370,
		7,
		1369
	],
	"./pages/Solutions/DigitalTransformation/LookingOtherServices/LookingOtherServices.scss": [
		3371,
		7,
		1370
	],
	"./pages/Solutions/DigitalTransformation/Promoters/Promoters": [
		824,
		9,
		649
	],
	"./pages/Solutions/DigitalTransformation/Promoters/Promoters.js": [
		824,
		9,
		649
	],
	"./pages/Solutions/DigitalTransformation/ServicesSection/ServicesSection": [
		413,
		9,
		559
	],
	"./pages/Solutions/DigitalTransformation/ServicesSection/ServicesSection.js": [
		413,
		9,
		559
	],
	"./pages/Solutions/DigitalTransformation/ServicesSection/ServicesSection.scss": [
		1329,
		7,
		1371
	],
	"./pages/Solutions/DigitalTransformation/TechnologiesSection/TechnologiesSection": [
		825,
		9,
		650
	],
	"./pages/Solutions/DigitalTransformation/TechnologiesSection/TechnologiesSection.js": [
		825,
		9,
		650
	],
	"./pages/Solutions/DigitalTransformation/WhatWeOffer/WhatWeOffer": [
		826,
		9,
		278
	],
	"./pages/Solutions/DigitalTransformation/WhatWeOffer/WhatWeOffer.js": [
		826,
		9,
		278
	],
	"./pages/Solutions/DigitalTransformation/WhyChooseMi/WhyChooseMi": [
		414,
		9,
		381
	],
	"./pages/Solutions/DigitalTransformation/WhyChooseMi/WhyChooseMi.js": [
		414,
		9,
		381
	],
	"./pages/Solutions/DigitalTransformation/WhyChooseMi/WhyChooseMi.scss": [
		1330,
		7,
		1372
	],
	"./pages/Solutions/EcommerceSolutions/AboutSection/AboutSection": [
		416,
		9,
		204
	],
	"./pages/Solutions/EcommerceSolutions/AboutSection/AboutSection.js": [
		416,
		9,
		204
	],
	"./pages/Solutions/EcommerceSolutions/AboutSection/AboutSection.scss": [
		1332,
		7,
		1373
	],
	"./pages/Solutions/EcommerceSolutions/AboutSectionSecondary/AboutSectionSecondary": [
		827,
		9,
		785
	],
	"./pages/Solutions/EcommerceSolutions/AboutSectionSecondary/AboutSectionSecondary.js": [
		827,
		9,
		785
	],
	"./pages/Solutions/EcommerceSolutions/EcommerceSolutions": [
		140,
		9,
		0,
		120,
		1,
		6,
		64
	],
	"./pages/Solutions/EcommerceSolutions/EcommerceSolutions.js": [
		140,
		9,
		0,
		120,
		1,
		6,
		64
	],
	"./pages/Solutions/EcommerceSolutions/Features/Features": [
		417,
		9,
		382
	],
	"./pages/Solutions/EcommerceSolutions/Features/Features.js": [
		417,
		9,
		382
	],
	"./pages/Solutions/EcommerceSolutions/Features/Features.scss": [
		1333,
		7,
		1374
	],
	"./pages/Solutions/EcommerceSolutions/HeroSection/HeroSection": [
		415,
		9,
		560
	],
	"./pages/Solutions/EcommerceSolutions/HeroSection/HeroSection.js": [
		415,
		9,
		560
	],
	"./pages/Solutions/EcommerceSolutions/HeroSection/HeroSection.scss": [
		1331,
		7,
		1375
	],
	"./pages/Solutions/EcommerceSolutions/ServicesSection/ServicesSection": [
		418,
		9,
		561
	],
	"./pages/Solutions/EcommerceSolutions/ServicesSection/ServicesSection.js": [
		418,
		9,
		561
	],
	"./pages/Solutions/EcommerceSolutions/ServicesSection/ServicesSection.scss": [
		1334,
		7,
		1376
	],
	"./pages/Solutions/EcommerceSolutions/SolutionsWeOffer/SolutionsWeOffer": [
		828,
		9,
		476
	],
	"./pages/Solutions/EcommerceSolutions/SolutionsWeOffer/SolutionsWeOffer.js": [
		828,
		9,
		476
	],
	"./pages/Solutions/EcommerceSolutions/WhyChooseMi/WhyChooseMi": [
		419,
		9,
		383
	],
	"./pages/Solutions/EcommerceSolutions/WhyChooseMi/WhyChooseMi.js": [
		419,
		9,
		383
	],
	"./pages/Solutions/EcommerceSolutions/WhyChooseMi/WhyChooseMi.scss": [
		1335,
		7,
		1377
	],
	"./pages/Solutions/EducationAppDevelopment/AboutSection/AboutSection": [
		478,
		9,
		197
	],
	"./pages/Solutions/EducationAppDevelopment/AboutSection/AboutSection.js": [
		478,
		9,
		197
	],
	"./pages/Solutions/EducationAppDevelopment/EducationAppDevelopment": [
		152,
		9,
		0,
		1,
		72
	],
	"./pages/Solutions/EducationAppDevelopment/EducationAppDevelopment.js": [
		152,
		9,
		0,
		1,
		72
	],
	"./pages/Solutions/EducationAppDevelopment/Features/Features": [
		480,
		9,
		477
	],
	"./pages/Solutions/EducationAppDevelopment/Features/Features.js": [
		480,
		9,
		477
	],
	"./pages/Solutions/EducationAppDevelopment/HeroSection/HeroSection": [
		477,
		9,
		458
	],
	"./pages/Solutions/EducationAppDevelopment/HeroSection/HeroSection.js": [
		477,
		9,
		458
	],
	"./pages/Solutions/EducationAppDevelopment/HeroSection/HeroSection.scss": [
		1384,
		7,
		1378
	],
	"./pages/Solutions/EducationAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		479,
		9,
		486
	],
	"./pages/Solutions/EducationAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		479,
		9,
		486
	],
	"./pages/Solutions/EducationAppDevelopment/WhyChoose/WhyChoose": [
		481,
		9,
		651
	],
	"./pages/Solutions/EducationAppDevelopment/WhyChoose/WhyChoose.js": [
		481,
		9,
		651
	],
	"./pages/Solutions/EnterpriseAppDevelopment/AboutSection/AboutSection": [
		393,
		9,
		187
	],
	"./pages/Solutions/EnterpriseAppDevelopment/AboutSection/AboutSection.js": [
		393,
		9,
		187
	],
	"./pages/Solutions/EnterpriseAppDevelopment/AboutSection/AboutSection.scss": [
		1309,
		7,
		1379
	],
	"./pages/Solutions/EnterpriseAppDevelopment/Benefits/Benefits": [
		829,
		9,
		652
	],
	"./pages/Solutions/EnterpriseAppDevelopment/Benefits/Benefits.js": [
		829,
		9,
		652
	],
	"./pages/Solutions/EnterpriseAppDevelopment/EnterpriseAppDevelopment": [
		135,
		9,
		0,
		115,
		1,
		2,
		57
	],
	"./pages/Solutions/EnterpriseAppDevelopment/EnterpriseAppDevelopment.js": [
		135,
		9,
		0,
		115,
		1,
		2,
		57
	],
	"./pages/Solutions/EnterpriseAppDevelopment/HeroSection/HeroSection": [
		392,
		9,
		459
	],
	"./pages/Solutions/EnterpriseAppDevelopment/HeroSection/HeroSection.js": [
		392,
		9,
		459
	],
	"./pages/Solutions/EnterpriseAppDevelopment/HeroSection/HeroSection.scss": [
		1308,
		7,
		1380
	],
	"./pages/Solutions/EnterpriseAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		3372,
		7,
		1381
	],
	"./pages/Solutions/EnterpriseAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3373,
		7,
		1382
	],
	"./pages/Solutions/EnterpriseAppDevelopment/ServicesSection/ServicesSection": [
		394,
		9,
		562
	],
	"./pages/Solutions/EnterpriseAppDevelopment/ServicesSection/ServicesSection.js": [
		394,
		9,
		562
	],
	"./pages/Solutions/EnterpriseAppDevelopment/ServicesSection/ServicesSection.scss": [
		1310,
		7,
		1383
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyChooseMi/WhyChooseMi": [
		395,
		9,
		384
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		395,
		9,
		384
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1311,
		7,
		1384
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyChooseSection/WhyChooseSection": [
		396,
		9,
		607
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		396,
		9,
		607
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1312,
		7,
		1385
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyGoFor/WhyGoFor": [
		830,
		9,
		259
	],
	"./pages/Solutions/EnterpriseAppDevelopment/WhyGoFor/WhyGoFor.js": [
		830,
		9,
		259
	],
	"./pages/Solutions/EntertainmentAppDevelopment/AboutSection/AboutSection": [
		483,
		9,
		199
	],
	"./pages/Solutions/EntertainmentAppDevelopment/AboutSection/AboutSection.js": [
		483,
		9,
		199
	],
	"./pages/Solutions/EntertainmentAppDevelopment/EntertainmentAppDevelopment": [
		153,
		9,
		0,
		1,
		73
	],
	"./pages/Solutions/EntertainmentAppDevelopment/EntertainmentAppDevelopment.js": [
		153,
		9,
		0,
		1,
		73
	],
	"./pages/Solutions/EntertainmentAppDevelopment/Features/Features": [
		485,
		9,
		421
	],
	"./pages/Solutions/EntertainmentAppDevelopment/Features/Features.js": [
		485,
		9,
		421
	],
	"./pages/Solutions/EntertainmentAppDevelopment/HeroSection/HeroSection": [
		482,
		9,
		563
	],
	"./pages/Solutions/EntertainmentAppDevelopment/HeroSection/HeroSection.js": [
		482,
		9,
		563
	],
	"./pages/Solutions/EntertainmentAppDevelopment/HeroSection/HeroSection.scss": [
		1385,
		7,
		1386
	],
	"./pages/Solutions/EntertainmentAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		484,
		9,
		422
	],
	"./pages/Solutions/EntertainmentAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		484,
		9,
		422
	],
	"./pages/Solutions/EntertainmentAppDevelopment/WhyChoose/WhyChoose": [
		486,
		9,
		653
	],
	"./pages/Solutions/EntertainmentAppDevelopment/WhyChoose/WhyChoose.js": [
		486,
		9,
		653
	],
	"./pages/Solutions/FintechSolutions/AboutSection/AboutSection": [
		421,
		9,
		205
	],
	"./pages/Solutions/FintechSolutions/AboutSection/AboutSection.js": [
		421,
		9,
		205
	],
	"./pages/Solutions/FintechSolutions/AboutSection/AboutSection.scss": [
		1337,
		7,
		1387
	],
	"./pages/Solutions/FintechSolutions/CantFindTechnology/CantFindTechnology": [
		241,
		9,
		615
	],
	"./pages/Solutions/FintechSolutions/CantFindTechnology/CantFindTechnology.js": [
		241,
		9,
		615
	],
	"./pages/Solutions/FintechSolutions/CantFindTechnology/CantFindTechnology.scss": [
		1034,
		7,
		1388
	],
	"./pages/Solutions/FintechSolutions/Features/Features": [
		422,
		9,
		234
	],
	"./pages/Solutions/FintechSolutions/Features/Features.js": [
		422,
		9,
		234
	],
	"./pages/Solutions/FintechSolutions/Features/Features.scss": [
		1338,
		7,
		1389
	],
	"./pages/Solutions/FintechSolutions/FintechSolutions": [
		141,
		9,
		0,
		121,
		1,
		6,
		60
	],
	"./pages/Solutions/FintechSolutions/FintechSolutions.js": [
		141,
		9,
		0,
		121,
		1,
		6,
		60
	],
	"./pages/Solutions/FintechSolutions/HeroSection/HeroSection": [
		420,
		9,
		564
	],
	"./pages/Solutions/FintechSolutions/HeroSection/HeroSection.js": [
		420,
		9,
		564
	],
	"./pages/Solutions/FintechSolutions/HeroSection/HeroSection.scss": [
		1336,
		7,
		1390
	],
	"./pages/Solutions/FintechSolutions/ServicesSection/ServicesSection": [
		423,
		9,
		565
	],
	"./pages/Solutions/FintechSolutions/ServicesSection/ServicesSection.js": [
		423,
		9,
		565
	],
	"./pages/Solutions/FintechSolutions/ServicesSection/ServicesSection.scss": [
		1343,
		7,
		1391
	],
	"./pages/Solutions/FintechSolutions/SolutionsWeOffer/SolutionsWeOffer": [
		831,
		9,
		487
	],
	"./pages/Solutions/FintechSolutions/SolutionsWeOffer/SolutionsWeOffer.js": [
		831,
		9,
		487
	],
	"./pages/Solutions/FintechSolutions/WhatIs/WhatIs": [
		832,
		9,
		478
	],
	"./pages/Solutions/FintechSolutions/WhatIs/WhatIs.js": [
		832,
		9,
		478
	],
	"./pages/Solutions/FintechSolutions/WhyChooseMi/WhyChooseMi": [
		424,
		9,
		385
	],
	"./pages/Solutions/FintechSolutions/WhyChooseMi/WhyChooseMi.js": [
		424,
		9,
		385
	],
	"./pages/Solutions/FintechSolutions/WhyChooseMi/WhyChooseMi.scss": [
		1344,
		7,
		1392
	],
	"./pages/Solutions/FintechSolutions/img/banking.svg": [
		1339,
		9,
		2763
	],
	"./pages/Solutions/FintechSolutions/img/finance.svg": [
		1341,
		9,
		2764
	],
	"./pages/Solutions/FintechSolutions/img/payment.svg": [
		1340,
		9,
		2765
	],
	"./pages/Solutions/FintechSolutions/img/wallet-app.svg": [
		1342,
		9,
		2766
	],
	"./pages/Solutions/FitnessSoultions/AboutSection/AboutSection": [
		430,
		9,
		206
	],
	"./pages/Solutions/FitnessSoultions/AboutSection/AboutSection.js": [
		430,
		9,
		206
	],
	"./pages/Solutions/FitnessSoultions/AboutSection/AboutSection.scss": [
		1350,
		7,
		1393
	],
	"./pages/Solutions/FitnessSoultions/AboutSectionSecondary/AboutSectionSecondary": [
		833,
		9,
		430
	],
	"./pages/Solutions/FitnessSoultions/AboutSectionSecondary/AboutSectionSecondary.js": [
		833,
		9,
		430
	],
	"./pages/Solutions/FitnessSoultions/BusinessGrow/BusinessGrow": [
		434,
		9,
		274
	],
	"./pages/Solutions/FitnessSoultions/BusinessGrow/BusinessGrow.js": [
		434,
		9,
		274
	],
	"./pages/Solutions/FitnessSoultions/BusinessGrow/BusinessGrow.scss": [
		1354,
		7,
		1394
	],
	"./pages/Solutions/FitnessSoultions/Features/Features": [
		431,
		9,
		386
	],
	"./pages/Solutions/FitnessSoultions/Features/Features.js": [
		431,
		9,
		386
	],
	"./pages/Solutions/FitnessSoultions/Features/Features.scss": [
		1351,
		7,
		1395
	],
	"./pages/Solutions/FitnessSoultions/FitnessSoultions": [
		143,
		9,
		0,
		123,
		1,
		6,
		65
	],
	"./pages/Solutions/FitnessSoultions/FitnessSoultions.js": [
		143,
		9,
		0,
		123,
		1,
		6,
		65
	],
	"./pages/Solutions/FitnessSoultions/HeroSection/HeroSection": [
		429,
		9,
		566
	],
	"./pages/Solutions/FitnessSoultions/HeroSection/HeroSection.js": [
		429,
		9,
		566
	],
	"./pages/Solutions/FitnessSoultions/HeroSection/HeroSection.scss": [
		1349,
		7,
		1396
	],
	"./pages/Solutions/FitnessSoultions/ServicesSection/ServicesSection": [
		433,
		9,
		567
	],
	"./pages/Solutions/FitnessSoultions/ServicesSection/ServicesSection.js": [
		433,
		9,
		567
	],
	"./pages/Solutions/FitnessSoultions/ServicesSection/ServicesSection.scss": [
		1353,
		7,
		1397
	],
	"./pages/Solutions/FitnessSoultions/SolutionsWeOffer/SolutionsWeOffer": [
		834,
		9,
		488
	],
	"./pages/Solutions/FitnessSoultions/SolutionsWeOffer/SolutionsWeOffer.js": [
		834,
		9,
		488
	],
	"./pages/Solutions/FitnessSoultions/WhyChoose/WhyChoose": [
		835,
		9,
		654
	],
	"./pages/Solutions/FitnessSoultions/WhyChoose/WhyChoose.js": [
		835,
		9,
		654
	],
	"./pages/Solutions/FitnessSoultions/WhyChooseMi/WhyChooseMi": [
		432,
		9,
		387
	],
	"./pages/Solutions/FitnessSoultions/WhyChooseMi/WhyChooseMi.js": [
		432,
		9,
		387
	],
	"./pages/Solutions/FitnessSoultions/WhyChooseMi/WhyChooseMi.scss": [
		1352,
		7,
		1398
	],
	"./pages/Solutions/FoodDeliverySolutions/AboutSection/AboutSection": [
		436,
		9,
		207
	],
	"./pages/Solutions/FoodDeliverySolutions/AboutSection/AboutSection.js": [
		436,
		9,
		207
	],
	"./pages/Solutions/FoodDeliverySolutions/AboutSection/AboutSection.scss": [
		1356,
		7,
		1399
	],
	"./pages/Solutions/FoodDeliverySolutions/AboutSectionSecondary/AboutSectionSecondary": [
		836,
		9,
		431
	],
	"./pages/Solutions/FoodDeliverySolutions/AboutSectionSecondary/AboutSectionSecondary.js": [
		836,
		9,
		431
	],
	"./pages/Solutions/FoodDeliverySolutions/BusinessGrow/BusinessGrow": [
		440,
		9,
		275
	],
	"./pages/Solutions/FoodDeliverySolutions/BusinessGrow/BusinessGrow.js": [
		440,
		9,
		275
	],
	"./pages/Solutions/FoodDeliverySolutions/BusinessGrow/BusinessGrow.scss": [
		1360,
		7,
		1400
	],
	"./pages/Solutions/FoodDeliverySolutions/Features/Features": [
		437,
		9,
		388
	],
	"./pages/Solutions/FoodDeliverySolutions/Features/Features.js": [
		437,
		9,
		388
	],
	"./pages/Solutions/FoodDeliverySolutions/Features/Features.scss": [
		1357,
		7,
		1401
	],
	"./pages/Solutions/FoodDeliverySolutions/FoodDeliverySolutions": [
		144,
		9,
		0,
		124,
		1,
		6,
		61
	],
	"./pages/Solutions/FoodDeliverySolutions/FoodDeliverySolutions.js": [
		144,
		9,
		0,
		124,
		1,
		6,
		61
	],
	"./pages/Solutions/FoodDeliverySolutions/HeroSection/HeroSection": [
		435,
		9,
		568
	],
	"./pages/Solutions/FoodDeliverySolutions/HeroSection/HeroSection.js": [
		435,
		9,
		568
	],
	"./pages/Solutions/FoodDeliverySolutions/HeroSection/HeroSection.scss": [
		1355,
		7,
		1402
	],
	"./pages/Solutions/FoodDeliverySolutions/ServicesSection/ServicesSection": [
		439,
		9,
		569
	],
	"./pages/Solutions/FoodDeliverySolutions/ServicesSection/ServicesSection.js": [
		439,
		9,
		569
	],
	"./pages/Solutions/FoodDeliverySolutions/ServicesSection/ServicesSection.scss": [
		1359,
		7,
		1403
	],
	"./pages/Solutions/FoodDeliverySolutions/SolutionsWeOffer/SolutionsWeOffer": [
		837,
		9,
		479
	],
	"./pages/Solutions/FoodDeliverySolutions/SolutionsWeOffer/SolutionsWeOffer.js": [
		837,
		9,
		479
	],
	"./pages/Solutions/FoodDeliverySolutions/WhyChoose/WhyChoose": [
		838,
		9,
		655
	],
	"./pages/Solutions/FoodDeliverySolutions/WhyChoose/WhyChoose.js": [
		838,
		9,
		655
	],
	"./pages/Solutions/FoodDeliverySolutions/WhyChooseMi/WhyChooseMi": [
		438,
		9,
		389
	],
	"./pages/Solutions/FoodDeliverySolutions/WhyChooseMi/WhyChooseMi.js": [
		438,
		9,
		389
	],
	"./pages/Solutions/FoodDeliverySolutions/WhyChooseMi/WhyChooseMi.scss": [
		1358,
		7,
		1404
	],
	"./pages/Solutions/FoodDeliverySolutions/img/banking.svg": [
		3374,
		9,
		2767
	],
	"./pages/Solutions/FoodDeliverySolutions/img/finance.svg": [
		3375,
		9,
		2768
	],
	"./pages/Solutions/FoodDeliverySolutions/img/payment.svg": [
		3376,
		9,
		2769
	],
	"./pages/Solutions/FoodDeliverySolutions/img/wallet-app.svg": [
		3377,
		9,
		2770
	],
	"./pages/Solutions/HealthCareSoultions.zip": [
		3378,
		9,
		2771
	],
	"./pages/Solutions/HealthCareSoultions/AboutSection/AboutSection": [
		426,
		9,
		208
	],
	"./pages/Solutions/HealthCareSoultions/AboutSection/AboutSection.js": [
		426,
		9,
		208
	],
	"./pages/Solutions/HealthCareSoultions/AboutSection/AboutSection.scss": [
		1346,
		7,
		1405
	],
	"./pages/Solutions/HealthCareSoultions/AboutSectionSecondary/AboutSectionSecondary": [
		839,
		9,
		625
	],
	"./pages/Solutions/HealthCareSoultions/AboutSectionSecondary/AboutSectionSecondary.js": [
		839,
		9,
		625
	],
	"./pages/Solutions/HealthCareSoultions/HealthCareSoultions": [
		142,
		9,
		0,
		122,
		1,
		6,
		69
	],
	"./pages/Solutions/HealthCareSoultions/HealthCareSoultions.js": [
		142,
		9,
		0,
		122,
		1,
		6,
		69
	],
	"./pages/Solutions/HealthCareSoultions/HeroSection/HeroSection": [
		425,
		9,
		570
	],
	"./pages/Solutions/HealthCareSoultions/HeroSection/HeroSection.js": [
		425,
		9,
		570
	],
	"./pages/Solutions/HealthCareSoultions/HeroSection/HeroSection.scss": [
		1345,
		7,
		1406
	],
	"./pages/Solutions/HealthCareSoultions/ServicesSection/ServicesSection": [
		427,
		9,
		571
	],
	"./pages/Solutions/HealthCareSoultions/ServicesSection/ServicesSection.js": [
		427,
		9,
		571
	],
	"./pages/Solutions/HealthCareSoultions/ServicesSection/ServicesSection.scss": [
		1347,
		7,
		1407
	],
	"./pages/Solutions/HealthCareSoultions/SolutionsWeOffer/SolutionsWeOffer": [
		840,
		9,
		489
	],
	"./pages/Solutions/HealthCareSoultions/SolutionsWeOffer/SolutionsWeOffer.js": [
		840,
		9,
		489
	],
	"./pages/Solutions/HealthCareSoultions/WhyChoose/WhyChoose": [
		841,
		9,
		656
	],
	"./pages/Solutions/HealthCareSoultions/WhyChoose/WhyChoose.js": [
		841,
		9,
		656
	],
	"./pages/Solutions/HealthCareSoultions/WhyChooseMi/WhyChooseMi": [
		428,
		9,
		390
	],
	"./pages/Solutions/HealthCareSoultions/WhyChooseMi/WhyChooseMi.js": [
		428,
		9,
		390
	],
	"./pages/Solutions/HealthCareSoultions/WhyChooseMi/WhyChooseMi.scss": [
		1348,
		7,
		1408
	],
	"./pages/Solutions/OnDemandAppDev/AboutSection/AboutSection": [
		448,
		9,
		209
	],
	"./pages/Solutions/OnDemandAppDev/AboutSection/AboutSection.js": [
		448,
		9,
		209
	],
	"./pages/Solutions/OnDemandAppDev/AboutSection/AboutSection.scss": [
		1375,
		7,
		1409
	],
	"./pages/Solutions/OnDemandAppDev/Features/Features": [
		451,
		9,
		391
	],
	"./pages/Solutions/OnDemandAppDev/Features/Features.js": [
		451,
		9,
		391
	],
	"./pages/Solutions/OnDemandAppDev/Features/Features.scss": [
		1378,
		7,
		1410
	],
	"./pages/Solutions/OnDemandAppDev/HeroSection/HeroSection": [
		447,
		9,
		572
	],
	"./pages/Solutions/OnDemandAppDev/HeroSection/HeroSection.js": [
		447,
		9,
		572
	],
	"./pages/Solutions/OnDemandAppDev/HeroSection/HeroSection.scss": [
		1374,
		7,
		1411
	],
	"./pages/Solutions/OnDemandAppDev/OnDemandAppDev": [
		146,
		9,
		0,
		126,
		1,
		6,
		63
	],
	"./pages/Solutions/OnDemandAppDev/OnDemandAppDev.js": [
		146,
		9,
		0,
		126,
		1,
		6,
		63
	],
	"./pages/Solutions/OnDemandAppDev/Services/Services": [
		842,
		9,
		619
	],
	"./pages/Solutions/OnDemandAppDev/Services/Services.js": [
		842,
		9,
		619
	],
	"./pages/Solutions/OnDemandAppDev/Services/Services.scss": [
		2032,
		7,
		1412
	],
	"./pages/Solutions/OnDemandAppDev/ServicesSection/ServicesSection": [
		449,
		9,
		573
	],
	"./pages/Solutions/OnDemandAppDev/ServicesSection/ServicesSection.js": [
		449,
		9,
		573
	],
	"./pages/Solutions/OnDemandAppDev/ServicesSection/ServicesSection.scss": [
		1376,
		7,
		1413
	],
	"./pages/Solutions/OnDemandAppDev/WhyChooseMi/WhyChooseMi": [
		450,
		9,
		392
	],
	"./pages/Solutions/OnDemandAppDev/WhyChooseMi/WhyChooseMi.js": [
		450,
		9,
		392
	],
	"./pages/Solutions/OnDemandAppDev/WhyChooseMi/WhyChooseMi.scss": [
		1377,
		7,
		1414
	],
	"./pages/Solutions/OnDemandAppDev/img/banking.svg": [
		3379,
		9,
		2772
	],
	"./pages/Solutions/OnDemandAppDev/img/finance.svg": [
		3380,
		9,
		2773
	],
	"./pages/Solutions/OnDemandAppDev/img/payment.svg": [
		3381,
		9,
		2774
	],
	"./pages/Solutions/OnDemandAppDev/img/wallet-app.svg": [
		3382,
		9,
		2775
	],
	"./pages/Solutions/ProductEngineeringServices/AboutSection/AboutSection": [
		398,
		9,
		188
	],
	"./pages/Solutions/ProductEngineeringServices/AboutSection/AboutSection.js": [
		398,
		9,
		188
	],
	"./pages/Solutions/ProductEngineeringServices/AboutSection/AboutSection.scss": [
		1314,
		7,
		1415
	],
	"./pages/Solutions/ProductEngineeringServices/HeroSection/HeroSection": [
		397,
		9,
		460
	],
	"./pages/Solutions/ProductEngineeringServices/HeroSection/HeroSection.js": [
		397,
		9,
		460
	],
	"./pages/Solutions/ProductEngineeringServices/HeroSection/HeroSection.scss": [
		1313,
		7,
		1416
	],
	"./pages/Solutions/ProductEngineeringServices/LookingDevelopers/LookingDevelopers.scss": [
		3383,
		7,
		1417
	],
	"./pages/Solutions/ProductEngineeringServices/LookingOtherServices/LookingOtherServices.scss": [
		3384,
		7,
		1418
	],
	"./pages/Solutions/ProductEngineeringServices/ProductEngineeringServices": [
		136,
		9,
		0,
		116,
		1,
		2,
		58
	],
	"./pages/Solutions/ProductEngineeringServices/ProductEngineeringServices.js": [
		136,
		9,
		0,
		116,
		1,
		2,
		58
	],
	"./pages/Solutions/ProductEngineeringServices/ServicesSection/ServicesSection": [
		399,
		9,
		574
	],
	"./pages/Solutions/ProductEngineeringServices/ServicesSection/ServicesSection.js": [
		399,
		9,
		574
	],
	"./pages/Solutions/ProductEngineeringServices/ServicesSection/ServicesSection.scss": [
		1315,
		7,
		1419
	],
	"./pages/Solutions/ProductEngineeringServices/WhyChooseMi/WhyChooseMi": [
		400,
		9,
		393
	],
	"./pages/Solutions/ProductEngineeringServices/WhyChooseMi/WhyChooseMi.js": [
		400,
		9,
		393
	],
	"./pages/Solutions/ProductEngineeringServices/WhyChooseMi/WhyChooseMi.scss": [
		1316,
		7,
		1420
	],
	"./pages/Solutions/QAServices/AboutSection/AboutSection": [
		562,
		9,
		394
	],
	"./pages/Solutions/QAServices/AboutSection/AboutSection.js": [
		562,
		9,
		394
	],
	"./pages/Solutions/QAServices/AboutSection/AboutSection.scss": [
		1476,
		7,
		1421
	],
	"./pages/Solutions/QAServices/HeroSection/HeroSection": [
		563,
		9,
		213
	],
	"./pages/Solutions/QAServices/HeroSection/HeroSection.js": [
		563,
		9,
		213
	],
	"./pages/Solutions/QAServices/HeroSection/HeroSection.scss": [
		1477,
		7,
		1422
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/appium.svg": [
		1482,
		9,
		2776
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/browserstack.svg": [
		3385,
		9,
		2777
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/git.svg": [
		1479,
		9,
		2778
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/jira.svg": [
		1478,
		9,
		2779
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/microsoft-azure.svg": [
		3386,
		9,
		2780
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/postman.svg": [
		1480,
		9,
		2781
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/redmine.svg": [
		1481,
		9,
		2782
	],
	"./pages/Solutions/QAServices/HeroSection/imgs/selenium.svg": [
		1483,
		9,
		2783
	],
	"./pages/Solutions/QAServices/LookingDevelopers/LookingDevelopers.scss": [
		3387,
		7,
		1423
	],
	"./pages/Solutions/QAServices/NewOpenSourceLibraries/NewOpenSourceLibraries": [
		843,
		9,
		195
	],
	"./pages/Solutions/QAServices/NewOpenSourceLibraries/NewOpenSourceLibraries.js": [
		843,
		9,
		195
	],
	"./pages/Solutions/QAServices/NewOpenSourceLibraries/NewOpenSourceLibraries.scss": [
		2033,
		7,
		1424
	],
	"./pages/Solutions/QAServices/OurRecentWork/OurRecentWork": [
		844,
		9,
		296
	],
	"./pages/Solutions/QAServices/OurRecentWork/OurRecentWork.js": [
		844,
		9,
		296
	],
	"./pages/Solutions/QAServices/OurRecentWork/OurRecentWork.scss": [
		2034,
		7,
		1425
	],
	"./pages/Solutions/QAServices/QAServices": [
		171,
		9,
		0,
		1,
		2,
		62
	],
	"./pages/Solutions/QAServices/QAServices.js": [
		171,
		9,
		0,
		1,
		2,
		62
	],
	"./pages/Solutions/QAServices/ServicesSection/ServicesSection": [
		564,
		9,
		575
	],
	"./pages/Solutions/QAServices/ServicesSection/ServicesSection.js": [
		564,
		9,
		575
	],
	"./pages/Solutions/QAServices/ServicesSection/ServicesSection.scss": [
		1484,
		7,
		1426
	],
	"./pages/Solutions/QAServices/WhatWeProvide/WhatWeProvide": [
		845,
		9,
		480
	],
	"./pages/Solutions/QAServices/WhatWeProvide/WhatWeProvide.js": [
		845,
		9,
		480
	],
	"./pages/Solutions/QAServices/WhatWeProvide/WhatWeProvide.scss": [
		3388,
		7,
		1427
	],
	"./pages/Solutions/QAServices/WhyChoose/WhyChoose": [
		846,
		9,
		423
	],
	"./pages/Solutions/QAServices/WhyChoose/WhyChoose.js": [
		846,
		9,
		423
	],
	"./pages/Solutions/QAServices/WhyChooseMi/WhyChooseMi": [
		565,
		9,
		395
	],
	"./pages/Solutions/QAServices/WhyChooseMi/WhyChooseMi.js": [
		565,
		9,
		395
	],
	"./pages/Solutions/QAServices/WhyChooseMi/WhyChooseMi.scss": [
		1485,
		7,
		1428
	],
	"./pages/Solutions/QAServices/WhyChooseSection/WhyChooseSection": [
		566,
		9,
		608
	],
	"./pages/Solutions/QAServices/WhyChooseSection/WhyChooseSection.js": [
		566,
		9,
		608
	],
	"./pages/Solutions/QAServices/WhyChooseSection/WhyChooseSection.scss": [
		1486,
		7,
		1429
	],
	"./pages/Solutions/RealEstateAppDevelopment/AboutSection/AboutSection": [
		453,
		9,
		192
	],
	"./pages/Solutions/RealEstateAppDevelopment/AboutSection/AboutSection.js": [
		453,
		9,
		192
	],
	"./pages/Solutions/RealEstateAppDevelopment/Features/Features": [
		455,
		9,
		424
	],
	"./pages/Solutions/RealEstateAppDevelopment/Features/Features.js": [
		455,
		9,
		424
	],
	"./pages/Solutions/RealEstateAppDevelopment/HeroSection/HeroSection": [
		452,
		9,
		609
	],
	"./pages/Solutions/RealEstateAppDevelopment/HeroSection/HeroSection.js": [
		452,
		9,
		609
	],
	"./pages/Solutions/RealEstateAppDevelopment/HeroSection/HeroSection.scss": [
		1379,
		7,
		1430
	],
	"./pages/Solutions/RealEstateAppDevelopment/RealEstateAppDevelopment": [
		147,
		9,
		0,
		1,
		74
	],
	"./pages/Solutions/RealEstateAppDevelopment/RealEstateAppDevelopment.js": [
		147,
		9,
		0,
		1,
		74
	],
	"./pages/Solutions/RealEstateAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		454,
		9,
		490
	],
	"./pages/Solutions/RealEstateAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		454,
		9,
		490
	],
	"./pages/Solutions/RealEstateAppDevelopment/WhyChoose/WhyChoose": [
		456,
		9,
		657
	],
	"./pages/Solutions/RealEstateAppDevelopment/WhyChoose/WhyChoose.js": [
		456,
		9,
		657
	],
	"./pages/Solutions/SocialMediaAppDevelopment/AboutSection/AboutSection": [
		468,
		9,
		200
	],
	"./pages/Solutions/SocialMediaAppDevelopment/AboutSection/AboutSection.js": [
		468,
		9,
		200
	],
	"./pages/Solutions/SocialMediaAppDevelopment/Features/Features": [
		470,
		9,
		425
	],
	"./pages/Solutions/SocialMediaAppDevelopment/Features/Features.js": [
		470,
		9,
		425
	],
	"./pages/Solutions/SocialMediaAppDevelopment/HeroSection/HeroSection": [
		467,
		9,
		576
	],
	"./pages/Solutions/SocialMediaAppDevelopment/HeroSection/HeroSection.js": [
		467,
		9,
		576
	],
	"./pages/Solutions/SocialMediaAppDevelopment/HeroSection/HeroSection.scss": [
		1382,
		7,
		1431
	],
	"./pages/Solutions/SocialMediaAppDevelopment/SocialMediaAppDevelopment": [
		150,
		9,
		0,
		1,
		75
	],
	"./pages/Solutions/SocialMediaAppDevelopment/SocialMediaAppDevelopment.js": [
		150,
		9,
		0,
		1,
		75
	],
	"./pages/Solutions/SocialMediaAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		469,
		9,
		481
	],
	"./pages/Solutions/SocialMediaAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		469,
		9,
		481
	],
	"./pages/Solutions/SocialMediaAppDevelopment/WhyChoose/WhyChoose": [
		471,
		9,
		658
	],
	"./pages/Solutions/SocialMediaAppDevelopment/WhyChoose/WhyChoose.js": [
		471,
		9,
		658
	],
	"./pages/Solutions/SportsAppDevelopment/AboutSection/AboutSection": [
		463,
		9,
		201
	],
	"./pages/Solutions/SportsAppDevelopment/AboutSection/AboutSection.js": [
		463,
		9,
		201
	],
	"./pages/Solutions/SportsAppDevelopment/Features/Features": [
		465,
		9,
		426
	],
	"./pages/Solutions/SportsAppDevelopment/Features/Features.js": [
		465,
		9,
		426
	],
	"./pages/Solutions/SportsAppDevelopment/HeroSection/HeroSection": [
		462,
		9,
		577
	],
	"./pages/Solutions/SportsAppDevelopment/HeroSection/HeroSection.js": [
		462,
		9,
		577
	],
	"./pages/Solutions/SportsAppDevelopment/HeroSection/HeroSection.scss": [
		1381,
		7,
		1432
	],
	"./pages/Solutions/SportsAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		464,
		9,
		427
	],
	"./pages/Solutions/SportsAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		464,
		9,
		427
	],
	"./pages/Solutions/SportsAppDevelopment/SportsAppDevelopment": [
		149,
		9,
		0,
		1,
		76
	],
	"./pages/Solutions/SportsAppDevelopment/SportsAppDevelopment.js": [
		149,
		9,
		0,
		1,
		76
	],
	"./pages/Solutions/SportsAppDevelopment/WhyChoose/WhyChoose": [
		466,
		9,
		659
	],
	"./pages/Solutions/SportsAppDevelopment/WhyChoose/WhyChoose.js": [
		466,
		9,
		659
	],
	"./pages/Solutions/StartupsAppDev/AboutSection/AboutSection": [
		402,
		9,
		189
	],
	"./pages/Solutions/StartupsAppDev/AboutSection/AboutSection.js": [
		402,
		9,
		189
	],
	"./pages/Solutions/StartupsAppDev/AboutSection/AboutSection.scss": [
		1318,
		7,
		1433
	],
	"./pages/Solutions/StartupsAppDev/Approach/Approach": [
		847,
		9,
		660
	],
	"./pages/Solutions/StartupsAppDev/Approach/Approach.js": [
		847,
		9,
		660
	],
	"./pages/Solutions/StartupsAppDev/HeroSection/HeroSection": [
		401,
		9,
		461
	],
	"./pages/Solutions/StartupsAppDev/HeroSection/HeroSection.js": [
		401,
		9,
		461
	],
	"./pages/Solutions/StartupsAppDev/HeroSection/HeroSection.scss": [
		1317,
		7,
		1434
	],
	"./pages/Solutions/StartupsAppDev/LookingDevelopers/LookingDevelopers.scss": [
		3389,
		7,
		1435
	],
	"./pages/Solutions/StartupsAppDev/LookingOtherServices/LookingOtherServices.scss": [
		3390,
		7,
		1436
	],
	"./pages/Solutions/StartupsAppDev/ServicesSection/ServicesSection": [
		403,
		9,
		578
	],
	"./pages/Solutions/StartupsAppDev/ServicesSection/ServicesSection.js": [
		403,
		9,
		578
	],
	"./pages/Solutions/StartupsAppDev/ServicesSection/ServicesSection.scss": [
		1319,
		7,
		1437
	],
	"./pages/Solutions/StartupsAppDev/StartupsAppDev": [
		137,
		9,
		0,
		117,
		1,
		2,
		59
	],
	"./pages/Solutions/StartupsAppDev/StartupsAppDev.js": [
		137,
		9,
		0,
		117,
		1,
		2,
		59
	],
	"./pages/Solutions/StartupsAppDev/TechnologiesSection/TechnologiesSection": [
		848,
		9,
		661
	],
	"./pages/Solutions/StartupsAppDev/TechnologiesSection/TechnologiesSection.js": [
		848,
		9,
		661
	],
	"./pages/Solutions/StartupsAppDev/WhyChooseMi/WhyChooseMi": [
		404,
		9,
		396
	],
	"./pages/Solutions/StartupsAppDev/WhyChooseMi/WhyChooseMi.js": [
		404,
		9,
		396
	],
	"./pages/Solutions/StartupsAppDev/WhyChooseMi/WhyChooseMi.scss": [
		1320,
		7,
		1438
	],
	"./pages/Solutions/StartupsAppDev/WhyChooseSection/WhyChooseSection": [
		405,
		9,
		610
	],
	"./pages/Solutions/StartupsAppDev/WhyChooseSection/WhyChooseSection.js": [
		405,
		9,
		610
	],
	"./pages/Solutions/StartupsAppDev/WhyChooseSection/WhyChooseSection.scss": [
		1321,
		7,
		1439
	],
	"./pages/Solutions/TravelAppDevelopment/AboutSection/AboutSection": [
		458,
		9,
		202
	],
	"./pages/Solutions/TravelAppDevelopment/AboutSection/AboutSection.js": [
		458,
		9,
		202
	],
	"./pages/Solutions/TravelAppDevelopment/Features/Features": [
		460,
		9,
		428
	],
	"./pages/Solutions/TravelAppDevelopment/Features/Features.js": [
		460,
		9,
		428
	],
	"./pages/Solutions/TravelAppDevelopment/HeroSection/HeroSection": [
		457,
		9,
		579
	],
	"./pages/Solutions/TravelAppDevelopment/HeroSection/HeroSection.js": [
		457,
		9,
		579
	],
	"./pages/Solutions/TravelAppDevelopment/HeroSection/HeroSection.scss": [
		1380,
		7,
		1440
	],
	"./pages/Solutions/TravelAppDevelopment/SolutionsWeProvide/SolutionsWeProvide": [
		459,
		9,
		429
	],
	"./pages/Solutions/TravelAppDevelopment/SolutionsWeProvide/SolutionsWeProvide.js": [
		459,
		9,
		429
	],
	"./pages/Solutions/TravelAppDevelopment/TravelAppDevelopment": [
		148,
		9,
		0,
		1,
		77
	],
	"./pages/Solutions/TravelAppDevelopment/TravelAppDevelopment.js": [
		148,
		9,
		0,
		1,
		77
	],
	"./pages/Solutions/TravelAppDevelopment/WhyChoose/WhyChoose": [
		461,
		9,
		662
	],
	"./pages/Solutions/TravelAppDevelopment/WhyChoose/WhyChoose.js": [
		461,
		9,
		662
	],
	"./pages/SuccessStories/AbWorkoutStory/AbWorkoutStory": [
		849,
		9,
		0,
		3,
		1,
		8,
		168
	],
	"./pages/SuccessStories/AbWorkoutStory/AbWorkoutStory.js": [
		849,
		9,
		0,
		3,
		1,
		8,
		168
	],
	"./pages/SuccessStories/AbWorkoutStory/AbWorkoutStory.scss": [
		2035,
		7,
		1441
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/Poppins-Bold.ttf": [
		3391,
		9,
		2784
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/Poppins-Light.ttf": [
		3392,
		9,
		2785
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/Poppins-Medium.ttf": [
		3393,
		9,
		2786
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/Poppins-Regular.ttf": [
		3394,
		9,
		2787
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/Poppins-SemiBold.ttf": [
		3395,
		9,
		2788
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/Poppins-Thin.ttf": [
		3396,
		9,
		2789
	],
	"./pages/SuccessStories/AbWorkoutStory/fonts/stylesheet.css": [
		3397,
		7,
		858
	],
	"./pages/SuccessStories/AbWorkoutStory/images/6pp-Tim-De-Jardine.jpeg": [
		2046,
		9,
		3370
	],
	"./pages/SuccessStories/AbWorkoutStory/images/ab-challenges.png": [
		2041,
		9,
		3371
	],
	"./pages/SuccessStories/AbWorkoutStory/images/ab-features.png": [
		2043,
		9,
		3372
	],
	"./pages/SuccessStories/AbWorkoutStory/images/ab-outcome.png": [
		2045,
		9,
		3373
	],
	"./pages/SuccessStories/AbWorkoutStory/images/ab-product.png": [
		2042,
		9,
		3374
	],
	"./pages/SuccessStories/AbWorkoutStory/images/ab-splash.png": [
		2036,
		9,
		3375
	],
	"./pages/SuccessStories/AbWorkoutStory/images/app-store.svg": [
		2037,
		9,
		2790
	],
	"./pages/SuccessStories/AbWorkoutStory/images/banner-bg.png": [
		3398,
		9,
		3376
	],
	"./pages/SuccessStories/AbWorkoutStory/images/banner-bg.svg": [
		3399,
		9,
		2791
	],
	"./pages/SuccessStories/AbWorkoutStory/images/client.png": [
		3400,
		9,
		3377
	],
	"./pages/SuccessStories/AbWorkoutStory/images/downloads.svg": [
		2040,
		9,
		2792
	],
	"./pages/SuccessStories/AbWorkoutStory/images/kotlin.png": [
		3401,
		9,
		3378
	],
	"./pages/SuccessStories/AbWorkoutStory/images/play-store.svg": [
		2038,
		9,
		2793
	],
	"./pages/SuccessStories/AbWorkoutStory/images/projectA.png": [
		3402,
		9,
		3379
	],
	"./pages/SuccessStories/AbWorkoutStory/images/projectB.png": [
		3403,
		9,
		3380
	],
	"./pages/SuccessStories/AbWorkoutStory/images/projectC.png": [
		3404,
		9,
		3381
	],
	"./pages/SuccessStories/AbWorkoutStory/images/purplestar.svg": [
		2039,
		9,
		2794
	],
	"./pages/SuccessStories/AbWorkoutStory/images/sqlite.svg": [
		3405,
		9,
		2795
	],
	"./pages/SuccessStories/AbWorkoutStory/images/swift.png": [
		3406,
		9,
		3382
	],
	"./pages/SuccessStories/AbWorkoutStory/images/tech-bg.svg": [
		3407,
		9,
		2796
	],
	"./pages/SuccessStories/AbWorkoutStory/images/testimonial.png": [
		3408,
		9,
		3383
	],
	"./pages/SuccessStories/AbWorkoutStory/images/tick.svg": [
		2044,
		9,
		2797
	],
	"./pages/SuccessStories/BhojStory/BhojStory": [
		850,
		9,
		0,
		3,
		1,
		8,
		157
	],
	"./pages/SuccessStories/BhojStory/BhojStory.js": [
		850,
		9,
		0,
		3,
		1,
		8,
		157
	],
	"./pages/SuccessStories/BhojStory/BhojStory.scss": [
		2048,
		7,
		1442
	],
	"./pages/SuccessStories/BhojStory/fonts/Poppins-Bold.ttf": [
		3409,
		9,
		2798
	],
	"./pages/SuccessStories/BhojStory/fonts/Poppins-Light.ttf": [
		3410,
		9,
		2799
	],
	"./pages/SuccessStories/BhojStory/fonts/Poppins-Medium.ttf": [
		3411,
		9,
		2800
	],
	"./pages/SuccessStories/BhojStory/fonts/Poppins-Regular.ttf": [
		3412,
		9,
		2801
	],
	"./pages/SuccessStories/BhojStory/fonts/Poppins-SemiBold.ttf": [
		3413,
		9,
		2802
	],
	"./pages/SuccessStories/BhojStory/fonts/Poppins-Thin.ttf": [
		3414,
		9,
		2803
	],
	"./pages/SuccessStories/BhojStory/fonts/stylesheet.css": [
		3415,
		7,
		859
	],
	"./pages/SuccessStories/BhojStory/images/AppStore.svg": [
		2051,
		9,
		2804
	],
	"./pages/SuccessStories/BhojStory/images/BhojDeals(Rahul-Bajaj).jpg": [
		2062,
		9,
		3384
	],
	"./pages/SuccessStories/BhojStory/images/PlayStore.svg": [
		2052,
		9,
		2805
	],
	"./pages/SuccessStories/BhojStory/images/app-store.svg": [
		2049,
		9,
		2806
	],
	"./pages/SuccessStories/BhojStory/images/banner-bg.png": [
		3416,
		9,
		3385
	],
	"./pages/SuccessStories/BhojStory/images/banner-bg.svg": [
		3417,
		9,
		2807
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-challenges.png": [
		2057,
		9,
		3386
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-features.png": [
		2058,
		9,
		3387
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-laptop.png": [
		2060,
		9,
		3388
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-product.png": [
		3418,
		9,
		3389
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-splash.png": [
		2056,
		9,
		3390
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-tech-bg.svg": [
		3419,
		9,
		2808
	],
	"./pages/SuccessStories/BhojStory/images/bhoj-tech.svg": [
		3420,
		9,
		2809
	],
	"./pages/SuccessStories/BhojStory/images/bhoj.mp4": [
		2061,
		9,
		2810
	],
	"./pages/SuccessStories/BhojStory/images/client.png": [
		3421,
		9,
		3391
	],
	"./pages/SuccessStories/BhojStory/images/hike.svg": [
		2055,
		9,
		2811
	],
	"./pages/SuccessStories/BhojStory/images/kotlin.png": [
		3422,
		9,
		3392
	],
	"./pages/SuccessStories/BhojStory/images/laravel.svg": [
		3423,
		9,
		2812
	],
	"./pages/SuccessStories/BhojStory/images/mysql.svg": [
		3424,
		9,
		2813
	],
	"./pages/SuccessStories/BhojStory/images/play-store.svg": [
		2050,
		9,
		2814
	],
	"./pages/SuccessStories/BhojStory/images/projectA.png": [
		3425,
		9,
		3393
	],
	"./pages/SuccessStories/BhojStory/images/projectB.png": [
		3426,
		9,
		3394
	],
	"./pages/SuccessStories/BhojStory/images/projectC.png": [
		3427,
		9,
		3395
	],
	"./pages/SuccessStories/BhojStory/images/restaurants.svg": [
		2053,
		9,
		2815
	],
	"./pages/SuccessStories/BhojStory/images/swift.png": [
		3428,
		9,
		3396
	],
	"./pages/SuccessStories/BhojStory/images/team.svg": [
		2054,
		9,
		2816
	],
	"./pages/SuccessStories/BhojStory/images/testimonial.png": [
		3429,
		9,
		3397
	],
	"./pages/SuccessStories/BhojStory/images/tick.svg": [
		2059,
		9,
		2817
	],
	"./pages/SuccessStories/BhojStory/images/vuejs.svg": [
		3430,
		9,
		2818
	],
	"./pages/SuccessStories/EneaaAppStory/EnneAppStory.scss": [
		2064,
		7,
		1443
	],
	"./pages/SuccessStories/EneaaAppStory/EnneaAppStory": [
		851,
		9,
		0,
		3,
		1,
		8,
		165
	],
	"./pages/SuccessStories/EneaaAppStory/EnneaAppStory.js": [
		851,
		9,
		0,
		3,
		1,
		8,
		165
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/Poppins-Bold.ttf": [
		3431,
		9,
		2819
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/Poppins-Light.ttf": [
		3432,
		9,
		2820
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/Poppins-Medium.ttf": [
		3433,
		9,
		2821
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/Poppins-Regular.ttf": [
		3434,
		9,
		2822
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/Poppins-SemiBold.ttf": [
		3435,
		9,
		2823
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/Poppins-Thin.ttf": [
		3436,
		9,
		2824
	],
	"./pages/SuccessStories/EneaaAppStory/fonts/stylesheet.css": [
		3437,
		7,
		860
	],
	"./pages/SuccessStories/EneaaAppStory/images/android.svg": [
		2070,
		9,
		2825
	],
	"./pages/SuccessStories/EneaaAppStory/images/app-store.svg": [
		2066,
		9,
		2826
	],
	"./pages/SuccessStories/EneaaAppStory/images/banner-bg.svg": [
		3438,
		9,
		2827
	],
	"./pages/SuccessStories/EneaaAppStory/images/client.png": [
		3439,
		9,
		3398
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-challenges.png": [
		2072,
		9,
		3399
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-feature.png": [
		2074,
		9,
		3400
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-outcome.png": [
		2076,
		9,
		3401
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-product.png": [
		2073,
		9,
		3402
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-splash.png": [
		2065,
		9,
		3403
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-tech-bg.png": [
		3440,
		9,
		3404
	],
	"./pages/SuccessStories/EneaaAppStory/images/ennea-tech-bg.svg": [
		3441,
		9,
		2828
	],
	"./pages/SuccessStories/EneaaAppStory/images/enneaApp(Elan-BenAmi).jpeg": [
		2077,
		9,
		3405
	],
	"./pages/SuccessStories/EneaaAppStory/images/enneaapp.mp4": [
		2078,
		9,
		2829
	],
	"./pages/SuccessStories/EneaaAppStory/images/ipad.svg": [
		2068,
		9,
		2830
	],
	"./pages/SuccessStories/EneaaAppStory/images/iphone.svg": [
		2069,
		9,
		2831
	],
	"./pages/SuccessStories/EneaaAppStory/images/ipod.svg": [
		2071,
		9,
		2832
	],
	"./pages/SuccessStories/EneaaAppStory/images/kotlin.png": [
		3442,
		9,
		3406
	],
	"./pages/SuccessStories/EneaaAppStory/images/laravel.svg": [
		3443,
		9,
		2833
	],
	"./pages/SuccessStories/EneaaAppStory/images/play-store.svg": [
		2067,
		9,
		2834
	],
	"./pages/SuccessStories/EneaaAppStory/images/projectA.png": [
		3444,
		9,
		3407
	],
	"./pages/SuccessStories/EneaaAppStory/images/projectB.png": [
		3445,
		9,
		3408
	],
	"./pages/SuccessStories/EneaaAppStory/images/projectC.png": [
		3446,
		9,
		3409
	],
	"./pages/SuccessStories/EneaaAppStory/images/swift.png": [
		3447,
		9,
		3410
	],
	"./pages/SuccessStories/EneaaAppStory/images/testimonial.png": [
		3448,
		9,
		3411
	],
	"./pages/SuccessStories/EneaaAppStory/images/tick.svg": [
		2075,
		9,
		2835
	],
	"./pages/SuccessStories/PangeaPodStory/PangeaPodStory": [
		852,
		9,
		3,
		8,
		170
	],
	"./pages/SuccessStories/PangeaPodStory/PangeaPodStory.js": [
		852,
		9,
		3,
		8,
		170
	],
	"./pages/SuccessStories/PangeaPodStory/PangeaPodStory.scss": [
		2079,
		7,
		1444
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/Poppins-Bold.ttf": [
		3449,
		9,
		2836
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/Poppins-Light.ttf": [
		3450,
		9,
		2837
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/Poppins-Medium.ttf": [
		3451,
		9,
		2838
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/Poppins-Regular.ttf": [
		3452,
		9,
		2839
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/Poppins-SemiBold.ttf": [
		3453,
		9,
		2840
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/Poppins-Thin.ttf": [
		3454,
		9,
		2841
	],
	"./pages/SuccessStories/PangeaPodStory/fonts/stylesheet.css": [
		3455,
		7,
		861
	],
	"./pages/SuccessStories/PangeaPodStory/images/app-store.svg": [
		2081,
		9,
		2842
	],
	"./pages/SuccessStories/PangeaPodStory/images/banner-bg.svg": [
		3456,
		9,
		2843
	],
	"./pages/SuccessStories/PangeaPodStory/images/client.png": [
		2089,
		9,
		3412
	],
	"./pages/SuccessStories/PangeaPodStory/images/guest.svg": [
		2083,
		9,
		2844
	],
	"./pages/SuccessStories/PangeaPodStory/images/laravel.svg": [
		3457,
		9,
		2845
	],
	"./pages/SuccessStories/PangeaPodStory/images/pangea-challenges.png": [
		2084,
		9,
		3413
	],
	"./pages/SuccessStories/PangeaPodStory/images/pangea-features.png": [
		2086,
		9,
		3414
	],
	"./pages/SuccessStories/PangeaPodStory/images/pangea-outcome.png": [
		2088,
		9,
		3415
	],
	"./pages/SuccessStories/PangeaPodStory/images/pangea-product.png": [
		2085,
		9,
		3416
	],
	"./pages/SuccessStories/PangeaPodStory/images/pangea-splash.png": [
		2080,
		9,
		3417
	],
	"./pages/SuccessStories/PangeaPodStory/images/play-store.svg": [
		2082,
		9,
		2846
	],
	"./pages/SuccessStories/PangeaPodStory/images/projectA.png": [
		3458,
		9,
		3418
	],
	"./pages/SuccessStories/PangeaPodStory/images/projectB.png": [
		3459,
		9,
		3419
	],
	"./pages/SuccessStories/PangeaPodStory/images/projectC.png": [
		3460,
		9,
		3420
	],
	"./pages/SuccessStories/PangeaPodStory/images/swift.png": [
		3461,
		9,
		3421
	],
	"./pages/SuccessStories/PangeaPodStory/images/tech-bg.svg": [
		3462,
		9,
		2847
	],
	"./pages/SuccessStories/PangeaPodStory/images/testimonial.png": [
		2090,
		9,
		3422
	],
	"./pages/SuccessStories/PangeaPodStory/images/tick.svg": [
		2087,
		9,
		2848
	],
	"./pages/SuccessStories/PigiStory/PigiStory": [
		853,
		9,
		0,
		3,
		1,
		8,
		158
	],
	"./pages/SuccessStories/PigiStory/PigiStory.js": [
		853,
		9,
		0,
		3,
		1,
		8,
		158
	],
	"./pages/SuccessStories/PigiStory/PigiStory.scss": [
		2091,
		7,
		1445
	],
	"./pages/SuccessStories/PigiStory/fonts/Poppins-Bold.ttf": [
		3463,
		9,
		2849
	],
	"./pages/SuccessStories/PigiStory/fonts/Poppins-Light.ttf": [
		3464,
		9,
		2850
	],
	"./pages/SuccessStories/PigiStory/fonts/Poppins-Medium.ttf": [
		3465,
		9,
		2851
	],
	"./pages/SuccessStories/PigiStory/fonts/Poppins-Regular.ttf": [
		3466,
		9,
		2852
	],
	"./pages/SuccessStories/PigiStory/fonts/Poppins-SemiBold.ttf": [
		3467,
		9,
		2853
	],
	"./pages/SuccessStories/PigiStory/fonts/Poppins-Thin.ttf": [
		3468,
		9,
		2854
	],
	"./pages/SuccessStories/PigiStory/fonts/stylesheet.css": [
		3469,
		7,
		862
	],
	"./pages/SuccessStories/PigiStory/images/Pigi(Aashil-Garg).jpg": [
		2104,
		9,
		3423
	],
	"./pages/SuccessStories/PigiStory/images/angular.svg": [
		3470,
		9,
		2855
	],
	"./pages/SuccessStories/PigiStory/images/app-store.svg": [
		2093,
		9,
		2856
	],
	"./pages/SuccessStories/PigiStory/images/banner-bg.png": [
		3471,
		9,
		3424
	],
	"./pages/SuccessStories/PigiStory/images/banner-bg.svg": [
		3472,
		9,
		2857
	],
	"./pages/SuccessStories/PigiStory/images/banner-img-2.png": [
		3473,
		9,
		3425
	],
	"./pages/SuccessStories/PigiStory/images/banner-img.png": [
		2092,
		9,
		3426
	],
	"./pages/SuccessStories/PigiStory/images/cart.svg": [
		2098,
		9,
		2858
	],
	"./pages/SuccessStories/PigiStory/images/challenges.png": [
		2100,
		9,
		3427
	],
	"./pages/SuccessStories/PigiStory/images/client.png": [
		3474,
		9,
		3428
	],
	"./pages/SuccessStories/PigiStory/images/features.png": [
		2101,
		9,
		3429
	],
	"./pages/SuccessStories/PigiStory/images/java.svg": [
		3475,
		9,
		2859
	],
	"./pages/SuccessStories/PigiStory/images/laptop.png": [
		2103,
		9,
		3430
	],
	"./pages/SuccessStories/PigiStory/images/location.svg": [
		2099,
		9,
		2860
	],
	"./pages/SuccessStories/PigiStory/images/mysql.svg": [
		3476,
		9,
		2861
	],
	"./pages/SuccessStories/PigiStory/images/nodejs.svg": [
		3477,
		9,
		2862
	],
	"./pages/SuccessStories/PigiStory/images/pigi.mp4": [
		2105,
		9,
		2863
	],
	"./pages/SuccessStories/PigiStory/images/play-store.svg": [
		2094,
		9,
		2864
	],
	"./pages/SuccessStories/PigiStory/images/product.png": [
		3478,
		9,
		3431
	],
	"./pages/SuccessStories/PigiStory/images/projectA.png": [
		3479,
		9,
		3432
	],
	"./pages/SuccessStories/PigiStory/images/projectB.png": [
		3480,
		9,
		3433
	],
	"./pages/SuccessStories/PigiStory/images/projectC.png": [
		3481,
		9,
		3434
	],
	"./pages/SuccessStories/PigiStory/images/smile.svg": [
		2095,
		9,
		2865
	],
	"./pages/SuccessStories/PigiStory/images/star.svg": [
		2096,
		9,
		2866
	],
	"./pages/SuccessStories/PigiStory/images/swift.png": [
		3482,
		9,
		3435
	],
	"./pages/SuccessStories/PigiStory/images/tech-bg.svg": [
		3483,
		9,
		2867
	],
	"./pages/SuccessStories/PigiStory/images/testimonial.png": [
		3484,
		9,
		3436
	],
	"./pages/SuccessStories/PigiStory/images/tick.svg": [
		2102,
		9,
		2868
	],
	"./pages/SuccessStories/PigiStory/images/vendor.svg": [
		2097,
		9,
		2869
	],
	"./pages/SuccessStories/SuccessstorytechnologystackImg/golang.svg": [
		3485,
		9,
		2870
	],
	"./pages/SuccessStories/SuccessstorytechnologystackImg/kotlin.svg": [
		3486,
		9,
		2871
	],
	"./pages/SuccessStories/SuccessstorytechnologystackImg/php.svg": [
		3487,
		9,
		2872
	],
	"./pages/SuccessStories/SuccessstorytechnologystackImg/react.svg": [
		3488,
		9,
		2873
	],
	"./pages/SuccessStories/SuccessstorytechnologystackImg/swift.svg": [
		3489,
		9,
		2874
	],
	"./pages/SuccessStories/Technologystackimg/angular.png": [
		2108,
		9,
		3437
	],
	"./pages/SuccessStories/Technologystackimg/golang.png": [
		2109,
		9,
		3438
	],
	"./pages/SuccessStories/Technologystackimg/java.png": [
		2106,
		9,
		3439
	],
	"./pages/SuccessStories/Technologystackimg/kotlin.png": [
		1039,
		9,
		3440
	],
	"./pages/SuccessStories/Technologystackimg/laravel.png": [
		1040,
		9,
		3441
	],
	"./pages/SuccessStories/Technologystackimg/mysql.png": [
		1611,
		9,
		3442
	],
	"./pages/SuccessStories/Technologystackimg/node-js.png": [
		2107,
		9,
		3443
	],
	"./pages/SuccessStories/Technologystackimg/php.png": [
		2110,
		9,
		3444
	],
	"./pages/SuccessStories/Technologystackimg/react.png": [
		1612,
		9,
		3445
	],
	"./pages/SuccessStories/Technologystackimg/sqlite.png": [
		2047,
		9,
		3446
	],
	"./pages/SuccessStories/Technologystackimg/swift.png": [
		983,
		9,
		3447
	],
	"./pages/SuccessStories/Technologystackimg/vue-js.png": [
		2063,
		9,
		3448
	],
	"./pages/SuccessStories/ZoominStory/ZoominStory": [
		854,
		9,
		0,
		3,
		1,
		8,
		162
	],
	"./pages/SuccessStories/ZoominStory/ZoominStory.js": [
		854,
		9,
		0,
		3,
		1,
		8,
		162
	],
	"./pages/SuccessStories/ZoominStory/ZoominStory.scss": [
		2111,
		7,
		1446
	],
	"./pages/SuccessStories/ZoominStory/fonts/Poppins-Bold.ttf": [
		3490,
		9,
		2875
	],
	"./pages/SuccessStories/ZoominStory/fonts/Poppins-Light.ttf": [
		3491,
		9,
		2876
	],
	"./pages/SuccessStories/ZoominStory/fonts/Poppins-Medium.ttf": [
		3492,
		9,
		2877
	],
	"./pages/SuccessStories/ZoominStory/fonts/Poppins-Regular.ttf": [
		3493,
		9,
		2878
	],
	"./pages/SuccessStories/ZoominStory/fonts/Poppins-SemiBold.ttf": [
		3494,
		9,
		2879
	],
	"./pages/SuccessStories/ZoominStory/fonts/Poppins-Thin.ttf": [
		3495,
		9,
		2880
	],
	"./pages/SuccessStories/ZoominStory/fonts/stylesheet.css": [
		3496,
		7,
		863
	],
	"./pages/SuccessStories/ZoominStory/images/AppStore.svg": [
		2118,
		9,
		2881
	],
	"./pages/SuccessStories/ZoominStory/images/app-store.svg": [
		2113,
		9,
		2882
	],
	"./pages/SuccessStories/ZoominStory/images/banner-bg.png": [
		3497,
		9,
		3449
	],
	"./pages/SuccessStories/ZoominStory/images/banner-bg.svg": [
		3498,
		9,
		2883
	],
	"./pages/SuccessStories/ZoominStory/images/client.png": [
		3499,
		9,
		3450
	],
	"./pages/SuccessStories/ZoominStory/images/downloads.svg": [
		2117,
		9,
		2884
	],
	"./pages/SuccessStories/ZoominStory/images/golang.svg": [
		3500,
		9,
		2885
	],
	"./pages/SuccessStories/ZoominStory/images/kotlin.png": [
		3501,
		9,
		3451
	],
	"./pages/SuccessStories/ZoominStory/images/php.png": [
		3502,
		9,
		3452
	],
	"./pages/SuccessStories/ZoominStory/images/play-store.svg": [
		2114,
		9,
		2886
	],
	"./pages/SuccessStories/ZoominStory/images/projectA.png": [
		3503,
		9,
		3453
	],
	"./pages/SuccessStories/ZoominStory/images/projectB.png": [
		3504,
		9,
		3454
	],
	"./pages/SuccessStories/ZoominStory/images/projectC.png": [
		3505,
		9,
		3455
	],
	"./pages/SuccessStories/ZoominStory/images/purplestar.svg": [
		2115,
		9,
		2887
	],
	"./pages/SuccessStories/ZoominStory/images/react.png": [
		3506,
		9,
		3456
	],
	"./pages/SuccessStories/ZoominStory/images/swift.png": [
		3507,
		9,
		3457
	],
	"./pages/SuccessStories/ZoominStory/images/tech-bg.svg": [
		3508,
		9,
		2888
	],
	"./pages/SuccessStories/ZoominStory/images/testimonial.png": [
		3509,
		9,
		3458
	],
	"./pages/SuccessStories/ZoominStory/images/tick.svg": [
		2121,
		9,
		2889
	],
	"./pages/SuccessStories/ZoominStory/images/yellowstar.svg": [
		2116,
		9,
		2890
	],
	"./pages/SuccessStories/ZoominStory/images/zoom-splash.png": [
		2112,
		9,
		3459
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin(Sachin-Katira).jpeg": [
		2123,
		9,
		3460
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin-challenges.png": [
		2119,
		9,
		3461
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin-features.png": [
		2120,
		9,
		3462
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin-laptop.png": [
		2122,
		9,
		3463
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin-product.png": [
		3510,
		9,
		3464
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin.mp4": [
		2124,
		9,
		2891
	],
	"./pages/SuccessStories/ZoominStory/images/zoomin.png": [
		3511,
		9,
		3465
	],
	"./pages/SwiftAppDevelopment/AboutSection/AboutSection": [
		280,
		9,
		230
	],
	"./pages/SwiftAppDevelopment/AboutSection/AboutSection.js": [
		280,
		9,
		230
	],
	"./pages/SwiftAppDevelopment/AboutSection/AboutSection.scss": [
		1171,
		7,
		1447
	],
	"./pages/SwiftAppDevelopment/BenefitsSection/BenefitsSection": [
		855,
		9,
		663
	],
	"./pages/SwiftAppDevelopment/BenefitsSection/BenefitsSection.js": [
		855,
		9,
		663
	],
	"./pages/SwiftAppDevelopment/HeroSection/HeroSection": [
		279,
		9,
		580
	],
	"./pages/SwiftAppDevelopment/HeroSection/HeroSection.js": [
		279,
		9,
		580
	],
	"./pages/SwiftAppDevelopment/HeroSection/HeroSection.scss": [
		1170,
		7,
		1448
	],
	"./pages/SwiftAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		3512,
		7,
		1449
	],
	"./pages/SwiftAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3513,
		7,
		1450
	],
	"./pages/SwiftAppDevelopment/Platforms/Platforms": [
		281,
		9,
		445
	],
	"./pages/SwiftAppDevelopment/Platforms/Platforms.js": [
		281,
		9,
		445
	],
	"./pages/SwiftAppDevelopment/Platforms/Platforms.scss": [
		1172,
		7,
		1451
	],
	"./pages/SwiftAppDevelopment/ServicesSection/ServicesSection": [
		282,
		9,
		581
	],
	"./pages/SwiftAppDevelopment/ServicesSection/ServicesSection.js": [
		282,
		9,
		581
	],
	"./pages/SwiftAppDevelopment/ServicesSection/ServicesSection.scss": [
		1173,
		7,
		1452
	],
	"./pages/SwiftAppDevelopment/SwiftAppDevelopment": [
		115,
		9,
		0,
		96,
		1,
		2,
		28
	],
	"./pages/SwiftAppDevelopment/SwiftAppDevelopment.js": [
		115,
		9,
		0,
		96,
		1,
		2,
		28
	],
	"./pages/SwiftAppDevelopment/TechnologiesSection/TechnologiesSection": [
		284,
		9,
		664
	],
	"./pages/SwiftAppDevelopment/TechnologiesSection/TechnologiesSection.js": [
		284,
		9,
		664
	],
	"./pages/SwiftAppDevelopment/WhyChooseMi/WhyChooseMi": [
		285,
		9,
		397
	],
	"./pages/SwiftAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		285,
		9,
		397
	],
	"./pages/SwiftAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1175,
		7,
		1453
	],
	"./pages/SwiftAppDevelopment/WhyChooseSection/WhyChooseSection": [
		283,
		9,
		783
	],
	"./pages/SwiftAppDevelopment/WhyChooseSection/WhyChooseSection.js": [
		283,
		9,
		783
	],
	"./pages/SwiftAppDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1174,
		7,
		1454
	],
	"./pages/Technologies/CoreValues/CoreValues": [
		255,
		9,
		240
	],
	"./pages/Technologies/CoreValues/CoreValues.js": [
		255,
		9,
		240
	],
	"./pages/Technologies/CoreValues/CoreValues.scss": [
		1146,
		7,
		1455
	],
	"./pages/Technologies/Platforms/Platforms": [
		254,
		9,
		243
	],
	"./pages/Technologies/Platforms/Platforms.js": [
		254,
		9,
		243
	],
	"./pages/Technologies/Platforms/Platforms.scss": [
		1141,
		7,
		1456
	],
	"./pages/Technologies/Technologies": [
		111,
		9,
		0,
		1,
		79
	],
	"./pages/Technologies/Technologies.js": [
		111,
		9,
		0,
		1,
		79
	],
	"./pages/Technologies/Technologies.scss": [
		1627,
		7,
		1457
	],
	"./pages/Technologies/TechnologiesHeroSection/HeroSection.scss": [
		1140,
		7,
		1458
	],
	"./pages/Technologies/TechnologiesHeroSection/TechnologiesHeroSection": [
		253,
		9,
		462
	],
	"./pages/Technologies/TechnologiesHeroSection/TechnologiesHeroSection.js": [
		253,
		9,
		462
	],
	"./pages/Technologies/TechnologiesSection/TechnologiesSection": [
		238,
		9,
		271
	],
	"./pages/Technologies/TechnologiesSection/TechnologiesSection.js": [
		238,
		9,
		271
	],
	"./pages/Technologies/TechnologiesSection/TechnologiesSection.scss": [
		1024,
		7,
		1459
	],
	"./pages/Technologies/TrendingTechs/TrendingTechs": [
		246,
		9,
		406
	],
	"./pages/Technologies/TrendingTechs/TrendingTechs.js": [
		246,
		9,
		406
	],
	"./pages/Technologies/TrendingTechs/TrendingTechs.scss": [
		1044,
		7,
		1460
	],
	"./pages/Technologies/TrendingTechs/img/docker.svg": [
		1048,
		9,
		2892
	],
	"./pages/Technologies/TrendingTechs/img/firebase.svg": [
		1049,
		9,
		2893
	],
	"./pages/Technologies/TrendingTechs/img/flutter.svg": [
		1045,
		9,
		2894
	],
	"./pages/Technologies/TrendingTechs/img/golang.svg": [
		1046,
		9,
		2895
	],
	"./pages/Technologies/TrendingTechs/img/kubernets.svg": [
		1050,
		9,
		2896
	],
	"./pages/Technologies/TrendingTechs/img/react.svg": [
		1047,
		9,
		2897
	],
	"./pages/Testimonial/HeroSection/HeroSection": [
		573,
		9,
		258
	],
	"./pages/Testimonial/HeroSection/HeroSection.js": [
		573,
		9,
		258
	],
	"./pages/Testimonial/HeroSection/HeroSection.scss": [
		1495,
		7,
		1461
	],
	"./pages/Testimonial/Items/Items": [
		574,
		9,
		784
	],
	"./pages/Testimonial/Items/Items.js": [
		574,
		9,
		784
	],
	"./pages/Testimonial/Items/Items.scss": [
		1496,
		7,
		1462
	],
	"./pages/Testimonial/Testimonial": [
		175,
		9,
		0,
		1,
		84
	],
	"./pages/Testimonial/Testimonial.js": [
		175,
		9,
		0,
		1,
		84
	],
	"./pages/ThankYou/ThankYou": [
		179,
		9,
		0,
		1,
		89
	],
	"./pages/ThankYou/ThankYou.js": [
		179,
		9,
		0,
		1,
		89
	],
	"./pages/ThankYou/ThankYou.scss": [
		1500,
		7,
		1463
	],
	"./pages/ThankYou/ThankYouSubscribe": [
		180,
		9,
		0,
		1,
		90
	],
	"./pages/ThankYou/ThankYouSubscribe.js": [
		180,
		9,
		0,
		1,
		90
	],
	"./pages/ThankYou/imgs/success.svg": [
		1501,
		9,
		2898
	],
	"./pages/VueJsDevelopment/AboutSection/AboutSection": [
		318,
		9,
		231
	],
	"./pages/VueJsDevelopment/AboutSection/AboutSection.js": [
		318,
		9,
		231
	],
	"./pages/VueJsDevelopment/AboutSection/AboutSection.scss": [
		1208,
		7,
		1464
	],
	"./pages/VueJsDevelopment/BenefitsSection/BenefitsSection": [
		856,
		9,
		665
	],
	"./pages/VueJsDevelopment/BenefitsSection/BenefitsSection.js": [
		856,
		9,
		665
	],
	"./pages/VueJsDevelopment/HeroSection/HeroSection": [
		317,
		9,
		582
	],
	"./pages/VueJsDevelopment/HeroSection/HeroSection.js": [
		317,
		9,
		582
	],
	"./pages/VueJsDevelopment/HeroSection/HeroSection.scss": [
		1207,
		7,
		1465
	],
	"./pages/VueJsDevelopment/LookingDevelopers/LookingDevelopers": [
		857,
		9,
		500
	],
	"./pages/VueJsDevelopment/LookingDevelopers/LookingDevelopers.js": [
		857,
		9,
		500
	],
	"./pages/VueJsDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2125,
		7,
		1466
	],
	"./pages/VueJsDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3514,
		7,
		1467
	],
	"./pages/VueJsDevelopment/ServicesSection/ServicesSection": [
		319,
		9,
		583
	],
	"./pages/VueJsDevelopment/ServicesSection/ServicesSection.js": [
		319,
		9,
		583
	],
	"./pages/VueJsDevelopment/ServicesSection/ServicesSection.scss": [
		1209,
		7,
		1468
	],
	"./pages/VueJsDevelopment/VueJsDevelopment": [
		121,
		9,
		0,
		102,
		1,
		2,
		38
	],
	"./pages/VueJsDevelopment/VueJsDevelopment.js": [
		121,
		9,
		0,
		102,
		1,
		2,
		38
	],
	"./pages/VueJsDevelopment/WhyChooseMi/WhyChooseMi": [
		321,
		9,
		398
	],
	"./pages/VueJsDevelopment/WhyChooseMi/WhyChooseMi.js": [
		321,
		9,
		398
	],
	"./pages/VueJsDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1211,
		7,
		1469
	],
	"./pages/VueJsDevelopment/WhyChooseSection/WhyChooseSection": [
		320,
		9,
		611
	],
	"./pages/VueJsDevelopment/WhyChooseSection/WhyChooseSection.js": [
		320,
		9,
		611
	],
	"./pages/VueJsDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1210,
		7,
		1470
	],
	"./pages/WearableAppDevelopment/AboutSection/AboutSection": [
		380,
		9,
		232
	],
	"./pages/WearableAppDevelopment/AboutSection/AboutSection.js": [
		380,
		9,
		232
	],
	"./pages/WearableAppDevelopment/AboutSection/AboutSection.scss": [
		1281,
		7,
		1471
	],
	"./pages/WearableAppDevelopment/HeroSection/HeroSection": [
		379,
		9,
		584
	],
	"./pages/WearableAppDevelopment/HeroSection/HeroSection.js": [
		379,
		9,
		584
	],
	"./pages/WearableAppDevelopment/HeroSection/HeroSection.scss": [
		1280,
		7,
		1472
	],
	"./pages/WearableAppDevelopment/LookingDevelopers/LookingDevelopers": [
		858,
		9,
		501
	],
	"./pages/WearableAppDevelopment/LookingDevelopers/LookingDevelopers.js": [
		858,
		9,
		501
	],
	"./pages/WearableAppDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		2126,
		7,
		1473
	],
	"./pages/WearableAppDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		3515,
		7,
		1474
	],
	"./pages/WearableAppDevelopment/ServicesSection/ServicesSection": [
		381,
		9,
		585
	],
	"./pages/WearableAppDevelopment/ServicesSection/ServicesSection.js": [
		381,
		9,
		585
	],
	"./pages/WearableAppDevelopment/ServicesSection/ServicesSection.scss": [
		1282,
		7,
		1475
	],
	"./pages/WearableAppDevelopment/TechnologiesSection/TechnologiesSection": [
		859,
		9,
		666
	],
	"./pages/WearableAppDevelopment/TechnologiesSection/TechnologiesSection.js": [
		859,
		9,
		666
	],
	"./pages/WearableAppDevelopment/WearableAppDevelopment": [
		132,
		9,
		0,
		112,
		1,
		2,
		68
	],
	"./pages/WearableAppDevelopment/WearableAppDevelopment.js": [
		132,
		9,
		0,
		112,
		1,
		2,
		68
	],
	"./pages/WearableAppDevelopment/WhyChooseMi/WhyChooseMi": [
		382,
		9,
		399
	],
	"./pages/WearableAppDevelopment/WhyChooseMi/WhyChooseMi.js": [
		382,
		9,
		399
	],
	"./pages/WearableAppDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1283,
		7,
		1476
	],
	"./pages/WebDevelopment/AboutSection/AboutSection": [
		333,
		9,
		233
	],
	"./pages/WebDevelopment/AboutSection/AboutSection.js": [
		333,
		9,
		233
	],
	"./pages/WebDevelopment/AboutSection/AboutSection.scss": [
		1223,
		7,
		1477
	],
	"./pages/WebDevelopment/HeroSection/HeroSection": [
		332,
		9,
		586
	],
	"./pages/WebDevelopment/HeroSection/HeroSection.js": [
		332,
		9,
		586
	],
	"./pages/WebDevelopment/HeroSection/HeroSection.scss": [
		1222,
		7,
		1478
	],
	"./pages/WebDevelopment/LookingDevelopers/LookingDevelopers.scss": [
		3516,
		7,
		1479
	],
	"./pages/WebDevelopment/LookingOtherServices/LookingOtherServices": [
		860,
		9,
		509
	],
	"./pages/WebDevelopment/LookingOtherServices/LookingOtherServices.js": [
		860,
		9,
		509
	],
	"./pages/WebDevelopment/LookingOtherServices/LookingOtherServices.scss": [
		2127,
		7,
		1480
	],
	"./pages/WebDevelopment/NewWhatWeDo/NewWhatWeDo": [
		336,
		9,
		244
	],
	"./pages/WebDevelopment/NewWhatWeDo/NewWhatWeDo.js": [
		336,
		9,
		244
	],
	"./pages/WebDevelopment/NewWhatWeDo/NewWhatWeDo.scss": [
		1225,
		7,
		1481
	],
	"./pages/WebDevelopment/OurRecentWork/OurRecentWork": [
		861,
		9,
		297
	],
	"./pages/WebDevelopment/OurRecentWork/OurRecentWork.js": [
		861,
		9,
		297
	],
	"./pages/WebDevelopment/OurRecentWork/OurRecentWork.scss": [
		2128,
		7,
		1482
	],
	"./pages/WebDevelopment/ServicesSection/ServicesSection": [
		335,
		9,
		587
	],
	"./pages/WebDevelopment/ServicesSection/ServicesSection.js": [
		335,
		9,
		587
	],
	"./pages/WebDevelopment/ServicesSection/ServicesSection.scss": [
		1224,
		7,
		1483
	],
	"./pages/WebDevelopment/TechnologiesSection/TechnologiesSection": [
		334,
		9,
		667
	],
	"./pages/WebDevelopment/TechnologiesSection/TechnologiesSection.js": [
		334,
		9,
		667
	],
	"./pages/WebDevelopment/WebDevelopment": [
		124,
		9,
		0,
		3,
		105,
		1,
		19
	],
	"./pages/WebDevelopment/WebDevelopment.js": [
		124,
		9,
		0,
		3,
		105,
		1,
		19
	],
	"./pages/WebDevelopment/WhatWeDo/WhatWeDo": [
		862,
		9,
		245
	],
	"./pages/WebDevelopment/WhatWeDo/WhatWeDo.js": [
		862,
		9,
		245
	],
	"./pages/WebDevelopment/WhatWeDo/WhatWeDo.scss": [
		2135,
		7,
		1484
	],
	"./pages/WebDevelopment/WhatWeDo/imgs/Apple_logo.svg": [
		2129,
		9,
		2899
	],
	"./pages/WebDevelopment/WhatWeDo/imgs/android-logo.svg": [
		2130,
		9,
		2900
	],
	"./pages/WebDevelopment/WhatWeDo/imgs/flutter-logo.svg": [
		2132,
		9,
		2901
	],
	"./pages/WebDevelopment/WhatWeDo/imgs/ionic-logo.svg": [
		2134,
		9,
		2902
	],
	"./pages/WebDevelopment/WhatWeDo/imgs/react-logo.svg": [
		2133,
		9,
		2903
	],
	"./pages/WebDevelopment/WhatWeDo/imgs/swift-logo.svg": [
		2131,
		9,
		2904
	],
	"./pages/WebDevelopment/WhyChooseMi/WhyChooseMi": [
		338,
		9,
		400
	],
	"./pages/WebDevelopment/WhyChooseMi/WhyChooseMi.js": [
		338,
		9,
		400
	],
	"./pages/WebDevelopment/WhyChooseMi/WhyChooseMi.scss": [
		1227,
		7,
		1485
	],
	"./pages/WebDevelopment/WhyChooseSection/WhyChooseSection": [
		337,
		9,
		612
	],
	"./pages/WebDevelopment/WhyChooseSection/WhyChooseSection.js": [
		337,
		9,
		612
	],
	"./pages/WebDevelopment/WhyChooseSection/WhyChooseSection.scss": [
		1226,
		7,
		1486
	],
	"./serviceWorker": [
		28,
		9
	],
	"./serviceWorker.js": [
		28,
		9
	],
	"./validations/ContactUsValidation": [
		233,
		9,
		7,
		808
	],
	"./validations/ContactUsValidation.js": [
		233,
		9,
		7,
		808
	],
	"./validations/NewsLetterValidation": [
		580,
		9,
		7,
		809
	],
	"./validations/NewsLetterValidation.js": [
		580,
		9,
		7,
		809
	],
	"./validations/WhitePaperValidation": [
		863,
		9,
		7,
		810
	],
	"./validations/WhitePaperValidation.js": [
		863,
		9,
		7,
		810
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 875;
module.exports = webpackAsyncContext;